let Array;
let Map;
let Date;
let sendBeacon$2;
let URL;
if (typeof window !== 'undefined') {
    Array = window.Array;
    Map = window.Map;
    Date = window.Date;
    sendBeacon$2 = window.navigator?.sendBeacon?.bind(window.navigator);
    URL = window.URL;
    const iframe = document.createElement('iframe');
    document.body.appendChild(iframe);
    if (iframe.contentWindow?.Array) {
        Array = iframe.contentWindow.Array;
    }
    if (iframe.contentWindow?.Date) {
        Date = iframe.contentWindow.Date;
    }
    if (iframe.contentWindow?.Map) {
        Map = iframe.contentWindow.Map;
    }
    // Note: "iframe.contentWindow.navigator.sendBeacon" will not work for WebKit browsers
    // once the source iframe.contentWindow has been removed from the DOM
    const isSafari = window.navigator?.vendor?.startsWith('Apple');
    if (iframe.contentWindow?.navigator?.sendBeacon && !isSafari) {
        sendBeacon$2 = iframe.contentWindow.navigator.sendBeacon.bind(window.navigator);
    }
    if (iframe.contentWindow?.URL) {
        URL = iframe.contentWindow.URL;
    }
    iframe.remove();
}

/**
 * @this {Promise}
 */
function finallyConstructor(callback) {
  var constructor = this.constructor;
  return this.then(
    function(value) {
      // @ts-ignore
      return constructor.resolve(callback()).then(function() {
        return value;
      });
    },
    function(reason) {
      // @ts-ignore
      return constructor.resolve(callback()).then(function() {
        // @ts-ignore
        return constructor.reject(reason);
      });
    }
  );
}

function allSettled(arr) {
  var P = this;
  return new P(function(resolve, reject) {
    if (!(arr && typeof arr.length !== 'undefined')) {
      return reject(
        new TypeError(
          typeof arr +
            ' ' +
            arr +
            ' is not iterable(cannot read property Symbol(Symbol.iterator))'
        )
      );
    }
    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    var remaining = args.length;

    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        var then = val.then;
        if (typeof then === 'function') {
          then.call(
            val,
            function(val) {
              res(i, val);
            },
            function(e) {
              args[i] = { status: 'rejected', reason: e };
              if (--remaining === 0) {
                resolve(args);
              }
            }
          );
          return;
        }
      }
      args[i] = { status: 'fulfilled', value: val };
      if (--remaining === 0) {
        resolve(args);
      }
    }

    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
}

/**
 * @constructor
 */
function AggregateError(errors, message) {
  (this.name = 'AggregateError'), (this.errors = errors);
  this.message = message || '';
}
AggregateError.prototype = Error.prototype;

function any(arr) {
  var P = this;
  return new P(function(resolve, reject) {
    if (!(arr && typeof arr.length !== 'undefined')) {
      return reject(new TypeError('Promise.any accepts an array'));
    }

    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return reject();

    var rejectionReasons = [];
    for (var i = 0; i < args.length; i++) {
      try {
        P.resolve(args[i])
          .then(resolve)
          .catch(function(error) {
            rejectionReasons.push(error);
            if (rejectionReasons.length === args.length) {
              reject(
                new AggregateError(
                  rejectionReasons,
                  'All promises were rejected'
                )
              );
            }
          });
      } catch (ex) {
        reject(ex);
      }
    }
  });
}

// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var setTimeoutFunc = setTimeout;

function isArray$1(x) {
  return Boolean(x && typeof x.length !== 'undefined');
}

function noop() {}

// Polyfill for Function.prototype.bind
function bind(fn, thisArg) {
  return function() {
    fn.apply(thisArg, arguments);
  };
}

/**
 * @constructor
 * @param {Function} fn
 */
function Promise$1(fn) {
  if (!(this instanceof Promise$1))
    throw new TypeError('Promises must be constructed via new');
  if (typeof fn !== 'function') throw new TypeError('not a function');
  /** @type {!number} */
  this._state = 0;
  /** @type {!boolean} */
  this._handled = false;
  /** @type {Promise|undefined} */
  this._value = undefined;
  /** @type {!Array<!Function>} */
  this._deferreds = [];

  doResolve(fn, this);
}

function handle(self, deferred) {
  while (self._state === 3) {
    self = self._value;
  }
  if (self._state === 0) {
    self._deferreds.push(deferred);
    return;
  }
  self._handled = true;
  Promise$1._immediateFn(function() {
    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      (self._state === 1 ? resolve$1 : reject)(deferred.promise, self._value);
      return;
    }
    var ret;
    try {
      ret = cb(self._value);
    } catch (e) {
      reject(deferred.promise, e);
      return;
    }
    resolve$1(deferred.promise, ret);
  });
}

function resolve$1(self, newValue) {
  try {
    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
    if (newValue === self)
      throw new TypeError('A promise cannot be resolved with itself.');
    if (
      newValue &&
      (typeof newValue === 'object' || typeof newValue === 'function')
    ) {
      var then = newValue.then;
      if (newValue instanceof Promise$1) {
        self._state = 3;
        self._value = newValue;
        finale(self);
        return;
      } else if (typeof then === 'function') {
        doResolve(bind(then, newValue), self);
        return;
      }
    }
    self._state = 1;
    self._value = newValue;
    finale(self);
  } catch (e) {
    reject(self, e);
  }
}

function reject(self, newValue) {
  self._state = 2;
  self._value = newValue;
  finale(self);
}

function finale(self) {
  if (self._deferreds === null) return;
  if (self._state === 2 && self._deferreds.length === 0) {
    Promise$1._immediateFn(function() {
      if (!self._handled) {
        Promise$1._unhandledRejectionFn(self._value);
      }
    });
  }

  for (var i = 0, len = self._deferreds.length; i < len; i++) {
    handle(self, self._deferreds[i]);
  }
  self._deferreds = null;
}

/**
 * @constructor
 */
function Handler(onFulfilled, onRejected, promise) {
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, self) {
  var done = false;
  try {
    fn(
      function(value) {
        if (done) return;
        done = true;
        resolve$1(self, value);
      },
      function(reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      }
    );
  } catch (ex) {
    if (done) return;
    done = true;
    reject(self, ex);
  }
}

Promise$1.prototype['catch'] = function(onRejected) {
  return this.then(null, onRejected);
};

Promise$1.prototype.then = function(onFulfilled, onRejected) {
  // @ts-ignore
  var prom = new this.constructor(noop);

  handle(this, new Handler(onFulfilled, onRejected, prom));
  return prom;
};

Promise$1.prototype['finally'] = finallyConstructor;

Promise$1.all = function(arr) {
  return new Promise$1(function(resolve, reject) {
    if (!isArray$1(arr)) {
      return reject(new TypeError('Promise.all accepts an array'));
    }

    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    var remaining = args.length;

    function res(i, val) {
      try {
        if (val && (typeof val === 'object' || typeof val === 'function')) {
          var then = val.then;
          if (typeof then === 'function') {
            then.call(
              val,
              function(val) {
                res(i, val);
              },
              reject
            );
            return;
          }
        }
        args[i] = val;
        if (--remaining === 0) {
          resolve(args);
        }
      } catch (ex) {
        reject(ex);
      }
    }

    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise$1.any = any;

Promise$1.allSettled = allSettled;

Promise$1.resolve = function(value) {
  if (value && typeof value === 'object' && value.constructor === Promise$1) {
    return value;
  }

  return new Promise$1(function(resolve) {
    resolve(value);
  });
};

Promise$1.reject = function(value) {
  return new Promise$1(function(resolve, reject) {
    reject(value);
  });
};

Promise$1.race = function(arr) {
  return new Promise$1(function(resolve, reject) {
    if (!isArray$1(arr)) {
      return reject(new TypeError('Promise.race accepts an array'));
    }

    for (var i = 0, len = arr.length; i < len; i++) {
      Promise$1.resolve(arr[i]).then(resolve, reject);
    }
  });
};

// Use polyfill for setImmediate for performance gains
Promise$1._immediateFn =
  // @ts-ignore
  (typeof setImmediate === 'function' &&
    function(fn) {
      // @ts-ignore
      setImmediate(fn);
    }) ||
  function(fn) {
    setTimeoutFunc(fn, 0);
  };

Promise$1._unhandledRejectionFn = function _unhandledRejectionFn(err) {
  if (typeof console !== 'undefined' && console) {
    console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
  }
};

/* eslint-disable */
// @ts-nocheck
try {
    // eslint-disable-next-line no-restricted-globals
    if ('queueMicrotask' in self) {
        // eslint-disable-next-line no-underscore-dangle,no-restricted-globals
        Promise$1._immediateFn = queueMicrotask.bind(self);
    }
    const _unhandledRejectionFn = Promise$1._unhandledRejectionFn;
    Promise$1._unhandledRejectionFn = (err) => {
        if ('thn' in self) {
            thn.logger?.warn?.('Possible Unhandled Promise Rejection:', err);
        }
        else {
            _unhandledRejectionFn(err);
        }
    };
}
catch { /* empty */ }

function sendBeacon$1(url, data) {
    const globalObject = globalThis;
    try {
        const xhr = globalObject.ActiveXObject ? new globalObject.ActiveXObject('Microsoft.XMLHTTP') : new XMLHttpRequest();
        xhr.open('POST', url, false);
        xhr.onerror = () => { };
        xhr.setRequestHeader('accept', '*/*');
        xhr.withCredentials = true;
        if (Object.prototype.toString.call(data) === '[object Blob]') {
            if (data.type) {
                xhr.setRequestHeader('content-type', data.type);
            }
        }
        else {
            const mime = typeof data === 'string' ? 'text/plain' : 'application/x-www-form-urlencoded';
            xhr.setRequestHeader('content-type', `${mime};charset=UTF-8`);
        }
        xhr.send(String(data));
        return true;
    }
    catch (_error) {
        return false;
    }
}

var AgentActionKind = /*@__PURE__*/(function (AgentActionKind = {}) {
    /**
     * Action to be called when applying a discount code (of any kind, not just of type "promocode").
     *
     * It corresponds to the Nostromo type `ButtonActionKind.ApplyPromoCode`.
     */
    AgentActionKind["ApplyDiscount"] = "apply-discount";
    /**
     * Action to be called when a UI/view is definetively closed from the [x] button
     * (or by a backdrop click) without having engaged with the contents of the message.
     */
    AgentActionKind["Dismiss"] = "dismiss";
    /**
     * Action to be called when a user positively engages with the UI/view, for instance
     * by executing a CTA. This is an exclusively disjunctive action with "dismiss", either
     * one or the other can happen, never both.
     */
    AgentActionKind["Engage"] = "engage";
    /**
     * Action to be called when a UI/view is closed.
     */
    AgentActionKind["Hide"] = "hide";
    /**
     * This action is usually called in replacemend of a CTA action
     * (like ApplyDiscount, OpenBookingEngine, OpenUri) when those actions
     * do not have a handler defined.
     *
     * Additionally is used by the Nostromo type `ButtonActionKind.CloseTool` on Inliners.
     */
    AgentActionKind["NoAction"] = "no-action";
    /**
     * Action that should never be called, is a Noop.
     */
    AgentActionKind["Fallback"] = "none";
    /**
     * Action to be called when a click happends on _any_ generic link of the contents.
     * By 'generic link' we mean a link not formally defined in the data struct, but just part of a
     * rich text/html of the message. This action should not be called when for clicks on buttons/CTAs.
     */
    AgentActionKind["GenericLinkClick"] = "generic-link-click";
    /**
     * Action to be called when loading a custom JS script.
     */
    AgentActionKind["LoadScript"] = "load-script";
    /**
     * Action to be called when opening the Booking Engine page, either with the default search data,
     * or with the last search data.
     *
     * It corresponds to the Nostromo type `ButtonActionKind.OpenBookingEngine`,
     * and `ButtonActionKind.LastSearch`.
     */
    AgentActionKind["OpenBookingEngine"] = "open-be";
    /**
     * Action to be called when opening a URI (either http(s), mail or tel).
     *
     * It corresponds to the Nostromo types `ButtonActionKind.OpenUrl`,
     * `ButtonActionKind.OpenMailClient` and `ButtonActionKind.CallPhoneNumber`.
     */
    AgentActionKind["OpenUri"] = "open-uri";
    /**
     * Action to be called to classify the visitor in an Audience group.
     */
    AgentActionKind["PredictiveAudience"] = "predictive-audience";
    /**
     * Action to be called when sending a (custom) form to the Site.
     *
     * It corresponds to the Nostromo type `ToolModuleKind.Form`.
     */
    AgentActionKind["SendForm"] = "send-form";
    /**
     * Action to be called when the visitor is sending a save-your-search email to himself/herself.
     * It corresponds to the Nostromo types `ToolModuleKind.SavedSearch` and
     * `ButtonActionKind.SavedSearch`.
     */
    AgentActionKind["SendSaveSearch"] = "send-save-search";
    /**
     * Action to be called when sending a contact email to the Site.
     */
    AgentActionKind["SendSiteContact"] = "send-site-contact";
    /**
     * Action to be called when subscribing to a mailing list, newsletter or similar.
     *
     * It corresponds to the Nostromo type `ToolModuleKind.EmailCapture`.
     */
    AgentActionKind["SendSubscribe"] = "send-subscribe";
    /**
     * Action to be called when a UI is displayed.
     */
    AgentActionKind["Show"] = "show";
    /**
     * Action to be called when the visitor is signing-in or signing-up with with THN.
     *
     * It corresponds to the Nostromo type `ToolModuleKind.Login`.
     */
    AgentActionKind["Login"] = "login";
    /**
     * Action to be called when a message/tool that needs to "move" the full body content is displayed.
     */
    AgentActionKind["TranslateDocumentBody"] = "translate-document-body";
    return AgentActionKind;
})(AgentActionKind);

var FontType = /*@__PURE__*/(function (FontType = {}) {
    FontType["Google"] = "google";
    FontType["File"] = "file";
    FontType["Regular"] = "regular";
    return FontType;
})(FontType);

var AnalyticsEventName = /*@__PURE__*/(function (AnalyticsEventName = {}) {
    AnalyticsEventName["Activity"] = "Activity";
    AnalyticsEventName["Audience"] = "Audience";
    AnalyticsEventName["MessageStatus"] = "MessageStatus";
    AnalyticsEventName["PackageStatus"] = "PackageStatus";
    AnalyticsEventName["PriceStatus"] = "PriceStatus";
    AnalyticsEventName["VisitorStatus"] = "VisitorStatus";
    return AnalyticsEventName;
})(AnalyticsEventName);

var WidgetTypeId = /*@__PURE__*/(function (WidgetTypeId = {}) {
    WidgetTypeId["Exit"] = "31";
    WidgetTypeId["Inliner"] = "33";
    WidgetTypeId["Layer"] = "32";
    WidgetTypeId["Note"] = "2";
    return WidgetTypeId;
})(WidgetTypeId);
var WidgetMode = /*@__PURE__*/(function (WidgetMode = {}) {
    WidgetMode["Auto"] = "auto";
    WidgetMode["DataLayer"] = "datalayer";
    WidgetMode["Manual"] = "manual";
    return WidgetMode;
})(WidgetMode);
var PageName = /*@__PURE__*/(function (PageName = {}) {
    PageName["BookingConfirmed"] = "Booking Confirmed";
    PageName["BookingIframe"] = "Booking Iframe";
    PageName["Calendar"] = "Calendar";
    PageName["Homepage"] = "Index";
    PageName["Packages"] = "Packages";
    PageName["RoomsAndRates"] = "Rooms and Rates";
    PageName["UserRegisterPage"] = "User Register Page";
    return PageName;
})(PageName);
var WidgetsList = /*@__PURE__*/(function (WidgetsList = {}) {
    WidgetsList["Booking"] = "booking";
    WidgetsList["BookingDraft"] = "booking-draft";
    WidgetsList["Chat"] = "chat";
    WidgetsList["Inliner"] = "inliner";
    WidgetsList["Kitt"] = "kitt";
    WidgetsList["Note"] = "note";
    WidgetsList["Package"] = "package";
    WidgetsList["Price"] = "price";
    WidgetsList["PriceMatch"] = "pricematch";
    WidgetsList["Review"] = "review";
    WidgetsList["Snippet"] = "snippet";
    WidgetsList["Layer"] = "layer";
    // Note: order is important. By pushing the Exit Widget to the end,
    // we increase the chance its view is created later.
    // When its z-index value draws with other widgets, then Exit would display on top.
    WidgetsList["Exit"] = "exit";
    return WidgetsList;
})(WidgetsList);

var CurrencyCode = /*@__PURE__*/(function (CurrencyCode = {}) {
    CurrencyCode["Aed"] = "AED";
    CurrencyCode["Afn"] = "AFN";
    CurrencyCode["All"] = "ALL";
    CurrencyCode["Amd"] = "AMD";
    CurrencyCode["Ang"] = "ANG";
    CurrencyCode["Aoa"] = "AOA";
    CurrencyCode["Ars"] = "ARS";
    CurrencyCode["Aud"] = "AUD";
    CurrencyCode["Awg"] = "AWG";
    CurrencyCode["Azn"] = "AZN";
    CurrencyCode["Bam"] = "BAM";
    CurrencyCode["Bbd"] = "BBD";
    CurrencyCode["Bdt"] = "BDT";
    CurrencyCode["Bgn"] = "BGN";
    CurrencyCode["Bhd"] = "BHD";
    CurrencyCode["Bif"] = "BIF";
    CurrencyCode["Bmd"] = "BMD";
    CurrencyCode["Bnd"] = "BND";
    CurrencyCode["Bob"] = "BOB";
    CurrencyCode["Brl"] = "BRL";
    CurrencyCode["Bsd"] = "BSD";
    CurrencyCode["Btn"] = "BTN";
    CurrencyCode["Bwp"] = "BWP";
    CurrencyCode["Byn"] = "BYN";
    CurrencyCode["Bzd"] = "BZD";
    CurrencyCode["Cad"] = "CAD";
    CurrencyCode["Cdf"] = "CDF";
    CurrencyCode["Chf"] = "CHF";
    CurrencyCode["Clp"] = "CLP";
    CurrencyCode["Cny"] = "CNY";
    CurrencyCode["Cop"] = "COP";
    CurrencyCode["Crc"] = "CRC";
    CurrencyCode["Cup"] = "CUP";
    CurrencyCode["Cve"] = "CVE";
    CurrencyCode["Czk"] = "CZK";
    CurrencyCode["Djf"] = "DJF";
    CurrencyCode["Dkk"] = "DKK";
    CurrencyCode["Dop"] = "DOP";
    CurrencyCode["Dzd"] = "DZD";
    CurrencyCode["Egp"] = "EGP";
    CurrencyCode["Ern"] = "ERN";
    CurrencyCode["Etb"] = "ETB";
    CurrencyCode["Eur"] = "EUR";
    CurrencyCode["Fjd"] = "FJD";
    CurrencyCode["Fkp"] = "FKP";
    CurrencyCode["Gbp"] = "GBP";
    CurrencyCode["Gel"] = "GEL";
    CurrencyCode["Ggp"] = "GGP";
    CurrencyCode["Ghs"] = "GHS";
    CurrencyCode["Gip"] = "GIP";
    CurrencyCode["Gmd"] = "GMD";
    CurrencyCode["Gnf"] = "GNF";
    CurrencyCode["Gtq"] = "GTQ";
    CurrencyCode["Gyd"] = "GYD";
    CurrencyCode["Hkd"] = "HKD";
    CurrencyCode["Hnl"] = "HNL";
    CurrencyCode["Hrk"] = "HRK";
    CurrencyCode["Htg"] = "HTG";
    CurrencyCode["Huf"] = "HUF";
    CurrencyCode["Idr"] = "IDR";
    CurrencyCode["Ils"] = "ILS";
    CurrencyCode["Imp"] = "IMP";
    CurrencyCode["Inr"] = "INR";
    CurrencyCode["Iqd"] = "IQD";
    CurrencyCode["Irr"] = "IRR";
    CurrencyCode["Isk"] = "ISK";
    CurrencyCode["Jep"] = "JEP";
    CurrencyCode["Jmd"] = "JMD";
    CurrencyCode["Jod"] = "JOD";
    CurrencyCode["Jpy"] = "JPY";
    CurrencyCode["Kes"] = "KES";
    CurrencyCode["Kgs"] = "KGS";
    CurrencyCode["Khr"] = "KHR";
    CurrencyCode["Kmf"] = "KMF";
    CurrencyCode["Kpw"] = "KPW";
    CurrencyCode["Krw"] = "KRW";
    CurrencyCode["Kwd"] = "KWD";
    CurrencyCode["Kyd"] = "KYD";
    CurrencyCode["Kzt"] = "KZT";
    CurrencyCode["Lak"] = "LAK";
    CurrencyCode["Lbp"] = "LBP";
    CurrencyCode["Lkr"] = "LKR";
    CurrencyCode["Lrd"] = "LRD";
    CurrencyCode["Lsl"] = "LSL";
    CurrencyCode["Lyd"] = "LYD";
    CurrencyCode["Mad"] = "MAD";
    CurrencyCode["Mdl"] = "MDL";
    CurrencyCode["Mga"] = "MGA";
    CurrencyCode["Mkd"] = "MKD";
    CurrencyCode["Mmk"] = "MMK";
    CurrencyCode["Mnt"] = "MNT";
    CurrencyCode["Mop"] = "MOP";
    CurrencyCode["Mru"] = "MRU";
    CurrencyCode["Mur"] = "MUR";
    CurrencyCode["Mvr"] = "MVR";
    CurrencyCode["Mwk"] = "MWK";
    CurrencyCode["Mxn"] = "MXN";
    CurrencyCode["Myr"] = "MYR";
    CurrencyCode["Mzn"] = "MZN";
    CurrencyCode["Nad"] = "NAD";
    CurrencyCode["Ngn"] = "NGN";
    CurrencyCode["Nio"] = "NIO";
    CurrencyCode["Nok"] = "NOK";
    CurrencyCode["Npr"] = "NPR";
    CurrencyCode["Nzd"] = "NZD";
    CurrencyCode["Omr"] = "OMR";
    CurrencyCode["Pab"] = "PAB";
    CurrencyCode["Pen"] = "PEN";
    CurrencyCode["Pgk"] = "PGK";
    CurrencyCode["Php"] = "PHP";
    CurrencyCode["Pkr"] = "PKR";
    CurrencyCode["Pln"] = "PLN";
    CurrencyCode["Pyg"] = "PYG";
    CurrencyCode["Qar"] = "QAR";
    CurrencyCode["Ron"] = "RON";
    CurrencyCode["Rsd"] = "RSD";
    CurrencyCode["Rub"] = "RUB";
    CurrencyCode["Rwf"] = "RWF";
    CurrencyCode["Sar"] = "SAR";
    CurrencyCode["Sbd"] = "SBD";
    CurrencyCode["Scr"] = "SCR";
    CurrencyCode["Sdg"] = "SDG";
    CurrencyCode["Sek"] = "SEK";
    CurrencyCode["Sgd"] = "SGD";
    CurrencyCode["Shp"] = "SHP";
    CurrencyCode["Sll"] = "SLL";
    CurrencyCode["Sos"] = "SOS";
    CurrencyCode["Spl"] = "SPL";
    CurrencyCode["Srd"] = "SRD";
    CurrencyCode["Stn"] = "STN";
    CurrencyCode["Svc"] = "SVC";
    CurrencyCode["Syp"] = "SYP";
    CurrencyCode["Szl"] = "SZL";
    CurrencyCode["Thb"] = "THB";
    CurrencyCode["Tjs"] = "TJS";
    CurrencyCode["Tmt"] = "TMT";
    CurrencyCode["Tnd"] = "TND";
    CurrencyCode["Top"] = "TOP";
    CurrencyCode["Try"] = "TRY";
    CurrencyCode["Ttd"] = "TTD";
    CurrencyCode["Tvd"] = "TVD";
    CurrencyCode["Twd"] = "TWD";
    CurrencyCode["Tzs"] = "TZS";
    CurrencyCode["Uah"] = "UAH";
    CurrencyCode["Ugx"] = "UGX";
    CurrencyCode["Usd"] = "USD";
    CurrencyCode["Uyu"] = "UYU";
    CurrencyCode["Uzs"] = "UZS";
    CurrencyCode["Vef"] = "VEF";
    CurrencyCode["Vnd"] = "VND";
    CurrencyCode["Vuv"] = "VUV";
    CurrencyCode["Wst"] = "WST";
    CurrencyCode["Xaf"] = "XAF";
    CurrencyCode["Xcd"] = "XCD";
    CurrencyCode["Xdr"] = "XDR";
    CurrencyCode["Xof"] = "XOF";
    CurrencyCode["Xpf"] = "XPF";
    CurrencyCode["Yer"] = "YER";
    CurrencyCode["Zar"] = "ZAR";
    CurrencyCode["Zmw"] = "ZMW";
    CurrencyCode["Zwd"] = "ZWD";
    return CurrencyCode;
})(CurrencyCode);
const CURRENT_SCRIPT_ATTR = 'data-thn-current';
const CURRENT_SCRIPT_VAR = '__thn_script_src';
const ENCODED_PATHS_KEY = '@@0'; // zero -> sifr -> cypher
const PUBLIC_EXT_VAR = '__thn_public_extension';
const STRINGIFY_REPLACEMENT = '---replaced---';
const SWAPS_VAR = '__thn_swaps';
const SET_PAGE_NAME_VAR = '__thn_page_name';
const NATIVE_NAME_VAR = 'thnnative';
const NATIVE_ENGINE_ID = '480';
const DEFAULT_PROPERTY_DESCRIPTOR = {
    enumerable: true,
    configurable: true,
};
const MEDIA = {
    1: { id: 1, name: 'desktop' },
    2: { id: 2, name: 'mobile' },
    // NOTE: id "3" was deprecated and merged with "2". Therefore, we do not
    // produce "3" values anymore, although they exist historically.
    // 3: { id: 3, name: 'tablet' },
    4: { id: 4, name: 'native' },
};
/**
 * We reset all the CSS properties to "initial" state to avoid styles piercing
 * in the Shadow DOM: https://open-wc.org/guides/knowledge/styling/styles-piercing-shadow-dom/
 *
 * Even when reseting to "initial" state, if the CSS property has an !important mark,
 * then the reseting is defeated and we need to add !important to the reseting too.
 *
 * This example website: https://www.thearca.com/ (property_id 1054897)
 * has an style of: `* { cursor: none !important; }`
 * which defeats our simple `all: initial` reset.
 * Because of this specific case we need to add the !important mark to the cursor CSS prop.
 */
const SHADOW_RESET_CSS = `
:host {
  all: initial;
  cursor: initial !important;
}

* {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
`;

var Device = /*@__PURE__*/(function (Device = {}) {
    Device["Desktop"] = "desktop";
    Device["Mobile"] = "mobile";
    Device["Native"] = "native";
    return Device;
})(Device);

var DiscountCodeKind = /*@__PURE__*/(function (DiscountCodeKind = {}) {
    DiscountCodeKind["Default"] = "default";
    DiscountCodeKind["Promocode"] = "default";
    DiscountCodeKind["Rate"] = "rate";
    DiscountCodeKind["Coupon"] = "coupon";
    DiscountCodeKind["Corpo"] = "corpo";
    DiscountCodeKind["Group"] = "group";
    return DiscountCodeKind;
})(DiscountCodeKind);

var LanguageCode = /*@__PURE__*/(function (LanguageCode = {}) {
    LanguageCode["Abkhazian"] = "ab";
    LanguageCode["Afar"] = "aa";
    LanguageCode["Afrikaans"] = "af";
    LanguageCode["Akan"] = "ak";
    LanguageCode["Albanian"] = "sq";
    LanguageCode["Amharic"] = "am";
    LanguageCode["Arabic"] = "ar";
    LanguageCode["Aragonese"] = "an";
    LanguageCode["Armenian"] = "hy";
    LanguageCode["Assamese"] = "as";
    LanguageCode["Avaric"] = "av";
    LanguageCode["Avestan"] = "ae";
    LanguageCode["Aymara"] = "ay";
    LanguageCode["Azerbaijani"] = "az";
    LanguageCode["Bambara"] = "bm";
    LanguageCode["Bashkir"] = "ba";
    LanguageCode["Basque"] = "eu";
    LanguageCode["Belarusian"] = "be";
    LanguageCode["Bengali"] = "bn";
    LanguageCode["Bihari"] = "bh";
    LanguageCode["Bislama"] = "bi";
    LanguageCode["Bosnian"] = "bs";
    LanguageCode["Breton"] = "br";
    LanguageCode["Bulgarian"] = "bg";
    LanguageCode["Burmese"] = "my";
    LanguageCode["Catalan"] = "ca";
    LanguageCode["Chamorro"] = "ch";
    LanguageCode["Chechen"] = "ce";
    LanguageCode["Chewa"] = "ny";
    LanguageCode["Chinese"] = "zh";
    LanguageCode["ChineseTraditional"] = "zh_TW";
    LanguageCode["Chuvash"] = "cv";
    LanguageCode["Cornish"] = "kw";
    LanguageCode["Corsican"] = "co";
    LanguageCode["Cree"] = "cr";
    LanguageCode["Croatian"] = "hr";
    LanguageCode["Czech"] = "cs";
    LanguageCode["Danish"] = "da";
    LanguageCode["Divehi"] = "dv";
    LanguageCode["Dutch"] = "nl";
    LanguageCode["Dzongkha"] = "dz";
    LanguageCode["English"] = "en";
    LanguageCode["Esperanto"] = "eo";
    LanguageCode["Estonian"] = "et";
    LanguageCode["Ewe"] = "ee";
    LanguageCode["Faroese"] = "fo";
    LanguageCode["Fijian"] = "fj";
    LanguageCode["Finnish"] = "fi";
    LanguageCode["French"] = "fr";
    LanguageCode["Fula"] = "ff";
    LanguageCode["Galician"] = "gl";
    LanguageCode["Georgian"] = "ka";
    LanguageCode["German"] = "de";
    LanguageCode["Greek"] = "el";
    LanguageCode["Greenlandic"] = "gn";
    LanguageCode["Gujarati"] = "gu";
    LanguageCode["Haitian"] = "ht";
    LanguageCode["Hausa"] = "ha";
    LanguageCode["Hebrew"] = "he";
    LanguageCode["Herero"] = "hz";
    LanguageCode["Hindi"] = "hi";
    LanguageCode["Hiri"] = "ho";
    LanguageCode["Hungarian"] = "hu";
    LanguageCode["Interlingua"] = "ia";
    LanguageCode["Indonesian"] = "id";
    LanguageCode["Interlingue"] = "ie";
    LanguageCode["Irish"] = "ga";
    LanguageCode["Igbo"] = "ig";
    LanguageCode["Inupiaq"] = "ik";
    LanguageCode["Ido"] = "io";
    LanguageCode["Icelandic"] = "is";
    LanguageCode["Italian"] = "it";
    LanguageCode["Inuktitut"] = "iu";
    LanguageCode["Japanese"] = "ja";
    LanguageCode["Javanese"] = "jv";
    LanguageCode["Kalaallisut"] = "kl";
    LanguageCode["Kannada"] = "kn";
    LanguageCode["Kanuri"] = "kr";
    LanguageCode["Kashmiri"] = "ks";
    LanguageCode["Kazakh"] = "kk";
    LanguageCode["Khmer"] = "km";
    LanguageCode["Kikuyu"] = "ki";
    LanguageCode["Kinyarwanda"] = "rw";
    LanguageCode["Kirghiz"] = "ky";
    LanguageCode["Komi"] = "kv";
    LanguageCode["Kongo"] = "kg";
    LanguageCode["Korean"] = "ko";
    LanguageCode["Kurdish"] = "ku";
    LanguageCode["Kuanyama"] = "kj";
    LanguageCode["Latin"] = "la";
    LanguageCode["Luxembourgish"] = "lb";
    LanguageCode["Ganda"] = "lg";
    LanguageCode["Limburgish"] = "li";
    LanguageCode["Lingala"] = "ln";
    LanguageCode["Lao"] = "lo";
    LanguageCode["Lithuanian"] = "lt";
    LanguageCode["Luba"] = "lu";
    LanguageCode["Latvian"] = "lv";
    LanguageCode["Manx"] = "gv";
    LanguageCode["Macedonian"] = "mk";
    LanguageCode["Malagasy"] = "mg";
    LanguageCode["Malay"] = "ms";
    LanguageCode["Malayalam"] = "ml";
    LanguageCode["Maltese"] = "mt";
    LanguageCode["Maori"] = "mi";
    LanguageCode["Marathi"] = "mr";
    LanguageCode["Marshallese"] = "mh";
    LanguageCode["Mongolian"] = "mn";
    LanguageCode["Nauru"] = "na";
    LanguageCode["Navajo"] = "nv";
    LanguageCode["NorthNdebele"] = "nd";
    LanguageCode["Nepali"] = "ne";
    LanguageCode["Ndonga"] = "ng";
    LanguageCode["NorwegianBokmal"] = "nb";
    LanguageCode["NorwegianNynorsk"] = "nn";
    LanguageCode["Norwegian"] = "no";
    LanguageCode["Nuosu"] = "ii";
    LanguageCode["SouthNdebele"] = "nr";
    LanguageCode["Occitan"] = "oc";
    LanguageCode["Ojibwe"] = "oj";
    LanguageCode["Old"] = "cu";
    LanguageCode["Oromo"] = "om";
    LanguageCode["Oriya"] = "or";
    LanguageCode["Ossetian"] = "os";
    LanguageCode["Panjabi"] = "pa";
    LanguageCode["Pali"] = "pi";
    LanguageCode["Persian"] = "fa";
    LanguageCode["Polish"] = "pl";
    LanguageCode["Pashto"] = "ps";
    LanguageCode["Portuguese"] = "pt";
    LanguageCode["Quechua"] = "qu";
    LanguageCode["Romansh"] = "rm";
    LanguageCode["Rundi"] = "rn";
    LanguageCode["Romanian"] = "ro";
    LanguageCode["Russian"] = "ru";
    LanguageCode["Sanskrit"] = "sa";
    LanguageCode["Sardinian"] = "sc";
    LanguageCode["Sindhi"] = "sd";
    LanguageCode["Northern"] = "se";
    LanguageCode["Samoan"] = "sm";
    LanguageCode["Sango"] = "sg";
    LanguageCode["Serbian"] = "sr";
    LanguageCode["Scottish"] = "gd";
    LanguageCode["Shona"] = "sn";
    LanguageCode["Sinhala"] = "si";
    LanguageCode["Slovak"] = "sk";
    LanguageCode["Slovene"] = "sl";
    LanguageCode["Somali"] = "so";
    LanguageCode["Sotho"] = "st";
    LanguageCode["Spanish"] = "es";
    LanguageCode["Sundanese"] = "su";
    LanguageCode["Swahili"] = "sw";
    LanguageCode["Swati"] = "ss";
    LanguageCode["Swedish"] = "sv";
    LanguageCode["Tamil"] = "ta";
    LanguageCode["Telugu"] = "te";
    LanguageCode["Tajik"] = "tg";
    LanguageCode["Thai"] = "th";
    LanguageCode["Tigrinya"] = "ti";
    LanguageCode["Tibetan"] = "bo";
    LanguageCode["Turkmen"] = "tk";
    LanguageCode["Tagalog"] = "tl";
    LanguageCode["Tswana"] = "tn";
    LanguageCode["Tonga"] = "to";
    LanguageCode["Turkish"] = "tr";
    LanguageCode["Tsonga"] = "ts";
    LanguageCode["Tatar"] = "tt";
    LanguageCode["Twi"] = "tw";
    LanguageCode["Tahitian"] = "ty";
    LanguageCode["Uighur"] = "ug";
    LanguageCode["Ukrainian"] = "uk";
    LanguageCode["Urdu"] = "ur";
    LanguageCode["Uzbek"] = "uz";
    LanguageCode["Venda"] = "ve";
    LanguageCode["Vietnamese"] = "vi";
    LanguageCode["Volapuk"] = "vo";
    LanguageCode["Walloon"] = "wa";
    LanguageCode["Welsh"] = "cy";
    LanguageCode["Wolof"] = "wo";
    LanguageCode["Western"] = "fy";
    LanguageCode["Xhosa"] = "xh";
    LanguageCode["Yiddish"] = "yi";
    LanguageCode["Yoruba"] = "yo";
    LanguageCode["Zhuang"] = "za";
    LanguageCode["Zulu"] = "zu";
    return LanguageCode;
})(LanguageCode);
var RightToLeftLanguageCode = /*@__PURE__*/(function (RightToLeftLanguageCode = {}) {
    RightToLeftLanguageCode["Arabic"] = "ar";
    RightToLeftLanguageCode["Hebrew"] = "he";
    RightToLeftLanguageCode["Persian"] = "fa";
    RightToLeftLanguageCode["Urdu"] = "ur";
    return RightToLeftLanguageCode;
})(RightToLeftLanguageCode);

var RuleKind = /*@__PURE__*/(function (RuleKind = {}) {
    RuleKind["Targeting"] = "targeting";
    return RuleKind;
})(RuleKind);

const searchDefaultLeadDays = 7;
var ReplayMethod = /*@__PURE__*/(function (ReplayMethod = {}) {
    /** @alias GET */
    ReplayMethod["Url"] = "URL";
    /** @alias POST */
    ReplayMethod["Dom"] = "DOM";
    ReplayMethod["Eval"] = "EVAL";
    return ReplayMethod;
})(ReplayMethod);

var SseEventName = /*@__PURE__*/(function (SseEventName = {}) {
    SseEventName["Demand"] = "data_demand_response";
    SseEventName["Disparity"] = "price_disparity_detected";
    SseEventName["Duetto"] = "duetto_occupancy_recovered";
    SseEventName["Oraculo"] = "oraculo_prediction";
    return SseEventName;
})(SseEventName);

var DiscountSetting = /*@__PURE__*/(function (DiscountSetting = {}) {
    DiscountSetting["DomDiscountInputDispatchEvents"] = "input_fire_event";
    DiscountSetting["DomDiscountSelectDispatchEvents"] = "select_fire_event";
    DiscountSetting["DomDiscountSelectSelector"] = "promocode_select_selector";
    DiscountSetting["DomDiscountSelectValue"] = "promocode_select_value";
    DiscountSetting["DomElementsRequireVisibility"] = "skip_form_invisible";
    DiscountSetting["DomSkip"] = "skip_POST";
    DiscountSetting["DomSubmitDelay"] = "send_form_delay";
    DiscountSetting["DomSubmitSelector"] = "form_button_selector";
    DiscountSetting["DomSubmitSkip"] = "skip_form_submit";
    DiscountSetting["UrlDiscountExtraParams"] = "promocode_extra_params";
    DiscountSetting["UrlSkip"] = "skip_GET";
    DiscountSetting["UrlTarget"] = "replay_url_target";
    return DiscountSetting;
})(DiscountSetting);

var CountdownKind = /*@__PURE__*/(function (CountdownKind = {}) {
    CountdownKind["FixedExpiration"] = "fixed-expiration";
    CountdownKind["DurationPerVisitor"] = "duration-per-visitor";
    return CountdownKind;
})(CountdownKind);

var DayName = /*@__PURE__*/(function (DayName = {}) {
    DayName["Sunday"] = "sunday";
    DayName["Monday"] = "monday";
    DayName["Tuesday"] = "tuesday";
    DayName["Wednesday"] = "wednesday";
    DayName["Thursday"] = "thursday";
    DayName["Friday"] = "friday";
    DayName["Saturday"] = "saturday";
    return DayName;
})(DayName);
var Day = /*@__PURE__*/(function (Day = {}) {
    Day[Day["Sunday"] = 0] = "Sunday";
    Day[Day["Monday"] = 1] = "Monday";
    Day[Day["Tuesday"] = 2] = "Tuesday";
    Day[Day["Wednesday"] = 3] = "Wednesday";
    Day[Day["Thursday"] = 4] = "Thursday";
    Day[Day["Friday"] = 5] = "Friday";
    Day[Day["Saturday"] = 6] = "Saturday";
    return Day;
})(Day);

var EvaluationFrequency = /*@__PURE__*/(function (EvaluationFrequency = {}) {
    /**
       * Show the tool once per page view.
       */
    EvaluationFrequency["OncePerPage"] = "once-per-page";
    /**
       * Show the tool only once per session on a given Site.
       */
    EvaluationFrequency["OncePerSession"] = "once-per-session";
    /**
       * Show the tool only once per session across any Site.
       */
    EvaluationFrequency["OncePerSessionCrossSite"] = "once-per-session-cross-site";
    /**
       * Show the tool only once per visitor on a given Site.
       */
    EvaluationFrequency["OncePerVisitor"] = "once-per-visitor";
    /**
       * Show the tool only once per visitor on a cross any Site.
       */
    EvaluationFrequency["OncePerVisitorCrossSite"] = "once-per-visitor-cross-site";
    return EvaluationFrequency;
})(EvaluationFrequency);

var ReferenceTimezone = /*@__PURE__*/(function (ReferenceTimezone = {}) {
    ReferenceTimezone["Site"] = "site";
    ReferenceTimezone["Visitor"] = "visitor";
    return ReferenceTimezone;
})(ReferenceTimezone);

var RetargetingPage = /*@__PURE__*/(function (RetargetingPage = {}) {
    RetargetingPage[RetargetingPage["Any"] = 0] = "Any";
    RetargetingPage[RetargetingPage["Home"] = 1] = "Home";
    RetargetingPage[RetargetingPage["Calendar"] = 2] = "Calendar";
    RetargetingPage[RetargetingPage["RoomsAndRates"] = 3] = "RoomsAndRates";
    RetargetingPage[RetargetingPage["UserRegisterPage"] = 4] = "UserRegisterPage";
    RetargetingPage[RetargetingPage["BookingConfirmed"] = 5] = "BookingConfirmed";
    return RetargetingPage;
})(RetargetingPage);

var CredentialsRealm = /*@__PURE__*/(function (CredentialsRealm = {}) {
    /** The website own/native credentials system */
    CredentialsRealm["Native"] = "website-own-system";
    /** The THN (aka Instant Login) credentials system */
    CredentialsRealm["Thn"] = "thn-instant-system";
    return CredentialsRealm;
})(CredentialsRealm);
var RuleConfigAbstractVariableRelationalOperation = /*@__PURE__*/(function (RuleConfigAbstractVariableRelationalOperation = {}) {
    RuleConfigAbstractVariableRelationalOperation["ValueIsNotEqual"] = "not-equal";
    RuleConfigAbstractVariableRelationalOperation["ValueIsEqual"] = "equal";
    RuleConfigAbstractVariableRelationalOperation["ValueIsNotEmpty"] = "not-empty";
    RuleConfigAbstractVariableRelationalOperation["ValueIsEmpty"] = "empty";
    RuleConfigAbstractVariableRelationalOperation["ValueIsLowerThan"] = "lower-than";
    RuleConfigAbstractVariableRelationalOperation["ValueIsGreaterThan"] = "greater-than";
    RuleConfigAbstractVariableRelationalOperation["ValueDoesContain"] = "contain";
    RuleConfigAbstractVariableRelationalOperation["ValueDoesNotContain"] = "not-contain";
    return RuleConfigAbstractVariableRelationalOperation;
})(RuleConfigAbstractVariableRelationalOperation);
var RuleConfigCondition = /*@__PURE__*/(function (RuleConfigCondition = {}) {
    RuleConfigCondition["ShouldInclude"] = "include";
    RuleConfigCondition["ShouldExclude"] = "exclude";
    return RuleConfigCondition;
})(RuleConfigCondition);
var RuleConfigRelationalOperation = /*@__PURE__*/(function (RuleConfigRelationalOperation = {}) {
    RuleConfigRelationalOperation["Between"] = "between";
    RuleConfigRelationalOperation["Contain"] = "contain";
    RuleConfigRelationalOperation["Equal"] = "equal";
    RuleConfigRelationalOperation["GreaterThan"] = "greater-than";
    RuleConfigRelationalOperation["LessThan"] = "less-than";
    return RuleConfigRelationalOperation;
})(RuleConfigRelationalOperation);
var OraculoSemanticLayer = /*@__PURE__*/(function (OraculoSemanticLayer = {}) {
    OraculoSemanticLayer["Intent"] = "intent";
    OraculoSemanticLayer["Spend"] = "spend";
    OraculoSemanticLayer["DestinationFlexibility"] = "destinationFlexibility";
    OraculoSemanticLayer["DateFlexibility"] = "dateFlexibility";
    OraculoSemanticLayer["Nights"] = "nights";
    return OraculoSemanticLayer;
})(OraculoSemanticLayer);
var RulesConfigProp = /*@__PURE__*/(function (RulesConfigProp = {}) {
    RulesConfigProp["DatalayerVariables"] = "datalayerVariables";
    RulesConfigProp["StayDemand"] = "stayDemand";
    RulesConfigProp["StayDuettoDemand"] = "stayDuettoDemand";
    RulesConfigProp["StayAvailability"] = "stayAvailability";
    RulesConfigProp["StayDates"] = "stayDates";
    RulesConfigProp["StayDays"] = "stayDays";
    RulesConfigProp["StayDaysUntilCheckIn"] = "stayDaysUntilCheckIn";
    RulesConfigProp["StayDisparities"] = "stayDisparities";
    RulesConfigProp["StayLength"] = "stayLength";
    RulesConfigProp["StayOccupancyAdults"] = "stayOccupancyAdults";
    RulesConfigProp["StayOccupancyChildren"] = "stayOccupancyChildren";
    RulesConfigProp["StayOccupancyRooms"] = "stayOccupancyRooms";
    RulesConfigProp["StayTotalCost"] = "stayTotalCost";
    RulesConfigProp["TrafficSource"] = "trafficSource";
    RulesConfigProp["UrlVariables"] = "urlVariables";
    RulesConfigProp["VisitDates"] = "visitDates";
    RulesConfigProp["VisitDays"] = "visitDays";
    RulesConfigProp["VisitHours"] = "visitHours";
    RulesConfigProp["VisitorDaysSincePreviousVisit"] = "visitorDaysSincePreviousVisit";
    RulesConfigProp["VisitorFunnelProgress"] = "visitorFunnelProgress";
    RulesConfigProp["VisitorGeolocation"] = "visitorGeolocation";
    RulesConfigProp["VisitorOraculoScore"] = "visitorOraculoScore";
    RulesConfigProp["VisitorPreviousVisitsCount"] = "visitorPreviousVisitsCount";
    RulesConfigProp["VisitorStatus"] = "visitorStatus";
    return RulesConfigProp;
})(RulesConfigProp);

var Scope = /*@__PURE__*/(function (Scope = {}) {
    /** eq to old chain tools */
    Scope["CrossSite"] = "cross-site";
    /** eq to old property tools */
    Scope["Site"] = "site";
    return Scope;
})(Scope);

var SocialDomain = /*@__PURE__*/(function (SocialDomain = {}) {
    SocialDomain["Facebook"] = "facebook";
    SocialDomain["Google"] = "google";
    SocialDomain["Instagram"] = "instagram";
    SocialDomain["Kayak"] = "kayak";
    SocialDomain["TripAdvisor"] = "tripadvisor";
    SocialDomain["Trivago"] = "trivago";
    SocialDomain["Twitter"] = "twitter";
    return SocialDomain;
})(SocialDomain);
var NostromoPage = /*@__PURE__*/(function (NostromoPage = {}) {
    NostromoPage["Home"] = "home";
    NostromoPage["Calendar"] = "calendar";
    NostromoPage["RoomsAndRates"] = "room";
    NostromoPage["UserRegisterPage"] = "register";
    NostromoPage["BookingConfirmed"] = "confirmed";
    return NostromoPage;
})(NostromoPage);
var NostromoAvailabilityType = /*@__PURE__*/(function (NostromoAvailabilityType = {}) {
    NostromoAvailabilityType["Custom"] = "custom";
    NostromoAvailabilityType["SoldOut"] = "soldOut";
    NostromoAvailabilityType["NotSoldOut"] = "notSoldOut";
    return NostromoAvailabilityType;
})(NostromoAvailabilityType);

var TriggerKind = /*@__PURE__*/(function (TriggerKind = {}) {
    TriggerKind["Idle"] = "on-idle";
    TriggerKind["Load"] = "on-load";
    TriggerKind["Scroll"] = "on-scroll";
    return TriggerKind;
})(TriggerKind);

var UriSchema = /*@__PURE__*/(function (UriSchema = {}) {
    UriSchema["Http"] = "http";
    UriSchema["Mailto"] = "mailto";
    UriSchema["Tel"] = "tel";
    return UriSchema;
})(UriSchema);

var ActivityKind = /*@__PURE__*/(function (ActivityKind = {}) {
    ActivityKind["Action"] = "action";
    /** @deprecated */
    ActivityKind["Engage"] = "click";
    /** @deprecated */
    ActivityKind["Dismiss"] = "close";
    return ActivityKind;
})(ActivityKind);

var PriceStatus = /*@__PURE__*/(function (PriceStatus = {}) {
    PriceStatus["Ok"] = "widget-ok";
    PriceStatus["WithoutAvailability"] = "no-rooms";
    // TODO: complete with other status values as needed
    return PriceStatus;
})(PriceStatus);
var PriceNightConfig = /*@__PURE__*/(function (PriceNightConfig = {}) {
    PriceNightConfig[PriceNightConfig["PerStay"] = 0] = "PerStay";
    PriceNightConfig[PriceNightConfig["PerNight"] = 1] = "PerNight";
    PriceNightConfig[PriceNightConfig["PerPerson"] = 2] = "PerPerson";
    PriceNightConfig[PriceNightConfig["PerAdult"] = 3] = "PerAdult";
    return PriceNightConfig;
})(PriceNightConfig);
var SearchPriceSpecial = /*@__PURE__*/(function (SearchPriceSpecial = {}) {
    /**
     * The cheapest normal available price (usually would be the BAR).
     */
    SearchPriceSpecial[SearchPriceSpecial["None"] = 0] = "None";
    /**
     * Any other thing that it is not the cheapest "normal" available price.
     * Id est, anthing that is sensitive to produces a _not real_ disparity.
     */
    SearchPriceSpecial[SearchPriceSpecial["Generic"] = 1] = "Generic";
    /**
     * The price is special because it is influenced by discount.
     */
    SearchPriceSpecial[SearchPriceSpecial["Discount"] = 2] = "Discount";
    return SearchPriceSpecial;
})(SearchPriceSpecial);
var SearchPriceType = /*@__PURE__*/(function (SearchPriceType = {}) {
    /**
     * The price amount does not include taxes.
     */
    SearchPriceType["WithoutTaxes"] = "base";
    /**
     * The price amount does include taxes.
     */
    SearchPriceType["WithTaxes"] = "full";
    return SearchPriceType;
})(SearchPriceType);

class AbortError extends Error {
    constructor(message = 'Aborted') {
        super(message);
        this.name = 'AbortError';
    }
}

class TimeoutError extends Error {
    constructor(message) {
        super(message);
        this.name = 'TimeoutError';
    }
}

// TODO: most of the type declarations must be moved from the AbortablePromise class
// to the AbortablePromiseLike interface
class AbortablePromise extends Promise$1 {
    /**
     * Creates an AbortablePromise that is resolved with an array of results when all of the provided Promises
     * resolve, or rejected when any Promise is rejected.
     * @param values An array of Promises.
     * @returns A new AbortablePromise.
     */
    static all(values) {
        return AbortablePromise.from(Promise$1.all(values));
    }
    /**
     * Creates an AbortablePromise that is resolved or rejected when the provided Promise is resolved
     * or rejected.
     * @param promise A Promise.
     * @returns A new AbortablePromise.
     */
    static from(promise, options) {
        // If promise is already an AbortablePromise, return it directly
        if (promise instanceof AbortablePromise) {
            return promise;
        }
        return new AbortablePromise((resolve, reject) => {
            promise.then(resolve).catch(reject);
        }, options);
    }
    /**
     * Creates an AbortablePromise that is resolved or rejected when any of the provided Promises are resolved
     * or rejected.
     * @param values An array of Promises.
     * @returns A new AbortablePromise.
     */
    static race(values) {
        return AbortablePromise.from(Promise$1.race(values));
    }
    /**
     * Creates a new rejected AbortablePromise for the provided reason.
     * @param reason The reason the promise was rejected.
     * @returns A new rejected AbortablePromise.
     */
    static reject(reason) {
        return AbortablePromise.from(Promise$1.reject(reason));
    }
    static resolve(value) {
        if (value) {
            return AbortablePromise.from(Promise$1.resolve(value));
        }
        return AbortablePromise.from(Promise$1.resolve());
    }
    abort;
    get abortReason() {
        return this.abortReasonValue;
    }
    clear;
    abortReasonValue;
    settled = false;
    /**
     * Creates a new AbortablePromise.
     * @param executor A callback used to initialize the AbortalePromise. This callback is passed two arguments:
     * a resolve callback used to resolve the promise with a value or the result of another promise,
     * and a reject callback used to reject the promise with a provided reason or error.
     * @param options?
     */
    constructor(executor, options = {}) {
        let timer;
        const abortController = new AbortController();
        const abortSignal = abortController.signal;
        const normalExecutor = (resolveOriginal, rejectOriginal) => {
            const { milliseconds = Number.POSITIVE_INFINITY, fallback, message, } = options?.timeout || {};
            const resolve = (value) => {
                this.clear();
                resolveOriginal(value);
            };
            const reject = (reason) => {
                this.clear();
                rejectOriginal(reason);
            };
            abortSignal.addEventListener('abort', () => {
                reject(new AbortError(this.abortReason));
            });
            if (!executor) {
                return;
            }
            if (typeof milliseconds !== 'number' || Math.sign(milliseconds) !== 1) {
                throw new TypeError(`Expected \`milliseconds\` to be a positive number, got \`${milliseconds}\``);
            }
            executor(resolve, reject, abortSignal);
            if (milliseconds === Number.POSITIVE_INFINITY) {
                return;
            }
            timer = setTimeout(() => {
                if (fallback) {
                    try {
                        resolve(fallback());
                    }
                    catch (error) {
                        reject(error);
                    }
                    return;
                }
                const errorMessage = typeof message === 'string' ? message : `Promise timed out after ${milliseconds} milliseconds`;
                const timeoutError = message instanceof Error ? message : new TimeoutError(errorMessage);
                reject(timeoutError);
                abortController.abort();
            }, milliseconds);
        };
        super(normalExecutor);
        this.abort = (reason) => {
            if (!this.settled) {
                this.abortReasonValue = reason || 'Aborted';
                abortController.abort();
            }
        };
        this.clear = () => {
            if (timer) {
                clearTimeout(timer);
                timer = undefined;
            }
            this.settled = true;
        };
    }
    then(onfulfilled, onrejected) {
        return super.then(onfulfilled, onrejected);
    }
    catch(onrejected) {
        return super.catch(onrejected);
    }
}

var stringCamelCase = camelCase$1;

// any combination of spaces and punctuation characters
// thanks to http://stackoverflow.com/a/25575009
var wordSeparatorsRegEx = /[\s\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,\-.\/:;<=>?@\[\]^_`{|}~]+/;

var basicCamelRegEx = /^[a-z\u00E0-\u00FCA-Z\u00C0-\u00DC][\d|a-z\u00E0-\u00FCA-Z\u00C0-\u00DC]*$/;
var fourOrMoreConsecutiveCapsRegEx = /([A-Z\u00C0-\u00DC]{4,})/g;
var allCapsRegEx = /^[A-Z\u00C0-\u00DC]+$/;

function camelCase$1(str) {
  var words = str.split(wordSeparatorsRegEx);
  var len = words.length;
  var mappedWords = new Array(len);
  for (var i = 0; i < len; i++) {
    var word = words[i];
    if (word === '') {
      continue;
    }
    var isCamelCase = basicCamelRegEx.test(word) && !allCapsRegEx.test(word);
    if (isCamelCase) {
      word = word.replace(fourOrMoreConsecutiveCapsRegEx, function(match, p1, offset) {
        return deCap(match, word.length - offset - match.length == 0);
      });
    }
    var firstLetter = word[0];
    firstLetter = i > 0 ? firstLetter.toUpperCase() : firstLetter.toLowerCase();
    mappedWords[i] = firstLetter + (!isCamelCase ? word.slice(1).toLowerCase() : word.slice(1));
  }
  return mappedWords.join('');
}

function deCap(match, endOfWord) {
  var arr = match.split('');
  var first = arr.shift().toUpperCase();
  var last = endOfWord ? arr.pop().toLowerCase() : arr.pop();
  return first + arr.join('').toLowerCase() + last;
}

var stringCapitalize = capitalize;

/*
  capitalize('capitals'); // 'Capitals'
  capitalize('Capitals'); // 'Capitals'
  capitalize('CapiTALS'); // 'Capitals'
  capitalize('many Words'); // 'Many words'
  capitalize('!exclaim'); // '!exclaim'
*/

function capitalize(str) {
  if (typeof str != 'string') {
    throw Error('just-capitalize expects a string argument');
  }
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

var collectionClone = clone;

/*
  Deep clones all properties except functions

  var arr = [1, 2, 3];
  var subObj = {aa: 1};
  var obj = {a: 3, b: 5, c: arr, d: subObj};
  var objClone = clone(obj);
  arr.push(4);
  subObj.bb = 2;
  obj; // {a: 3, b: 5, c: [1, 2, 3, 4], d: {aa: 1}}
  objClone; // {a: 3, b: 5, c: [1, 2, 3], d: {aa: 1, bb: 2}}
*/

function clone(obj) {
  let result = obj;
  var type = {}.toString.call(obj).slice(8, -1);
  if (type == 'Set') {
    return new Set([...obj].map(value => clone(value)));
  }
  if (type == 'Map') {
    return new Map([...obj].map(kv => [clone(kv[0]), clone(kv[1])]));
  }
  if (type == 'Date') {
    return new Date(obj.getTime());
  }
  if (type == 'RegExp') {
    return RegExp(obj.source, getRegExpFlags(obj));
  }
  if (type == 'Array' || type == 'Object') {
    result = Array.isArray(obj) ? [] : {};
    for (var key in obj) {
      // include prototype properties
      result[key] = clone(obj[key]);
    }
  }
  // primitives and non-supported objects (e.g. functions) land here
  return result;
}

function getRegExpFlags(regExp) {
  if (typeof regExp.source.flags == 'string') {
    return regExp.source.flags;
  } else {
    var flags = [];
    regExp.global && flags.push('g');
    regExp.ignoreCase && flags.push('i');
    regExp.multiline && flags.push('m');
    regExp.sticky && flags.push('y');
    regExp.unicode && flags.push('u');
    return flags.join('');
  }
}

var functionMemoize = memoize$1;

/*
  const sumByOne = memoize(function(value) {
    return value + 1;
  });

  sumByOne(10);
  sumByOne(10); -- Cache hit!

  sumByOne(20);
  sumByOne(20); -- Cache hit!

  // Custom cache
  var sum = memoize(function(a, b) {
    return a + b
  }, function(a, b) {
    return `${a}-${b}`
  })

  sum(10, 10)
  sum(10, 20)
  sum(10, 20) -- Cache hit!
*/

function memoize$1(callback, resolver) {
  if (typeof callback !== 'function') {
    throw new Error('`callback` should be a function');
  }

  if (resolver !== undefined && typeof resolver !== 'function') {
    throw new Error('`resolver` should be a function');
  }

  var cache = {};

  var memoized = function() {
    var args = Array.prototype.slice.call(arguments); // to simplify JSON.stringify
    var key = resolver ? resolver.apply(this, args) : JSON.stringify(args);

    if (!(key in cache)) {
      cache[key] = callback.apply(this, args);
    }

    return cache[key];
  };

  memoized.cache = cache;

  return memoized;
}

var objectExtend = extend;

/*
  var obj = {a: 3, b: 5};
  extend(obj, {a: 4, c: 8}); // {a: 4, b: 5, c: 8}
  obj; // {a: 4, b: 5, c: 8}

  var obj = {a: 3, b: 5};
  extend({}, obj, {a: 4, c: 8}); // {a: 4, b: 5, c: 8}
  obj; // {a: 3, b: 5}

  var arr = [1, 2, 3];
  var obj = {a: 3, b: 5};
  extend(obj, {c: arr}); // {a: 3, b: 5, c: [1, 2, 3]}
  arr.push(4);
  obj; // {a: 3, b: 5, c: [1, 2, 3, 4]}

  var arr = [1, 2, 3];
  var obj = {a: 3, b: 5};
  extend(true, obj, {c: arr}); // {a: 3, b: 5, c: [1, 2, 3]}
  arr.push(4);
  obj; // {a: 3, b: 5, c: [1, 2, 3]}

  extend({a: 4, b: 5}); // {a: 4, b: 5}
  extend({a: 4, b: 5}, 3); {a: 4, b: 5}
  extend({a: 4, b: 5}, true); {a: 4, b: 5}
  extend('hello', {a: 4, b: 5}); // throws
  extend(3, {a: 4, b: 5}); // throws
*/

function extend(/* [deep], obj1, obj2, [objn] */) {
  var args = [].slice.call(arguments);
  var deep = false;
  if (typeof args[0] == 'boolean') {
    deep = args.shift();
  }
  var result = args[0];
  if (isUnextendable(result)) {
    throw new Error('extendee must be an object');
  }
  var extenders = args.slice(1);
  var len = extenders.length;
  for (var i = 0; i < len; i++) {
    var extender = extenders[i];
    for (var key in extender) {
      if (Object.prototype.hasOwnProperty.call(extender, key)) {
        var value = extender[key];
        if (deep && isCloneable(value)) {
          var base = Array.isArray(value) ? [] : {};
          result[key] = extend(
            true,
            Object.prototype.hasOwnProperty.call(result, key) && !isUnextendable(result[key])
              ? result[key]
              : base,
            value
          );
        } else {
          result[key] = value;
        }
      }
    }
  }
  return result;
}

function isCloneable(obj) {
  return Array.isArray(obj) || {}.toString.call(obj) == '[object Object]';
}

function isUnextendable(val) {
  return !val || (typeof val != 'object' && typeof val != 'function');
}

var stringSnakeCase = snakeCase;

/*
  snakeCase('the quick brown fox'); // 'the_quick_brown_fox'
  snakeCase('the-quick-brown-fox'); // 'the_quick_brown_fox'
  snakeCase('the_quick_brown_fox'); // 'the_quick_brown_fox'
  snakeCase('theQuickBrownFox'); // 'the_quick_brown_fox'
  snakeCase('theQuickBrown Fox'); // 'the_quick_brown_Fox'
  snakeCase('thequickbrownfox'); // 'thequickbrownfox'
  snakeCase('the - quick * brown# fox'); // 'the_quick_brown_fox'
  snakeCase('theQUICKBrownFox'); // 'the_q_u_i_c_k_brown_fox'
*/

// any combination of spaces and punctuation characters
// thanks to http://stackoverflow.com/a/25575009
var wordSeparators = /[\s\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,\-.\/:;<=>?@\[\]^_`{|}~]+/;
var capitals = /[A-Z\u00C0-\u00D6\u00D9-\u00DD]/g;

function snakeCase(str) {
  //replace capitals with space + lower case equivalent for later parsing
  str = str.replace(capitals, function(match) {
    return ' ' + (match.toLowerCase() || match);
  });
  return str
    .trim()
    .split(wordSeparators)
    .join('_');
}

const { isArray } = Array;

function baseIsPrimitive(kindOrPredicate) {
    const isKind = typeof kindOrPredicate === 'string';
    return function baseIsPrimitiveOfKind(tag) {
        return function baseIsPrimitiveOfKindTag(value) {
            const t = typeof value;
            return (isKind && t === kindOrPredicate)
                || (!isKind && kindOrPredicate && kindOrPredicate(value))
                || (t === 'object'
                    && ((isArray(tag) && tag.includes(Object.prototype.toString.call(value)))
                        || Object.prototype.toString.call(value) === tag));
        };
    };
}

const isArguments = /* #__PURE__ */ baseIsPrimitive()([
    '[object Arguments]',
]);

const isBoolean = /* #__PURE__ */ baseIsPrimitive('boolean')('[object Boolean]');

/**
 * Checks if an object has a set of required keys on its first level
 *
 * @param An object (not a primitive)
 * @param An array of required props or a single prop that the object must have.
 */
function has$1(value, props) {
    if (!Array.isArray(props)) {
        return has$1(value, [props]);
    }
    if (Object(value) !== value) {
        return false;
    }
    return props.every((prop) => Object.prototype.hasOwnProperty.call(value, prop));
}

const tag = '[object Object]';
function isPlainObject(value) {
    const type = typeof value;
    return type === 'object'
        && Object.prototype.toString.call(value) === tag;
}

const isContainer = (value) => isPlainObject(value) && has$1(value, ['$decorator', '$register', '$list']);

const isDate = /* #__PURE__ */ baseIsPrimitive()([
    '[object Date]',
]);

const isString = /* #__PURE__ */ baseIsPrimitive('string')('[object String]');

const isError = /* #__PURE__ */ baseIsPrimitive((value) => (!!(value && typeof value === 'object' && 'message' in value && isString(value.message) && 'name' in value && isString(value.name) && !isPlainObject(value))))([
    '[object Error]',
    '[object DOMException]',
]);

const isFunction = /* #__PURE__ */ baseIsPrimitive('function')([
    '[object AsyncFunction]',
    '[object Function]',
    '[object GeneratorFunction]',
    '[object Proxy]',
]);

function isGlobalThis(value) {
    return value === globalThis;
}

function isNull(value) {
    return value === null;
}

const isElement = (value) => value != null && typeof value === 'object' && value.nodeType === 1 && !isPlainObject(value);

/* eslint-disable */
/**
 * Warning: this module is included "as-is" on Loader.
 * Because of that It uses older JS syntax.
 */
var isNative = /* #__PURE__ */ (function () {
    var toString = null;
    var toStringCandidates = [Object, Function, Number];
    var i = 0;
    while (toString === null && i < toStringCandidates.length) {
        toString = toStringCandidates[i].prototype.toString;
        if (String(toString).indexOf('native') === -1) {
            toString = null;
            i += 1;
        }
    }
    var fnToString = Function.prototype.toString;
    var reHostCtor = /^\[object .+?Constructor\]$/;
    var reNative = RegExp('^' +
        String(toString)
            .replace(/[.*+?^${}()|[\]\/\\]/g, '\\$&')
            .replace(/toString|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
    var isNative = toString === null ?
        function isNative(value) { return true; } :
        function isNative(value) {
            var type = typeof value;
            return type == 'function'
                // Use `Function#toString` to bypass the value's own `toString` method
                // and avoid being faked out.
                ? reNative.test(fnToString.call(value))
                // Fallback to a host object check because some environments will represent
                // things like typed arrays as DOM methods which may not conform to the
                // normal native pattern.
                : (value && type == 'object' && reHostCtor.test(toString.call(value))) || false;
        };
    return isNative;
}());

const isNumber = /* #__PURE__ */ baseIsPrimitive('number')('[object Number]');

function isNumeric(n) {
    return !Number.isNaN(parseFloat(n)) && Number.isFinite(Number(n));
}

function isPromiseLike(value) {
    if (value instanceof globalThis.Promise) {
        return true;
    }
    return typeof value === 'object'
        && value
        && (isFunction(value.then)
            || has$1(value, ['isFulfilled', 'isRejected']));
}

function isUndefined(value) {
    // eslint-disable-next-line no-void
    return value === void 0;
}

const isWindow = /* #__PURE__ */ baseIsPrimitive()([
    // Safari returns DOMWindow
    '[object DOMWindow]',
    // Chrome returns global
    '[object global]',
    // Firefox, Opera & IE9 return Window
    '[object Window]',
]);

/**
 * Add days to a date.
 *
 * @param {string|Date} from - The from date (if an string, THN format is expected: yyyy/mm/dd)
 * @param {number} days - The number of days to add.
 * @param {bool} [utc=false] - Return the Date converted to UTC.
 * @return {Date}
 */
const addDays = (from, days, utc = false) => {
    let copy;
    let sourceIsDate = false;
    if (typeof from === 'string') {
        // it is a THN date string yyyy/mm/dd
        const dateParts = from.split(/\W+/);
        const [year, month, day] = dateParts.map((dateEl) => Number(dateEl));
        copy = new Date(Date.UTC(year, month - 1, day));
    }
    else {
        // Copy the from date
        copy = new Date(from.getTime());
        sourceIsDate = true;
    }
    /* eslint-disable no-restricted-globals */
    const valid = copy instanceof Date && !isNaN(Number(copy));
    /* eslint-enable no-restricted-globals */
    if (!valid) {
        throw new Error('Invalid Date');
    }
    // Set the new date the given days forward
    if (days) {
        if (!days) {
            throw new Error(`Error in parameter days (${days})`);
        }
        else {
            copy.setTime(copy.getTime() + days * 24 * 60 * 60 * 1000);
        }
    }
    // only makes sense to shift towars UTC if the source data is a Date
    if (utc && sourceIsDate) {
        copy.setMinutes(copy.getMinutes() + copy.getTimezoneOffset());
    }
    // return the date
    return copy;
};

/**
 * Appends to a given URL string any query string parameters existing in current window URL.
 *
 * @param baseLocation - URL, which might contain its own query string params or not.
 * @param rootLocation - URL, usually the root window URL, to grab query params from.
 * @returns Decorated version of `baseLocation` with all current query string params, overriding any previously existing param.
 */
function appendUrlParams(baseLocation, rootLocation) {
    const baseUrl = new URL(baseLocation);
    const rootUrl = new URL(rootLocation);
    rootUrl.searchParams.forEach((value, key) => {
        baseUrl.searchParams.set(key, value);
    });
    return baseUrl.toString();
}

/**
 * Filters a list (array) of objects that contain a given property
 * and returns the value of the property on the last object
 *
 * @param {Array} list - The array of objects.
 * @param {string} property - The name of the property to serach in the objects.
 * @return {*} The value of the property found.
 */
function arrayGet(list, property) {
    const filtered = Array.isArray(list) && list.filter(function (obj) {
        if (obj && typeof obj === 'object' && !Array.isArray(obj)) {
            return property in obj;
        }
        return false;
    });
    if (filtered && filtered.length) {
        return filtered.pop()[property];
    }
    return undefined;
}

/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @returns {Function} Returns the new capped function.
 */
function ary(fn, n) {
    if (!isFunction(fn)) {
        return fn;
    }
    if (n === undefined) {
        n = fn.length;
    }
    return function (...args) {
        return fn.apply(this, args.slice(0, n));
    };
}

function base64ToBytes(base64, as = 'string') {
    const binString = atob(base64);
    const bytes = Uint8Array.from(binString, (m) => m.codePointAt(0));
    return as === 'string' ? new TextDecoder().decode(bytes) : bytes;
}

const p = 'personalization-';
const personalization = [
    'instant-btn',
    'kittchat',
    `${p}inliner`,
    `${p}notify`,
    `${p}popify`,
    'price-widget',
    'review-widget',
];
const agentPkgs = [
    'agent-engines',
    'agent-partnerships',
    'md5',
];
const npmPkgs = [
    'jquery',
    'moment-timezone',
    'vue',
];
const pkgScope = '@thehotelsnetwork/';
const buildScopedPkgName = (pkgName) => `${pkgScope}${pkgName}`;
const addTrailingSlash = (pairs) => pairs
    .flatMap((pair) => [pair, pair.map((pairItem) => `${pairItem}/`)]);
const resolveVersion = (pkgName, pkgVersions, defaultVersion = 'stable') => pkgVersions[pkgName] || defaultVersion;
const buildDefaultImportmap = (origin, pkgVersions = {}) => {
    const buildUrl = (path) => new URL(`/sjs${path}`, origin).toString();
    const pairs = [].concat(npmPkgs.map((pkgName) => [pkgName, buildUrl(`/${pkgName}@${resolveVersion(pkgName, pkgVersions, 'latest')}&bundle`)]), ((pkgName) => [[pkgName, buildUrl(`/${pkgName}@${resolveVersion(pkgName, pkgVersions, 'latest')}&bundle&exports=BrowserClient,Scope,defaultStackParser,getDefaultIntegrations,makeFetchTransport`)]])('@sentry/browser'), agentPkgs.map((pkgName) => {
        const scopedPkgName = buildScopedPkgName(pkgName);
        return [scopedPkgName, buildUrl(`/${scopedPkgName}@${resolveVersion(scopedPkgName, pkgVersions)}&bundle`)];
    }), personalization.map((pkgName) => {
        const scopedPkgName = buildScopedPkgName(pkgName);
        return [scopedPkgName, buildUrl(`/${scopedPkgName}@${resolveVersion(scopedPkgName, pkgVersions)}&external=vue&no-bundle`)];
    }));
    {
        const scopedPkgName = buildScopedPkgName('agent-fingerprint');
        pairs.push([scopedPkgName, buildUrl(`/${scopedPkgName}@${resolveVersion(scopedPkgName, pkgVersions)}&external=@thehotelsnetwork/md5&no-bundle`)]);
    }
    const mainPkgName = buildScopedPkgName('agent-main');
    {
        const externals = pairs.map(([name]) => name).sort((a, b) => b.length - a.length).join(',');
        pairs.push([mainPkgName, buildUrl(`/${mainPkgName}@${resolveVersion(mainPkgName, pkgVersions)}&external=${externals}&no-bundle`)]);
    }
    const imports = Object.fromEntries(addTrailingSlash(pairs));
    imports[mainPkgName] = `${imports[mainPkgName]}/dist/main.js`;
    const extraImports = Object.fromEntries(addTrailingSlash(Object.entries(pkgVersions)
        .filter(([pkgName]) => !has$1(imports, pkgName))
        .map(([pkgName]) => [pkgName, buildUrl(`/${pkgName}@${resolveVersion(pkgName, pkgVersions)}&bundle`)])));
    return {
        imports: Object.assign(imports, extraImports),
    };
};

function bytesToBase64(bytesOrString) {
    const bytes = typeof bytesOrString === 'string' ? new TextEncoder().encode(bytesOrString) : bytesOrString;
    const binString = Array.from(bytes, (x) => String.fromCodePoint(x)).join('');
    return btoa(binString);
}

function camelCase(value) {
    const sanitizedValue = value.replace(/([A-Z])([A-Z]+)([a-z]?)/, (_m, p1, p2, p3) => {
        const word = p3 ? `${p2.slice(0, -1).toLowerCase()}${p2.slice(-1)}` : p2.toLowerCase();
        return `${p1}${word}${p3}`;
    });
    return stringCamelCase(sanitizedValue);
}

/**
 * Wraps a function to avoid its execution if {@link module:lifecycle.page_unload|page_unload} has been called.
 *
 * @param fn - The original function.
 * @return {CancellableFunction<T>} The new function that will not execute after a page_unload() call.
 */
function cancellable(fn) {
    let cancelled = false;
    const wrapped = (...args) => (cancelled ? undefined : fn(...args));
    wrapped.cancel = () => { cancelled = true; };
    return wrapped;
}

const { document: document$2 } = globalThis;
const defaults = {
    iframe: {
        scrolling: 'no',
        frameBorder: '0',
        allowTransparency: 'true',
        seamless: 'seamless',
        style: {
            width: '100%',
            height: '100%',
            background: 'transparent',
            border: '0',
        },
        // Put this title by default on all iframes
        // and override in each widget as needed
        title: 'Advertisement Content',
    },
    style: {
        type: 'text/css',
        crossOrigin: 'anonymous',
    },
    link: {
        rel: 'stylesheet',
        type: 'text/css',
    },
};
const styleToString = (style) => Object.keys(style).map((key) => `${key}:${style[key]}`).join(';');
function createElement(tag, customAttrs = {}, doc = document$2) {
    // get default attributes
    const defaultAttrs = tag in defaults ? defaults[tag] : {};
    // Merge styles
    const defaultStyle = defaultAttrs.style;
    const customStyle = customAttrs.style;
    const finalStyle = { ...defaultStyle, ...customStyle };
    // merge default and custom attributes
    const finalAttrs = {
        ...defaultAttrs,
        ...customAttrs,
        ...(finalStyle && { style: styleToString(finalStyle) }),
    };
    // create the element
    const el = doc.createElement(tag);
    // set the attributes
    Object.entries(finalAttrs).forEach(([key, value]) => {
        if (value) {
            el.setAttribute(key, value);
        }
    });
    // return the element
    return el;
}

/**
 * ECMA standard "date time string format" is: `YYYY-MM-DDTHH:mm:ss.sssZ`
 *
 * Various components can be omitted, so the following are all valid:
 *  - Date-only form: YYYY, YYYY-MM, YYYY-MM-DD
 *  - Date-time form: one of the above date-only forms, followed by T, followed by HH:mm, HH:mm:ss, or HH:mm:ss.sss. Each combination can be followed by a time zone offset.
 * For example, "2011-10-10" (date-only form), "2011-10-10T14:48:00" (date-time form), or "2011-10-10T14:48:00.000+09:00" (date-time form with milliseconds and time zone) are all valid date time strings.
 *
 * When the time zone offset is absent, date-only forms are interpreted as a UTC time and date-time forms are interpreted as a local time. The interpretation as a UTC time is due to a historical spec error that was not consistent with ISO 8601 but could not be changed due to web compatibility.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#date_time_string_format
 */
const interpretedAsUtcRegExp = /(Z|\+00:?00)$|^\d{13}$|^\d{10}$|^\d{4}(-\d{2}(-\d{2}(T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|\+00:?00))?)?)?$/;
const offsetRegExp = /Z$|([+-])(\d{2}):?(\d{2})/;
const detectDateStringOffset = (input) => {
    const inputString = String(input);
    if (interpretedAsUtcRegExp.test(inputString)) {
        return 0;
    }
    const result = inputString.match(offsetRegExp);
    if (!result) {
        return null;
    }
    if (result[0] === 'Z') {
        return 0;
    }
    const sign = result[1];
    const hours = Number(result[2]);
    const minutes = Number(result[3]);
    const total = (hours * 60) + minutes;
    return total && sign === '+' ? (total * -1) : total;
};

/**
 * Converts raw number, string, or Date to a Date object.
 */
const toDate = (input) => {
    const inputAsString = String(input);
    // Check if input is a raw UNIX timestamp (must convert to Date)
    if (inputAsString.match(/^\d{5,}$$/)) {
        if (inputAsString.length === 10) {
            return new Date(Number(inputAsString) * 1000);
        }
        if (inputAsString.length === 13) {
            return new Date(Number(inputAsString));
        }
        return null;
    }
    try {
        return new Date(input);
    }
    catch {
        return null;
    }
};
const dateToString = (input, asUtcOrTimezoneOffset, glue = '/') => {
    let timezoneOffset = 0;
    const date = toDate(input);
    const localOffset = date?.getTimezoneOffset() ?? 0;
    if (isDate(input)) {
        if (isNumber(asUtcOrTimezoneOffset)) {
            timezoneOffset = (asUtcOrTimezoneOffset * -1) + localOffset;
        }
        else if (asUtcOrTimezoneOffset === true) { // asUtc is false by default
            timezoneOffset = localOffset;
        }
    }
    else {
        const inputOffset = detectDateStringOffset(input);
        if (isNumber(inputOffset)) {
            // if there is an offset is in the input, we need to invert it
            const effectiveInputOffset = inputOffset ? (inputOffset * -1) : 0;
            timezoneOffset = effectiveInputOffset + localOffset;
        }
    }
    // Invalid date
    if (!date || Number.isNaN(date.getTime())) {
        return null;
    }
    // apply offset
    date.setMinutes(date.getMinutes() + timezoneOffset);
    return `${date.getFullYear()}${glue}${(`0${date.getMonth() + 1}`).slice(-2)}${glue}${(`0${date.getDate()}`).slice(-2)}`;
};

/**
 * Calc the difference between dates, in days.
 *
 * @param {number|string} rawArrival - a date
 * @param {number|string} rawDeparture - a date
 * @return {number} - Number of days between both dates.
 */
function daysBetween(rawArrival, rawDeparture) {
    let parts;
    let parsedArrival;
    let parsedDeparture;
    let rawArrivalParam = rawArrival;
    let rawDepartureParam = rawDeparture;
    if (typeof rawArrival === 'number') {
        rawArrivalParam = String(rawArrivalParam);
    }
    if (typeof rawDeparture === 'number') {
        rawDepartureParam = String(rawDepartureParam);
    }
    if (typeof rawArrivalParam === 'string') {
        parts = rawArrivalParam.substring(0, 10).split(/[/-]/).map(el => Number(el));
        // it is a THN date string yyyy/mm/dd
        if (parts.length > 2) {
            parsedArrival = new Date(parts[0], parts[1] - 1, parts[2]);
        }
        else { // unixtimestamp
            parts = rawArrivalParam.match(/^\d{10}/)?.map(el => parseInt(el, 10)) || [];
            if (parts?.length) {
                parsedArrival = new Date(parts[0] * 1000);
            }
        }
    }
    else if (rawArrivalParam instanceof Date) {
        // Copy date parts of the timestamps, discarding the time parts.
        parsedArrival = new Date(rawArrivalParam.getFullYear(), rawArrivalParam.getMonth(), rawArrivalParam.getDate());
    }
    if (typeof rawDepartureParam === 'string') {
        parts = rawDepartureParam.substring(0, 10).split(/[/-]/).map(el => Number(el));
        // it is a THN date string yyyy/mm/dd
        if (parts.length > 2) {
            parsedDeparture = new Date(parts[0], parts[1] - 1, parts[2]);
        }
        else { // unixtimestamp
            parts = rawDepartureParam.match(/^\d{10}/)?.map(el => parseInt(el, 10)) || [];
            if (parts?.length) {
                parsedDeparture = new Date(parts[0] * 1000);
            }
        }
    }
    else if (rawDepartureParam instanceof Date) {
        // Copy date parts of the timestamps, discarding the time parts.
        parsedDeparture = new Date(rawDepartureParam.getFullYear(), rawDepartureParam.getMonth(), rawDepartureParam.getDate());
    }
    // Do the math.
    const millirawDeparturesPerDay = 1000 * 60 * 60 * 24;
    if (!parsedArrival || !parsedDeparture) {
        throw new Error('Unable to parse dates.');
    }
    // correct offsets: in case they are in a diferent DST
    parsedArrival.setMinutes(parsedArrival.getMinutes() - parsedArrival.getTimezoneOffset());
    parsedDeparture.setMinutes(parsedDeparture.getMinutes() - parsedDeparture.getTimezoneOffset());
    // diff
    const millisBetween = parsedDeparture.getTime() - parsedArrival.getTime();
    const days = millisBetween / millirawDeparturesPerDay;
    // Use round to avoid some timezone errors in the JS engine
    // (for instance Brazil/East on DST)
    return Math.round(days);
}

function debounceFn(func, wait = 0, options) {
    let lastArgs;
    let lastThis;
    let maxWait;
    let result;
    let timerId;
    let lastCallTime;
    let lastInvokeTime = 0;
    let leading = false;
    let maxing = false;
    let trailing = true;
    if (isPlainObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? Math.max(Number(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        const args = lastArgs;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const thisArg = lastThis;
        lastArgs = undefined;
        lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args || []);
        return result;
    }
    function remainingWait(time) {
        if (lastCallTime === undefined) {
            return wait;
        }
        const timeSinceLastCall = time - lastCallTime;
        const timeSinceLastInvoke = time - lastInvokeTime;
        const waitResult = wait - timeSinceLastCall;
        return maxing ? Math.min(waitResult, (maxWait ?? 0) - timeSinceLastInvoke) : waitResult;
    }
    function shouldInvoke(time) {
        const timeSinceLastCall = time - (lastCallTime ?? 0);
        const timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait)
            || (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= (maxWait ?? 0)));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
            return invokeFunc(time);
        }
        lastArgs = undefined;
        lastThis = undefined;
        return result;
    }
    function timerExpired() {
        const time = Date.now();
        if (shouldInvoke(time)) {
            return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
        return undefined;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function cancel() {
        if (timerId !== undefined) {
            clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = undefined;
        lastCallTime = undefined;
        lastThis = undefined;
        timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge(Date.now());
    }
    function debounced(...args) {
        const time = Date.now();
        const isInvoking = shouldInvoke(time);
        // eslint-disable-next-line prefer-rest-params
        lastArgs = arguments;
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) {
                return leadingEdge(lastCallTime);
            }
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) {
            timerId = setTimeout(timerExpired, wait);
        }
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
const debounce = debounceFn;

/**
 * Logic to delegate an event to a parent node.
 */
function delegateLogic(anchor, eventList, selector, handler, useCapture) {
    if (!anchor) {
        throw new Error('Called on unexistent node');
    }
    const wrapper = function thnDelegationWrapper(event) {
        for (let target = event.target; target && target !== this; target = target.parentElement) {
            // loop parent nodes from the target to the delegation node
            if (target.matches(selector)) {
                handler.call(target, event);
                break;
            }
        }
    };
    eventList.forEach((eventName) => {
        anchor.addEventListener(eventName, wrapper, useCapture);
    });
    return function thnUndelegate() {
        eventList.forEach((eventName) => {
            anchor.removeEventListener(eventName, wrapper, useCapture);
        });
    };
}
/**
 * Normalize the arguments to be passed to the delegate function.
 */
function normalizeArguments(anchorOrEvent, eventsOrSelector, selectorOrHandler, handlerOrUseCapture = false, useCapture = false) {
    let anchor;
    let events;
    let selector;
    let handler;
    let capture;
    if (typeof handlerOrUseCapture === 'function') {
        anchor = anchorOrEvent;
        events = eventsOrSelector;
        selector = selectorOrHandler;
        handler = handlerOrUseCapture;
        capture = useCapture;
    }
    else {
        anchor = globalThis.document;
        events = anchorOrEvent;
        selector = eventsOrSelector;
        handler = selectorOrHandler;
        capture = handlerOrUseCapture;
    }
    if (typeof anchor === 'string') {
        anchor = globalThis.document.querySelector(anchor);
    }
    return [anchor, events.split(/\s*,\s*/), selector, handler, capture];
}
const delegate = (anchorOrEvent, eventsOrSelector, selectorOrHandler, handlerOrUseCapture = false, useCapture = false) => {
    // Normalize the arguments
    const normalized = normalizeArguments(anchorOrEvent, eventsOrSelector, selectorOrHandler, handlerOrUseCapture, useCapture);
    // Call the delegate logic
    return delegateLogic(...normalized);
};

/**
 * PHP's empty equivalent
 *
 * @param {*} mixedVar
 * @return {bool}
 */
function empty(mixedVar) {
    //  discuss at: http://locutus.io/php/empty/
    if (mixedVar === undefined) {
        return true;
    }
    if (mixedVar === null) {
        return true;
    }
    if (mixedVar === false) {
        return true;
    }
    if (mixedVar === 0) {
        return true;
    }
    if (mixedVar === '') {
        return true;
    }
    if (mixedVar === '0') {
        return true;
    }
    if (Number.isNaN(mixedVar)) {
        return true;
    }
    // Instances of HTMLElement, Date are considered as "not-empty"
    // instances of any other object, depending if they have keys
    if (typeof mixedVar === 'object'
        && !isElement(mixedVar)
        && !isDate(mixedVar)) {
        return Object.keys(mixedVar).length === 0;
    }
    return false;
}

/**
 * Check if a given object/array is {@link module:utils.empty|empty}, recursively.
 *
 * @param {*} obj
 * @return {boolean}
 */
function emptyRecursive(obj) {
    return (isArray(obj) || isPlainObject(obj))
        ? Object.keys(obj).every((key) => emptyRecursive(obj[key]))
        : empty(obj);
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function eq(value, other) {
    if (Number.isNaN(value) && Number.isNaN(other)) {
        return true;
    }
    return value === other;
}

function filter$1(collection, predicate) {
    if (!collection
        || typeof collection !== 'object'
        || !isFunction(predicate)) {
        return collection;
    }
    if (isArray(collection)) {
        return collection.filter(predicate);
    }
    return Object.fromEntries(Object.entries(collection).filter(([key, value]) => predicate(value, key, collection)));
}

function flattenObject(value) {
    const result = {};
    function recurse(currentValue, prefix) {
        if (isPlainObject(currentValue)) {
            for (const [key, val] of Object.entries(currentValue)) {
                if (prefix === '') {
                    recurse(val, key);
                }
                else {
                    recurse(val, `${prefix}.${key}`);
                }
            }
        }
        else if (isArray(currentValue)) {
            for (let i = 0; i < currentValue.length; i += 1) {
                recurse((currentValue)[i], `${prefix}[${i}]`);
            }
        }
        else {
            result[prefix] = currentValue;
        }
    }
    recurse(value, '');
    return result;
}

function flow(...funcs) {
    if (funcs.length === 1
        && isArray(funcs[0])) {
        funcs = funcs.pop();
    }
    return function (...args) {
        return funcs.reduce((acc, curr, idx) => curr.apply(this, idx === 0 ? acc : [acc]), args);
    };
}

const generateCallbackQueue = (...args) => {
    if (Array.isArray(args) && args.length === 1 && isFunction(args[0])) {
        return generateCallbackQueue({ callback: args[0], edge: 'trailing' });
    }
    let callbacks = [];
    const defaultCallbacks = {
        leading: [],
        trailing: [],
    };
    args.forEach((arg) => {
        if (isPlainObject(arg) && isFunction(arg.callback)) {
            const edge = arg.edge || 'trailing';
            defaultCallbacks[edge].push(arg.callback);
        }
    });
    return (...extraCallbacks) => {
        // with 1+ arguments: register the callbacks
        if (extraCallbacks.length) {
            extraCallbacks.forEach((extraCallback) => {
                // If its not already in the callback's array
                if (!callbacks.includes(extraCallback) && isFunction(extraCallback)) {
                    callbacks.push(extraCallback);
                }
            });
            return;
        }
        // without arguments: execute all the registered callbacks
        const finalCallbacks = [
            ...defaultCallbacks.leading,
            ...callbacks,
            ...defaultCallbacks.trailing,
        ];
        // clean up
        callbacks = [];
        // pick the first callback
        let currentCallback = finalCallbacks.shift();
        // if exists
        while (currentCallback) {
            try {
                currentCallback();
            }
            catch {
                /* empty */
            }
            finally {
                // pick next one
                currentCallback = finalCallbacks.shift();
            }
        }
    };
};

const CURRENCY_SYMBOLS = {
    AR$: 'ARS',
    '€': 'EUR',
    EURO: 'EUR',
    $: 'USD',
    US$: 'USD',
    'US $': 'USD',
    $US: 'USD',
    '$ US': 'USD',
    U$S: 'USD',
    Kč: 'CZK',
    '£': 'GBP',
    'GBP£': 'GBP',
    POUND: 'GBP',
    Лв: 'BGN',
    лв: 'BGN',
    $CA: 'CAD',
    CA$: 'CAD',
    C$: 'CAD',
    $C: 'CAD',
    'CN¥': 'CNY',
    R$: 'BRL',
    Rp: 'IDR',
    '₹': 'INR',
    '¥': 'JPY',
    HK$: 'HKD',
    Kn: 'HRK',
    MX: 'MXN',
    MX$: 'MXN',
    MXN$: 'MXN',
    $MX: 'MXN',
    $MXN: 'MXN',
    'MX $': 'MXN',
    '$ MX': 'MXN',
    MXP: 'MXN',
    '₱': 'PHP',
    zł: 'PLN',
    '₽': 'RUB',
    S$: 'SGD',
    '฿': 'THB',
    Fr: 'CHF',
    '₪': 'ILS',
    'ש״ח': 'ILS',
    '₩': 'KRW',
    'د.إ': 'AED',
    Ft: 'HUF',
    Kr: 'SEK',
    kr: 'SEK',
    RD$: 'DOP',
    NZ: 'NZD',
    NZ$: 'NZD',
    'NZ $': 'NZD',
    AU: 'AUD',
    AU$: 'AUD',
    A$: 'AUD',
    'AU $': 'AUD',
    '₺': 'TRY',
    TL: 'TRY',
    '₫': 'VND',
    NTD: 'TWD',
    CFA: 'XOF',
    Nkr: 'NOK',
    Dkr: 'DKK',
};
/**
 * This collection represents those TLDs which we may commonly find associated
 * to other 2nd level domains for certain countries or registrar authorities.
 * @see {@link https://en.wikipedia.org/wiki/Second-level_domain}
 */
const POPULAR_TLD = [
    'dz',
    'au',
    'at',
    'br',
    'fr',
    'hu',
    'nz',
    'pk',
    'il',
    'jp',
    'ru',
    'za',
    'kr',
    'es',
    'lk',
    'th',
    'tt',
    'tt',
    'tr',
    'ua',
    'uk',
    'us',
    'zm',
    'ca',
    'nl',
    'yu',
    'rs',
    'me',
    'tv',
    'sg',
    'my',
    'tz',
];

let codesRe;
const search = /[\n\r\s]+/g;
const replace = ' ';
/**
 * Given a symbol, returns the ISO code of the currency.
 *
 * @param text - The input symbol.
 * @return The ISO code of the currency or undefined if unknown.
 */
function getCurrencyCode(text) {
    if (!codesRe) {
        codesRe = new RegExp(`^(${Object.values(CurrencyCode).join('|')})$`, 'i');
    }
    if (!text) {
        return undefined;
    }
    // if the input is a valid ISO code, return it
    // otherwise return the value in the dictionary (undefined if not found)
    // note we replace any consecutive \n\r\s for a single space
    return (text.match(codesRe)
        ? text.toUpperCase()
        : CURRENCY_SYMBOLS[text.replace(search, replace)]);
}

/**
 * Strip whitespace (or other characters) from the beginning and end of a string
 *
 * @param str - The string that will be trimmed.
 * @param characterMask - All characters that you want to be stripped.
 *  Defaults to `\\s\\uFEFF\\xA0`.
 * @return The trimmed string
 */
function trim(str, characterMask = '\\s\\uFEFF\\xA0') {
    return isString(str)
        ? str.replace(new RegExp(`^[${characterMask}]+|[${characterMask}]+$`, 'g'), '')
        : str;
}

/**
 * Gets url search query string. If location hash has query params format, append to search string.
 *
 * @param {string} [urlString=window.location.href] - The URL to work with.
 * @returns {string} - The query string, as a single string with leading `?`
 */
function getQueryString(urlString = globalThis.location?.href?.toString()) {
    try {
        const url = new URL(urlString);
        let queryString = url.search;
        // If the hash is "queryString" like
        if (url.hash.indexOf('=') > 0) {
            const [hashPreQuery, hashPostQuery] = url.hash.split('?');
            const queryStringOnHash = trim(hashPostQuery || hashPreQuery, '#');
            queryString += `${queryString ? '&' : '?'}${queryStringOnHash}`;
        }
        return queryString;
    }
    catch (_e) {
        return '';
    }
}

/**
 * Search the value of a parameter in the query string.
 *
 * @param {string} val - The name of the field to be retrieved.
 * @param {string} [search=window.location.search] - The query string.
 * @param {bool} [first=false] - If true returns the first occurrence found.
 * @return {string}
 */
function parseUrlParameter(val, search = getQueryString(), first = false) {
    let result = '';
    const searchParams = new URLSearchParams(search);
    if (searchParams.has(val)) {
        const values = searchParams.getAll(val);
        result = first ? values[0] : values[values.length - 1];
    }
    return result;
}

/**
 * Get Domain from a URL
 *
 * @param {string} url
 * @return {string}
 */
function getDomain(url) {
    let domain = '';
    if (url !== undefined && url !== '') {
        let tempDomain = url;
        // Strip '//' prefixes and full URL path, if any
        if (url.indexOf('//') >= 0) {
            [, , tempDomain] = url.split('/');
        }
        else {
            [tempDomain] = url.split('/');
        }
        // Checks if host is a IPv4
        if (tempDomain.match(/((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)/g)) {
            domain = tempDomain;
        }
        else {
            // Remove port address, if any
            [tempDomain] = tempDomain.split(':');
            // if more than 2 dot-separated segments are found, we will try to detect popular TLDs
            // usually associated with historical 2nd level domains.
            const domainSegments = tempDomain.split('.');
            if (domainSegments.length >= 3) {
                const [tld, subTld, ...segments] = domainSegments.reverse();
                const couldBe2ndLevelDomain = POPULAR_TLD.some((extension) => extension === tld);
                // As a premise for this algorithm, we assume that if the following segment (sub_tld)
                // is below 4 chars, it is indeed a 2nd-level TLD (.com, .gov, .co, etc) and it is then discarded.
                if (couldBe2ndLevelDomain && subTld.length <= 3) {
                    domain = segments[0];
                }
                else {
                    domain = subTld;
                }
                // If split yields only one segment, then we're most likely against a testing environment such as `localhost`
            }
            else if (domainSegments.length === 1) {
                [domain] = domainSegments;
            }
            else {
                const [domainName] = tempDomain.match(/((?:www\d?\.)?(?:\w[-\w]{0-61}\w|\w)(?:\.\w[-\w]{0-61}\w|\w)*?)\.((?:\w{2-3}\.)?\w+)/gi);
                [domain] = domainName.split('.');
            }
        }
    }
    // If there's no domain, try the "utm_source" param
    if (domain === '') {
        const utmParam = parseUrlParameter('utm_source').toLowerCase();
        if (['tripadvisor'].indexOf(utmParam) !== -1) { // only certain domains (like tripadvisor) are allowed
            domain = utmParam;
        }
    }
    return domain;
}

function get$1(item, propsArg, defaultValue) {
    let obj = item;
    if (!obj) {
        return defaultValue;
    }
    let props;
    let prop;
    if (Array.isArray(propsArg)) {
        props = propsArg.slice(0);
    }
    if (typeof propsArg === 'string') {
        props = propsArg.split(/\.|\[|\]/g).filter(Boolean);
    }
    if (typeof propsArg === 'symbol') {
        props = [propsArg];
    }
    if (!Array.isArray(props)) {
        throw new Error('props arg must be an array, a string or a symbol');
    }
    while (props.length) {
        prop = props.shift();
        if (!obj) {
            return defaultValue;
        }
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        obj = obj[prop];
        if (obj === undefined) {
            return defaultValue;
        }
    }
    return obj;
}

function gt(value, other) {
    return value > other;
}

function gte(value, other) {
    return value >= other;
}

function prototypeCheck(prop) {
    // coercion is intentional to catch prop values like `['__proto__']`
    if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') {
        throw new Error('setting of prototype values not supported');
    }
}
function set$1(target, propsArg, value) {
    let props;
    let obj = target;
    if (Array.isArray(propsArg)) {
        props = propsArg.slice(0);
    }
    if (typeof propsArg === 'string') {
        props = propsArg.split(/\.|\[|\]/g).filter(Boolean);
    }
    if (typeof propsArg === 'symbol') {
        props = [propsArg];
    }
    if (!Array.isArray(props)) {
        throw new Error('props arg must be an array, a string or a symbol');
    }
    const lastProp = props.pop();
    if (!lastProp) {
        return target;
    }
    prototypeCheck(lastProp);
    let thisProp = props.shift();
    try {
        while (thisProp) {
            prototypeCheck(thisProp);
            const nextProp = props.shift();
            // @ts-ignore
            if (typeof obj[thisProp] === 'undefined' || obj[thisProp] === null) {
                // @ts-ignore
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,no-param-reassign
                obj[thisProp] = isNumeric(nextProp) ? [] : {};
            }
            // @ts-ignore
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,no-param-reassign
            obj = obj[thisProp];
            const typeObj = typeof obj;
            if (!obj || !(typeObj === 'object' || typeObj === 'function')) {
                return target;
            }
            thisProp = nextProp;
        }
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,no-param-reassign
        obj[lastProp] = value;
        // eslint-disable-next-line no-empty
    }
    catch (_) { }
    return target;
}

/**
 * AKA monkey-patch
 *
 * Set the value at `path` of `object` to a wrapper function.
 * When that wrapper function is invoked It in turn will
 * invoke `fn` and the original function at `path` (if any).
 * The wrapper function is **not** bound to `object`, binding
 * continues to be set by invokation.
 *
 * The return value is a restoration function. When the
 * restoration function is invoked, the original function
 * at `path` will be set on `object`. If the current value
 * of `path` is not the wrapper function, the restoration
 * will not take place. In that situation you need to pass
 * `{ force: true }` on the restoration invokation to
 * make it happen anyway.
 *
 * **Note:** This method mutates `object`.
 */
function hijack(object, path, fn) {
    const original = get$1(object, path);
    const hijacked = function () {
        fn.apply(this, arguments);
        return isFunction(original)
            ? original.apply(this, arguments)
            : original;
    };
    set$1(object, path, hijacked);
    let restored = false;
    return function ({ force = false } = {}) {
        // When already restored, do nothing more
        if (restored) {
            return restored;
        }
        // Only when the hijacked fn continues in place
        // is safe to restore the original fn
        if (get$1(object, path) === hijacked || force === true) {
            set$1(object, path, original);
            restored = true;
        }
        return restored;
    };
}

function identity$1(value) {
    return value;
}

function inArray(needle, haystack) {
    if (Array.isArray(needle)) { // This is an stupid feature, we should not support it :(
        return needle.filter(function (variable) { return inArray(variable, haystack); }).length > 0;
    }
    return Array.isArray(haystack) && haystack.indexOf(needle) > -1;
}

function invokeFrom(source, object, path, ...args) {
    const candidateFn = get$1(source, path);
    if (isFunction(candidateFn)) {
        // @ts-ignore impossible to satisfy declared return type here
        // eslint-disable-next-line  @typescript-eslint/no-unsafe-return
        return candidateFn.apply(object, args);
    }
    // @ts-ignore impossible to satisfy declared return type here
    return undefined;
}

function invoke(object, path, ...args) {
    // @ts-ignore impossible to satisfy declared return type here
    // eslint-disable-next-line  @typescript-eslint/no-unsafe-return
    return invokeFrom(object, object, path, ...args);
}

/**
  * Detects if the current browser is Internet Explorer or Edge.
 */
function isIe() {
    return !!globalThis.document.documentMode || /Edge/.test(globalThis.navigator.userAgent);
}

function isIframed$1() {
    // check that "self" have not been replaced
    return !!(globalThis.self && globalThis.Window
        && globalThis.self instanceof globalThis.Window
        && globalThis.self !== globalThis.top);
}

const _globalThis = globalThis;
/**
 * Check if the given element is visible using `getComputedStyle`.
 * "Is visible" means that the element (and any ancestor) have
 * the property `display` to value different form `none`
 *  and also it is not hidden.
 *
 * @param {object} element
 * @return {bool}
 */
function isVisible(element, injectedWindow) {
    if (!(isElement(element))) {
        return false;
    }
    const window = isWindow(injectedWindow) ? injectedWindow : _globalThis;
    const elementParam = element;
    const style = window.getComputedStyle?.(elementParam);
    const result = style && style.visibility !== 'hidden' && style.display !== 'none'
        && (!elementParam.parentElement || isVisible(elementParam.parentElement, window));
    return result;
}

function loadScriptFn(urlOrOptions) {
    const options = isString(urlOrOptions)
        ? { url: urlOrOptions, document: globalThis.document } : urlOrOptions;
    const { url, document = globalThis.document, } = options;
    const executor = (resolve, reject) => {
        const script = document.createElement('script');
        script.addEventListener('load', () => {
            script.remove();
            resolve();
        });
        script.addEventListener('error', ( /* err */) => {
            script.remove();
            reject(new Error(`Loading script error: "${url}"`));
        });
        if (!document.head) {
            reject(new Error('Loading script error: no document.head'));
            return null;
        }
        script.src = url;
        document.head.appendChild(script);
        return script;
    };
    return new Promise$1(executor);
}
const loadScript$1 = loadScriptFn;

function lt(value, other) {
    return value < other;
}

function lte(value, other) {
    return value <= other;
}

const map = (collection, iteratee) => {
    if (typeof collection !== 'object'
        || !collection
        || !isFunction(iteratee)) {
        return collection;
    }
    if (isArray(collection)) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return collection.map(iteratee);
    }
    const target = collection;
    const iter = iteratee;
    return Object.keys(target).reduce((acc, key) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const value = iter(target[key], key, target);
        if (!isUndefined(value)) {
            acc[key] = value;
        }
        return acc;
    }, {});
};

function memoize(callback, resolver) {
    const memoized = functionMemoize(callback, resolver);
    memoized.cache.clear = () => {
        Object.keys(memoized.cache).forEach((key) => {
            if (key !== 'clear') {
                // @ts-ignore
                delete memoized.cache[key];
            }
        });
    };
    return memoized;
}

const merge = (obj1, ...objn) => objectExtend(true, obj1, ...objn);

/**
 * Find the "nearest" DOM element that matches the given selector.
 * The big difference with standard "closest" is that it searches
 * in all the DOM tree, not just in the parents hierarchy.
 *
 * @param el - The initial element.
 * @param selector - The search.
 * @param predicate - Extra validation function to be passed foreach found element.
 *
 * @return The nearest element, if any.
 */
function nearest(el, selector, predicate = (value) => !!value) {
    let found = Array.from(el.querySelectorAll(selector)).filter(predicate);
    let elParam = el;
    while (!found.length && elParam?.parentElement) {
        elParam = elParam.parentElement;
        found = Array.from(elParam?.querySelectorAll(selector)).filter(predicate);
    }
    if (!found.length) {
        return null;
    }
    if (found.length === 1) {
        return found[0];
    }
    // return the found element that is
    // closest to its parent
    const distances = found.map((other) => {
        let dist = 0;
        let otherEl = other.parentElement;
        while (otherEl !== elParam && otherEl?.parentElement) {
            dist += 1;
            otherEl = otherEl.parentElement;
        }
        return dist;
    });
    return found[distances.indexOf(Math.min(...distances))];
}

function negate(predicate) {
    return function (...args) {
        return !predicate.apply(this, args);
    };
}

const notEmpty = /* #__PURE__ */ negate(empty);

const defaultOptions$2 = {
    depth: -1,
    first: true,
    isValid: () => true,
    objectLike: false,
};
const objectGet = (target, properties, inputOptions = {}, registry = [], iterationCount = 1) => {
    if (target === undefined || target === null) {
        return undefined;
    }
    const obj = target;
    if (!Array.isArray(properties)) {
        return objectGet(obj, [properties], inputOptions, registry, iterationCount);
    }
    const options = {
        ...defaultOptions$2,
        ...inputOptions,
    };
    // This object has already been checked: avoid infinite recursion
    if (registry.includes(obj)) {
        return undefined;
    }
    // Register the object
    registry.push(obj);
    // Go into the search ...
    let keys = Object.getOwnPropertyNames(obj).filter((key) => key !== 'prototype');
    // On strict mode: remove forbidden properties
    const isStrictMode = (function modeTest() {
        // @ts-ignore
        return !this;
    }());
    if (isStrictMode) {
        keys = keys.filter((k) => !['caller', 'callee', 'arguments'].includes(k));
    }
    let value;
    let key;
    let search;
    let foundValue;
    for (let i = 0; i < keys.length; i += 1) {
        key = keys[i];
        value = obj[key];
        if (properties.indexOf(key) > -1 && options.isValid(value)) {
            foundValue = value;
            if (options.first) {
                return foundValue;
            }
        }
        else if (value
            && (isPlainObject(value) || (options.objectLike && typeof value === 'object'))
            && (iterationCount <= options.depth || options.depth === -1)) {
            search = objectGet(value, properties, options, registry, iterationCount + 1);
            if (search) {
                foundValue = search;
                if (options.first) {
                    return foundValue;
                }
            }
        }
    }
    return foundValue;
};

const MutationObserver = globalThis.MutationObserver || globalThis.WebKitMutationObserver, eventListenerSupported = globalThis.addEventListener;
const defaultMutationObserverInit = {
    childList: true,
    subtree: true,
    characterData: true,
};
const prop = 'thn_mutation_observer';
function stopObserveDom(obj, callback) {
    // not enough arguments
    if (!obj || !callback) {
        return;
    }
    // not observing
    if (!Object.prototype.hasOwnProperty.call(obj, prop)) {
        return;
    }
    if (MutationObserver) {
        obj[prop].disconnect();
        delete obj[prop];
    }
    else if (eventListenerSupported) {
        obj[prop].forEach(function (event) {
            obj.removeEventListener(event, callback, false);
        });
    }
}
function observeDom(obj, callback, mutationObserverInit) {
    // not enough arguments
    if (!obj || !callback) {
        return;
    }
    // if already observing
    if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        // remove the current observers
        stopObserveDom(obj, callback);
        // proceed to replace
    }
    mutationObserverInit = mutationObserverInit || {};
    const options = { ...defaultMutationObserverInit, ...mutationObserverInit };
    if (MutationObserver) {
        // define a new observer and store as a local property of the element
        obj[prop] = new MutationObserver(callback);
        // have the observer observe foo for changes in children
        obj[prop].observe(obj, options);
    }
    else if (eventListenerSupported) {
        const events = [];
        if (options.subtree) {
            events.push('DOMSubtreeModified');
        }
        if (options.attributes) {
            events.push('DOMAttrModified');
        }
        if (options.childList) {
            events.push('DOMNodeInserted');
            events.push('DOMNodeRemoved');
        }
        if (options.characterData) {
            events.push('DOMCharacterDataModified');
        }
        events.forEach(function (event) {
            obj.addEventListener(event, callback, false);
        });
        obj[prop] = events;
    }
}

function omit(collection, props) {
    const effectiveProps = isArray(props) ? props : [props];
    return filter$1(collection, (_item, key) => !effectiveProps.includes(key));
}

const defaultOptions$1 = {
    preserveQueryParams: false,
};
const openLink = (linkUri, windowName, options = {}) => {
    const { document } = globalThis;
    const openLinkOptions = {
        ...defaultOptions$1,
        ...options,
    };
    let href = linkUri;
    if (openLinkOptions.uriSchema === 'http' && openLinkOptions.preserveQueryParams) {
        href = appendUrlParams(linkUri, String(globalThis.location));
    }
    const linkElement = createElement('a', {
        href,
        target: windowName,
        style: {
            display: 'none',
        },
    });
    const eventInitDict = {
        bubbles: true,
        cancelable: false,
        view: globalThis,
        detail: 1,
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        ctrlKey: false,
        altKey: false,
        shiftKey: false,
        metaKey: false,
        button: 0,
        relatedTarget: null,
    };
    document.body.appendChild(linkElement);
    const mousedownEvent = new MouseEvent('mousedown', eventInitDict);
    linkElement.dispatchEvent(mousedownEvent);
    const clickEvent = new MouseEvent('click', eventInitDict);
    linkElement.dispatchEvent(clickEvent);
    linkElement.remove();
};

function baseOver(method) {
    return function over(...args) {
        if (args.length === 1 && Array.isArray(args[0])) {
            const realArgs = args.pop();
            return over(...realArgs);
        }
        return function (value) {
            return args[method]((predicate) => predicate(value));
        };
    };
}

/**
 * Creates a function that checks if **all** of the `predicates` return
 * truthy when invoked with the arguments it receives.
 */
const overEvery = /* #__PURE__ */ baseOver('every');

/**
 * Creates a function that checks if **any** of the `predicates` return
 * truthy when invoked with the arguments it receives.
 */
const overSome = /* #__PURE__ */ baseOver('some');

const uniq = (value) => [...new Set(value)];

/* eslint-disable no-continue */
const price$3 = '[\\d][\\d\\s,.]+';
const currency$2 = '[^\\d\\s,.]+';
const regexp$1 = {
    leading: new RegExp(`(${currency$2})\\s*$`),
    trailing: new RegExp(`^\\s*(${currency$2})`),
};
/**
 * Extract a currency code from a text.
 *
 * @param {string} text - The text to parse.
 * @param {('leading'|'trailing')} [edge='leading'] Search the currency
 *  code before or after _an hypotetic_ price.
 * @return {string|undefined}
 */
function parseCurrency(text, edge = 'leading') {
    if (typeof text !== 'string') {
        return undefined;
    }
    const parts = text.split(new RegExp(price$3));
    const segments = {
        leading: parts ? parts[0] : text,
        trailing: parts ? parts[parts.length - 1] : text,
    };
    let edges = Object.keys(regexp$1);
    // validate
    if (edges.includes(edge)) {
        edges.unshift(edge);
        edges = uniq(edges);
    }
    let current;
    do {
        current = edges.shift();
        const re = regexp$1[current];
        const segment = segments[current];
        if (!re || !segment) {
            continue;
        }
        const match = segment.match(re);
        if (!match) {
            continue;
        }
        if (match) {
            const guess = getCurrencyCode(match[1]);
            if (guess) {
                return guess;
            }
        }
    } while (current);
    return undefined;
}

const selectorWithShadowRootRegex = /(.+):host\((.*)\)$/;
function findMountElement(selector, { all = false, checkId, document = globalThis.document } = {}) {
    try {
        if (!selector) {
            return null;
        }
        const shadowRootMatches = selector.match(selectorWithShadowRootRegex);
        if (shadowRootMatches?.length === 3) {
            const [, outsideSelector, rawShadowRootSelector] = shadowRootMatches;
            const parsedShadowRootSelector = (checkId ? `${rawShadowRootSelector}:not([id="${checkId}"])` : rawShadowRootSelector);
            const mountSelector = all ? document.querySelector(outsideSelector)?.shadowRoot?.querySelectorAll(parsedShadowRootSelector)
                : document.querySelector(outsideSelector)?.shadowRoot?.querySelector(parsedShadowRootSelector);
            return mountSelector || null;
        }
        const parsedSelector = checkId ? `${selector}:not([id="${checkId}"])` : selector;
        let mountSelector = all ? document.querySelectorAll(parsedSelector) : document.querySelector(parsedSelector);
        if (mountSelector) {
            return mountSelector;
        }
        document.querySelectorAll('iframe').forEach((iframe) => {
            if (mountSelector) { // already found: exit
                return;
            }
            try {
                const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
                if (!iframeDoc) {
                    return;
                }
                mountSelector = findMountElement(selector, { all, checkId, document: iframeDoc });
            }
            catch (e) {
                // cross-domain iframes will throw an exception
                // ignore and just continue to the next iframe element
            }
        });
        return mountSelector;
    }
    catch {
        return null;
    }
}

const document$1 = globalThis.document;
/**
 * Decode html entities.
 *
 * @param {string} html - The input text.
 * @return {string}
 */
function decodeHtml(html) {
    const txt = document$1.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
}

/**
 * Remove characters except last one.
 *
 * @param {string} string - The text to process.
 * @param {string} token - The text to be removed.
 */
function removeAllButLast(string, token) {
    const parts = string.split(token);
    if (parts[1] === undefined) {
        return string;
    }
    return parts.slice(0, -1).join('') + token + parts.slice(-1);
}

const defaultOptions = {
    BHD: { allowThreeDecimals: true },
    KWD: { allowThreeDecimals: true },
    OMR: { allowThreeDecimals: true },
};
/**
 * Extract a numeric value from a text (formated price).
 *
 * @param {string} original_sentence - The text to parse.
 * @param {object} [options]
 * @param {string} [options.currency]
 * @param {bool} [options.allow_three_decimals=false]
 * @return {number}
 */
function parseNumber(originalSentence, options) {
    // Early exit
    // Return value if is integer or float
    if (typeof originalSentence === 'number') {
        return originalSentence;
    }
    let sentence = decodeHtml(originalSentence);
    const match = sentence.match(/^(.*?)(\d[\d\s,.]*)(.*?)$/);
    let decimalCharacter;
    if (!options || !isPlainObject(options)) {
        options = {};
    }
    if (match) {
        if (match[2]) {
            sentence = match[2];
        }
        if (!options.currency && match[1]) {
            options.currency = parseCurrency(match[1], 'trailing');
        }
        if (!options.currency && match[3]) {
            options.currency = parseCurrency(match[3], 'leading');
        }
    }
    // Incorporate the default options for this currency
    // notice the "options" param has precedence
    options = { ...defaultOptions[options.currency] || {}, ...options };
    // First, erase Extra Points or Commas
    if (typeof sentence !== 'undefined') {
        if ((sentence.match(/,/g) != null) && (sentence.match(/,/g).length > 1)) {
            sentence = removeAllButLast(sentence, ',');
        }
        if ((sentence.match(/./g) != null) && (sentence.match(/./g).length > 1)) {
            sentence = removeAllButLast(sentence, '.');
        }
    }
    // And also Breaks and Spaces
    sentence = sentence.replace(/[\r\n\s]+/g, '');
    const sentenceCropped = sentence.match(/\d[\d,.\s]*/); // Obtains the price from the string by substracting the money "  31 343,23 €" > "  31 343,23 "
    if (sentenceCropped == null) {
        return null;
    }
    const matches = sentenceCropped[0].trim().match(/[0-9,\s.]*/); // Removes white spaces from beginning and end of the sentence.
    const lastPeriod = sentenceCropped[0].lastIndexOf('.');
    const lastComma = sentenceCropped[0].lastIndexOf(',');
    const lastSpace = sentenceCropped[0].lastIndexOf(' ');
    if (lastComma !== -1 && lastComma > lastPeriod) {
        decimalCharacter = ',';
    }
    else {
        decimalCharacter = '.';
    }
    const validDecimalPositions = [
        matches[0].length - 3, // "143.43"
        matches[0].length - 2, // "143.5"
    ];
    // make three decimals a valid option
    if (options.allowThreeDecimals === true) {
        validDecimalPositions.push(matches[0].length - 4); // "143.621"
    }
    // if no-last-space and no-last-comma: ready to return
    // but last-period must be in a valid position or removed
    if (lastSpace === -1 && lastComma === -1 && validDecimalPositions.indexOf(lastPeriod) === -1) {
        return Number(matches[0].replace('.', ''));
    }
    // if no-last-space and no-last-period: ready to return
    // but last-comma must be in a valid position or removed
    if (lastSpace === -1 && lastPeriod === -1 && validDecimalPositions.indexOf(lastComma) === -1) {
        return Number(matches[0].replace(',', ''));
    }
    if (matches && matches[0]) {
        if (decimalCharacter === ',') {
            return Number(matches[0].replace(/\s/g, '').replace(/\./g, '').replace(',', '.')); // Changes the price format from xx.xxx,dd or xx xxx,dd to xxxxxx.dd
        }
        return Number(matches[0].replace(/\s/g, '').replace(/,/g, '')); // Changes the price format from xx,xxx.dd or xx xxx.dd to xxxxxx.dd
    }
    return null;
}

function partialRight(fn, ...fixed) {
    return function (...args) {
        return fn(...args, ...fixed);
    };
}

function partial(fn, ...fixedArgs) {
    return function (...args) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-assignment
        return fn.apply(this, [...fixedArgs, ...args]);
    };
}

function pick(collection, props) {
    if (!collection || typeof collection !== 'object') {
        return collection;
    }
    return props.reduce((acc, key) => {
        if (has$1(collection, key)) {
            acc[key] = collection[key];
        }
        return acc;
    }, {});
}

const dateNow = globalThis.performance?.now
    ? /* #__PURE__ */ globalThis.performance.now.bind(globalThis.performance)
    : Date.now;
class Recorder {
    registry;
    defaultLabel = '';
    constructor(data = {}) {
        this.registry = new Map(Object.entries(data));
    }
    time(label = this.defaultLabel) {
        if (this.registry.has(label)) {
            return undefined;
        }
        const time = dateNow();
        this.registry.set(label, time);
        return time;
    }
    timeLog(label = this.defaultLabel) {
        const timestamp = this.registry.get(label);
        if (!timestamp) {
            return undefined;
        }
        return dateNow() - timestamp;
    }
    timeEnd(label = this.defaultLabel) {
        const timestamp = this.registry.get(label);
        if (!timestamp) {
            return undefined;
        }
        const time = dateNow();
        const duration = time - timestamp;
        this.registry.delete(label);
        return duration;
    }
    has(label = this.defaultLabel) {
        return this.registry.has(label);
    }
    toJSON() {
        const data = {};
        this.registry.forEach((time, label) => {
            data[label] = time;
        });
        return data;
    }
}

const avoid = /* #__PURE__ */ overSome(isElement, isContainer, isPromiseLike, isWindow);
function filter(_key, value) {
    return avoid(value)
        ? STRINGIFY_REPLACEMENT
        : value;
}
const stringify = ((...[value, replacer, space]) => {
    let args = [value, replacer, space];
    if (isFunction(replacer)) {
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        args = [value, (k, v) => replacer(k, filter(k, v)), space];
    }
    else if (!isArray(replacer)) {
        args = [value, filter, space];
    }
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    return globalThis.JSON.stringify.apply(null, args);
});

function sum(array) {
    return array.reduce(function (acc, curr) {
        if (isNumeric(curr)) {
            acc += curr;
        }
        return acc;
    }, 0);
}

const document$3 = globalThis.document;
/**
 * Check browser support.
 *
 * @param {string} feature - The feature to be checked:
 *  - "shadow_dom"
 *  - "local_storage"
 *  - "touch" events
 *
 * @return {boolean}
 */
function supports(feature) {
    switch (feature) {
        case 'shadow_dom':
            // return !!(document.head.createShadowRoot || document.head.attachShadow);
            return !!((document$3.head && document$3.head.attachShadow) || globalThis.Element.attachShadow);
        case 'local_storage':
        case 'session_storage': {
            // Checking needs try/catch for Safari
            const key = feature.split('_')[0];
            try {
                const storage = globalThis[`${key}Storage`];
                return !!storage;
            }
            catch (e) {
                return false;
            }
        }
        case 'touch':
            return 'ontouchend' in document$3;
        default:
            return false;
    }
}

/**
 * Triggers/dispatches an event.
 *
 * @param typeArg The name of the event, for instance 'click'.
 * @param customEventInitDetails When present, a CustomEvent instead
 *  of Event will be dispatched. This object will be placed in the
 *  `details` property of the event.
 *  Note: we have CustomEvent is polyfilled.
 * @param element The element from which the event is
 *  dispatched. If not present, then global `window` will be used.
 */
const trigger = (typeArg, customEventInitDetails, element, globalThisService = globalThis) => {
    try {
        let event;
        const defaultInit = {
            bubbles: true,
            cancellable: false,
        };
        const effectiveElement = element || globalThisService;
        if (customEventInitDetails) {
            defaultInit.detail = customEventInitDetails;
            event = new globalThisService.CustomEvent(typeArg, defaultInit);
        }
        else {
            event = new globalThisService.Event(typeArg, defaultInit);
        }
        effectiveElement.dispatchEvent(event);
    }
    catch (e) { /* empty */ }
};

var utils = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Recorder: Recorder,
    addDays: addDays,
    appendUrlParams: appendUrlParams,
    arrayGet: arrayGet,
    ary: ary,
    base64ToBytes: base64ToBytes,
    buildDefaultImportmap: buildDefaultImportmap,
    bytesToBase64: bytesToBase64,
    camelCase: camelCase,
    cancellable: cancellable,
    capitalize: stringCapitalize,
    cloneDeep: collectionClone,
    createElement: createElement,
    dateToString: dateToString,
    daysBetween: daysBetween,
    debounce: debounce,
    delegate: delegate,
    empty: empty,
    emptyRecursive: emptyRecursive,
    eq: eq,
    filter: filter$1,
    findMountElement: findMountElement,
    flattenObject: flattenObject,
    flow: flow,
    generateCallbackQueue: generateCallbackQueue,
    get: get$1,
    getCurrencyCode: getCurrencyCode,
    getDomain: getDomain,
    gt: gt,
    gte: gte,
    has: has$1,
    hijack: hijack,
    identity: identity$1,
    inArray: inArray,
    invoke: invoke,
    invokeFrom: invokeFrom,
    isArguments: isArguments,
    isArray: isArray,
    isBoolean: isBoolean,
    isContainer: isContainer,
    isDate: isDate,
    isElement: isElement,
    isError: isError,
    isFunction: isFunction,
    isGlobalThis: isGlobalThis,
    isIe: isIe,
    isIframed: isIframed$1,
    isNative: isNative,
    isNull: isNull,
    isNumber: isNumber,
    isNumeric: isNumeric,
    isPlainObject: isPlainObject,
    isPromiseLike: isPromiseLike,
    isString: isString,
    isUndefined: isUndefined,
    isVisible: isVisible,
    isWindow: isWindow,
    loadScript: loadScript$1,
    lt: lt,
    lte: lte,
    map: map,
    memoize: memoize,
    merge: merge,
    nearest: nearest,
    negate: negate,
    notEmpty: notEmpty,
    objectGet: objectGet,
    observeDom: observeDom,
    omit: omit,
    openLink: openLink,
    overEvery: overEvery,
    overSome: overSome,
    parseCurrency: parseCurrency,
    parseNumber: parseNumber,
    parseUrlParameter: parseUrlParameter,
    partial: partial,
    partialRight: partialRight,
    pick: pick,
    set: set$1,
    snakeCase: stringSnakeCase,
    stopObserveDom: stopObserveDom,
    stringify: stringify,
    sum: sum,
    supports: supports,
    trigger: trigger,
    trim: trim,
    uniq: uniq
});

/**
 * BottleJS v2.0.1 - 2022-06-28
 * A powerful dependency injection micro container
 *
 * Copyright (c) 2022 Stephen Young
 * Licensed MIT
 */
var Bottle;

/**
 * String constants
 */
var DELIMITER = '.';
var FUNCTION_TYPE = 'function';
var STRING_TYPE = 'string';
var GLOBAL_NAME = '__global__';
var PROVIDER_SUFFIX = 'Provider';

/**
 * Unique id counter;
 *
 * @type Number
 */
var id = 0;

/**
 * Local slice alias
 *
 * @type Functions
 */
var slice = Array.prototype.slice;

/**
 * Iterator used to walk down a nested object.
 *
 * If Bottle.config.strict is true, this method will throw an exception if it encounters an
 * undefined path
 *
 * @param Object obj
 * @param String prop
 * @return mixed
 * @throws Error if Bottle is unable to resolve the requested service.
 */
var getNested = function getNested(obj, prop) {
    var service = obj[prop];
    if (service === undefined && Bottle.config.strict) {
        throw new Error('Bottle was unable to resolve a service.  `' + prop + '` is undefined.');
    }
    return service;
};

/**
 * Get a nested bottle. Will set and return if not set.
 *
 * @param String name
 * @return Bottle
 */
var getNestedBottle = function getNestedBottle(name) {
    var bottle;
    if (!this.nested[name]) {
        bottle = Bottle.pop();
        this.nested[name] = bottle;
        this.factory(name, function SubProviderFactory() {
            return bottle.container;
        });
    }
    return this.nested[name];
};

/**
 * Get a service stored under a nested key
 *
 * @param String fullname
 * @return Service
 */
var getNestedService = function getNestedService(fullname) {
    return fullname.split(DELIMITER).reduce(getNested, this);
};

/**
 * Function used by provider to set up middleware for each request.
 *
 * @param Number id
 * @param String name
 * @param Object instance
 * @param Object container
 * @return void
 */
var applyMiddleware = function applyMiddleware(middleware, name, instance, container) {
    var descriptor = {
        configurable : true,
        enumerable : true
    };
    if (middleware.length) {
        descriptor.get = function getWithMiddlewear() {
            var index = 0;
            var next = function nextMiddleware(err) {
                if (err) {
                    throw err;
                }
                if (middleware[index]) {
                    middleware[index++](instance, next);
                }
            };
            next();
            return instance;
        };
    } else {
        descriptor.value = instance;
        descriptor.writable = true;
    }

    Object.defineProperty(container, name, descriptor);

    return container[name];
};

/**
 * Register middleware.
 *
 * @param String name
 * @param Function func
 * @return Bottle
 */
var middleware = function middleware(fullname, func) {
    var parts, name;
    if (typeof fullname === FUNCTION_TYPE) {
        func = fullname;
        fullname = GLOBAL_NAME;
    }

    parts = fullname.split(DELIMITER);
    name = parts.shift();
    if (parts.length) {
        getNestedBottle.call(this, name).middleware(parts.join(DELIMITER), func);
    } else {
        if (!this.middlewares[name]) {
            this.middlewares[name] = [];
        }
        this.middlewares[name].push(func);
    }
    return this;
};

/**
 * Used to process decorators in the provider
 *
 * @param Object instance
 * @param Function func
 * @return Mixed
 */
var reducer = function reducer(instance, func) {
    return func(instance);
};


/**
 * Get decorators and middleware including globals
 *
 * @return array
 */
var getWithGlobal = function getWithGlobal(collection, name) {
    return (collection[name] || []).concat(collection.__global__ || []);
};


/**
 * Create the provider properties on the container
 *
 * @param String name
 * @param Function Provider
 * @return Bottle
 */
var createProvider = function createProvider(name, Provider) {
    var providerName, properties, container, decorators, middlewares;
    container = this.container;
    decorators = this.decorators;
    middlewares = this.middlewares;
    providerName = name + PROVIDER_SUFFIX;

    properties = Object.create(null);
    properties[providerName] = {
        configurable : true,
        enumerable : true,
        get : function getProvider() {
            var instance = new Provider();
            delete container[providerName];
            container[providerName] = instance;
            return instance;
        }
    };

    properties[name] = {
        configurable : true,
        enumerable : true,
        get : function getService() {
            var provider = container[providerName];
            var instance;
            if (provider) {
                // filter through decorators
                instance = getWithGlobal(decorators, name).reduce(reducer, provider.$get(container));

                delete container[providerName];
                delete container[name];
            }
            return instance === undefined ? instance : applyMiddleware(getWithGlobal(middlewares, name),
                name, instance, container);
        }
    };

    Object.defineProperties(container, properties);
    return this;
};


/**
 * Register a provider.
 *
 * @param String fullname
 * @param Function Provider
 * @return Bottle
 */
var provider = function provider(fullname, Provider) {
    var parts, name;
    parts = fullname.split(DELIMITER);
    if (this.providerMap[fullname] && parts.length === 1 && !this.container[fullname + PROVIDER_SUFFIX]) {
        return console.error(fullname + ' provider already instantiated.');
    }
    this.originalProviders[fullname] = Provider;
    this.providerMap[fullname] = true;

    name = parts.shift();

    if (parts.length) {
        getNestedBottle.call(this, name).provider(parts.join(DELIMITER), Provider);
        return this;
    }
    return createProvider.call(this, name, Provider);
};

/**
 * Register a factory inside a generic provider.
 *
 * @param String name
 * @param Function Factory
 * @return Bottle
 */
var factory$2 = function factory(name, Factory) {
    return provider.call(this, name, function GenericProvider() {
        this.$get = Factory;
    });
};

/**
 * Private helper for creating service and service factories.
 *
 * @param String name
 * @param Function Service
 * @return Bottle
 */
var createService = function createService(name, Service, isClass) {
    var deps = arguments.length > 3 ? slice.call(arguments, 3) : [];
    var bottle = this;
    return factory$2.call(this, name, function GenericFactory() {
        var serviceFactory = Service; // alias for jshint
        var args = deps.map(getNestedService, bottle.container);

        if (!isClass) {
            return serviceFactory.apply(null, args);
        }
        return new (Service.bind.apply(Service, [null].concat(args)))();
    });
};

/**
 * Register a class service
 *
 * @param String name
 * @param Function Service
 * @return Bottle
 */
var service = function service(name, Service) {
    return createService.apply(this, [name, Service, true].concat(slice.call(arguments, 2)));
};

/**
 * Register a function service
 */
var serviceFactory = function serviceFactory(name, factoryService) {
    return createService.apply(this, [name, factoryService, false].concat(slice.call(arguments, 2)));
};

/**
 * Define a mutable property on the container.
 *
 * @param String name
 * @param mixed val
 * @return void
 * @scope container
 */
var defineValue = function defineValue(name, val) {
    Object.defineProperty(this, name, {
        configurable : true,
        enumerable : true,
        value : val,
        writable : true
    });
};

/**
 * Iterator for setting a plain object literal via defineValue
 *
 * @param Object container
 * @param string name
 */
var setValueObject = function setValueObject(container, name) {
    var nestedContainer = container[name];
    if (!nestedContainer) {
        nestedContainer = {};
        defineValue.call(container, name, nestedContainer);
    }
    return nestedContainer;
};


/**
 * Register a value
 *
 * @param String name
 * @param mixed val
 * @return Bottle
 */
var value = function value(name, val) {
    var parts;
    parts = name.split(DELIMITER);
    name = parts.pop();
    defineValue.call(parts.reduce(setValueObject, this.container), name, val);
    return this;
};

/**
 * Define an enumerable, non-configurable, non-writable value.
 *
 * @param String name
 * @param mixed value
 * @return undefined
 */
var defineConstant = function defineConstant(name, value) {
    Object.defineProperty(this, name, {
        configurable : false,
        enumerable : true,
        value : value,
        writable : false
    });
};

/**
 * Register a constant
 *
 * @param String name
 * @param mixed value
 * @return Bottle
 */
var constant = function constant(name, value) {
    var parts = name.split(DELIMITER);
    name = parts.pop();
    defineConstant.call(parts.reduce(setValueObject, this.container), name, value);
    return this;
};

/**
 * Register decorator.
 *
 * @param String fullname
 * @param Function func
 * @return Bottle
 */
var decorator = function decorator(fullname, func) {
    var parts, name;
    if (typeof fullname === FUNCTION_TYPE) {
        func = fullname;
        fullname = GLOBAL_NAME;
    }

    parts = fullname.split(DELIMITER);
    name = parts.shift();
    if (parts.length) {
        getNestedBottle.call(this, name).decorator(parts.join(DELIMITER), func);
    } else {
        if (!this.decorators[name]) {
            this.decorators[name] = [];
        }
        this.decorators[name].push(func);
    }
    return this;
};

/**
 * Register a function that will be executed when Bottle#resolve is called.
 *
 * @param Function func
 * @return Bottle
 */
var defer = function defer(func) {
    this.deferred.push(func);
    return this;
};


/**
 * Immediately instantiates the provided list of services and returns them.
 *
 * @param Array services
 * @return Array Array of instances (in the order they were provided)
 */
var digest = function digest(services) {
    return (services || []).map(getNestedService, this.container);
};

/**
 * Register an instance factory inside a generic factory.
 *
 * @param {String} name - The name of the service
 * @param {Function} Factory - The factory function, matches the signature required for the
 * `factory` method
 * @return Bottle
 */
var instanceFactory = function instanceFactory(name, Factory) {
    return factory$2.call(this, name, function GenericInstanceFactory(container) {
        return {
            instance : Factory.bind(Factory, container)
        };
    });
};

/**
 * A filter function for removing bottle container methods and providers from a list of keys
 */
var byMethod = function byMethod(name) {
    return !/^\$(?:decorator|register|list)$|Provider$/.test(name);
};

/**
 * List the services registered on the container.
 *
 * @param Object container
 * @return Array
 */
var list = function list(container) {
    return Object.keys(container || this.container || {}).filter(byMethod);
};

/**
 * Named bottle instances
 *
 * @type Object
 */
var bottles = {};

/**
 * Get an instance of bottle.
 *
 * If a name is provided the instance will be stored in a local hash.  Calling Bottle.pop multiple
 * times with the same name will return the same instance.
 *
 * @param String name
 * @return Bottle
 */
var pop = function pop(name) {
    var instance;
    if (typeof name === STRING_TYPE) {
        instance = bottles[name];
        if (!instance) {
            bottles[name] = instance = new Bottle();
            instance.constant('BOTTLE_NAME', name);
        }
        return instance;
    }
    return new Bottle();
};

/**
 * Clear all named bottles.
 */
var clear = function clear(name) {
    if (typeof name === STRING_TYPE) {
        delete bottles[name];
    } else {
        bottles = {};
    }
};

/**
 * Register a service, factory, provider, or value based on properties on the object.
 *
 * properties:
 *  * Obj.$name   String required ex: `'Thing'`
 *  * Obj.$type   String optional 'service', 'factory', 'provider', 'value'.  Default: 'service'
 *  * Obj.$inject Mixed  optional only useful with $type 'service' name or array of names
 *  * Obj.$value  Mixed  optional Normally Obj is registered on the container.  However, if this
 *                       property is included, it's value will be registered on the container
 *                       instead of the object itsself.  Useful for registering objects on the
 *                       bottle container without modifying those objects with bottle specific keys.
 *
 * @param Function Obj
 * @return Bottle
 */
var register = function register(Obj) {
    var value = Obj.$value === undefined ? Obj : Obj.$value;
    return this[Obj.$type || 'service'].apply(this, [Obj.$name, value].concat(Obj.$inject || []));
};

/**
 * Deletes providers from the map and container.
 *
 * @param String name
 * @return void
 */
var removeProviderMap = function resetProvider(name) {
    delete this.providerMap[name];
    delete this.container[name];
    delete this.container[name + PROVIDER_SUFFIX];
};

/**
 * Resets providers on a bottle instance. If 'names' array is provided, only the named providers will be reset.
 *
 * @param Array names
 * @return void
 */
var resetProviders = function resetProviders(names) {
    var tempProviders = this.originalProviders;
    var shouldFilter = Array.isArray(names);

    Object.keys(this.originalProviders).forEach(function resetProvider(originalProviderName) {
        if (shouldFilter && names.indexOf(originalProviderName) === -1) {
            return;
        }
        var parts = originalProviderName.split(DELIMITER);
        if (parts.length > 1) {
            parts.forEach(removeProviderMap, getNestedBottle.call(this, parts[0]));
        }
        removeProviderMap.call(this, originalProviderName);
        this.provider(originalProviderName, tempProviders[originalProviderName]);
    }, this);
};


/**
 * Execute any deferred functions
 *
 * @param Mixed data
 * @return Bottle
 */
var resolve = function resolve(data) {
    this.deferred.forEach(function deferredIterator(func) {
        func(data);
    });

    return this;
};


/**
 * Bottle constructor
 *
 * @param String name Optional name for functional construction
 */
Bottle = function Bottle(name) {
    if (!(this instanceof Bottle)) {
        return Bottle.pop(name);
    }

    this.id = id++;

    this.decorators = {};
    this.middlewares = {};
    this.nested = {};
    this.providerMap = {};
    this.originalProviders = {};
    this.deferred = [];
    this.container = {
        $decorator : decorator.bind(this),
        $register : register.bind(this),
        $list : list.bind(this)
    };
};

/**
 * Bottle prototype
 */
Bottle.prototype = {
    constant : constant,
    decorator : decorator,
    defer : defer,
    digest : digest,
    factory : factory$2,
    instanceFactory: instanceFactory,
    list : list,
    middleware : middleware,
    provider : provider,
    resetProviders : resetProviders,
    register : register,
    resolve : resolve,
    service : service,
    serviceFactory : serviceFactory,
    value : value
};

/**
 * Bottle static
 */
Bottle.pop = pop;
Bottle.clear = clear;
Bottle.list = list;

/**
 * Global config
 */
Bottle.config = {
    strict : false
};

function createError$1(message) {
    var err = new Error(message);
    err.source = "ulid";
    return err;
}
// These values should NEVER change. If
// they do, we're no longer making ulids!
var ENCODING = "0123456789ABCDEFGHJKMNPQRSTVWXYZ"; // Crockford's Base32
var ENCODING_LEN = ENCODING.length;
var TIME_MAX = Math.pow(2, 48) - 1;
var TIME_LEN = 10;
var RANDOM_LEN = 16;
function randomChar(prng) {
    var rand = Math.floor(prng() * ENCODING_LEN);
    if (rand === ENCODING_LEN) {
        rand = ENCODING_LEN - 1;
    }
    return ENCODING.charAt(rand);
}
function encodeTime(now, len) {
    if (isNaN(now)) {
        throw new Error(now + " must be a number");
    }
    if (now > TIME_MAX) {
        throw createError$1("cannot encode time greater than " + TIME_MAX);
    }
    if (now < 0) {
        throw createError$1("time must be positive");
    }
    if (Number.isInteger(now) === false) {
        throw createError$1("time must be an integer");
    }
    var mod = void 0;
    var str = "";
    for (; len > 0; len--) {
        mod = now % ENCODING_LEN;
        str = ENCODING.charAt(mod) + str;
        now = (now - mod) / ENCODING_LEN;
    }
    return str;
}
function encodeRandom(len, prng) {
    var str = "";
    for (; len > 0; len--) {
        str = randomChar(prng) + str;
    }
    return str;
}
function detectPrng() {
    var root = arguments[1];

    if (!root) {
        root = typeof globalThis !== "undefined" ? globalThis : null;
    }
    var browserCrypto = root && (root.crypto || root.msCrypto);
    if (browserCrypto) {
        return function () {
            var buffer = new Uint8Array(1);
            browserCrypto.getRandomValues(buffer);
            return buffer[0] / 0xff;
        };
    }
    throw createError$1("secure crypto unusable, insecure Math.random not allowed");
}
function factory$1(currPrng) {
    if (!currPrng) {
        currPrng = detectPrng();
    }
    return function ulid(seedTime) {
        if (isNaN(seedTime)) {
            seedTime = Date.now();
        }
        return encodeTime(seedTime, TIME_LEN) + encodeRandom(RANDOM_LEN, currPrng);
    };
}
var ulid$1 = /* #__PURE__ */factory$1();

function baseRegexpTest(regexp) {
    return function regexpTest(str) {
        return isString(str) ? regexp.test(str) : false;
    };
}

const isBase64 = /* #__PURE__ */ baseRegexpTest(/^[A-Z0-9+/=]*$/i);
const isBase64String = /* #__PURE__ */ overEvery(isString, isBase64);

const BABIES_AGE = 0;
const CHILDREN_AGE = 10;
const PRICE_TYPES = ['base', 'full'];
const ROOM_TYPES = ['standard', 'superior', 'suite'];
const WIDGET_MODES = ['auto', 'manual', 'datalayer'];
const WIDGET_PRICE_MODES = [...WIDGET_MODES, 'pages'];
const WIDGET_POSITIONS = [
    // code: <vertical> <vertical-mod>? <horizontal>
    'CL', // center left
    'CR', // center rigth
    'IB', // inline before
    'II', // inline inside
    'IA', // inline after
    'LC', // lower center
    'LL', // lower left
    'LML', // lower middle left
    'LMR', // lower middle right
    'LR', // lower right
    'UL', // upper left
    'UML', // upper middle left
    'UMR', // upper middle right
    'UR', // upper right
];
const WIDGET_MOBILE_POSITIONS = [
    // code: <horizontal> <vertical>
    'BT', // bottom bar (special, legacy)
    'LT', // left top
    'LM', // left middle
    'LB', // left bottom
    'RT', // right top
    'RM', // right middle
    'RB', // right bottom
    'IB', // inline before
    'II', // inline inside
    'IA', // inline after
];
const COUNTRY_CODES = [
    'af', // Afghanistan
    'al', // Albania
    'dz', // Algeria
    'as', // American Samoa
    'ad', // Andorra
    'ao', // Angola
    'ai', // Anguilla
    'aq', // Antarctica
    'ag', // Antigua and Barbuda
    'ar', // Argentina
    'am', // Armenia
    'aw', // Aruba
    'au', // Australia
    'at', // Austria
    'az', // Azerbaijan
    'bs', // Bahamas (the)
    'bh', // Bahrain
    'bd', // Bangladesh
    'bb', // Barbados
    'by', // Belarus
    'be', // Belgium
    'bz', // Belize
    'bj', // Benin
    'bm', // Bermuda
    'bt', // Bhutan
    'bo', // Bolivia (Plurinational State of)
    'bq', // Bonaire, Sint Eustatius and Saba
    'ba', // Bosnia and Herzegovina
    'bw', // Botswana
    'bv', // Bouvet Island
    'br', // Brazil
    'io', // British Indian Ocean Territory (the)
    'bn', // Brunei Darussalam
    'bg', // Bulgaria
    'bf', // Burkina Faso
    'bi', // Burundi
    'cv', // Cabo Verde
    'kh', // Cambodia
    'cm', // Cameroon
    'ca', // Canada
    'ky', // Cayman Islands (the)
    'cf', // Central African Republic (the)
    'td', // Chad
    'cl', // Chile
    'cn', // China
    'cx', // Christmas Island
    'cc', // Cocos (Keeling) Islands (the)
    'co', // Colombia
    'km', // Comoros (the)
    'cd', // Congo (the Democratic Republic of the)
    'cg', // Congo (the)
    'ck', // Cook Islands (the)
    'cr', // Costa Rica
    'hr', // Croatia
    'cu', // Cuba
    'cw', // Curaçao
    'cy', // Cyprus
    'cz', // Czechia
    'ci', // Côte d'Ivoire
    'dk', // Denmark
    'dj', // Djibouti
    'dm', // Dominica
    'do', // Dominican Republic (the)
    'ec', // Ecuador
    'eg', // Egypt
    'sv', // El Salvador
    'gq', // Equatorial Guinea
    'er', // Eritrea
    'ee', // Estonia
    'sz', // Eswatini
    'et', // Ethiopia
    'fk', // Falkland Islands (the) [Malvinas]
    'fo', // Faroe Islands (the)
    'fj', // Fiji
    'fi', // Finland
    'fr', // France
    'gf', // French Guiana
    'pf', // French Polynesia
    'tf', // French Southern Territories (the)
    'ga', // Gabon
    'gm', // Gambia (the)
    'ge', // Georgia
    'de', // Germany
    'gh', // Ghana
    'gi', // Gibraltar
    'gr', // Greece
    'gl', // Greenland
    'gd', // Grenada
    'gp', // Guadeloupe
    'gu', // Guam
    'gt', // Guatemala
    'gg', // Guernsey
    'gn', // Guinea
    'gw', // Guinea-Bissau
    'gy', // Guyana
    'ht', // Haiti
    'hm', // Heard Island and McDonald Islands
    'va', // Holy See (the)
    'hn', // Honduras
    'hk', // Hong Kong
    'hu', // Hungary
    'is', // Iceland
    'in', // India
    'id', // Indonesia
    'ir', // Iran (Islamic Republic of)
    'iq', // Iraq
    'ie', // Ireland
    'im', // Isle of Man
    'il', // Israel
    'it', // Italy
    'jm', // Jamaica
    'jp', // Japan
    'je', // Jersey
    'jo', // Jordan
    'kz', // Kazakhstan
    'ke', // Kenya
    'ki', // Kiribati
    'kp', // Korea (the Democratic People's Republic of)
    'kr', // Korea (the Republic of)
    'kw', // Kuwait
    'kg', // Kyrgyzstan
    'la', // Lao People's Democratic Republic (the)
    'lv', // Latvia
    'lb', // Lebanon
    'ls', // Lesotho
    'lr', // Liberia
    'ly', // Libya
    'li', // Liechtenstein
    'lt', // Lithuania
    'lu', // Luxembourg
    'mo', // Macao
    'mg', // Madagascar
    'mw', // Malawi
    'my', // Malaysia
    'mv', // Maldives
    'ml', // Mali
    'mt', // Malta
    'mh', // Marshall Islands (the)
    'mq', // Martinique
    'mr', // Mauritania
    'mu', // Mauritius
    'yt', // Mayotte
    'mx', // Mexico
    'fm', // Micronesia (Federated States of)
    'md', // Moldova (the Republic of)
    'mc', // Monaco
    'mn', // Mongolia
    'me', // Montenegro
    'ms', // Montserrat
    'ma', // Morocco
    'mz', // Mozambique
    'mm', // Myanmar
    'na', // Namibia
    'nr', // Nauru
    'np', // Nepal
    'nl', // Netherlands (the)
    'nc', // New Caledonia
    'nz', // New Zealand
    'ni', // Nicaragua
    'ne', // Niger (the)
    'ng', // Nigeria
    'nu', // Niue
    'nf', // Norfolk Island
    'mp', // Northern Mariana Islands (the)
    'no', // Norway
    'om', // Oman
    'pk', // Pakistan
    'pw', // Palau
    'ps', // Palestine, State of
    'pa', // Panama
    'pg', // Papua New Guinea
    'py', // Paraguay
    'pe', // Peru
    'ph', // Philippines (the)
    'pn', // Pitcairn
    'pl', // Poland
    'pt', // Portugal
    'pr', // Puerto Rico
    'qa', // Qatar
    'mk', // Republic of North Macedonia
    'ro', // Romania
    'ru', // Russian Federation (the)
    'rw', // Rwanda
    're', // Réunion
    'bl', // Saint Barthélemy
    'sh', // Saint Helena, Ascension and Tristan da Cunha
    'kn', // Saint Kitts and Nevis
    'lc', // Saint Lucia
    'mf', // Saint Martin (French part)
    'pm', // Saint Pierre and Miquelon
    'vc', // Saint Vincent and the Grenadines
    'ws', // Samoa
    'sm', // San Marino
    'st', // Sao Tome and Principe
    'sa', // Saudi Arabia
    'sn', // Senegal
    'rs', // Serbia
    'sc', // Seychelles
    'sl', // Sierra Leone
    'sg', // Singapore
    'sx', // Sint Maarten (Dutch part)
    'sk', // Slovakia
    'si', // Slovenia
    'sb', // Solomon Islands
    'so', // Somalia
    'za', // South Africa
    'gs', // South Georgia and the South Sandwich Islands
    'ss', // South Sudan
    'es', // Spain
    'lk', // Sri Lanka
    'sd', // Sudan (the)
    'sr', // Suriname
    'sj', // Svalbard and Jan Mayen
    'se', // Sweden
    'ch', // Switzerland
    'sy', // Syrian Arab Republic
    'tw', // Taiwan (Province of China)
    'tj', // Tajikistan
    'tz', // Tanzania, United Republic of
    'th', // Thailand
    'tl', // Timor-Leste
    'tg', // Togo
    'tk', // Tokelau
    'to', // Tonga
    'tt', // Trinidad and Tobago
    'tn', // Tunisia
    'tr', // Turkey
    'tm', // Turkmenistan
    'tc', // Turks and Caicos Islands (the)
    'tv', // Tuvalu
    'ug', // Uganda
    'ua', // Ukraine
    'ae', // United Arab Emirates (the)
    'gb', // United Kingdom of Great Britain and Northern Ireland (the)
    'um', // United States Minor Outlying Islands (the)
    'us', // United States of America (the)
    'uy', // Uruguay
    'uz', // Uzbekistan
    'vu', // Vanuatu
    've', // Venezuela (Bolivarian Republic of)
    'vn', // Viet Nam
    'vg', // Virgin Islands (British)
    'vi', // Virgin Islands (U.S.)
    'wf', // Wallis and Futuna
    'eh', // Western Sahara
    'ye', // Yemen
    'zm', // Zambia
    'zw', // Zimbabwe
    'ax', // Åland Islands
];

function baseIn(predicateOrArray) {
    if (isArray(predicateOrArray)) {
        return ((value) => predicateOrArray.includes(value));
    }
    if (!isFunction(predicateOrArray)) {
        throw new TypeError('Not a function');
    }
    return ary(predicateOrArray, 1);
}

const isCountryCode = /* #__PURE__ */ baseIn(COUNTRY_CODES);

const isCurrencyCode = /* #__PURE__ */ baseIn(/* #__PURE__ */ Object.values(CurrencyCode));

function baseOp(op) {
    return function baseGt(baseArgPred) {
        return function baseCheckedGt(argPred) {
            return function baseTypedGt(arg2) {
                if (!baseArgPred(arg2)) {
                    throw new Error('Invalid');
                }
                return function typedGt(arg1) {
                    return overEvery(argPred, partialRight(op, arg2))(arg1);
                };
            };
        };
    };
}

const baseGte = /* #__PURE__ */ baseOp(gte);

const baseNumericGte = /* #__PURE__ */ baseGte(globalThis.isFinite)(isNumeric);

const isNumericGteZero = /* #__PURE__ */ baseNumericGte(0);

function baseLength(amount) {
    return function isLengthAmount(value) {
        return value && value.length && value.length
            && isNumericGteZero(amount) && value.length === amount;
    };
}

const is32CharString = /* #__PURE__ */ overEvery(isString, baseLength(32));

const regexp = /^\d{4}\/\d{2}\/\d{2}$/;
const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
/**
 * Validates that the input string is a valid date formatted as "yyyy/mm/dd".
 */
const isThnDate = (value) => {
    // First check for the pattern
    if (!isString(value) || !regexp.test(value)) {
        return false;
    }
    // Parse the date parts to integers
    const [year, month, day] = value.split('/').map((p) => parseInt(p, 10));
    // Check the ranges of month and year
    if (year < 1000 || year > 3000 || month === 0 || month > 12) {
        return false;
    }
    // Adjust for leap years
    monthLength[1] = (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) ? 29 : 28;
    // Check the range of the day
    return day > 0 && day <= monthLength[month - 1];
};

const isDataLayerDate = (value) => {
    const formattedDate = typeof value === 'string' ? value.replace(/-/g, '/') : value;
    return !!isThnDate(formattedDate);
};

function isDateBegin(value, { dateEnd } = {}) {
    return isThnDate(value) && isThnDate(dateEnd)
        && daysBetween(value, dateEnd) >= 1;
}

function isDateEnd(value, { dateBegin } = {}) {
    return isThnDate(value) && isThnDate(dateBegin)
        && daysBetween(dateBegin, value) >= 1;
}

const isEmail = /* #__PURE__ */ baseRegexpTest(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/i);

const isNonemptyString = (value) => isString(value) && notEmpty(value.trim());

const baseGt = /* #__PURE__ */ baseOp(gt);

const baseNumericGt = /* #__PURE__ */ baseGt(globalThis.isFinite)(isNumeric);

const isNumericGtZero = /* #__PURE__ */ baseNumericGt(0);

function isThnId(value) {
    return isNumeric(value) && String(value).length === 7;
}

const pattern = /^(http(s)?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.,*~#?&//=[\]{}()!|]*)$/;
const isUrl = /* #__PURE__ */ baseRegexpTest(pattern);

const ifElse = (pred, trueFn, falseFn) => (
// eslint-disable-next-line @typescript-eslint/no-unsafe-return
(v) => (pred(v) ? trueFn(v) : falseFn(v)));

const whenFn = (fn) => (isFunction(fn)
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    ? (value, ...args) => (isUndefined(value) ? value : fn(value, ...args))
    : fn);
const mapFn = /* #__PURE__ */ partialRight(map, whenFn);
const protect = /* #__PURE__ */ ifElse(isFunction, whenFn, mapFn);

const shouldRecurse$1 = (value) => isPlainObject(value) || isArray(value);
function toCamelCase$1(collection, excludeOrMap) {
    const mapFn = (value) => {
        if (shouldRecurse$1(value)) {
            return toCamelCase$1(value, excludeOrMap);
        }
        return value;
    };
    const excludeList = Array.isArray(excludeOrMap) ? excludeOrMap : [];
    const keyMap = excludeOrMap && !Array.isArray(excludeOrMap) ? excludeOrMap : {};
    if (isArray(collection)) {
        return collection.map(mapFn);
    }
    return Object.fromEntries(Object.entries(collection).map((pair) => {
        const [key, value] = pair;
        const explicitKey = keyMap[key];
        // When the explicit keys maps has a value of false,
        // it means deeply ignore transformations on that object
        if (explicitKey === false) {
            return pair;
        }
        return [
            excludeList.includes(key) ? key : (explicitKey || camelCase(key)),
            mapFn(value),
        ];
    }));
}

const shouldRecurse = (value) => isPlainObject(value) || isArray(value);
function toSnakeCase(collection, excludeOrMap) {
    const mapFn = (value) => {
        if (shouldRecurse(value)) {
            return toSnakeCase(value, excludeOrMap);
        }
        return value;
    };
    const excludeList = Array.isArray(excludeOrMap) ? excludeOrMap : [];
    const keyMap = {};
    if (isArray(collection)) {
        return collection.map(mapFn);
    }
    return Object.fromEntries(Object.entries(collection).map(([key, value]) => [
        excludeList.includes(key) ? key : (keyMap[key] || stringSnakeCase(key)),
        mapFn(value),
    ]));
}

function toUpper(value) {
    return String(value).toUpperCase();
}

function baseCreateExecutorFn(executeSchema) {
    return function createExecuteFn(schema, defaultOptions = {}) {
        const executeStrict = partialRight(executeSchema, schema, { strict: true });
        const executeLax = partialRight(executeSchema, schema, { strict: false });
        return (payload, { strict = true } = defaultOptions) => (strict ? executeStrict : executeLax)(payload);
    };
}

const GLUE = '.';
function internalUnset(obj, path, reg) {
    const [head, ...tail] = path.split(GLUE);
    if (tail.length) {
        // Can't recurse into a empty object
        if (empty(obj)) {
            return false;
        }
        // Build a new registry if it has not been done before
        const registry = reg || new WeakMap();
        // Keep track of the current object
        registry.set(obj, true);
        // @ts-ignore
        const nextObj = obj?.[head];
        if (registry.get(nextObj) === true) {
            return false;
        }
        return internalUnset(nextObj, tail.join(GLUE), registry);
    }
    // @ts-ignore
    // eslint-disable-next-line no-param-reassign
    delete obj?.[path];
    return true;
}
const unset = ary(internalUnset, 2);

const WILDCARD$1 = '.*.';
const TRAILWILDCARD$1 = '.*';
/**
 * Maps the original object by invoking the
 * predicate properties of the formatters.
 *
 * The formatter key represents the "path" of
 * the target in the original object.
 *
 * Wildcards are supported, for arrays and objects.
 * Example: * `users.*.visits.last`
 *
 * @param original - The original object.
 * @param formatters - Spec of predicates and format functions.
 */
const format = (original, originalFormatters = {}, options = { strict: true }) => {
    const { strict } = options;
    const data = strict === true
        ? map(collectionClone(originalFormatters), function hollow(value) {
            return isPlainObject(value) ? map(value, hollow) : undefined;
        })
        : collectionClone(original);
    const context = collectionClone(original);
    const formatters = flattenObject(originalFormatters);
    Object.keys(formatters).forEach((key) => {
        const formatter = formatters[key];
        const wildparts = key.split(WILDCARD$1);
        const root = wildparts[0];
        const rest = wildparts.length > 1
            ? wildparts.slice(1).join(WILDCARD$1) : undefined;
        if (!rest) {
            const trailwildparts = root.split(TRAILWILDCARD$1);
            const realroot = trailwildparts[0];
            const trail = trailwildparts.length > 1;
            const value = get$1(context, realroot);
            if (trail) {
                try {
                    const newValue = map(value, (item) => formatter(item, value));
                    set$1(data, realroot, newValue);
                }
                catch { /* empty */ }
            }
            else {
                const newValue = formatter(value, context);
                const operation = newValue !== undefined ? set$1 : unset;
                operation(data, root, newValue);
            }
        }
        else {
            const value = get$1(context, root);
            const wildformatters = { [rest]: formatter };
            const newValue = filter$1(map(value, (item) => format(item, wildformatters, options)), (item) => item !== undefined);
            const operation = Object.keys(newValue).length > 0 ? set$1 : unset;
            operation(data, root, newValue);
        }
    });
    return data;
};

const createFormattingFn = /* #__PURE__ */ baseCreateExecutorFn(format);

const WILDCARD = '.*.';
const TRAILWILDCARD = '.*';
/**
 * Maps the original object by invoking the
 * predicate properties of the validators.
 *
 * The validator key represents the "path" of
 * the target in the original object.
 *
 * Wildcards are supported, for arrays and objects.
 * Example: * `users.*.visits.last`
 *
 * @param original - The original object.
 * @param validators - Spec of predicates and validate functions.
 */
const validate = (original, originalValidators = {}, options = { strict: true }) => {
    const { strict } = options;
    const data = strict === true
        ? map(collectionClone(original), function hollow(value) {
            return isPlainObject(value) ? map(value, hollow) : undefined;
        })
        : collectionClone(original);
    const context = collectionClone(original);
    const memory = {};
    const validators = flattenObject(originalValidators);
    Object.keys(validators).forEach((key) => {
        const validator = validators[key];
        const wildparts = key.split(WILDCARD);
        const root = wildparts[0];
        const rest = wildparts.length > 1
            ? wildparts.slice(1).join(WILDCARD) : undefined;
        if (!rest) {
            const trailwildparts = root.split(TRAILWILDCARD);
            const realroot = trailwildparts[0];
            const trail = trailwildparts.length > 1;
            const value = get$1(context, realroot);
            if (trail) {
                const newValue = filter$1(value, (item) => validator(item, value));
                set$1(data, realroot, newValue);
            }
            else {
                const valid = validator(value, context);
                const operation = valid === true ? set$1 : unset;
                operation(data, realroot, value);
            }
        }
        else {
            const value = get$1(context, root);
            // Memory only needs to include direct properties
            if (!rest.includes(WILDCARD)
                && rest.split(TRAILWILDCARD).length === 1) {
                memory[root] = memory[root] || [];
                memory[root].push(rest);
            }
            const wildvalidators = { [rest]: validator };
            const newValue = map(value, (item) => validate(item, wildvalidators, { strict: false }));
            const operation = Object.keys(newValue).length > 0 ? set$1 : unset;
            operation(data, root, newValue);
        }
    });
    if (strict === true) {
        Object.keys(memory).forEach((root) => {
            const value = get$1(data, root);
            const newValue = map(value, (item) => filter$1(item, (_, idx) => memory[root].includes(idx)));
            set$1(data, root, newValue);
        });
    }
    return data;
};

const createValidationFn = /* #__PURE__ */ baseCreateExecutorFn(validate);

function createTransformFn(formattingFn, validationFn, defaultOptions) {
    const transformStrict = flow(partialRight(formattingFn, { strict: true }), partialRight(validationFn, { strict: true }));
    const transformLax = flow(partialRight(formattingFn, { strict: false }), partialRight(validationFn, { strict: false }));
    return (payload, { strict = true } = defaultOptions) => (strict ? transformStrict : transformLax)(payload);
}

function createModel(formattingSchema, validationSchema, defaultOptions = { strict: true }) {
    const format = createFormattingFn(formattingSchema, defaultOptions);
    const validate = createValidationFn(validationSchema, defaultOptions);
    const transform = createTransformFn(format, validate, defaultOptions);
    return {
        validationSchema,
        formattingSchema,
        format,
        validate,
        transform,
    };
}

function baseEvery(predicate) {
    if (isArray(predicate)) {
        predicate = ary(partialRight(inArray, predicate), 1);
    }
    if (!isFunction(predicate)) {
        throw new TypeError('Not a function');
    }
    return function every(value) {
        if (isArray(value)) {
            return value.every(predicate);
        }
        if (value && typeof value === 'object') {
            return Object.keys(value).every((key) => predicate(value[key], key, value));
        }
        return false;
    };
}

const baseLte = /* #__PURE__ */ baseOp(lte);

const baseIntegerLte = /* #__PURE__ */ baseLte(Number.isInteger)(Number.isInteger);

function isCssSelector(value) {
    // TODO: can we do more to validate a CSS selector?
    return isNonemptyString(value);
}

const baseIntegerGt = /* #__PURE__ */ baseGt(Number.isInteger)(Number.isInteger);

const isIntegerGtZero = /* #__PURE__ */ baseIntegerGt(0);

const isIntegerGteZero = /* #__PURE__ */ baseIntegerGt(-1);

function baseKeyedWith(predicate) {
    if (isArray(predicate)) {
        predicate = partialRight(inArray, predicate);
    }
    if (!isFunction(predicate)) {
        throw new TypeError('Not a function');
    }
    return baseEvery((item, key) => predicate(key));
}

const isLanguageCode = /* #__PURE__ */ baseIn(/* #__PURE__ */ Object.values(LanguageCode));

const isKeyedWithLanguage = /* #__PURE__ */ baseKeyedWith(isLanguageCode);

const isWidgetMobilePosition = /* #__PURE__ */ baseIn(WIDGET_MOBILE_POSITIONS);

const isWidgetPosition = /* #__PURE__ */ baseIn(WIDGET_POSITIONS);

const isWidgetPriceMode = /* #__PURE__ */ baseIn(WIDGET_PRICE_MODES);

const styleConfig = (value) => {
    if (isNull(value)) {
        return true;
    }
    if (!isPlainObject(value)) {
        return false;
    }
    // Minimum shape of a valid "styleConfig" object is "basics: { mainColor: '000000' }"
    // additionally it could contain an "extra" prop with an arbitrary object
    // and an "isMigrated" boolean prop denoting if "styleConfig" is effective
    return !!(value?.basics?.mainColor);
};
const validationSchemaConfig = {
    abTest: isBoolean,
    closeTime: isIntegerGteZero,
    cssSelector: isCssSelector,
    deviceCssSelector: isCssSelector,
    deviceFormat: isIntegerGteZero,
    deviceMargin: isString,
    devicePosition: /* #__PURE__ */ overSome(isWidgetPosition, isWidgetMobilePosition),
    deviceStyleConfig: styleConfig,
    formatFamily: isString,
    formatName: isString,
    gotoengine: isBoolean,
    gotoengineBtnText: /* #__PURE__ */ overEvery(isIntegerGtZero, /* #__PURE__ */ baseIntegerLte(2)),
    margin: isString,
    matches: /* #__PURE__ */ baseEvery(isPlainObject),
    mirrorRtlLang: isBoolean,
    mobileCssSelector: isCssSelector,
    mobileMargin: isString,
    mobileOnline: isBoolean,
    mobilePosition: isWidgetMobilePosition,
    mobileStyleConfig: styleConfig,
    mode: isWidgetPriceMode,
    noCheapest: isBoolean,
    online: isBoolean,
    otaAnonym: isBoolean,
    otaAnonymTexts: isKeyedWithLanguage,
    position: isWidgetPosition,
    priceNight: /* #__PURE__ */ overEvery(isIntegerGteZero, /* #__PURE__ */ baseIntegerLte(3)),
    priceRoom: isBoolean,
    showClosed: /* #__PURE__ */ overEvery(isIntegerGteZero, /* #__PURE__ */ baseIntegerLte(2)),
    showContact: isBoolean,
    showSaveSearch: isBoolean,
    styleConfig,
    termsActive: isBoolean,
    zIndex: Number.isInteger,
};

const naive = /\d{1,3}(\.\d{1,3}){3}/;
function isIp(str) {
    return isString(str)
        && naive.test(str)
        && str.split('.').filter((octect) => octect >= 0 && octect <= 255).length === 4;
}

const isUnixTs = /* #__PURE__ */ overEvery(isIntegerGteZero, (v) => String(v).match(/^\d{10}$/));

const validationSchemaContext = {
    accountKey: is32CharString,
    bookingSystem: isIntegerGtZero,
    canApplyDiscount: isBoolean,
    contextToken: isNonemptyString,
    country: isCountryCode,
    media: /* #__PURE__ */ baseIn(/* #__PURE__ */ Object.values(Device)),
    fingerprint: is32CharString,
    geolocationId: isIntegerGtZero,
    hotelCurrency: isCurrencyCode,
    hotelId: isThnId,
    ip: isIp,
    isAbTestControlUser: isBoolean,
    language: isLanguageCode,
    location: isUrl,
    logged: isBoolean,
    nolog: isBoolean,
    origin: isBoolean,
    overrides: isPlainObject,
    pageId: isThnId,
    pageName: isNonemptyString,
    promocodeVars: isPlainObject,
    propertyId: isThnId,
    referrer: isUrl,
    saveSearchBaseUrl: isNonemptyString,
    scriptVersion: isNonemptyString,
    searchUrl: isBoolean, // setting
    terms: isPlainObject,
    visitDate: isUnixTs, // The main user visit date (formerly search_date)
    visitorLastComparison: isPlainObject,
    widgetName: /* #__PURE__ */ baseIn(['price', 'package']),
};

function isAdults(value, { guests, roomsDispo } = {}) {
    if (!isIntegerGtZero(value)) {
        return false;
    }
    if (guests && value > guests) {
        return false;
    }
    if (isArray(roomsDispo)
        && value !== sum(roomsDispo.filter(isPlainObject).map((r) => r.adults))) {
        return false;
    }
    return true;
}

function isBabies(value, { guests, roomsDispo } = {}) {
    if (!isIntegerGteZero(value)) {
        return false;
    }
    // Maximum children is "guests - 1" because adults minimum is 1
    if (guests && value > guests - 1) {
        return false;
    }
    if (isArray(roomsDispo)
        && value !== sum(roomsDispo.filter(isPlainObject).map((r) => (isArray(r.childrenAges) ? r.childrenAges.filter((a) => a === BABIES_AGE).length : (r.children || 0))))) {
        return false;
    }
    return true;
}

function isChildren(value, { guests, roomsDispo } = {}) {
    if (!isIntegerGteZero(value)) {
        return false;
    }
    // Maximum children is "guests - 1" because adults minimum is 1
    if (guests && value > guests - 1) {
        return false;
    }
    if (isArray(roomsDispo)
        && value !== sum(roomsDispo.filter(isPlainObject).map((r) => (isArray(r.childrenAges) ? r.childrenAges.filter((a) => a !== BABIES_AGE).length : (r.children || 0))))) {
        return false;
    }
    return true;
}

const baseFloatGt = /* #__PURE__ */ baseGt(isNumeric)(isNumeric);

const isFloatGtZero = /* #__PURE__ */ baseFloatGt(0);

function isGuests(value, { adults, roomsDispo } = {}) {
    if (!isIntegerGtZero(value)) {
        return false;
    }
    if (adults && value < adults) {
        return false;
    }
    if (isArray(roomsDispo)
        && value !== sum(roomsDispo.filter(isPlainObject).map((r) => (r.adults + (isArray(r.childrenAges) ? r.childrenAges.length : (r.children || 0)))))) {
        return false;
    }
    return true;
}

function roomPrice({ id, name, priceSpecial, rate, totalNight, breakfast, refundable, }) {
    if (id && !(isString(id) || isNumeric(id))) {
        return false;
    }
    if (name && !isString(name)) {
        return false;
    }
    if (priceSpecial && !isIntegerGteZero(priceSpecial)) {
        return false;
    }
    if (rate && !isString(rate)) {
        return false;
    }
    if (!isFloatGtZero(totalNight)) {
        return false;
    }
    if (breakfast !== undefined && !isBoolean(breakfast)) {
        return false;
    }
    if (refundable !== undefined && !isBoolean(refundable)) {
        return false;
    }
    return true;
}
function roomPrices(value) {
    if (!Array.isArray(value)) {
        return false;
    }
    const ids = value.map((p) => p.id).filter((id) => id);
    if (uniq(ids).length !== ids.length) {
        return false; // dup
    }
    // all items must be valid, no context check
    return value.filter(roomPrice).length === value.length;
}
function roomDetail(value) {
    if (value.id && !(isString(value.id) || isNumeric(value.id))) {
        return false;
    }
    if (value.name && !isString(value.name)) {
        return false;
    }
    if (value.type && !ROOM_TYPES.includes(value.type)) {
        return false;
    }
    if (!isAdults(value.adults)) {
        return false;
    }
    if (!isChildren(value.children)) {
        return false;
    }
    if (!roomPrices(value.prices)) {
        return false;
    }
    return true;
}
function isRoomDetails(value) {
    if (!Array.isArray(value)) {
        return false;
    }
    const ids = value.map((r) => r.id).filter((id) => id);
    if (uniq(ids).length !== ids.length) {
        return false; // dup
    }
    // all items must be valid, no context check
    return value.filter(roomDetail).length === value.length;
}

function isRoomsDispo(value) {
    if (!Array.isArray(value) || value.length === 0) {
        return false;
    }
    // all items must be valid, no context check
    const validValues = value.filter(function (room) {
        if (!isPlainObject(room)) {
            return false;
        }
        if (!isAdults(room.adults)) {
            return false;
        }
        if (isChildren(room.children)) {
            // Case "children" + "childrenAges"
            return room.children === 0
                || (isArray(room.childrenAges)
                    && room.childrenAges.length === room.children
                    && room.childrenAges.every(isNumericGteZero));
        }
        if (!empty(room.children)) {
            return false;
        }
        if (!empty(room.childrenAges)) {
            // Case "childrenAges" without "children"
            return isArray(room.childrenAges)
                && room.childrenAges.every(isNumericGteZero);
        }
        return true;
    });
    return validValues.length === value.length;
}

const validationSchemaSearch = {
    adults: isAdults,
    babies: isBabies,
    children: isChildren,
    currency: isCurrencyCode,
    dateBegin: isDateBegin,
    dateEnd: isDateEnd,
    flightOrigin: isNonemptyString,
    flightDestination: isNonemptyString,
    guests: isGuests,
    noRooms: isBoolean,
    price: isFloatGtZero,
    priceSpecial: isIntegerGteZero,
    priceType: /* #__PURE__ */ baseIn(PRICE_TYPES),
    pricematchId: /* #__PURE__ */ overEvery(isArray, (value) => value.every(isThnId)),
    promocode: isNonemptyString,
    promocodeType: /* #__PURE__ */ baseIn(/* #__PURE__ */ Object.values(DiscountCodeKind)),
    roomDetails: isRoomDetails,
    rooms: isIntegerGtZero,
    roomsDispo: isRoomsDispo,
    nights: isNumericGtZero,
};

const validationSchemaMetadata = {
    custom: isBoolean,
    priceVersion: isIntegerGteZero,
};

// eslint-disable-next-line prefer-object-spread
const validationSchema$a = /* #__PURE__ */ Object.assign({}, 
/* #__PURE__ */ pick(validationSchemaContext, [
    'pageId',
    'propertyId',
]), 
/* #__PURE__ */ pick(validationSchemaConfig, [
    'closeTime',
    'cssSelector',
    'gotoengine',
    'gotoengineBtnText',
    'margin',
    'mobileCssSelector',
    'mobileMargin',
    'mobileOnline',
    'mobilePosition',
    'mobileStyleConfig',
    'noCheapest',
    'online',
    'position',
    'priceNight',
    'showClosed',
    'showContact',
    'showSaveSearch',
    'styleConfig',
]), 
/* #__PURE__ */ pick(validationSchemaMetadata, [
    'custom',
]), 
/* #__PURE__ */ pick(validationSchemaSearch, [
    'adults',
    'children',
    'currency',
    'dateBegin',
    'dateEnd',
    'price',
    'rooms',
]));

function baseFromContext(path) {
    return function boundFromContext(formatter) {
        return function boundFormatter(_, context) {
            const getValue = (p) => get$1(context, p);
            const selectedPath = isArray(path)
                ? path.find((candidate) => getValue(candidate) !== undefined)
                : path;
            return selectedPath
                ? formatter(get$1(context, selectedPath), context)
                : undefined;
        };
    };
}

function baseNegate(formatter) {
    return function negate(...args) {
        return !formatter(...args);
    };
}

function online(value, context = {}) {
    return !empty(context.office) ? true : !empty(value);
}

function toLower(value) {
    return String(value).toLowerCase();
}

const formattingSchemaConfig = /* #__PURE__ */ protect({
    abTest: notEmpty,
    closeTime: Number,
    cssSelector: String,
    deviceCssSelector: String,
    deviceFormat: Number,
    deviceMargin: String,
    devicePosition: toUpper,
    deviceStyleConfig: identity$1,
    formatFamily: String,
    formatName: String,
    gotoengine: /* #__PURE__ */ flow(Number, Boolean),
    gotoengineBtnText: Number,
    margin: String,
    matches: /* #__PURE__ */ ary(/* #__PURE__ */ partialRight(filter$1, notEmpty), 1),
    mirrorRtlLang: /* #__PURE__ */ flow(Number, Boolean),
    mobileCssSelector: String,
    mobileMargin: String,
    mobileOnline: online,
    mobilePosition: toUpper,
    mobileStyleConfig: identity$1,
    mode: toLower,
    noCheapest: /* #__PURE__ */ flow(Number, Boolean),
    online,
    otaAnonym: /* #__PURE__ */ flow(Number, Boolean),
    otaAnonymTexts: /* #__PURE__ */ ary(/* #__PURE__ */ partialRight(map, /* #__PURE__ */ ((codes) => (v, k) => ((codes.includes(k) && trim(v)) || undefined))(/* #__PURE__ */ Object.values(LanguageCode))), 1),
    position: toUpper,
    priceNight: Number,
    priceRoom: /* #__PURE__ */ flow(Number, Boolean),
    showClosed: Number,
    showContact: /* #__PURE__ */ flow(Number, Boolean),
    showSaveSearch: /* #__PURE__ */ flow(Number, Boolean),
    styleConfig: identity$1,
    termsActive: /* #__PURE__ */ flow(Number, Boolean),
    zIndex: Number,
});

const toBoolean = (value) => Boolean(isNumeric(value) ? Number(value) : value);

const toStringTrim = /* #__PURE__ */ flow(String, trim);

const formattingSchemaContext = /* #__PURE__ */ protect({
    accountKey: String,
    bookingSystem: Number,
    canApplyDiscount: toBoolean,
    contextToken: String,
    country: /* #__PURE__ */ flow(toLower, trim),
    fingerprint: toStringTrim,
    geolocationId: Number,
    hotelCurrency: String,
    hotelId: Number,
    ip: String,
    isAbTestControlUser: /* #__PURE__ */ flow(Number, Boolean),
    language: toStringTrim,
    location: String,
    logged: /* #__PURE__ */ flow(Number, Boolean),
    media: String,
    nolog: /* #__PURE__ */ flow(Number, Boolean),
    origin: /* #__PURE__ */ flow(Number, Boolean),
    overrides: identity$1, // Formatted/validated at spec_thn
    pageId: Number,
    pageName: String,
    promocodeVars: identity$1,
    propertyId: Number,
    referrer: String,
    saveSearchBaseUrl: String,
    scriptVersion: String,
    searchUrl: /* #__PURE__ */ flow(Number, Boolean), // setting
    terms: identity$1, // Formatted/validated at spec_thn
    visitDate: Number, // The main visit date (anciently search_date, currently generally known as pageLoadTime)
    visitorLastComparison: identity$1, // User data
    widgetName: String,
});

function baseFromContextWhenUndefined(path) {
    return function boundBaseFromContextWhenUndefined(formatter) {
        const fromContext = baseFromContext(path)(protect(formatter));
        return function boundFromContextWhenUndefined(value, context) {
            return (isUndefined(value) ? fromContext : formatter)(value, context);
        };
    };
}

function baseDefault(defaultValue) {
    return function boundDefault(value) {
        return value === undefined
            ? defaultValue
            : value;
    };
}

/**
 * Attempts to convert the input value to a valid date string in THN format.
 */
function dateAttempt(value) {
    if (!(typeof value === 'string' || typeof value === 'number' || value instanceof Date)) {
        return undefined;
    }
    // if the value is a string, format the date in THN format to check if it is valid
    const parsedValue = typeof value === 'string' ? value.replace(/-/g, '/') : value;
    if (typeof parsedValue === 'string' && isThnDate(parsedValue)) {
        return parsedValue;
    }
    // if it wasn't a correct THN format date, let's try to get it anyway
    const newValue = dateToString(parsedValue);
    if (newValue && isThnDate(newValue)) {
        return newValue;
    }
    return undefined;
}

function inferAdults(value, { adults, guests, rooms, roomsDispo, } = {}) {
    // Just formatting the same "adults" property
    if (value !== undefined) {
        return Number(value);
    }
    // Converting from sse
    if (isArray(rooms) && rooms.length) {
        return sum(rooms.map((r) => r.adults));
    }
    // Taking it from the "roomsDispo"
    if (isArray(roomsDispo) && roomsDispo.length) {
        return sum(roomsDispo.filter(isPlainObject).map((r) => r.adults));
    }
    // Taking it from the "adults"
    if (adults !== undefined) {
        return Number(adults);
    }
    // Taking it from the "guests"
    if (guests !== undefined) {
        return Number(guests);
    }
    return undefined;
}
function inferBabies(value, { babies, rooms, roomsDispo } = {}) {
    // Just formatting the same "babies" property
    if (value !== undefined) {
        return Number(value);
    }
    // Converting from sse
    if (isArray(rooms) && rooms.length) {
        return sum(rooms.map((r) => (r.children || []).filter((c) => c.age === BABIES_AGE).length));
    }
    // Taking it from "roomsDispo"
    if (isArray(roomsDispo) && roomsDispo.length) {
        return sum(roomsDispo.filter(isPlainObject).map(function (r) {
            return isArray(r.childrenAges)
                ? r.childrenAges.filter((c) => c === BABIES_AGE).length
                : 0;
        }));
    }
    // Taking it from the "babies"
    if (babies !== undefined) {
        return Number(babies);
    }
    return undefined;
}
function inferChildren(value, { children, rooms, roomsDispo } = {}) {
    // Just formatting the same "children" property
    if (value !== undefined) {
        return Number(value);
    }
    // Converting from sse
    if (isArray(rooms) && rooms.length) {
        return sum(rooms.map((r) => (r.children || []).filter((c) => c.age !== BABIES_AGE).length));
    }
    // Taking it from "roomsDispo"
    if (isArray(roomsDispo) && roomsDispo.length) {
        return sum(roomsDispo.filter(isPlainObject).map(function (r) {
            return isArray(r.childrenAges)
                ? r.childrenAges.filter((c) => c !== BABIES_AGE).length
                : (r.children || 0);
        }));
    }
    // Taking it from the "children"
    if (children !== undefined) {
        return Number(children);
    }
    return undefined;
}
function fromSse(value) {
    return value && value.replace(/-/g, '/');
}
function dateBegin$3(value, { begin_date: beginDate } = {}) {
    // Just formatting the same value
    if (value !== undefined) {
        return dateAttempt(value);
    }
    // Or converting from sse
    return fromSse(beginDate);
}
function dateEnd$3(value, { end_date: endDate } = {}) {
    // Just formatting the same value
    if (value !== undefined) {
        return dateAttempt(value);
    }
    // Or converting from sse
    return fromSse(endDate);
}
function inferGuests(value, { adults, babies, children, guests, rooms, roomsDispo, } = {}) {
    // Just formatting the same "guests" property
    if (value !== undefined) {
        return Number(value);
    }
    // Converting from sse
    if (isArray(rooms) && rooms.length) {
        return sum(rooms.map((r) => (r.children || []).length + r.adults));
    }
    // Taking it from "roomsDispo"
    if (isArray(roomsDispo) && roomsDispo.length) {
        return sum(roomsDispo.filter(isPlainObject).map(function (r) {
            return (r.adults || 0)
                + (isArray(r.childrenAges)
                    ? r.childrenAges.length
                    : (r.children || 0));
        }));
    }
    // Taking it from the "guests"
    if (guests !== undefined) {
        return Number(guests);
    }
    // Taking it from adults/children/babies
    if (adults) {
        return adults + (children || 0) + (babies || 0);
    }
    return value;
}
function pricematchId(value) {
    if (isString(value)) {
        return value.split(',').map(Number);
    }
    return value;
}
function inferRooms(value, { rooms, roomsDispo } = {}) {
    // Just formatting the same "rooms" property
    if (value !== undefined && !isArray(rooms)) {
        return Number(value);
    }
    // Converting from sse
    if (isArray(rooms) && rooms.length) {
        return rooms.length;
    }
    // Taking it from "roomsDispo"
    if (isArray(roomsDispo) && roomsDispo.length) {
        return roomsDispo.filter(isPlainObject).length;
    }
    // Taking from the context
    if (isNumeric(rooms)) {
        return Number(rooms);
    }
    // Default value
    return 1;
}
function inferRoomsDispo(value, { adults, babies, children, rooms, roomsDispo, } = {}) {
    const effectiveValue = value ?? roomsDispo;
    // Just formatting the same "roomsDispo" property
    if (Array.isArray(effectiveValue) && effectiveValue.length) {
        return effectiveValue.filter(isPlainObject)
            .map((roomInfo) => ({ ...roomInfo, childrenAges: roomInfo.childrenAges ?? [...Array(Number(roomInfo.children) || 0)].map(() => CHILDREN_AGE) }));
    }
    // Converting from sse
    if (isArray(rooms) && rooms.length) {
        return rooms.map((r) => ({
            adults: Number(r.adults),
            children: (r.children || []).length,
            childrenAges: (r.children || []).map((c) => c.age),
        }));
    }
    // Taking it from adults/children/babies
    const data = [...Array(Number(rooms) || 1)]
        .map((_r) => ({ adults: 0, children: 0, childrenAges: [] }));
    for (let count = 0; count < adults || 0; count += 1) {
        data[count % data.length].adults += 1;
    }
    for (let count = 0; count < babies || 0; count += 1) {
        data[count % data.length].childrenAges.push(BABIES_AGE);
        data[count % data.length].children += 1;
    }
    for (let count = 0; count < children || 0; count += 1) {
        data[count % data.length].childrenAges.push(CHILDREN_AGE);
        data[count % data.length].children += 1;
    }
    return data;
}
// eslint-disable-next-line no-shadow
function inferNights(value, { dateBegin, dateEnd } = {}) {
    if (value !== undefined) {
        return Number(value);
    }
    if (dateBegin && dateEnd) {
        const begin = dateAttempt(dateBegin);
        const end = dateAttempt(dateEnd);
        return daysBetween(begin, end);
    }
    return undefined;
}
const formattingSchemaSearch = {
    adults: inferAdults,
    babies: inferBabies,
    children: inferChildren,
    currency: /* #__PURE__ */ protect(toUpper),
    dateBegin: dateBegin$3,
    dateEnd: dateEnd$3,
    flightOrigin: /* #__PURE__ */ protect(/* #__PURE__ */ flow(toUpper, trim)),
    flightDestination: /* #__PURE__ */ protect(/* #__PURE__ */ flow(toUpper, trim)),
    guests: inferGuests,
    noRooms: /* #__PURE__ */ protect(/* #__PURE__ */ flow(Number, Boolean)),
    price: /* #__PURE__ */ protect(Number),
    priceSpecial: /* #__PURE__ */ flow(/* #__PURE__ */ baseFromContextWhenUndefined(['priceSpecial', /* from sse case */ 'price_special'])(Number), /* #__PURE__ */ baseDefault(0), Number),
    priceType: /* #__PURE__ */ baseFromContextWhenUndefined(['priceType', /* from sse case */ 'price_type'])(identity$1),
    pricematchId,
    promocode: (value) => (value ? String(value) : undefined),
    promocodeType: (value) => (value ? String(value) : undefined),
    roomDetails: /* #__PURE__ */ baseFromContextWhenUndefined(['roomDetails', /* from sse case */ 'room_details'])((v) => toCamelCase$1(v)),
    rooms: inferRooms,
    roomsDispo: inferRoomsDispo,
    nights: inferNights,
};

function dateBegin$2(value, { daysFrom } = {}) {
    if (value) {
        return value;
    }
    if (!daysFrom) {
        return undefined;
    }
    return dateToString(addDays(new Date(), parseInt(daysFrom, 10)));
}
function dateEnd$2(value, { daysFrom, nights } = {}) {
    if (value) {
        return value;
    }
    if (!(daysFrom && nights)) {
        return undefined;
    }
    return dateToString(addDays(new Date(), parseInt(daysFrom, 10) + parseInt(nights, 10)));
}
// eslint-disable-next-line prefer-object-spread
const protectedProps = /* #__PURE__ */ protect(/* #__PURE__ */ Object.assign({}, 
/* #__PURE__ */ pick(formattingSchemaContext, [
    'pageId',
    'propertyId',
]), 
/* #__PURE__ */ pick(formattingSchemaConfig, [
    'closeTime',
    'cssSelector',
    'gotoengine',
    'gotoengineBtnText',
    'noCheapest',
    'online',
    'priceNight',
    'showClosed',
]), 
/* #__PURE__ */ pick(formattingSchemaSearch, [
    'adults',
    'children',
    'currency',
    'price',
    'rooms',
])));
const unprotectedProps = {
    custom: /* #__PURE__ */ baseNegate(/* #__PURE__ */ baseFromContext('prcPagesCache')(Number)),
    dateBegin: dateBegin$2,
    dateEnd: dateEnd$2,
    margin: /* #__PURE__ */ baseFromContext('toolMargin')(formattingSchemaConfig.margin),
    mobileCssSelector: /* #__PURE__ */ baseFromContext('mobCssSelector')(formattingSchemaConfig.mobileCssSelector),
    mobileMargin: /* #__PURE__ */ baseFromContext('mobToolMargin')(formattingSchemaConfig.mobileMargin),
    mobileOnline: /* #__PURE__ */ baseFromContext('mobOnline')(formattingSchemaConfig.mobileOnline),
    mobilePosition: /* #__PURE__ */ baseFromContext('mobPstn')(formattingSchemaConfig.mobilePosition),
    mobileStyleConfig: /* #__PURE__ */ baseFromContext('mobStyleConfig')(formattingSchemaConfig.mobileStyleConfig),
    position: /* #__PURE__ */ baseFromContext('wdgtPstn')(formattingSchemaConfig.position),
    showContact: /* #__PURE__ */ baseFromContext('contact')(formattingSchemaConfig.showContact),
    showSaveSearch: /* #__PURE__ */ baseFromContext('sendSearch')(formattingSchemaConfig.showSaveSearch),
    styleConfig: /* #__PURE__ */ baseFromContext('wdgtStyleConfig')(formattingSchemaConfig.styleConfig),
};
// eslint-disable-next-line prefer-object-spread
const formattingSchema$b = /* #__PURE__ */ Object.assign({}, protectedProps, unprotectedProps);

const comparisonPagesModel = /* #__PURE__ */ createModel(formattingSchema$b, validationSchema$a);

const isUlid = /* #__PURE__ */ overEvery(isString, baseLength(26));

function bindNestedSchemaToLocalContext(validationSchema, ancestorKey = '') {
    return map(validationSchema, (validator, key) => {
        const qualifiedKey = [ancestorKey, key].filter(Boolean).join('.');
        return isFunction(validator)
            ? (value, context) => validator(value, get$1(context, ancestorKey) || context)
            : bindNestedSchemaToLocalContext(validator, qualifiedKey);
    });
}

function isSseDate(value) {
    return /^\d{4}-\d{2}-\d{2}$/.test(value)
        && isThnDate(value.replace(/-/g, '/'));
}
const isNonEmptySseDate = /* #__PURE__ */ overEvery(isNonemptyString, isSseDate);
function rooms$2(value) {
    if (!Array.isArray(value) || value.length === 0) {
        return false;
    }
    return value.every(function (room) {
        return isAdults(room.adults)
            && (room.children === undefined
                || room.children.every(function (item) {
                    return item.age === null || isIntegerGteZero(item.age);
                }));
    });
}
const configValidationSchema = {
    ab_test: validationSchemaConfig.abTest,
    online: validationSchemaConfig.online,
    online_mobile: validationSchemaConfig.mobileOnline,
    price_night: validationSchemaConfig.priceNight,
    price_room: validationSchemaConfig.priceRoom,
};
const validationSchemaParams = {
    begin_date: isNonEmptySseDate,
    config: configValidationSchema,
    country_code: validationSchemaContext.country,
    currency: validationSchemaSearch.currency,
    custom: validationSchemaMetadata.custom,
    end_date: isNonEmptySseDate,
    flight_destination: validationSchemaSearch.flightDestination,
    flight_origin: validationSchemaSearch.flightOrigin,
    hotel_id: validationSchemaContext.hotelId,
    is_ab_test_control_user: validationSchemaContext.isAbTestControlUser,
    language: validationSchemaContext.language,
    price: validationSchemaSearch.price,
    price_special: validationSchemaSearch.priceSpecial,
    price_type: validationSchemaSearch.priceType,
    pricematch_ids: validationSchemaSearch.pricematchId,
    promocode: validationSchemaSearch.promocode,
    promocode_type: validationSchemaSearch.promocodeType,
    property_id: validationSchemaContext.propertyId,
    rooms: rooms$2,
    room_details: (v) => validationSchemaSearch.roomDetails(v && toCamelCase$1(v)),
    search_id: isUlid,
};
const validationSchema$9 = /* #__PURE__ */ bindNestedSchemaToLocalContext({
    // Note: "contextToken" is the **only** camel case prop in this schema
    contextToken: validationSchemaContext.contextToken,
    data: {
        params: validationSchemaParams,
    },
    metadata: {
        fingerprint: validationSchemaContext.fingerprint,
        location: validationSchemaContext.location,
        media: validationSchemaContext.media,
        parent_id: isIntegerGtZero,
        page_load_date: isUnixTs,
        page_id: validationSchemaContext.pageId,
        page_name: validationSchemaContext.pageName,
        price_version: validationSchemaMetadata.priceVersion,
        referrer: validationSchemaContext.referrer,
        trace_id: is32CharString,
    },
});

function baseFromContextAfterAttempt(path) {
    return function boundBaseFromContextAfterAttempt(formatter) {
        const fromContext = baseFromContext(path)(protect(formatter));
        return function boundFromContextAfterAttempt(value, context) {
            const result = formatter(value, context);
            return isUndefined(result) ? fromContext(value, context) : result;
        };
    };
}

function baseExtractFlatFormatter(formattingSchema) {
    return function boundExtractFlatFormatter(prop) {
        const flatProp = prop.split('.').pop();
        return baseFromContextAfterAttempt([flatProp, prop])(get$1(formattingSchema, prop));
    };
}

function orUlid(value) {
    return value || ulid$1();
}

/* eslint no-bitwise: OFF */
const s = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';
const l = /* #__PURE__ */ Array.from(s).reduce(
// eslint-disable-next-line no-return-assign,no-param-reassign,no-multi-assign,no-sequences
(t, c, i) => ((t[c] = t[c.toLowerCase()] = i), t), {
    I: s.indexOf('1'),
    i: s.indexOf('1'),
    L: s.indexOf('1'),
    l: s.indexOf('1'),
    O: s.indexOf('0'),
    o: s.indexOf('0'),
    U: s.indexOf('V'),
    u: s.indexOf('V'),
});
const e = (t) => l[t];
function decode(t) {
    const c = new Uint8Array(16);
    const i = [];
    for (let f = 0, A = t.length; f < A; f += 1) {
        i.push(e(t[f]));
    }
    // eslint-disable-next-line no-return-assign
    return ((c[0] = (i[0] << 5) | i[1]),
        (c[1] = (i[2] << 3) | (i[3] >> 2)),
        (c[2] = (i[3] << 6) | (i[4] << 1) | (i[5] >> 4)),
        (c[3] = (i[5] << 4) | (i[6] >> 1)),
        (c[4] = (i[6] << 7) | (i[7] << 2) | (i[8] >> 3)),
        (c[5] = (i[8] << 5) | i[9]),
        (c[6] = (i[10] << 3) | (i[11] >> 2)),
        (c[7] = (i[11] << 6) | (i[12] << 1) | (i[13] >> 4)),
        (c[8] = (i[13] << 4) | (i[14] >> 1)),
        (c[9] = (i[14] << 7) | (i[15] << 2) | (i[16] >> 3)),
        (c[10] = (i[16] << 5) | i[17]),
        (c[11] = (i[18] << 3) | (i[19] >> 2)),
        (c[12] = (i[19] << 6) | (i[20] << 1) | (i[21] >> 4)),
        (c[13] = (i[21] << 4) | (i[22] >> 1)),
        (c[14] = (i[22] << 7) | (i[23] << 2) | (i[24] >> 3)),
        (c[15] = (i[24] << 5) | i[25]),
        c);
}
// eslint-disable-next-line no-bitwise
const ulidToHexString = (str) => Array.from(decode(str), (byte) => `0${(byte & 0xFF).toString(16)}`.slice(-2)).join('');

const validationSchema$8 = /* #__PURE__ */ bindNestedSchemaToLocalContext({
    config: validationSchemaConfig,
    context: validationSchemaContext,
    metadata: validationSchemaMetadata,
    search: validationSchemaSearch,
});

const formattingSchemaMetadata = /* #__PURE__ */ protect({
    custom: Boolean,
    priceVersion: Number,
});

const formattingSchema$a = /* #__PURE__ */ bindNestedSchemaToLocalContext({
    config: /* #__PURE__ */ map(formattingSchemaConfig, (formatter, key) => baseFromContextAfterAttempt(key)(formatter)),
    context: /* #__PURE__ */ map(formattingSchemaContext, (formatter, key) => baseFromContextAfterAttempt(key)(formatter)),
    metadata: /* #__PURE__ */ map(formattingSchemaMetadata, (formatter, key) => baseFromContextAfterAttempt(key)(formatter)),
    search: /* #__PURE__ */ map(formattingSchemaSearch, (formatter, key) => baseFromContextAfterAttempt(key)(formatter)),
});

const comparisonStandardModel = /* #__PURE__ */ createModel(formattingSchema$a, validationSchema$8);

function formatDate$1(value) {
    // Converting from "price" canonical format
    return value && dateAttempt(value)?.replace(/\//g, '-');
}
function beginDate(value, { dateBegin }) {
    if (value !== undefined) {
        return value;
    }
    return formatDate$1(dateBegin);
}
function endDate(value, { dateEnd }) {
    if (value !== undefined) {
        return value;
    }
    return formatDate$1(dateEnd);
}
function rooms$1(value, { adults, children, babies, rooms: roomsPayload, roomsDispo, }) {
    if (value !== undefined && Array.isArray(value)) {
        return value;
    }
    // "roomsDispo" is the dominant source
    if (Array.isArray(roomsDispo)) {
        return roomsDispo.filter(isPlainObject).map((r) => ({
            adults: Number(r?.adults),
            // "childrenAges" is the dominant source
            children: Array.isArray(r.childrenAges)
                ? r.childrenAges.map((a) => ({ age: Number(a) }))
                : [...Array(Number(r.children || 0))].map((a) => ({ age: CHILDREN_AGE })),
        }));
    }
    const data = [...Array(roomsPayload || 1)]
        .map((r) => ({ adults: 0, children: [] }));
    for (let count = 0; count < adults || 0; count += 1) {
        data[count % data.length].adults += 1;
    }
    for (let count = 0; count < children || 0; count += 1) {
        data[count % data.length].children.push({ age: CHILDREN_AGE });
    }
    for (let count = 0; count < babies || 0; count += 1) {
        data[count % data.length].children.push({ age: BABIES_AGE });
    }
    return data;
}
const extractFlatFormatterFromComparison = /* #__PURE__ */ baseExtractFlatFormatter(comparisonStandardModel.formattingSchema);
// eslint-disable-next-line prefer-object-spread
const configFormattingSchema = /* #__PURE__ */ Object.assign({
    online_mobile: /* #__PURE__ */ flow(function (value, { mobileOnline } = {}) {
        return value ?? mobileOnline;
    }, comparisonStandardModel.formattingSchema.config.mobileOnline),
}, 
/* #__PURE__ */ [
    'ab_test',
    'online',
    'price_night',
    'price_room',
].reduce((result, prop) => ( /* #__PURE__ */Object.assign(result, /* #__PURE__ */ Object.fromEntries([[prop, extractFlatFormatterFromComparison(`config.${camelCase(prop)}`)]]))), {}));
// eslint-disable-next-line prefer-object-spread
const paramsFormattingSchema = /* #__PURE__ */ Object.assign({
    // Own formatters
    begin_date: beginDate,
    country_code: /* #__PURE__ */ flow((value, { country } = {}) => (value || country || 'ES'), comparisonStandardModel.formattingSchema.context.country),
    end_date: endDate,
    pricematch_ids: /* #__PURE__ */ flow((value, { pricematchId } = {}) => (value || pricematchId), comparisonStandardModel.formattingSchema.search.pricematchId),
    rooms: rooms$1,
    search_id: orUlid,
    config: configFormattingSchema,
}, 
// Reuse some from price
/* #__PURE__ */ [
    'hotel_id',
    'is_ab_test_control_user',
    'language',
    'property_id',
].reduce((result, prop) => ( /* #__PURE__ */Object.assign(result, /* #__PURE__ */ Object.fromEntries([[prop, extractFlatFormatterFromComparison(`context.${camelCase(prop)}`)]]))), {}), 
/* #__PURE__ */ [
    'custom',
].reduce((result, prop) => ( /* #__PURE__ */Object.assign(result, /* #__PURE__ */ Object.fromEntries([[prop, extractFlatFormatterFromComparison(`metadata.${prop}`)]]))), {}), 
/* #__PURE__ */ [
    'currency',
    'flight_destination',
    'flight_origin',
    'price',
    'price_special',
    'price_type',
    'promocode',
    'promocode_type',
].reduce((result, prop) => ( /* #__PURE__ */Object.assign(result, /* #__PURE__ */ Object.fromEntries([[prop, extractFlatFormatterFromComparison(`search.${camelCase(prop)}`)]]))), {}), {
    room_details: /* #__PURE__ */ baseFromContextWhenUndefined([/* from standard case */ 'roomDetails', /* from plain case */ 'room_details'])((v) => toSnakeCase(v)),
});
function traceId(value) {
    return value || ulidToHexString(ulid$1());
}
function parentId(value) {
    return value || 1;
}
// eslint-disable-next-line prefer-object-spread
const metadataFormattingSchema = /* #__PURE__ */ Object.assign({
    trace_id: traceId,
    parent_id: parentId,
    page_load_date: /* #__PURE__ */ flow((value, { visitDate } = {}) => (value || visitDate), Number),
}, 
/* #__PURE__ */ [
    'fingerprint',
    'location',
    'media',
    'page_name',
    'page_id',
    'referrer',
].reduce((result, prop) => ( /* #__PURE__ */Object.assign(result, /* #__PURE__ */ Object.fromEntries([[prop, extractFlatFormatterFromComparison(`context.${camelCase(prop)}`)]]))), {}), 
/* #__PURE__ */ [
    'price_version',
].reduce((result, prop) => ( /* #__PURE__ */Object.assign(result, /* #__PURE__ */ Object.fromEntries([[prop, extractFlatFormatterFromComparison(`metadata.${camelCase(prop)}`)]]))), {}));
const formattingSchema$9 = /* #__PURE__ */ bindNestedSchemaToLocalContext({
    // Note: "contextToken" is the **only** camel case prop in this schema
    contextToken: /* #__PURE__ */ extractFlatFormatterFromComparison('context.contextToken'),
    data: {
        params: paramsFormattingSchema,
    },
    metadata: metadataFormattingSchema,
});

const comparisonSseModel = /* #__PURE__ */ createModel(formattingSchema$9, validationSchema$9);

const validationSchema$7 = {
    price_match: /* #__PURE__ */ overSome(isPlainObject, isNull),
};

// eslint-disable-next-line camelcase
function price_match(value) {
    if (value && isString(value?.vars?.code)) {
        value.vars.code = {
            value: value.vars.code,
        };
    }
    return value;
}
const formattingSchema$8 = {
    price_match,
};

const comparisonSseNormalizerModel = /* #__PURE__ */ createModel(formattingSchema$8, validationSchema$7, { strict: false });
const _transform = comparisonSseNormalizerModel.transform;
comparisonSseNormalizerModel.transform = (...args) => {
    const result = _transform(...args);
    return result && toCamelCase$1(result);
};

const validationSchema$6 = {
    adults: isAdults,
    children: isChildren,
    bookingId: isNonemptyString,
    currency: isCurrencyCode,
    dateBegin: isDateBegin,
    dateEnd: isDateEnd,
    price: isFloatGtZero,
    promocode: isNonemptyString,
    promocodeType: /* #__PURE__ */ baseIn(/* #__PURE__ */ Object.values(DiscountCodeKind)),
    rooms: isIntegerGtZero,
};

function adults(_, { booking } = {}) {
    // Taking it from "rooms"
    if (booking && booking.rooms && isArray(booking.rooms) && booking.rooms.length) {
        return booking.rooms.reduce(function getAdults(total, room) {
            return total + room.adults;
        }, 0);
    }
    return undefined;
}
function children(_, { booking } = {}) {
    // Taking it from "rooms"
    if (booking && booking.rooms && isArray(booking.rooms) && booking.rooms.length) {
        return booking.rooms.reduce(function getAdults(total, room) {
            return total + room.children;
        }, 0);
    }
    return undefined;
}
function bookingId$1(_, { booking } = {}) {
    if (booking?.id !== undefined && booking?.id !== null) {
        return trim(String(booking.id));
    }
    return undefined;
}
function currency$1(_, { currencyCode } = {}) {
    if (currencyCode !== undefined) {
        return trim(toUpper(currencyCode));
    }
    return undefined;
}
function dateBegin$1(_, { booking } = {}) {
    if (booking && booking.checkIn) {
        return dateAttempt(booking.checkIn);
    }
    return undefined;
}
function dateEnd$1(_, { booking } = {}) {
    if (booking && booking.checkOut) {
        return dateAttempt(booking.checkOut);
    }
    return undefined;
}
function price$1(_, { booking } = {}) {
    if (booking && booking.totalCost !== undefined) {
        return Number(booking.totalCost);
    }
    return undefined;
}
function promocode$1(_, { booking } = {}) {
    if (booking && booking.promoCode !== undefined) {
        return trim(String(booking.promoCode));
    }
    return '';
}
function promocodeType$1(_, { booking } = {}) {
    const promocodeTypes = {
        generic: 'default',
        rate: 'rate',
        coupon: 'coupon',
    };
    if (booking && booking.promoCode && booking.promoCodeType !== undefined) {
        const loweredPromocodeType = toLower(booking.promoCodeType);
        return Object.keys(promocodeTypes).includes(loweredPromocodeType) ? promocodeTypes[loweredPromocodeType] : 'default';
    }
    return undefined;
}
function rooms(_, { booking } = {}) {
    // Taking it from "rooms"
    if (booking && booking.rooms && isArray(booking.rooms) && booking.rooms.length) {
        return booking.rooms.length;
    }
    return undefined;
}
const formattingSchema$7 = {
    adults,
    children,
    bookingId: bookingId$1,
    currency: currency$1,
    dateBegin: dateBegin$1,
    dateEnd: dateEnd$1,
    price: price$1,
    promocode: promocode$1,
    promocodeType: promocodeType$1,
    rooms,
};

const datalayerEventBookingModel = /* #__PURE__ */ createModel(formattingSchema$7, validationSchema$6);

function currency(_, { currencyCode } = {}) {
    if (currencyCode !== undefined) {
        return trim(toUpper(currencyCode));
    }
    return undefined;
}
function dateBegin(_, { search } = {}) {
    if (search && search.checkIn) {
        return dateAttempt(search.checkIn);
    }
    return undefined;
}
function dateEnd(_, { search } = {}) {
    if (search && search.checkOut) {
        return dateAttempt(search.checkOut);
    }
    return undefined;
}
function flightOrigin(_, { search } = {}) {
    if (search && search.flightOrigin) {
        return trim(toUpper(search.flightOrigin));
    }
    return undefined;
}
function flightDestination(_, { search } = {}) {
    if (search && search.flightDestination) {
        return trim(toUpper(search.flightDestination));
    }
    return undefined;
}
function noRooms(_, { results } = {}) {
    if (results && results.availability !== undefined) {
        return !results.availability;
    }
    return undefined;
}
function price$2(_, context = {}) {
    const begin = dateBegin(undefined, context);
    const end = dateEnd(undefined, context);
    const flight = flightOrigin(undefined, context);
    const nights = begin && end && daysBetween(begin, end);
    let total = Number(context?.results?.lowestPriceWithTaxes
        || context?.results?.lowestPriceWithoutTaxes);
    if (!total) {
        total = Number(context?.results?.priceWithTaxes
            || context?.results?.priceWithoutTaxes);
    }
    return (!flight && nights && total) ? total / nights : total;
}
function priceType(_, context = {}) {
    if (context?.results?.lowestPriceWithTaxes !== undefined) {
        return SearchPriceType.WithTaxes;
    }
    if (context?.results?.lowestPriceWithoutTaxes !== undefined) {
        return SearchPriceType.WithoutTaxes;
    }
    if (context?.results?.priceWithTaxes !== undefined) {
        return SearchPriceType.WithTaxes;
    }
    if (context?.results?.priceWithoutTaxes !== undefined) {
        return SearchPriceType.WithoutTaxes;
    }
    return undefined;
}
function priceSpecial(_, context = {}) {
    if (context?.results?.lowestPriceWithTaxes !== undefined || context?.results?.lowestPriceWithoutTaxes !== undefined) {
        return Number(SearchPriceSpecial.None);
    }
    if (context?.results?.priceWithTaxes !== undefined || context?.results?.priceWithoutTaxes !== undefined) {
        return Number(SearchPriceSpecial.Generic);
    }
    return undefined;
}
function promocode(_, { search } = {}) {
    if (search && search.promoCode) {
        return trim(String(search.promoCode));
    }
    return '';
}
function promocodeType(_, { search } = {}) {
    const promocodeTypes = {
        generic: 'default',
        rate: 'rate',
        coupon: 'coupon',
    };
    if (search && search.promoCode && search.promoCodeType) {
        const loweredPromocodeType = toLower(search.promoCodeType);
        return Object.keys(promocodeTypes).includes(loweredPromocodeType) ? promocodeTypes[loweredPromocodeType] : 'default';
    }
    return undefined;
}
function rates(ratesPayload) {
    if (isArray(ratesPayload)) {
        return ratesPayload.filter(isPlainObject).map(function (r) {
            return {
                id: r.id ? String(r.id) : null,
                name: r.name ? String(r.name) : null,
                totalNight: r.priceWithTaxes ? Number(r.priceWithTaxes) : null,
                breakfast: !!r.breakfast,
                refundable: !!r.refundable,
            };
        });
    }
    return [];
}
function roomDetails(_, { results } = {}) {
    if (results && results.rooms && isArray(results.rooms) && results.rooms.length) {
        return results.rooms.filter(isPlainObject).map(function (r) {
            return {
                id: r.id ? String(r.id) : null,
                name: r.name ? String(r.name) : null,
                type: r.type && ROOM_TYPES.includes(toLower(r.type)) ? toLower(r.type) : 'standard',
                adults: r.adults ? Number(r.adults) : null,
                children: r.children ? Number(r.children) : null,
                prices: r.rates ? rates(r.rates) : null,
            };
        });
    }
    return undefined;
}
function roomsDispo(_, { search } = {}) {
    if (search && search.rooms && isArray(search.rooms) && search.rooms.length) {
        return search.rooms.filter(isPlainObject).map((r) => {
            const childrenAges = (r.childrenAges || []).filter(isNumericGteZero);
            const hasChildrenAges = !!childrenAges.length;
            const children = (hasChildrenAges ? childrenAges.length : r.children) ?? 0;
            return {
                adults: r.adults,
                children,
                childrenAges: hasChildrenAges ? childrenAges : new Array(children).fill(CHILDREN_AGE),
            };
        });
    }
    return undefined;
}
const formattingSchema$6 = {
    currency,
    dateBegin,
    dateEnd,
    flightOrigin,
    flightDestination,
    noRooms,
    price: price$2,
    priceType,
    priceSpecial,
    promocode,
    promocodeType,
    roomDetails,
    roomsDispo,
};

const datalayerEventSearchModel = /* #__PURE__ */ createModel(formattingSchema$6, validationSchemaSearch);

const validationSchema$5 = {
    event: isNonemptyString,
    thn: {
        currencyCode: isCurrencyCode,
        booking: {
            id: isNonemptyString,
            checkIn: isDataLayerDate,
            checkOut: isDataLayerDate,
            totalCost: isFloatGtZero,
            promoCode: isNonemptyString,
        },
    },
};

const checkIn = (_, { date_begin: dateBegin = '' } = {}) => {
    const formattedDate = typeof dateBegin === 'string' ? dateBegin.replace(/-/g, '/') : dateBegin;
    if (isThnDate(formattedDate)) {
        return dateAttempt(formattedDate)?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1-$2-$3');
    }
    return undefined;
};
const checkOut = (_, { date_end: dateEnd = '' } = {}) => {
    const formattedDate = typeof dateEnd === 'string' ? dateEnd.replace(/-/g, '/') : dateEnd;
    if (isThnDate(formattedDate)) {
        return dateAttempt(formattedDate)?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1-$2-$3');
    }
    return undefined;
};
const currencyCode$1 = (_, { currency = '' } = {}) => {
    if (currency !== undefined) {
        return trim(toUpper(currency));
    }
    return undefined;
};
const bookingId = (_, { booking_id: id = '' } = {}) => {
    if (typeof id === 'string' || typeof id === 'number') {
        const convertedId = typeof id === 'number' ? String(id) : id;
        return trim(convertedId);
    }
    return undefined;
};
const totalCost = (_, { price = '' } = {}) => {
    if (price !== undefined) {
        return Number(price);
    }
    return undefined;
};
const discountCode = (_, { promocode = '' } = {}) => {
    if (promocode !== undefined) {
        return trim(String(promocode));
    }
    return undefined;
};
const formattingSchema$5 = {
    event: (_) => 'thnBookingConfirmation',
    thn: {
        currencyCode: currencyCode$1,
        booking: {
            id: bookingId,
            checkIn,
            checkOut,
            totalCost,
            promoCode: discountCode,
        },
    },
};

/**
 * - input: classic booking data as found in SDK usage (same as classically returned by Engine `bookingParseData`).
 * - output: a DataLayer message corresponding to "event: thnBookingConfirmation"
 */
const bookingDatalayerModel = /* #__PURE__ */ createModel(formattingSchema$5, validationSchema$5);

const validationSchema$4 = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'bookingDetails.*': (value) => {
        const item = value;
        return !!((item?.price && item?.currency) || item?.bookingId);
    },
};

const isDateBeginWithDash = (value, { dateEnd } = {}) => {
    if (!isString(value)) {
        return false;
    }
    const formattedValue = value?.replace(/-/g, '/');
    const formattedDateEnd = dateEnd?.replace(/-/g, '/');
    return isDateBegin(formattedValue, { dateEnd: formattedDateEnd });
};
const isDateEndWithDash = (value, { dateBegin } = {}) => {
    if (!isString(value)) {
        return false;
    }
    const formattedValue = value?.replace(/-/g, '/');
    const formattedDateBegin = dateBegin?.replace(/-/g, '/');
    return isDateEnd(formattedValue, { dateBegin: formattedDateBegin });
};
const validationSchema$3 = {
    adults: isNumericGtZero,
    bookingId: /* #__PURE__ */ overSome(isNonemptyString, isNumericGtZero),
    children: isNumericGtZero,
    currency: isCurrencyCode,
    dateBegin: isDateBeginWithDash,
    dateEnd: isDateEndWithDash,
    price: isNumericGtZero,
    promocode: isString,
    promocodeType: /* #__PURE__ */ baseIn(/* #__PURE__ */ Object.values(DiscountCodeKind)),
    propertyId: isThnId,
    rooms: isNumericGtZero,
    set: isBoolean,
};

const priceValue = (value) => (isString(value) ? parseFloat(value.replace(',', '.')) : value);
const formatDate = (value) => {
    const effectiveValue = isThnDate(value) ? value : dateAttempt(value);
    if (isString(effectiveValue)) {
        // Note for bookings we are formating to simplified ISO YYYY-MM-DD rather than to THN format YYYY/MM/DD
        return effectiveValue.replace(/\//g, '-');
    }
    return undefined;
};
const formatToStringFromNumber = (value) => {
    if ((isString(value) || isNumber(value)) && !Number.isNaN(value)) {
        const convertedId = isNumber(value) ? String(value) : value;
        return trim(convertedId);
    }
    return undefined;
};
const currencyCode = /* #__PURE__ */ flow(toUpper, trim);
const formatToStringValue = /* #__PURE__ */ flow(String, trim);
const formatToNumberValue = Number;
const isSet = (value = true) => value;
const protectedFormattingSchema = /* #__PURE__ */ protect({
    adults: formatToNumberValue,
    bookingId: formatToStringFromNumber,
    children: formatToNumberValue,
    currency: currencyCode,
    dateBegin: formatDate,
    dateEnd: formatDate,
    price: priceValue,
    promocode: formatToStringFromNumber,
    promocodeType: formatToStringValue,
    propertyId: formatToNumberValue,
    rooms: formatToNumberValue,
});
const unprotectedFormattingSchema = {
    set: isSet,
};
// eslint-disable-next-line prefer-object-spread
const formattingSchema$4 = /* #__PURE__ */ Object.assign({}, protectedFormattingSchema, unprotectedFormattingSchema);

const bookingDetailsItemModel = /* #__PURE__ */ createModel(formattingSchema$4, validationSchema$3);

const formattingSchema$3 = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'bookingDetails.*': (value) => bookingDetailsItemModel.transform(value),
};

const bookingDetailsModel = /* #__PURE__ */ createModel(formattingSchema$3, validationSchema$4);

const validationSchema$2 = {
    office: isBoolean,
    online: isBoolean,
    overrides: isPlainObject,
    promocodeVars: (value) => (isPlainObject(value) && Object.values(DiscountCodeKind).every((key) => Array.isArray(value[key]))),
    terms: isKeyedWithLanguage,
};

function overrides(value, context = {}) {
    if (isPlainObject(value)) {
        Object.keys(value).forEach(function (key) {
            const item = value[key];
            if (isNumeric(item)) {
                // Convert to boolean
                value[key] = !empty(item);
            }
        });
    }
    return value;
}

const pickLanguageKeys = /* #__PURE__ */ ary(/* #__PURE__ */ partialRight(pick, /* #__PURE__ */ Object.values(LanguageCode)), 1);
const promocodeVars = (value) => (Object.values(DiscountCodeKind).reduce((acc, cur) => ({ ...acc, [cur]: (value?.[cur] || []) }), {}));
const formattingSchema$2 = {
    office: toBoolean,
    online,
    overrides,
    promocodeVars,
    terms: pickLanguageKeys,
};

const thnDataModel = /* #__PURE__ */ createModel(formattingSchema$2, validationSchema$2, { strict: false });

const validationSchema$1 = () => ({});

function visitorTracker(value) {
    const { sessionTHNRef: sessionThnRef, ...visitorTrackerRest } = value;
    return {
        ...visitorTrackerRest,
        sessionThnRef,
    };
}
function lastComparison(value) {
    const camelized = toCamelCase$1(value);
    if (camelized.status === PriceStatus.WithoutAvailability) {
        camelized[camelCase(PriceStatus.WithoutAvailability)] = true;
    }
    camelized.dateBegin = camelized.dateBegin?.replace?.(/-/g, '/');
    camelized.dateEnd = camelized.dateEnd?.replace?.(/-/g, '/');
    if (isString(camelized.visitDate)) {
        camelized.visitDate = Number(camelized.visitDate) || undefined;
    }
    camelized.widgetName = camelized.widget;
    return camelized;
}
const formattingSchema$1 = {
    'visitor.tracker': /* #__PURE__ */ protect(visitorTracker),
    'visitor.lastComparison': /* #__PURE__ */ protect(lastComparison),
};

const visitorVisitDataAbsNormalizerModel = /* #__PURE__ */ createModel(formattingSchema$1, validationSchema$1, { strict: false });

const validationSchema = {
    tools: isArray,
    snippets: isArray,
};

const languageCodes = /* #__PURE__ */ Object.values(LanguageCode);
const keyMap = /* #__PURE__ */ Object.fromEntries(
/* #__PURE__ */ languageCodes
    .filter((langCode) => langCode.includes('_'))
    // Makes a map of explicit keys to be transformend to a given value ["zh_TW", "zh-TW"]
    .map((langCode) => ([langCode, langCode.replace(/_/g, '-')]))
    // Make sure the "tokens" prop of a tool is deeply not transformed to camelCase (to protect dynamic-tags)
    .concat([['tokens', false]]));
// The resulting keyMap value will look like: { "zh_TW": "zh-TW", "tokens": false }
const toCamelCase = (v) => toCamelCase$1(v, keyMap);
const formattingSchema = {
    'tools.*': toCamelCase,
    'snippets.*': toCamelCase,
};

const visitorToolsAbsNormalizerModel = /* #__PURE__ */ createModel(formattingSchema, validationSchema);

function has(serviceName) {
    const container = serviceName.indexOf('.') > -1
        ? get$1(this, serviceName.split('.').reverse().slice(1).reverse()
            .join('.'))
        : this;
    const name = serviceName.split('.').reverse().slice(0, 1)[0];
    return !!(container && name && container.$list().indexOf(name) > -1);
}
function bottleDecorator(bottle) {
    // Add "$has" method
    Object.defineProperty(bottle.container, '$has', {
        value: has.bind(bottle.container),
    });
    // Add access to the bottle instance through the container
    bottle.factory('bottle', () => bottle);
    return bottle;
}
function bottleFactory() {
    return bottleDecorator(new Bottle());
}

const bottle$1 = /* #__PURE__ */ bottleFactory();

const { container } = bottle$1;

/**
 * The core data object, only defined once per load.
 *
 * @namespace thn.data
 * @memberof thn
 */
const data = {};

/**
 * Returns the current environment value
 * or a boolean if a param is passed to compare.
 *
 * The current application environment is determined via the
 * `thn.data.environment` variable.
 *
 * @param value - The expected environment.
 *  Returns a boolean to express if the current environment matches.
 * @return The current environment value or boolean match.
 */
function environment$1(value) {
    const currentEnvironment = data.environment;
    if (Array.isArray(value)) {
        return value.includes(currentEnvironment);
    }
    if (typeof value === 'string') {
        return value === currentEnvironment;
    }
    return currentEnvironment;
}
/**
 * Gets/sets an environment value.
 *
 * @param key - The name of the variable.
 * @param value - The value to be set.
 * @return The value
 */
function env$1(key, value = null) {
    if (value !== null) {
        container?.logger?.warn('This function has been deprecated in favor of the Agent devtools extension. Find more info at: https://bit.ly/agent-devtools');
        data[key] = value;
    }
    return data[key];
}

function preserve(obj) {
    return omit(obj, this.__preserved.concat(Object.keys(this.__computed)));
}

function reset(filter = preserve) {
    const transform = this.transform || identity$1;
    const original = transform(filter.apply(this, [this.__init]));
    Object.assign(this.data, original);
    return this;
}

/**
 * Setup/configure some data and fns on any `Setupable`.
 */
const setup = function setup({ data, extend = false, functions, methods, source, } = {}) {
    if (this.data === undefined) {
        Object.defineProperty(this, 'data', {
            configurable: false,
            enumerable: true,
            value: data || {},
            writable: false,
        });
    }
    const priscine = () => empty(this.data);
    const inaugural = priscine();
    const preserveBound = preserve.bind(this);
    const callables = (obj) => {
        const refine = inaugural ? identity$1 : preserveBound;
        return filter$1(refine(obj), isFunction);
    };
    const commit = () => {
        reset.apply(this, [inaugural ? identity$1 : preserveBound]);
    };
    const stage = (other = {}) => {
        const previous = this.__init || {};
        this.__init = {
            ...this.__default,
            ...(extend ? previous : {}),
            ...other,
        };
    };
    const top = has$1(this, 'widgets');
    if (priscine()) {
        // 1 - add the computed properties
        Object.defineProperties(this.data, this.__computed);
        // 2 - init with the default data
        stage();
        commit();
        // 3 - init widgets
        if (top) {
            Object.values(WidgetsList).forEach((name) => {
                const camelName = camelCase(name);
                if (!this.widgets || !this.widgets?.[camelName]) {
                    return;
                }
                this.widgets?.[camelName].setup({
                    container: this.container,
                });
            });
        }
    }
    // functions/methods can be injected at any moment
    if (functions) {
        Object.assign(this, callables(functions));
    }
    if (methods) {
        Object.assign(this, map(callables(methods), (fn) => fn.bind(this)));
    }
    const remoteData = source?.initData;
    if (empty(remoteData)) {
        return this;
    }
    stage(remoteData);
    commit();
    // widgets (will work only on top thn)
    if (top && source) {
        Object.values(WidgetsList).forEach((name) => {
            const camelName = camelCase(name);
            try {
                if (!this.widgets?.[camelName]) {
                    return;
                }
            }
            catch (_e) {
                return;
            }
            // setup the widget with the data
            this.widgets[camelName].setup({
                source: source.widgets?.[camelName] || {},
                container: this.container,
            });
        });
    }
    return this;
};

const MAX_WINDOW_MESSAGES = 500;
const LATEST = '4.0';

// Source: https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const pkgSemVerRegExp = /((?:@[^/]*\/)?[^/]*)@(_dev|(?:(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?))/;
const parseVersions = (urls) => Object.fromEntries(urls.map((key) => {
    const m = key.match(pkgSemVerRegExp);
    return m && [m[1], m[2]];
})
    .filter((value) => value !== null));

/// <reference types="systemjs" />
// Common THN
const __default = {
    accountKey: '',
    environment: 'production',
    hostname: 'www.thehotelsnetwork.com',
    // thn script has been initialized
    initialized: false,
    // Build info
    buildDate: "2025-11-12T09:49:40.933Z",
    buildCommit: "24a2cad59",
    // The server time, aka "visitDate"
    pageLoadTime: null,
    // widget version
    version: LATEST,
    versionReal: LATEST,
    // css prefix
    prefix: 'thn--',
    mode: 'hotel',
    office: false,
    // pages
    pages: [],
    // log
    log: [],
    // current page
    pageId: undefined,
    pageName: undefined,
    pageCheckCount: 0,
    rightAlignLanguages: /* #__PURE__ */ Object.values(RightToLeftLanguageCode),
    // the value of the query string param "thn_ref"
    thnRef: undefined,
    // Hotel Timezone
    timezone: undefined,
    // hotel propertyId
    propertyId: 0,
    hotelId: 0,
    hotelCurrency: 'USD',
    globalSettings: {},
    injectedSettings: {},
    propertySettings: {},
    bookingSystemSettings: {},
    corporateSettings: {},
    visitor: {},
    overrides: {},
    // CONSTANTS
    GA_TRACKING_ID: 'UA-62725679-1',
    MAX_WINDOW_MESSAGES,
    promocodeVars: {},
};
function decoratePropertyDescriptor(descriptor = {}) {
    return {
        ...DEFAULT_PROPERTY_DESCRIPTOR,
        ...descriptor,
    };
}
const __computed = {
    /* #__PURE */
    engineId: decoratePropertyDescriptor({
        get() {
            if (this.media?.name === Device.Native) {
                return NATIVE_ENGINE_ID;
            }
            return this.mode === 'hotel' ? this.bookingSystem : this.accountUserId;
        },
    }),
    /* #__PURE */
    host: decoratePropertyDescriptor({
        get() {
            return `https://${this.hostname}`;
        },
    }),
    /* #__PURE */
    media: decoratePropertyDescriptor({
        get: (function () {
            let result; // Memoized
            return function get() {
                // TODO: re-memoize once usage of "production" is standarized
                // if (result) {
                //     return result;
                // }
                const userAgentDetails = container.parseUserAgent();
                if (userAgentDetails.mobile || userAgentDetails.tablet) {
                    result = 2;
                }
                else if (userAgentDetails.native) {
                    result = 4;
                }
                else {
                    result = 1;
                }
                return MEDIA[result];
            };
        }()),
    }),
    /* #__PURE */
    resolvedVersions: decoratePropertyDescriptor({
        get() {
            const System = globalThis.thn?.System;
            const registryKey = System && Object.getOwnPropertySymbols(System)[0];
            if (!registryKey || !System) {
                return {};
            }
            // @ts-ignore System registry is a private object
            const moduleUrls = Object.keys(System[registryKey]);
            // Parse the effectively loaded versions
            return parseVersions(moduleUrls);
        },
    }),
    /* #__PURE */
    script: decoratePropertyDescriptor({
        get() {
            // eslint-disable-next-line no-restricted-globals
            const _global = globalThis;
            return (_global[CURRENT_SCRIPT_VAR] && { src: _global[CURRENT_SCRIPT_VAR] }) // manual
                || Array.from(globalThis.document.querySelectorAll(`script[${CURRENT_SCRIPT_ATTR}="1"]`)).pop();
        },
        set: function trap() { },
    }),
    /* #__PURE */
    scriptSrc: decoratePropertyDescriptor({
        get() {
            return this.script && this.script.src;
        },
        set: function trap() { },
    }),
    /* #__PURE */
    visitDate: decoratePropertyDescriptor({
        get() {
            return this.pageLoadTime;
        },
        set(value) {
            this.pageLoadTime = value;
        },
        enumerable: true,
    }),
};
// data to be preserved when changing script identity
const __preserved = [
    'contextToken',
    'log',
    'visitorToken',
];

/**
 * Global thn namespace.
 * @namespace
 * @global
 * @name thn
 */
const thn$1 = function () { };
Object.assign(thn$1, {
    __default,
    __preserved,
    __computed,
    bottle: bottle$1,
    container,
    setup(options) {
        setup.call(thn$1, {
            data,
            functions: {
                env: env$1,
                environment: environment$1,
                reset,
                setup,
            },
        });
        return this.setup(options);
    },
    transform: thnDataModel.transform,
});

const DEFAULT_DATABASE_NAME$1 = 'ImmortalDB';
const DEFAULT_BASE_PATH = '/__OFFLINE__/';
class CacheApiStore {
    cachePromise;
    globalThis;
    dbName;
    basePath;
    constructor({ globalThis = window, dbName = DEFAULT_DATABASE_NAME$1, basePath = DEFAULT_BASE_PATH }) {
        if (!('caches' in globalThis)) {
            throw new Error('Missing "caches" in globalThis');
        }
        this.globalThis = globalThis;
        this.dbName = dbName;
        this.basePath = basePath;
        this.cachePromise = this.globalThis.caches.open(this.dbName);
        // @ts-ignore need to accommodate to the ImmortalDb Stores async constructors pattern
        // eslint-disable-next-line no-constructor-return
        return (async () => {
            try {
                // @ts-ignore
                await this.cachePromise;
            }
            catch (err) {
                return null;
            }
            return this;
        })();
    }
    async get(key) {
        const cache = await this.cachePromise;
        const res = await cache.match(this.buildKey(key));
        if (!res) {
            return undefined;
        }
        const content = await res.text();
        return content;
    }
    async set(key, value) {
        const cache = await this.cachePromise;
        await cache.put(this.buildKey(key), new Response(value, { headers: { 'content-type': 'text/plain' } }));
    }
    async remove(key) {
        const cache = await this.cachePromise;
        await cache.delete(this.buildKey(key));
    }
    buildKey(key) {
        return `${this.basePath}?${key}`;
    }
}

function createCoder(...fns) {
    const applyFns = flow(...fns);
    return (value) => value && applyFns(value);
}

const defaultEncoder = /* #__PURE__ */ createCoder(stringify, globalThis.btoa);

function unBase64(value) {
    return (isBase64String(value) && globalThis.atob(value)) || value;
}

function unStringify(value) {
    return (isString(value) && JSON.parse(value)) || value;
}

const defaultDecoder = /* #__PURE__ */ createCoder(unBase64, unStringify);

class ImmortalError extends Error {
    constructor(message = 'ImmortalDB unexpected error') {
        super(message);
        this.name = 'ImmortalError';
    }
}

class ImmortalEncoderError extends ImmortalError {
    constructor(message = 'Unable to encode the value to be stored') {
        super(message);
        this.name = 'ImmortalEncoderError';
    }
}

class ImmortalDecoderError extends ImmortalError {
    constructor(message = 'Unable to decode the stored value') {
        super(message);
        this.name = 'ImmortalDecoderError';
    }
}

class ImmortalStoresPartialError extends ImmortalError {
    constructor(message = 'Some stores failed to perform operation') {
        super(message);
        this.name = 'ImmortalStoresPartialError';
    }
}

class ImmortalStoresTotalError extends ImmortalError {
    constructor(message = 'All stores failed to perform operation') {
        super(message);
        this.name = 'ImmortalStoresTotalError';
    }
}

/*! js-cookie v3.0.5 | MIT */
/* eslint-disable no-var */
function assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (name, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    name = encodeURIComponent(name)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      name + '=' + converter.write(value, name) + stringifiedAttributes)
  }

  function get (name) {
    if (typeof document === 'undefined' || (arguments.length && !name)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);

        if (name === found) {
          break
        }
      } catch (e) {}
    }

    return name ? jar[name] : jar
  }

  return Object.create(
    {
      set,
      get,
      remove: function (name, attributes) {
        set(
          name,
          '',
          assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

init(defaultConverter, { path: '/' });

/**
 * Counts unique elements of an iterable.
 */
function countUniques(iterable) {
    let nullishCount = 0;
    const counter = Object.create(null);
    iterable.forEach((el) => {
        if (el === undefined || el === null) {
            nullishCount += 1;
            return;
        }
        const amount = counter[el] || 0;
        counter[el] = amount + 1;
    });
    const result = Object.entries(counter);
    if (nullishCount) {
        result.push([undefined, nullishCount]);
    }
    return result;
}

function getGlobal() {
    if (typeof self !== 'undefined') { return self; }
    if (typeof window !== 'undefined') { return window; }
    if (typeof global !== 'undefined') { return global; }
    throw new Error('unable to locate global object');
}

class Store {
    constructor(dbName = 'keyval-store', storeName = 'keyval') {
        this.storeName = storeName;
        this._dbp = new Promise$1((resolve, reject) => {
            const openreq = indexedDB.open(dbName, 1);
            openreq.onerror = () => reject(openreq.error);
            openreq.onsuccess = () => resolve(openreq.result);
            // First time setup: create an empty object store
            openreq.onupgradeneeded = () => {
                openreq.result.createObjectStore(storeName);
            };
        });
    }
    _withIDBStore(type, callback) {
        return this._dbp.then(db => new Promise$1((resolve, reject) => {
            const transaction = db.transaction(this.storeName, type);
            transaction.oncomplete = () => resolve();
            transaction.onabort = transaction.onerror = () => reject(transaction.error);
            callback(transaction.objectStore(this.storeName));
        }));
    }
}
let store;
function getDefaultStore() {
    if (!store)
        store = new Store();
    return store;
}
function get(key, store = getDefaultStore()) {
    let req;
    return store._withIDBStore('readonly', store => {
        req = store.get(key);
    }).then(() => req.result);
}
function set(key, value, store = getDefaultStore()) {
    return store._withIDBStore('readwrite', store => {
        store.put(value, key);
    });
}
function del(key, store = getDefaultStore()) {
    return store._withIDBStore('readwrite', store => {
        store.delete(key);
    });
}

//
// ImmortalDB - A resilient key-value store for browsers.
//
// Ansgar Grunseid
// grunseid.com
// grunseid@gmail.com
//
// License: MIT
//


const DEFAULT_DATABASE_NAME = 'ImmortalDB';
const DEFAULT_STORE_NAME = 'key-value-pairs';

class IndexedDbStore {
    constructor(dbName = DEFAULT_DATABASE_NAME, storeName = DEFAULT_STORE_NAME) {
        this.store = new Store(dbName, storeName);

        return (async () => {
            // Safari throws a SecurityError if IndexedDB.open() is called in a
            // cross-origin iframe.
            //
            //   SecurityError: IDBFactory.open() called in an invalid security context
            //
            // Catch such and fail gracefully.
            //
            // TODO(grun): Update idb-keyval's Store class to fail gracefully in
            // Safari. Push the fix(es) upstream.
            try {
                await this.store._dbp;
            } catch (err) {
                if (err.name === 'SecurityError') {
                    return null; // Failed to open an IndexedDB database.
                }
                throw err;
            }

            return this;
        })();
    }

    async get(key) {
        const value = await get(key, this.store);
        return typeof value === 'string' ? value : undefined;
    }

    async set(key, value) {
        await set(key, value, this.store);
    }

    async remove(key) {
        await del(key, this.store);
    }
}

//
// ImmortalDB - A resilient key-value store for browsers.
//
// Ansgar Grunseid
// grunseid.com
// grunseid@gmail.com
//
// License: MIT
//

class StorageApiWrapper {
    constructor(store) {
        this.store = store;

        return (async () => this)();
    }

    async get(key) {
        const value = this.store.getItem(key);
        return typeof value === 'string' ? value : undefined;
    }

    async set(key, value) {
        this.store.setItem(key, value);
    }

    async remove(key) {
        this.store.removeItem(key);
    }
}

class LocalStorageStore extends StorageApiWrapper {
    constructor() {
        super(window.localStorage);
    }
}

class SessionStorageStore extends StorageApiWrapper {
    constructor() {
        super(window.sessionStorage);
    }
}

const DEFAULT_VALUE$2 = undefined;
const DEFAULT_KEY_PREFIX = '_immortal|';
const DEFAULT_STORES = [];

const window$1 = /* #__PURE__ */ getGlobal();

try {
    if (window$1 && window$1.indexedDB) {
        DEFAULT_STORES.push(IndexedDbStore);
    }
} catch (err) {}

try {
    if (window$1 && window$1.localStorage) {
        DEFAULT_STORES.push(LocalStorageStore);
    }
} catch (err) {}

const FULFILLED = 'fulfilled';
const REJECTED = 'rejected';

const identity = (value) => value;

class ImmortalStorage extends EventTarget {

    constructor(
        stores = DEFAULT_STORES,
        keyPrefix = DEFAULT_KEY_PREFIX,
        defaultValue = DEFAULT_VALUE$2,
        encoder = identity,
        decoder = identity,
    ) {
        super();
        this._encoder = encoder || identity;
        this._decoder = decoder || identity;
        this._defaultValue = defaultValue;
        this._keyPrefix = keyPrefix ?? DEFAULT_KEY_PREFIX;
        this._stores = [];
        this._locks = new Map();
        this.onReady = (async () => {
            const results = await Promise$1.allSettled(stores.map((StoreClassOrInstance) => {
                if (typeof StoreClassOrInstance !== 'function') {
                    return StoreClassOrInstance;
                }
                try {
                    return new StoreClassOrInstance();
                } catch (error) {
                    return Promise$1.reject(error);
                }
            }));
            this._stores = results
                .filter((result) => result.status === FULFILLED)
                .map((result) => result.value)
                .filter((store) => store);
            if (this._stores.length === 0) {
                return Promise$1.reject(new Error('Unable to construct any store'));
            }
            return Promise$1.resolve();
        })();
    }

    _createErrorFromSettledPromises(settledPromises, operation) {

        const reasons = settledPromises
            .filter((result) => result.status === REJECTED)
            .map((result) => result.reason instanceof Error ? result.reason.message : String(result.reason));

        if (reasons.length > 0) {
            const all = this._stores.length === reasons.length;
            const errorMessage = [
                `${all ? 'All' : 'Some'} stores failed to ${operation}(). Store errors:`,
                ...reasons.map(reason => `    * "${reason}"`),
            ].join('\n');
            const ActualError = all ? ImmortalStoresTotalError : ImmortalStoresPartialError;
            return new ActualError(errorMessage);
        }

        return undefined;
    }

    async _lock(key) {
        if (!this._acquireLock(key)) {
            return new Promise$1((resolve) => {
                this.addEventListener(key, function unlockHandler() {
                    if (this._acquireLock(key)) {
                        this.removeEventListener(key, unlockHandler);
                        resolve();
                    }
                });
            });
        }
    }

    async _unlock(key) {
        this._locks.delete(key);
        this.dispatchEvent(new Event(key));
    }

    _prefix(value) {
        return `${this._keyPrefix}${value}`;
    }

    _acquireLock(key) {
        if (!this._locks.has(key)) {
            this._locks.set(key, true);
            return true;
        }
        return false;
    }

    async get(key, _default = this._defaultValue) {
        await this._lock(key);
        try {
            const result = await this._get(key, _default);
            await this._unlock(key);
            return result;
        } catch (reason) {
            await this._unlock(key);
            throw reason;
        }
    }

    async _get(key, _default = this._defaultValue) {
        await this.onReady;

        const prefixedKey = this._prefix(key);


        const results = await Promise$1.allSettled(
            this._stores.map((store) => store.get(prefixedKey))
        );

        const values = results
            .filter((result) => result.status === FULFILLED)
            .map((result) => result.value);

        const counted = countUniques(values);
        counted.sort((a, b) => a[1] <= b[1]);

        const validated = counted
            .filter(([value]) => value !== undefined && value !== 'undefined');

        if (validated.length === 0) {
            const error = this._createErrorFromSettledPromises(results, 'get');
            if (!error) {
                await this._remove(key);
            }

            return _default;
        }

        const [value] = validated[0];
        let decodedValue;

        try {
            decodedValue = await this._decoder(value);
        } catch (_) {
            throw new ImmortalDecoderError();
        }

        try {
            await this._set(key, decodedValue);
        } catch (error) {
            if (error instanceof ImmortalEncoderError) {
                throw error;
            }
        }

        return decodedValue;
    }

    async set(key, value) {
        await this._lock(key);
        try {
            const result = await this._set(key, value);
            await this._unlock(key);
            return result;
        } catch (reason) {
            await this._unlock(key);
            throw reason;
        }
    }

    async _set(key, value) {
        await this.onReady;

        const prefixedKey = this._prefix(key);
        let encodedValue;

        try {
            encodedValue = await this._encoder(value);
        } catch (_) {
            throw new ImmortalEncoderError();
        }

        if (encodedValue === undefined || encodedValue === 'undefined') {
            throw new ImmortalEncoderError('Unable to store encoded value "undefined"');
        }

        const results = await Promise$1.allSettled(
            this._stores.map((store) => store.set(prefixedKey, encodedValue)),
        );

        const error = this._createErrorFromSettledPromises(results, 'set');
        if (error) {
            throw error;
        }

        const integrityCheckResults = await Promise$1.allSettled(
            this._stores.map((store) => store.get(prefixedKey).then((storedEncodedValue) => {
                if (storedEncodedValue && storedEncodedValue !== 'undefined' && storedEncodedValue !== encodedValue) {
                    return Promise$1.reject(new Error('Integrity check failed'));
                }
            }))
        );

        const integrityError = this._createErrorFromSettledPromises(integrityCheckResults, 'set');
        if (integrityError) {
            throw integrityError;
        }

        return value;
    }

    async remove(key) {
        await this._lock(key);
        try {
            const result = await this._remove(key);
            await this._unlock(key);
            return result;
        } catch (reason) {
            await this._unlock(key);
            throw reason;
        }
    }

    async _remove(key) {
        await this.onReady;

        const prefixedKey = this._prefix(key);

        const results = await Promise$1.allSettled(
            this._stores.map((store) => store.remove(prefixedKey)),
        );

        const error = this._createErrorFromSettledPromises(results, 'remove');
        if (error) {
            throw error;
        }

        return this._defaultValue;
    }
}

function factory({ keyPrefix, defaultValue, encoder = defaultEncoder, decoder = defaultDecoder, indexedDbDatabaseName, indexedDbTableName, }) {
    let indexedDbClassOrInstance = IndexedDbStore;
    let cacheApiStoreClassOrInstance = CacheApiStore;
    if (indexedDbDatabaseName) {
        try {
            const indexedDbArgs = [indexedDbDatabaseName, indexedDbTableName].filter(Boolean);
            indexedDbClassOrInstance = new IndexedDbStore(...indexedDbArgs);
            cacheApiStoreClassOrInstance = new CacheApiStore({
                dbName: indexedDbDatabaseName,
                basePath: 'https://www.thehotelsnetwork.com/__OFFLINE__/',
            });
            // eslint-disable-next-line no-empty
        }
        catch (_) { }
    }
    const stores = [
        cacheApiStoreClassOrInstance,
        indexedDbClassOrInstance,
        LocalStorageStore,
        SessionStorageStore,
    ].filter(Boolean);
    return new ImmortalStorage(stores, keyPrefix, defaultValue, encoder, decoder);
}

/**
 * ROT47 is a derivative of ROT13 which, in addition to scrambling the
 * basic letters, treats numbers and common symbols.
 *
 * @param {string} input='' - The string to rotate
 * @return {string}
 * @example
 * rot47('The Quick Brown Fox Jumps Over The Lazy Dog.')
 * // => "%96 "F:4< qC@H? u@I yF>AD ~G6C %96 {2KJ s@8]"
 */
function rot47(input = '') {
    const output = new Array(input.length);
    for (let i = 0; i < input.length; i += 1) {
        const charCode = input.charCodeAt(i);
        const rotCharCode = charCode >= 33 && charCode <= 126
            ? (33 + ((charCode + 14) % 94))
            : charCode;
        output[i] = String.fromCharCode(rotCharCode);
    }
    return output.join('');
}

function escapeUnicode(str) {
    return str?.split('')
        .map((c) => (
    // eslint-disable-next-line no-control-regex
    /^[\x00-\x7F]$/.test(c)
        ? c
        : c.split('').map(a => `\\u${a.charCodeAt(0).toString(16).padStart(4, '0')}`).join(''))).join('');
}

const rotEncoder = /* #__PURE__ */ createCoder(stringify, escapeUnicode, rot47, globalThis.btoa);

function unEscapeUnicode(str) {
    return str.replace(/\\u([\d\w]{4})/gi, (_, g1) => String.fromCharCode(parseInt(g1, 16)));
}

const unRot = (value) => ((isString(value) && rot47(value)) || value);
const rotDecoder = /* #__PURE__ */ createCoder(unBase64, unRot, unEscapeUnicode, unStringify);

var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    CacheApiStore: CacheApiStore,
    defaultDecoder: defaultDecoder,
    defaultEncoder: defaultEncoder,
    factory: factory,
    rotDecoder: rotDecoder,
    rotEncoder: rotEncoder
});

function createAllowedLocation(callEngine, globalThis, logger) {
    const log = (...msg) => {
        logger.error('allowedLocation()', 'THN Agent is not allowed to run in this context.', ...msg);
    };
    return function allowedLocation() {
        // Script can not run inside this kind of special iframe
        if (globalThis.location.href === 'about:srcdoc') {
            log('Location:', globalThis.location);
            return false;
        }
        // Script can not run inside a webpage that is loaded by the THN personalization web extension
        if (globalThis[PUBLIC_EXT_VAR]) {
            log('Public web extension detected.');
            return false;
        }
        // If the engine implements allowedLocation
        if (callEngine('allowedLocation') === false) {
            log('Forbidden by Engine.');
            return false;
        }
        return true;
    };
}

function isEqual(page, otherPage) {
    if (page.name !== otherPage.name) {
        return false;
    }
    if ((page.location || otherPage.location) && page.location !== otherPage.location) {
        return false;
    }
    if ((page.parameters || otherPage.parameters) && page.parameters !== otherPage.parameters) {
        return false;
    }
    if ((page.conditions || otherPage.conditions) && page.conditions?.toString() !== otherPage.conditions?.toString()) {
        return false;
    }
    return true;
}
function pagesMigrationCheck(pagesCollection, { errorMonitor }) {
    const [referencePages, ...restPagesCollection] = pagesCollection;
    if (restPagesCollection.some((otherPages) => otherPages.length !== referencePages.length)) {
        errorMonitor.addError(new Error('Pages missmatch: different length'));
        return;
    }
    for (let i = 0; i < referencePages.length; i += 1) {
        const referencePage = referencePages[i];
        for (const otherPages of restPagesCollection) {
            const otherPage = otherPages[i];
            if (!isEqual(referencePage, otherPage)) {
                const homonymousSubset = referencePages.filter((p) => p.name === referencePage.name);
                const homonymousOtherSubset = otherPages.filter((p) => p.name === referencePage.name);
                const hasHomonyms = homonymousSubset.length > 1;
                if (!hasHomonyms
                    || homonymousSubset.length !== homonymousOtherSubset.length
                    || !homonymousOtherSubset.find((homonymUnorderedPage) => isEqual(referencePage, homonymUnorderedPage))) {
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    errorMonitor.addError(new Error('Pages missmatch: different item'), { page_id: referencePage.pageId });
                    return;
                }
            }
        }
    }
}

/**
 * @jest-environment jest-environment-jsdom-global
 */
/* eslint-disable @typescript-eslint/naming-convention */
const debugPrefix$7 = 'bootstrap()';
const createBootstrap = (allowedLocation, bottle, bus, callEngine, containerAsync, domReady, environment, errorMonitor, getSetting, globalState, globalThis, languageCheck, logger, loggerStatic, networkIdleCallback, parseUserAgent, shutdown, start, scheduler) => async function bootstrap({ data: basicData }) {
    logger.debug('(timing)', map(globalThis.performance?.timing?.toJSON(), (t) => new Date(t).toISOString()));
    // THN main data setup
    // Important: call thn.setup before, to initialize bs & property settings
    const doSetup = cancellable(async () => {
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        thn$1.setup({ source: basicData });
        await scheduler.yield();
    });
    shutdown(() => doSetup.cancel());
    const widgetsModulePromise = AbortablePromise.from(containerAsync.widgets);
    shutdown(() => widgetsModulePromise.abort());
    if (!basicData) {
        logger.warn('Not possible to bootstrap a Site with empty data');
        return;
    }
    await doSetup();
    // Errors monitor config
    errorMonitor.setConfig({
        account_key: globalState.accountKey,
        booking_system: globalState.bookingSystem,
        build_at: globalState.buildDate,
        build_commit: globalState.buildCommit,
        get country() { return globalState.country; },
        device: globalState.media.name,
        engine_id: globalState.engineId,
        hotel_name: globalState.hotelName,
        mode: globalState.mode,
        office: globalState.office,
        get page_name() { return globalState.pageName; },
        get partnership_id() { return bottle.container.partnershipManager?.getCurrentPartnership()?.getId(); },
        property_id: globalState.propertyId,
        republished_at: globalState.republishDate,
        site_id: globalState.siteId,
        // Usually we want to report "versionReal" which is printed in the module file,
        // rather than "version" which is the site configured version (in the basic fetched json).
        // That is because there is no guarantee the module loaded corresponds to the "version" configured.
        // There is only one exception: if there is value intersection between "versionReal" and "version",
        // then "version" might be the more specific/exact thing to be reported (should be safe at least).
        version: globalState.version.includes(globalState.versionReal)
            ? globalState.version
            : globalState.versionReal,
    });
    // Start a parallel process to check the partnership
    let partnershipId = [];
    // Incorporate the ones in the URL if they exist
    if (globalState.scriptSrc) {
        const src = new URL(globalState.scriptSrc);
        partnershipId = (src.searchParams.get('partnership_id') || '').split(/\s*,\s*/g);
    }
    // Then the ones at property level
    partnershipId = partnershipId.concat(getSetting('partnership_id') || []);
    // And finally check the partnership
    bus.emit('thn:exec', null, {
        func: 'partnershipCheck',
        args: [partnershipId.filter((id) => id)],
    });
    // Now we can start logging ...
    logger.info('Booting THN script ...');
    trigger('thn_setup', {});
    // Basic Data Log
    const hasSemver = globalState.semver && isNumeric(globalState.semver.charAt(0));
    const semverInfoMsg = globalState.semver
        ? ` (semver: ${hasSemver ? globalState.semver : '<unpublished>'})` : '';
    const configuredVersionInfoMsg = globalState.version !== globalState.versionReal
        ? ` (configured: ${globalState.version})` : '';
    logger.info(`Agent version: ${globalState.versionReal}${semverInfoMsg}${configuredVersionInfoMsg}`);
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    logger.info(`Environment: ${environment()}`);
    logger.info(`Site mode: ${globalState.mode.toUpperCase()}`);
    logger.info(`Debug level: ${loggerStatic.getLevel().name} (${loggerStatic.getLevel().value})`);
    if (globalThis.navigator && globalThis.navigator.userAgent) {
        logger.debug('User agent:', globalThis.navigator.userAgent);
    }
    const clientTime = new Date();
    logger.debug('Client browser:', parseUserAgent());
    logger.debug('Client time:', clientTime.toString());
    logger.debug('Client UTC time:', clientTime.toUTCString());
    logger.debug('Client timezone offset:', clientTime.getTimezoneOffset());
    if (!empty(globalState.hotelId) && !empty(globalState.propertyId)) {
        logger.info('Hotel id:', globalState.hotelId);
        logger.info('Property id:', globalState.propertyId);
        logger.info('Hotel name:', globalState.hotelName);
    }
    else {
        logger.info('Account key:', globalState.accountKey);
    }
    logger.info('User id:', globalState.accountUserId);
    logger.info('Booking system:', globalState.bookingSystem);
    logger.info('In iframe:', (isIframed$1() ? 'Yes' : 'No'));
    logger.info('Script src:', globalState.scriptSrc);
    logger.debug(debugPrefix$7, 'Location:', globalThis.location.href);
    if (bottle.container.loadManager) {
        logger.debug('Start loadManager service');
    }
    if (bottle.container.idleManager) {
        logger.debug('Start idleManager service');
    }
    if (bottle.container.scrollManager) {
        logger.debug('Start scrollManager service');
    }
    if (bottle.container.exitManager) {
        logger.debug('Start exitManager service');
    }
    // STEP 4: load engine
    logger.info('Loading engine ...');
    // "async.engine" must be reseted before executin a new instantiation.
    // Note: "async.engine" will internally reset/redefine the sync "engine" service.
    bottle.resetProviders(['async.engine']);
    const engineModulePromise = AbortablePromise.from(containerAsync.engine);
    shutdown(() => engineModulePromise.abort());
    await engineModulePromise;
    // To boot the engine we need to guarantee widgets existence
    await widgetsModulePromise;
    await doSetup();
    // STEP 5: check if this is an allowed url (with Engine execution)
    if (!allowedLocation()) {
        return;
    }
    // TODO: remove this temporal check once pagesNext and pages become one
    if (getSetting('pages_migration_check') && globalState.mode !== 'corporate' && globalState.pages && 'pagesNext' in globalState) {
        pagesMigrationCheck([globalState.pages, globalState.pagesNext], { errorMonitor });
    }
    logger.debug(debugPrefix$7, 'Booting engine');
    // STEP 6: boot the engine if needed
    callEngine('boot');
    // STEP 7: load disparitiesManager
    if (bottle.container.disparitiesManager) {
        logger.debug('Start disparitiesManager service');
    }
    // STEP 8: load demandManager
    if (bottle.container.demandManager) {
        logger.debug('Start demandManager service');
    }
    // STEP 9: load instant booking
    let instantBookingPromise;
    if (getSetting('instant_booking')) {
        instantBookingPromise = AbortablePromise.from(containerAsync.instantBooking);
        shutdown(() => instantBookingPromise.abort());
    }
    // STEP 10: init Swaps
    let swapsBridgePromise;
    if (globalThis[SWAPS_VAR]) {
        swapsBridgePromise = AbortablePromise.from(containerAsync.swapsBridge);
        shutdown(() => swapsBridgePromise.abort());
    }
    // STEP 11: load oraculoManager
    if (bottle.container.oraculoManager) {
        logger.debug('Start oraculoManager service');
    }
    // Generate the function that will call to start
    // once the minimum stuff is ready to rumble
    const starter = cancellable(() => {
        logger.info('Starting regular work (ʘ‿ʘ)');
        const cancellableStart = cancellable(start);
        shutdown(() => {
            cancellableStart.cancel();
        });
        return Promise$1.all([
            instantBookingPromise,
            swapsBridgePromise,
            languageCheck(),
        ])
            .then(() => cancellableStart());
    });
    shutdown(() => {
        starter.cancel();
    });
    const isAudit = ('__nativePromise' in globalThis && '__nativePerformance' in globalThis && '__nativeFetch' in globalThis && '__nativeURL' in globalThis);
    const forceCompleteAudit = new URL(globalThis.location.href).searchParams.has('thn_audit');
    const alterAudit = isAudit && !forceCompleteAudit;
    const startTrigger = globalState.widgetLoad;
    const effectiveTrigger = alterAudit ? 'networkIdleCallback:5000:30000' : startTrigger;
    await new Promise$1((resolve) => {
        let effectiveTriggerName;
        let timeout;
        let idleTime;
        if (effectiveTrigger === 'document.ready') {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            domReady().then(() => resolve(starter()));
        }
        else if (effectiveTrigger?.match(/^window\.load/)) {
            [effectiveTriggerName, timeout = 20000] = effectiveTrigger.split(':');
            let cleanup;
            let forcedStarter;
            const exec = () => { cleanup(); resolve(starter()); };
            if (isNumeric(timeout)) {
                forcedStarter = globalThis.setTimeout(exec, Number(timeout));
            }
            cleanup = () => {
                globalThis.clearTimeout(forcedStarter);
                globalThis.removeEventListener('load', exec, false);
            };
            globalThis.addEventListener('load', exec, false);
            shutdown(cleanup);
        }
        else if (effectiveTrigger?.match(/^requestIdleCallback/)) {
            [effectiveTriggerName, timeout = 800] = effectiveTrigger.split(':');
            // call the starter function when the browser is idle and get the id of the requestIdleCallback
            const requestIdleCallbackId = globalThis.requestIdleCallback(() => { resolve(starter()); }, { timeout: Number(timeout) });
            shutdown(() => { globalThis.cancelIdleCallback(requestIdleCallbackId); });
        }
        else if (effectiveTrigger?.match(/^setTimeout/)) {
            [effectiveTriggerName, timeout = 0] = effectiveTrigger.split(':');
            const delayedStarter = globalThis.setTimeout(() => { resolve(starter()); }, Number(timeout));
            shutdown(() => { globalThis.clearTimeout(delayedStarter); });
        }
        else if (effectiveTrigger?.match(/^networkIdleCallback/)) {
            [effectiveTriggerName, idleTime, timeout] = effectiveTrigger.split(':');
            const options = {};
            if (idleTime) {
                options.idleTime = Number(idleTime);
            }
            if (timeout) {
                options.timeout = Number(timeout);
            }
            const cancel = networkIdleCallback(() => { resolve(starter()); }, options);
            shutdown(() => { cancel(); });
        }
        if (!effectiveTrigger) {
            return;
        }
        logger.info(`End of boot: scheduling start on "${effectiveTriggerName || effectiveTrigger}"${timeout && isNumeric(timeout) ? ` (timeout ${timeout})` : ''}`);
    });
};

let langsRegex;
/**
 * Regular expression that will parse and match both ISO-639-1 and ISO-3166-2 strings.
 * It does not provide validation for region-specific acronyms when testing against ISO-3166-2 strings.
 * It only validates and matches the first 2 chars in the input string value.
 * @typedef languages_regexp
 */
const createLangsRegex = () => {
    if (!langsRegex) {
        langsRegex = new RegExp(`^(${Object.values(LanguageCode).join('|')})([\\s_-]\\w{2,5})?$`, 'i');
    }
    return langsRegex;
};
function executeCallback(callback) {
    return isFunction(callback) ? (payload) => callback(payload) : () => undefined;
}
const normalizeLanguageCode = (value) => {
    if (!isString(value)) {
        return null;
    }
    const langRegex = createLangsRegex();
    const langMatch = value.match(langRegex);
    if (!langMatch) {
        return null;
    }
    const regionCode = (langMatch[2] || '').toUpperCase().replace(/[\s-]+/, '_');
    const normalizedCasing = `${langMatch[1].toLowerCase()}${regionCode}`;
    switch (normalizedCasing) {
        // Chinese traditional should be returned with the region code
        case 'zh_TW':
        case 'zh_HANT':
            return 'zh_TW';
        case 'nb':
        case 'nb_NO':
            return 'no';
        // Default case it to return the 2 letters ISO code without the optional region code
        default:
            return normalizedCasing.split('_')[0];
    }
};
function createSetLanguage(bus, getSetting, globalState, logger) {
    /**
    * Sets the given language as the THN data object language should the language provided is
    * different from the one already persisted in-memory. Additionally it spawns a `thn:language.set`
    * custom event.
    *
    * @param lang - Language token, which will be validated upon parsing. Supports both ISO-639-1 and ISO-3166-2 tokens.
    * @param callback - Callback that will be run once the result object is crafted and prior to broadcasting any event.
    * @returns A Language update object, informing about both whether the language state has changed or not and the current language token.
    */
    return function setLanguage(lang, callback) {
        const customLanguageMap = getSetting('custom_language_map');
        const language = normalizeLanguageCode(customLanguageMap[lang] || lang) ?? 'en';
        const resolve = executeCallback(callback);
        const result = {
            language,
            changed: language !== globalState.language,
        };
        // Nothing to be done if this is the same language already set
        if (!result.changed) {
            resolve(result);
            return result;
        }
        // Otherwise update the overall language state
        // eslint-disable-next-line no-param-reassign
        globalState.language = language;
        logger.info(`Language: "${globalState.language}"`);
        // Resolve the callback before any further action to give a
        // chance to other code to react before the page_check()
        resolve(result);
        // Emit the language change, that will trigger the page_check()
        bus.emit('thn:language.set', null, result);
        return result;
    };
}

// type PartialEngine = Pick<Container['engine'], 'languageCheck'>;
const debugPrefix$6 = 'languageCheck()';
/**
 * RegExp to test common URL pattern like "http://domain.com/en/"
 */
const urlRe = /^\/(\w{2})(-\w{2,4})?(\/|$)/i;
/**
  * Get the HTML lang attr
  */
const getHtmlLang = (globalThis, { attributes = ['lang'] } = {}) => {
    const html = globalThis.document.documentElement;
    const values = attributes.map((attr) => html.getAttribute(attr)).filter((value) => !!value);
    return values.length === 0 ? '' : values[0].substring(0, 2).toLowerCase();
};
function createLanguageCheck(domReady, callEngine, globalThis, logger, setLanguage) {
    /**
    * Get and validate HTML lang attr and use setLanguage()
    */
    const setLanguageFromHtml = (callback) => {
        const htmlLang = getHtmlLang(globalThis);
        return setLanguage(htmlLang, callback);
    };
    const initializeDefaultLang = (resolve, reject) => {
        domReady().then(() => { setLanguageFromHtml(resolve); }, () => { reject(); });
    };
    /**
    * Detects the language of the current page.
    */
    return function languageCheck() {
        logger.debug(debugPrefix$6, 'Call');
        return new Promise$1((resolve, reject) => {
            const context = {
                langs: createLangsRegex(),
                urlRe,
                getHtmlLang: () => getHtmlLang(globalThis),
            };
            Promise$1.resolve(callEngine('languageCheck', context))
                .then((detectedLang) => {
                if (!detectedLang) {
                    return initializeDefaultLang(resolve, reject);
                }
                return setLanguage(detectedLang, resolve);
            })
                .catch(() => { initializeDefaultLang(resolve, reject); });
        });
    };
}

function createOnStateChange(bus, callEngine, globalThis, logger) {
    return function onStateChange(event) {
        bus.emit('thn:on-state-change#start', null); // #start of function execution hook
        const debugPrefix = 'onStateChange()';
        const context = {
            detail: event.detail || {
                state: null,
                title: globalThis.document.title,
                url: globalThis.location.toString(),
            },
        };
        logger.debug(debugPrefix, 'Call');
        logger.debug(debugPrefix, 'State:', context.detail.state);
        logger.debug(debugPrefix, 'Title:', context.detail.title);
        logger.debug(debugPrefix, 'URL:', context.detail.url);
        bus.emit('thn:on-state-change', null, context); // #default function execution hook
        callEngine('onStateChange', context);
        bus.emit('thn:on-state-change#end', null, context); // #end of function execution hook
    };
}

function createOnHashChange(bus, callEngine, globalThis, logger) {
    return function onHashChange() {
        bus.emit('thn:on-hash-change#start', null); // #start of function execution hook
        const debugPrefix = 'onHashChange()';
        logger.debug(debugPrefix, 'Call');
        logger.debug(debugPrefix, 'Hash:', globalThis.location.hash);
        bus.emit('thn:on-hash-change', null); // #default function execution hook
        callEngine('onHashChange');
        bus.emit('thn:on-hash-change#end', null); // #end of function execution hook
    };
}

/**
 * Check if conditions for a page are met.
 */
function pageCheckConditions(page, services) {
    const { globalThis, logger } = services;
    try {
        const pathRegExp = page.location && new RegExp(page.location, 'i');
        const searchRegExp = page.parameters && new RegExp(page.parameters, 'i');
        if (empty(page.location)
            && empty(page.parameters)
            && empty(page.conditions)) {
            return false;
        }
        if (!empty(page.conditions)
            && typeof page.conditions !== 'function') {
            throw new TypeError('"conditions" must be a function');
        }
        if ((empty(page.location)
            || globalThis.location?.pathname === page.location
            || globalThis.location?.pathname.includes(page.location)
            || (page.location.length > 1 && pathRegExp && globalThis.location?.pathname.match(pathRegExp))) && (empty(page.parameters)
            || globalThis.location?.search.replace('?', '') === page.parameters
            || (searchRegExp && globalThis.location?.search.match(searchRegExp))) && (empty(page.conditions)
            || page.conditions())) {
            return true;
        }
    }
    catch (e) {
        logger.warn('Error on Page evaluation', page);
        logger.error(e);
    }
    return false;
}

const debugPrefix$5$1 = 'pageCheck()';
const detectPage = (globalThis, globalState, logger) => {
    // Public API: It is possible to set/create a page using a global var
    const manualPageName = globalThis[SET_PAGE_NAME_VAR] && String(globalThis[SET_PAGE_NAME_VAR]);
    if (manualPageName) {
        logger.debug(`Manual set of page using "${SET_PAGE_NAME_VAR}": ${manualPageName}`);
        // If the page is manually set using a name
        // let's search a match with our known pages
        const existingPageMatch = globalState.pages.find((page) => page.name === manualPageName);
        // The detectedPage either is the match, or a new fresh page
        // that will be eventually created via visit beacon (backend)
        return existingPageMatch || {
            name: manualPageName,
            pageId: undefined,
        };
    }
    const pageCheckConditionsServices = {
        globalThis,
        logger,
    };
    // Normal flow: check if some of the know thnData.pages fulfills conditions
    return globalState.pages.find((page) => {
        if (pageCheckConditions(page, pageCheckConditionsServices)) {
            // Match! assign and break
            return true;
        }
        return false;
    });
};
function createPageCheck(bus, globalThis, globalState, logger) {
    let runsCounter = 0;
    const pageCheck = ({ ignoreState = false, shouldPageUnload = runsCounter > 0, force = false, } = {}) => {
        // Protect from early executions (from 3rd actors, or engines)
        if (!globalState.initialized && ignoreState !== true) {
            logger.warn(debugPrefix$5$1, 'Not allowed to execute before Agent start()');
            return;
        }
        // Keep track of the number of runs
        runsCounter += 1;
        const detectedPage = detectPage(globalThis, globalState, logger);
        const currentPage = {
            pageId: globalState.pageId,
            pageName: globalState.pageName,
        };
        const isSamePage = detectedPage
            && detectedPage.pageId === currentPage.pageId
            && detectedPage.name === currentPage.pageName;
        // Nothing to do if the detected page is already the current page...
        // except if the option "force" (to process) has been used
        if (isSamePage && !force) {
            return;
        }
        const currentPageIsEmpty = !(currentPage.pageId || currentPage.pageName);
        const pageChanged = (currentPageIsEmpty && detectedPage) // from "no page" to "page x"
            || (detectedPage && !isSamePage) // from "page y" to "page x"
            || (!currentPageIsEmpty && !detectedPage); // from "page y" to "no page"
        // If page was empty and continues being empty we have nothing to do...
        // except if the option "force" (to process) has been used
        // or this is the initial run
        const isInitial = runsCounter <= 1 || globalState.initialized === false;
        const pageContinuesBeingEmpty = currentPageIsEmpty && !pageChanged;
        if (pageContinuesBeingEmpty && !isInitial && !force) {
            return;
        }
        // If we have a currentPage (non-empty), then let's execute unload actions
        // of the (still) currentPage **before** setting the newly detectePage
        if ((!currentPageIsEmpty && shouldPageUnload) || force) {
            bus.emit('thn:exec', null, { func: 'pageUnload' });
        }
        const normalizedPage = {
            pageId: detectedPage?.pageId,
            pageName: detectedPage?.name,
        };
        const result = {
            changed: !!pageChanged,
            ...normalizedPage,
        };
        // Set the detected page in the state object
        Object.assign(globalState, normalizedPage);
        // Emit the result for effects
        bus.emitDelayedReplace('thn:page.set', null, result);
    };
    pageCheck.resetCounter = () => { runsCounter = 0; };
    return pageCheck;
}

const debugPrefix$4$1 = 'pageUnload()';
function createPageUnload(bus, logger) {
    let callbackQueue;
    return function pageUnload(...args) {
        if (!callbackQueue) {
            callbackQueue = generateCallbackQueue(() => {
                logger?.debug(debugPrefix$4$1, 'Call');
                bus?.emit('thn:page.unload', null);
            });
        }
        return callbackQueue(...args);
    };
}

function createReload(logger, pageCheck, pageUnload) {
    return function reload(timeout = 5000) {
        const debugPrefix = 'reload()';
        logger.debug(debugPrefix, 'Call ', timeout);
        const forcedPageCheck = cancellable(() => {
            logger.debug(debugPrefix, 'Exec');
            // This will unload and fully reload the page
            pageCheck({ force: true });
        });
        // Note a pageUnload will cancel the effective work
        setTimeout(forcedPageCheck, timeout);
        pageUnload(() => forcedPageCheck.cancel());
    };
}

const debugPrefix$3$1 = 'start()';
function createStart(bus, errorMonitor, getSetting, globalState, globalThis, logger, pageCheck, isIframed$1$1 = isIframed$1, parseUrlParameter$1 = parseUrlParameter, trigger$1 = trigger) {
    return function start(options = { awakening: false }) {
        try {
            const performancePrefix = 'thn:start';
            const currentMark = `${performancePrefix}#start`;
            globalThis.performance?.clearMarks(currentMark);
            globalThis.performance?.mark(currentMark);
            try {
                const startMark = 'thn:loader#start';
                const endMark = currentMark;
                const duration = globalThis.performance.measure(`thn:(${startMark}->${endMark})`, startMark, endMark)?.duration;
                logger.debug(`(timing) from ${startMark} to ${endMark}:`, duration);
            }
            catch { /* empty */ }
            const isAwakening = options.awakening === true;
            const mustWaitForAwakening = getSetting('disable_await_awake') === false;
            logger.info(`Device type: ${globalState.media.name} (${globalState.media.id})`);
            trigger$1('thn_start', {});
            if (!isAwakening) {
                bus.emit('thn:exec', null, { func: 'listen' });
            }
            if (isIframed$1$1() && mustWaitForAwakening && !isAwakening) {
                logger.debug(debugPrefix$3$1, 'Delaying until awakening arrives ...');
                return;
            }
            // if this is a child script, ping the parent
            if (isIframed$1$1()) {
                logger.debug(debugPrefix$3$1, 'Ping to the parent');
                // this message must succeed, use always *
                globalThis.parent.postMessage({ action: 'thn_ping' }, '*');
            }
            logger.info('Is office:', (globalState.office ? 'Yes' : 'No'));
            // Detection of flag "thn_ref=saved_search_email" only needs to be done once
            // eslint-disable-next-line no-param-reassign
            globalState.thnRef = parseUrlParameter$1('thn_ref');
            // Check Pages. Special attention to Review and Prices Widget
            if (isAwakening) {
                setTimeout(() => {
                    pageCheck({ ignoreState: true });
                    trigger$1('thn_ready', {});
                }, 50);
            }
            else {
                pageCheck({ ignoreState: true });
                trigger$1('thn_ready', {});
            }
        }
        catch (error) {
            errorMonitor.addError(error);
        }
    };
}

const debugPrefix$2$1 = 'shutdown()';
function createShutdown(bus, callEngine, logger, pageUnload) {
    let callbackQueue;
    return function shutdown(...args) {
        if (!callbackQueue) {
            callbackQueue = generateCallbackQueue(() => {
                logger.debug(debugPrefix$2$1, 'Call');
                // Page unload should destroy all widgets set up in the page
                pageUnload();
                // Engine
                callEngine('shutdown');
                // Hard reset the globalState
                bus.emit('thn:exec', null, {
                    func: 'setup',
                    args: [{
                            extend: false,
                            source: {
                                initData: {
                                    initialized: false,
                                },
                            },
                        }],
                });
                // Emit shutdown event
                bus.emit('thn:shutdown', null);
                // Remove all listeners
                bus.emit('thn:exec', null, { func: 'unlisten' });
            });
        }
        return callbackQueue(...args);
    };
}

/* eslint-disable no-continue */
function decodeDeep(data) {
    if (!data && typeof data !== 'object') {
        return;
    }
    const encodedPaths = (ENCODED_PATHS_KEY in data
        && Array.isArray(data[ENCODED_PATHS_KEY])
        && data[ENCODED_PATHS_KEY]) || [];
    // eslint-disable-next-line no-param-reassign
    delete data[ENCODED_PATHS_KEY];
    for (const [key, value] of Object.entries(data)) {
        if (!value) {
            continue;
        }
        if (typeof value === 'string' && encodedPaths.includes(key)) {
            try {
                // eslint-disable-next-line no-param-reassign
                data[key] = rotDecoder(value);
            }
            catch { /* empty */ }
            continue;
        }
        if (typeof value === 'object') {
            decodeDeep(value);
        }
    }
}

/// <reference types="systemjs" />
const route = '/get_loader_data';
const fetchLoaderData = ({ params, baseUrl }) => {
    if (!baseUrl) {
        return Promise$1.reject();
    }
    const { URL } = globalThis;
    const url = new URL(baseUrl);
    url.pathname = route;
    for (const [key, value] of Object.entries(params)) {
        if (value !== undefined) {
            const strValue = String(value);
            const snakeKey = stringSnakeCase(key);
            const effectiveValue = snakeKey === 'property_id' ? rotEncoder(strValue) : strValue;
            if (effectiveValue) {
                url.searchParams.set(snakeKey, effectiveValue);
            }
        }
    }
    const { System } = globalThis.thn || {};
    const loaderDataPromise = System
        ? System.import(url.toString()).then((mod) => (mod.default || {}))
        : Promise$1.resolve({});
    return loaderDataPromise
        .then((loader) => {
        decodeDeep(loader);
        const raw = loader?.data?.initData;
        if (raw) {
            // duplicate "office" from the root level into "initData" too
            raw.office = loader.office;
            // keep a copy of the "real" hostname returned by loader data
            raw.hostnameReal = raw.hostname;
            // and replace the hostname with the one in the URL of this request
            raw.hostname = url.host;
        }
        return loader;
    })
        .catch(() => ({}));
};

function createStopAwakeChildScript(globalState, logger) {
    return function stopAwakeChildScript() {
        if (!globalState.awakening) {
            return;
        }
        logger.debug('stopAwakeChildScript() Parent script do_thn_awake has been stopped');
        clearInterval(globalState.awakening);
        if (globalState.awakeningTimeout) {
            clearTimeout(globalState.awakeningTimeout);
        }
        // eslint-disable-next-line no-param-reassign
        globalState.awakening = null;
        // eslint-disable-next-line no-param-reassign
        globalState.awakeningTimeout = null;
    };
}

// Do not send "awakening" probes to iframes of Facebook, Twitter, Google, Addthis
const blacklistSrc = /https?:\/\/([^.]+\.)*(facebook|twitter|google|addthis)\.com/i;
function createAwakeChildScript(globalState, globalThis, logger, stopAwakeChildScript) {
    return function awakeChildScript() {
        // Early guard: if we already have a registered child agent, return
        if (globalState.childFrame) {
            return;
        }
        if (globalState.awakening) {
            stopAwakeChildScript();
        }
        // eslint-disable-next-line no-param-reassign
        globalState.awakening = setInterval(() => {
            Array.from(globalThis.document.getElementsByTagName('iframe')).forEach((iframeEl) => {
                if (!(iframeEl?.contentWindow)) {
                    return;
                }
                if (iframeEl.src?.match(blacklistSrc)) {
                    return;
                }
                iframeEl.contentWindow.postMessage({ action: 'thn_awake' }, '*');
            });
        }, 400);
        logger.debug('awakeChildScript() Parent script do_thn_awake has been started');
        // eslint-disable-next-line no-param-reassign
        globalState.awakeningTimeout = setTimeout(stopAwakeChildScript, 180000); // 3 mins
    };
}

class PartnershipManager {
    globalThis;
    logger;
    siteCheck;
    constructor(globalThis, logger, siteCheck) {
        this.globalThis = globalThis;
        this.logger = logger;
        this.siteCheck = siteCheck;
    }
    currentPartnership;
    getCurrentPartnership() {
        return this.currentPartnership;
    }
    /**
     * Load a partnership module.
     *
     * @param id - The id of the partnership.
     */
    async load(id) {
        const debugPrefix = 'load()';
        this.logger.debug(debugPrefix, 'Call');
        this.logger.debug(debugPrefix, 'Loading', id);
        let partnershipModule;
        try {
            partnershipModule = await import(`@thehotelsnetwork/agent-partnerships/${id}`);
        }
        catch (_error) {
            partnershipModule = undefined;
        }
        // alias: import('@thehotelsnetwork/agent-partnerships')
        if (!partnershipModule) {
            this.logger.debug(debugPrefix, 'Partnership not found', id);
            return undefined;
        }
        return partnershipModule.factory({
            document: this.globalThis.document,
            thn: this.globalThis.thn,
            window: this.globalThis,
        });
    }
    /**
     * Change the current partnership.
     *
     * @param partnershipOrId - The partnership or its id.
     */
    async change(partnershipOrId) {
        const debugPrefix = 'change()';
        this.logger.debug(debugPrefix, 'Call');
        if (empty(partnershipOrId)) {
            return Promise$1.reject();
        }
        this.logger.debug(debugPrefix, 'Partnership', typeof partnershipOrId === 'string' ? partnershipOrId : partnershipOrId.getId());
        const partnership = typeof partnershipOrId === 'string'
            ? await this.load(partnershipOrId)
            : partnershipOrId;
        if (empty(partnership)) {
            return Promise$1.reject();
        }
        // Shutdown the previous partnership
        if (this.currentPartnership && this.currentPartnership.shutdown) {
            this.logger.debug(debugPrefix, 'Shutting down partnership', this.currentPartnership.getId());
            this.currentPartnership.shutdown();
        }
        this.currentPartnership = partnership;
        // Initialize this new partnership
        if (partnership.boot) {
            this.logger.debug(debugPrefix, 'Booting partnership', partnership.getId());
            partnership.boot();
        }
        // Make an initial site check
        return this.siteCheck();
    }
    async findValidPartnership(partnershipIds) {
        for (const partnershipId of partnershipIds) {
            // eslint-disable-next-line no-await-in-loop
            const partnership = await this.load(partnershipId);
            if (partnership?.check()) {
                return partnership;
            }
        }
        return undefined;
    }
    handlePartnershipChange(partnership) {
        if (partnership && !(this.currentPartnership && this.currentPartnership?.getId() === partnership.getId())) {
            return this.change(partnership);
        }
        return Promise$1.resolve();
    }
    /**
    * Given a list of partnerships, loads and checks them
    * in order, until one is suitable for the current page.
    * Then "installs" it using {@link partnershipManager.change}.
    *
    * If there is a partnership already "installed" it is
    * always included into the list to be checked (trailing).
    *
    * @param candidatePartnershipIds - The partnershisp to be checked.
    */
    check(candidatePartnershipIds) {
        const debugPrefix = 'check()';
        this.logger.debug(debugPrefix, 'Call');
        const partnershipIds = Array.isArray(candidatePartnershipIds)
            ? candidatePartnershipIds
            : candidatePartnershipIds.split(/\s*,\s*/g).filter((id) => id);
        const currentPartnershipId = this.currentPartnership?.getId();
        // In case the current partnership is NOT in the
        // candidate partnerships, add it as a last option.
        // That way we can force to change the partnership by setting,
        // but still will maintain the current partnership if it
        // is suitable for this page.
        if (currentPartnershipId && !partnershipIds.includes(currentPartnershipId)) {
            partnershipIds.push(currentPartnershipId);
        }
        this.logger.debug(debugPrefix, 'Candidates:', partnershipIds);
        return this.findValidPartnership(partnershipIds)
            .then(partnership => this.handlePartnershipChange(partnership))
            .catch(() => { });
    }
}

const debugPrefix$1$1 = 'siteChange()';
function createSiteChange(bootstrap, errorMonitor, globalState, globalThis, logger, scheduler, shutdown) {
    /**
   * Changes the current running site identity.
   *
   * Doesn't validate the changes, that work should
   * be done in {@link thn.siteCheck}.
   *
   * @param [options]
   * @param [options.propertyId] - The propertyId to load.
   * @param [options.accountKey] - The accountKey (corpo) to load.
   * @param [options.loader] - The existing "loader data".
   */
    return function siteChange({ propertyId, accountKey, loader } = {}) {
        logger.debug(debugPrefix$1$1, 'Call');
        // Always shutdown
        shutdown();
        if (!(loader || propertyId || accountKey)) {
            return Promise$1.resolve();
        }
        const loaderDataPromise = loader
            ? Promise$1.resolve(loader)
            : fetchLoaderData({
                params: { propertyId, accountKey },
                baseUrl: globalState.host,
            });
        let isRunning = false;
        const onLoaderData = cancellable(async (finalLoader) => {
            isRunning = true;
            logger.debug(debugPrefix$1$1, 'Got loader data, performing bootstrap()');
            await scheduler.yield();
            return bootstrap(finalLoader)
                .catch((reason) => {
                if (reason instanceof AbortError) {
                    logger.debug(debugPrefix$1$1, 'Bootstrap controlled abort!');
                }
                else {
                    throw reason;
                }
            });
        });
        shutdown(() => {
            if (!isRunning) {
                logger.debug(debugPrefix$1$1, 'Canceling previous siteChange');
                onLoaderData.cancel();
            }
        });
        return loaderDataPromise.then(onLoaderData).catch((e) => {
            errorMonitor.addError(e);
            /* eslint-disable no-console */
            globalThis.console?.error?.(e);
        });
    };
}

const EXTERNAL_ID_PARAM = 'partnership_hotel_id';
const PARTNERSHIP_PARAM = 'partnership_id';

function isSameSite(other, current, _globalThis = globalThis) {
    let effectiveCurrentData = current;
    if (!current) {
        effectiveCurrentData = _globalThis.thn?.data;
    }
    if (!effectiveCurrentData) {
        return false;
    }
    /* eslint-disable eqeqeq */
    if (other.propertyId) {
        return other.propertyId == effectiveCurrentData.propertyId;
    }
    if (other.accountKey) {
        return other.accountKey == effectiveCurrentData.accountKey && other.propertyId == effectiveCurrentData.propertyId;
    }
    /* eslint-enable eqeqeq */
    return false;
}

// eslint-disable-next-line no-underscore-dangle
function _resolveSiteId(url) {
    const { URL } = globalThis;
    const scriptUrl = new URL(url);
    const [propertyId, hotelId, accountKey, bahiaprincipeId, octorateId, partnershipId, externalId,] = [
        scriptUrl.searchParams.get('property_id'),
        scriptUrl.searchParams.get('hotel_id'),
        scriptUrl.searchParams.get('account_key'),
        scriptUrl.searchParams.get('bahiaprincipe_id'),
        scriptUrl.searchParams.get('octorate_id'),
        scriptUrl.searchParams.get('partnership_id'),
        scriptUrl.searchParams.get('partnership_hotel_id'),
    ];
    if (propertyId) {
        return Promise$1.resolve({ propertyId: Number(propertyId) });
    }
    // Legacy hotels do not have a propertyId but someother thing ...
    if (hotelId || bahiaprincipeId || octorateId
        || (partnershipId && externalId)) {
        const askUrl = new URL(scriptUrl);
        askUrl.pathname = '/js/site-identity.json';
        return globalThis.fetch(askUrl.toString(), { credentials: 'include' })
            .then((res) => res.json())
            .catch(() => null);
    }
    if (accountKey) {
        return Promise$1.resolve({ accountKey });
    }
    return Promise$1.resolve(null);
}
const resolveSiteId = /* #__PURE__ */ memoize(_resolveSiteId);

const debugPrefix$8 = 'siteCheck()';
function createSiteCheck(bottle, errorMonitor, globalState, globalThis, logger, siteChange, resolveSiteId$1 = resolveSiteId, isSameSite$1 = isSameSite) {
    /**
   * Check if the current site identity has changed.
   *
   * The site identity refers to the propertyId in a hotel
   * script, or the accountKey in a corpo script.
   *
   * If the function receives an options object with a
   * "loader" property, that takes precedence as the source
   * of the propertyId/accountKey. Otherwise this
   * function will try to use the partnership to guess
   * the current site identity.
   *
   * @param [options.loader] - An existing "loader data".
   */
    return function siteCheck({ loader } = {}) {
        logger.debug(debugPrefix$8, 'Call');
        const resolved = Promise$1.resolve();
        const loaderData = loader?.data?.initData;
        // If a loader has been passed directly
        if (loaderData) {
            logger.debug(debugPrefix$8, 'With loader:', loader);
            if (!isSameSite$1(loaderData)) {
                return siteChange({ loader });
            }
            return resolved;
        }
        // Otherwise check the partnership module
        const currentPartnership = bottle.container.partnershipManager.getCurrentPartnership();
        if (!currentPartnership) {
            logger.debug(debugPrefix$8, 'No partnership installed');
            return resolved;
        }
        let result = currentPartnership.getSiteId();
        if (empty(result)) {
            logger.debug(debugPrefix$8, 'Partnership unable to detect the site id');
            return resolved;
        }
        // When the return value is not a plain object such as null
        // we assume that refers to the "externalId"
        if (!isPlainObject(result)) {
            result = {
                externalId: result,
            };
        }
        // If the partnership has returned a propertyId or accountKey
        // that takes precedence
        if ('propertyId' in result) {
            const propertyId = Number(result.propertyId);
            logger.debug(debugPrefix$8, 'Partnership detected propertyId', propertyId);
            if (!isSameSite$1({ propertyId })) {
                return siteChange({ propertyId });
            }
            return resolved;
        }
        if ('accountKey' in result) {
            const { accountKey } = result;
            logger.debug(debugPrefix$8, 'Partnership detected accountKey', accountKey);
            if (!isSameSite$1({ accountKey })) {
                return siteChange({ accountKey });
            }
            return resolved;
        }
        // Otherwise if the partnership has returned a externalId
        if ('externalId' in result) {
            const { externalId } = result;
            logger.debug(debugPrefix$8, 'Partnership detected externalId', externalId);
            // Build a "virtual" script URL to be passed to resolveSiteId
            const baseUrl = new URL(globalState.scriptSrc || globalState.host || globalThis.location.href);
            if (!externalId) {
                const currentExternalId = baseUrl.searchParams.get(EXTERNAL_ID_PARAM);
                if (currentExternalId) {
                    // The value of "partnership_hotel_id" on the current script
                    // prevails over an emptyish result, because the partnership module
                    // will most probably not pick that value.
                    logger.debug(debugPrefix$8, `Abort: the script fixed externalId ${currentExternalId} prevails`);
                    return resolved;
                }
            }
            Array.from(baseUrl.searchParams.keys()).forEach((key) => { baseUrl.searchParams.delete(key); });
            const partnershipId = currentPartnership.getId();
            if (partnershipId) {
                baseUrl.searchParams.set(PARTNERSHIP_PARAM, partnershipId);
            }
            if (externalId) {
                baseUrl.searchParams.set(EXTERNAL_ID_PARAM, externalId);
            }
            return resolveSiteId$1(baseUrl).then((info) => {
                logger.debug(debugPrefix$8, 'Query result:', info);
                if (partnershipId && externalId && !info) {
                    // PoC: try to register this misses only for Partnership 14.
                    // If this error proves itself useful, we may generalize it.
                    if (partnershipId === '14') {
                        errorMonitor.addError(new Error(`Unmapped ${EXTERNAL_ID_PARAM}`), { [EXTERNAL_ID_PARAM]: externalId, [PARTNERSHIP_PARAM]: partnershipId });
                    }
                }
                const another = info ?? {};
                if (!isSameSite$1(another)) {
                    return siteChange(another);
                }
                return resolved;
            });
        }
        return resolved;
    };
}

function handleDatalayerBookingConfirmation(payload) {

  const debugPrefix = 'handle_datalayer_booking_confirmation()';

  container.logger.debug(debugPrefix, `Received datalayer event "${payload.message.event}"`);
  container.logger.debug(debugPrefix, `${stringify(payload)}`);

  const widget = container.booking;
  const expectedPageName = PageName.BookingConfirmed;
  const shouldUnload = data.pageName !== expectedPageName
  || (data.pageName === expectedPageName && widget.data.mode === 'auto');

  // Destroy this page load
  if (shouldUnload) {
    container.pageUnload();
  }

  // Config de widget in "datalayer" mode
  if (widget.data.mode !== 'datalayer') {
    widget.setConfig({ mode: 'datalayer' });
  }

  // Manually set the page
  if (!data.pageName) {
    container.globalThis[SET_PAGE_NAME_VAR] = expectedPageName;
  }

  // Subscribe to the next page_check
  container.bus.once('thn:page.set', function ({
    changed,
    pageName,
  }) {
    // On page_check, if the page has not changed
    // we should try trigger a widget update to
    // force the reading of the datalayer data
    if (!changed && pageName === expectedPageName) {
      widget.reset().init();
    }

    // If the page changed, actions should happen naturally
  });

  container.pageCheck({ ignoreState: true });
}

function handleDatalayerSearch(payload) {

  const debugPrefix = 'handle_datalayer_search()';

  container.logger.debug(debugPrefix, `Received datalayer event "${payload.message.event}"`);
  container.logger.debug(debugPrefix, `${stringify(payload)}`);

  // If the message contains a search rooms array, we will clone it into the model
  // to avoid the DataLayerHelper handling of "childrenAges: []" as a falsy value (not updating)
  if (payload.message?.thn?.search?.rooms && payload.model?.thn?.search?.rooms) {
    payload.model.thn.search.rooms = collectionClone(payload.message.thn.search.rooms);
  }

  const isPwp = !!(
    (
      get$1(payload, 'message.thn.search')
            && get$1(payload, 'message.thn.search.flightOrigin')
    ) || (
      !get$1(payload, 'message.thn.search')
            && get$1(payload, 'model.thn.search.flightOrigin')
    )
  );
  const widget = container[isPwp ? 'package' : 'price'];
  const expectedPageName = isPwp
    ? PageName.Packages
    : PageName.RoomsAndRates;
  const shouldUnload = data.pageName !== expectedPageName
    || (data.pageName === expectedPageName && widget.data.mode === 'auto');

  // If provided, update agent's active language state
  const language = get$1(payload, 'message.thn.languageCode');
  if (language) {
    container.setLanguage(language);
  }

  // Destroy this page load
  if (shouldUnload) {
    container.pageUnload();
  }

  // Config de widget in "datalayer" mode
  if (widget.data.mode !== 'datalayer') {
    widget.setConfig({ mode: 'datalayer' });
  }

  // Manually set the page
  if (!data.pageName) {
    container.globalThis[SET_PAGE_NAME_VAR] = expectedPageName;
  }

  if (data.pageName === expectedPageName) {
    widget.update();
  }

  container.pageCheck({ ignoreState: true });
}

function handleThnAwake(event) {

  if (!isIframed$1()) {
    return;
  }

  // "thn_awake" action triggers "start" on an sleeping child script
  if (event.data && event.data.action === 'thn_awake') {

    container.logger.debug('handle_thn_awake()', 'Child script awakening ...');

    // Execute "thn.start({ awakening: true });"
    container.bus.emit('thn:exec', null, { func: 'start', args: [{ awakening: true }] });
  }
}

function handleThnExec({ data } = {}) {

  if (!data || data.action !== 'thn_exec') {
    return;
  }

  // "thn_exec" action
  container.logger.debug('handle_thn_exec()', data.payload);
  container.bus.emit('thn:exec', null, data.payload);
}

/* eslint-disable no-console */
/**
 * Prints basic info about the current script in the console.
 * Propagates the call to a possible child script.
 */
function info() {
    const style = 'color: #df421e';
    const max = 120;
    let { href } = container.globalThis.location;
    const { globalState } = container;
    if (!globalState.initialized) {
        console.warn('THN Agent has been not initialized yet');
        return;
    }
    if (href.length > max) {
        const diff = href.length - max;
        const diff2 = Math.round(diff / 2);
        const diff1 = diff - diff2;
        const med = Math.round(href.length / 2);
        href = `${href.substr(0, med - diff1)}...${href.substr(med + diff2)}`;
    }
    console.log('%c*************** Script info ****************', style);
    console.log(`%c**  Version     : ${globalState.version} (using ${globalState.versionReal})`, style);
    console.log(`%c**  Packages    : ${Object.entries(globalState.resolvedVersions).map(pair => `${pair[0]}@${pair[1]}`).join(', ')}`, style);
    console.log(`%c**  Environment : ${globalState.environment}`, style);
    console.log(`%c**  Debug level : ${container.Logger.getLevel().name} (${container.Logger.getLevel().value})`, style);
    console.log(`%c**  Mode        : ${globalState.mode.toUpperCase()}`, style);
    console.log(`%c**  User id     : ${globalState.accountUserId}`, style);
    if (globalState.mode === 'hotel') {
        console.log(`%c**  Property id : ${globalState.propertyId}`, style);
        console.log(`%c**  Hotel id    : ${globalState.hotelId}`, style);
        if (globalState.hotelName) {
            console.log(`%c**  Hotel name  : ${globalState.hotelName}`, style);
        }
    }
    else {
        console.log(`%c**  Account key : ${globalState.accountKey}`, style);
    }
    console.log(`%c**  Engine id   : ${globalState.bookingSystem} (using ${globalState.engineId})`, style);
    if (globalState.bookingSystemName) {
        console.log(`%c**  Engine name : ${globalState.bookingSystemName}`, style);
    }
    if (globalState.siteId) {
        console.log(`%c**  Site id     : ${globalState.siteId}`, style);
    }
    if (globalState.accountId) {
        console.log(`%c**  Account id  : ${globalState.accountId}`, style);
    }
    if (globalState.language) {
        console.log(`%c**  Language    : ${globalState.language}`, style);
    }
    console.log(`%c**  Fingerprint : ${globalState.fingerprint} (source: ${globalState.fingerprintSource})`, style);
    const geolocation = globalState.visitor?.geolocation;
    if (geolocation && geolocation.city && geolocation.country && geolocation.location) {
        console.log(`%c**  Geolocation : ${isPlainObject(geolocation.city) ? geolocation.city.name : geolocation.city}, ${geolocation.country.name} (${geolocation.country.code})`, style);
    }
    if (globalState.pageName && globalState.pageId) {
        console.log(`%c**  Page        : ${globalState.pageName} (${globalState.pageId})`, style);
    }
    console.log(`%c**  Device type : ${globalState.media.name} (${globalState.media.id})`, style);
    console.log(`%c**  Is office   : ${globalState.office ? 'Yes' : 'No'}`, style);
    console.log(`%c**  In iframe   : ${isIframed$1() ? 'Yes' : 'No'}`, style);
    console.log(`%c**  Script src  : ${globalState.scriptSrc}`, style);
    console.log(`%c**  Location    : ${href}`, style);
    if (!empty(container.price.data.debugUrl)) {
        console.log(`%c**  PW debug    : ${container.price.data.debugUrl}`, style);
    }
    if (!empty(container.price.data.status)) {
        console.log(`%c**  PW status   : ${container.price.data.status}`, style);
    }
    if (!empty(container.package.data.debugUrl)) {
        console.log(`%c**  PWP debug   : ${container.package.data.debugUrl}`, style);
    }
    if (!empty(container.package.data.status)) {
        console.log(`%c**  PWP status  : ${container.package.data.status}`, style);
    }
    if (container.swaps) {
        console.log('%c**  Swaps       : Detected. See more with thn.infoSwaps()', style);
    }
    console.log('%c********************************************', style);
    globalState.childFrame?.postMessage({ action: 'thn_info' }, { targetOrigin: '*' });
}

function handleThnInfo(event) {
  // "thn_info" action shows console info about this script
  if (event.data && event.data.action === 'thn_info') {
    info();
  }
}

/**
 * Executes language set side-effects.
 *
 * @param {object} [options]
 * @param {string} [options.language] - The new language ISO code.
 * @return {void}
 */
function handleEffectLanguageSet({ language }) {
  container.logger.info(`Language has been set to "${language}", proceeding to reload`);
  container.bus.emit('thn:exec', null, { func: 'pageCheck', args: [{ force: true }] });
}

/**
 * Executes the page set side-effects.
 */
async function handleEffectPageSet(...args) {
    const { pageId, pageName, } = args[0];
    container.logger.info(`Page detected: ${pageName ? `"${pageName} (${pageId || '-'})"` : '<none>'}`);
    trigger('thn_load', {});
    container.errorMonitor.setConfig(Object.fromEntries(Object.entries(container.globalState.resolvedVersions)
        .map((pair) => [`pkg.${pair[0].replace('@thehotelsnetwork', '@thn')}`, pair[1]])));
    const prepareVisitorTokensPromise = container.prepareVisitorTokens();
    container.pageUnload(() => { prepareVisitorTokensPromise.abort(); });
    prepareVisitorTokensPromise.then(() => {
        const prepareVisitorVisitDataPromise = container.prepareVisitorVisitData();
        container.pageUnload(() => { prepareVisitorVisitDataPromise.abort(); });
        return prepareVisitorVisitDataPromise;
    }).catch((error) => {
        if (!(error instanceof AbortError)) {
            container.logger.warn(error);
        }
    });
    // On "Booking Iframe" pages execute awakeChildScript (by default we expect
    // a child companion script to be awaiting before start executing).
    // Additionally: Corpos have more freedom to launch the awakening, we do not
    // require the mapping of "Booking Iframe" because the URL won't be reused anyway.
    if (pageName === PageName.BookingIframe
        || (container.globalState.mode === 'corporate' && !isIframed$1())) {
        container.awakeChildScript();
    }
    if (pageName === PageName.Calendar) {
        // "genericPageObserveDom" is an engine's deprecated function
        // It was used to setup DOM observation on "Calendar" pages.
        container.callEngine('genericPageObserveDom');
    }
}

function handleThnPageUnload(event) {
  // "thn_page_unload" calls thn.page_unload (on parent script)
  if (event.data && event.data.action === 'thn_page_unload') {
    container.logger.debug('handle_thn_page_unload()', 'Received a page unload order from the child script ...');
    container.pageUnload();
  }
}

const debugPrefix$5 = 'handleThnPing()';

function handleThnPing(event) {
  if (event?.data?.action !== 'thn_ping') {
    return;
  }
  // "thn_ping" action registers the child Agent in the parent
  const { globalState, logger } = container;

  logger.debug(debugPrefix$5, 'Ping from the child');

  // we are in the parent Agent, then
  // store the "source" prop of the event
  // as it contains a reference to the Window that sent the msg
  globalState.companionOrigin = event.origin;
  globalState.childFrame = event.source;

  // then return the ping to the child
  logger.debug(debugPrefix$5, 'Pong to the child');
  globalState.childFrame.postMessage({ action: 'thn_pong' }, globalState.companionOrigin);

  // and finally stop the awakening process
  container.stopAwakeChildScript();
}

function handleThnPong(event) {

  const debugPrefix = 'handleThnPong()';

  // "thn_pong" action registers the parent script in the child
  if (event?.data?.action === 'thn_pong') {
    // we are in the child script, then
    // store the "origin" property of the event
    // as it contains the protocol+host to be targeted by the child
    container.logger.debug(debugPrefix, 'Pong from the parent');
    container.globalState.companionOrigin = event.origin;
  }
}

function handleThnShutdown(event) {
  // "thn_shutdown" calls thn.shutdown (on parent script)
  if (event.data && event.data.action === 'thn_shutdown') {
    container.logger.debug('handle_thn_shutdown()', 'Received a shutdown order from the child script ...');
    container.bus.emit('thn:exec', null, { func: 'shutdown' });
  }
}

/**
 * Executes the page unloading side-effects.
 *
 * @return {void}
 */
function handleEffectPageUnload() {
    // Always reset the sendPageVisit
    container.sendPageVisit.reset();
    // Remove detected page and context data associated with the previous visit
    ['contextId', 'contextToken', 'pageId', 'pageName']
        .forEach((prop) => {
        set$1(data, prop, undefined);
    });
    // Always reset the sendBeacon memoization
    container.sendBeacon.cache.clear();
}

/**
 * Executes the side-effects of having set visitor visit data.
 *
 * @param {object} _visitorVisitData
 * @return {void}
 */
async function handleEffectVisitorVisitDataSet(visitorVisitData) {

  // Order of processes followed in the handler:
  // - prepare visitor tools
  // - store visitor Oraculo data
  // - sending beacons (main visit, origin visit, retargetings, etc)

  // Procedure 1: prepare visitor tools
  const prepareVisitorToolsPromise = container.prepareVisitorTools();
  container.pageUnload(() => { prepareVisitorToolsPromise.abort(); });

  prepareVisitorToolsPromise
    .catch((error) => {
      if (!(error instanceof AbortError)) {
        container.logger.warn(error);
      }
    });

  // Procedure 2: store visitor Oraculo data
  const isTargetPage = container.price?.isTargetPage?.(container.globalState.pageName)
    || container.package?.isTargetPage?.(container.globalState.pageName);

  if (!isTargetPage) {
    const visitorOraculoResults = visitorVisitData?.visitor?.lastOraculoResult
      || container.globalState.visitor.lastOraculoResult;

    if (!empty(visitorOraculoResults)) {
      container.oraculoManager.set(visitorOraculoResults);
    }
  }

  const pkgVersions = container.globalState.resolvedVersions;
  container.logger.debug('Packages:', pkgVersions);
  // Procedure 3: send the main/origin visit beacon
  const pageName = container.globalState.pageName;

  // Note sendTintoAssessment may not do any real work (depend on a setting).
  container.sendTintoAssessment();

  // Only when a page has been detected
  if (!pageName) {
    return;
  }

  container.sendPageVisit(pageName);
}

function handleThnPageUnloadTentative(event) {
    // "thn_page_unload_tentative" action is send by a child Agent when a event
    // "visibilitychange:hidden" happens. The child does not know if It is caused by "real navigation".
    // When the event is caused by a tab-switch, both documents (child and parent) will have
    // a "hidden" state. If the parent is not "hidden", then we infer the child frame is
    // navigating, and thus we proceed to "page unload". On the contrary, if both are
    // "hidden", we don't confirm nor do anything (either we are tab-switching or destroying the tab).
    if (event?.data?.action !== 'thn_page_unload_tentative') {
        return;
    }
    const childFrameNavigation = container.globalThis.document.visibilityState === 'visible';
    container.logger.debug('Tentative pageUnload requested. Proceed:', childFrameNavigation);
    if (childFrameNavigation) {
        // Unregister the child script
        delete container.globalState.childFrame;
        container.bus.emit('thn:exec', null, { args: [{ force: true }], func: 'pageCheck' });
    }
}

function handleWindowResizeEnd() {
    const userAgent = container.parseUserAgent();
    let prevDevice = 'desktop';
    if (userAgent.mobile) {
        prevDevice = 'mobile';
    }
    else if (userAgent.tablet) {
        prevDevice = 'tablet';
    }
    const { mobile, tablet } = container.parseUserAgentDevice();
    let newDevice = 'desktop';
    if (mobile) {
        newDevice = 'mobile';
    }
    else if (tablet) {
        newDevice = 'tablet';
    }
    if (prevDevice !== newDevice) {
        container.parseUserAgent.cache.clear();
        container.pageCheck({ force: true, ignoreState: true, shouldPageUnload: true });
        container.logger.debug(`handleWindowResizeEnd() - User Agent Device changed ${prevDevice} => ${newDevice}`);
    }
}

let restoreOnpopstate;
let restorePushState;
let restoreReplaceState;
let globalListening;
let onDocumentVisibilityChange;
let onWindowMessage;
let onWindowOrientationchange;
let onWindowOrientationchangeEnd;
let onWindowResize;
let onWindowResizeEnd;
let unlistenCallbacks;

function observeHashChangesProxy(e) {
  container.onHashChange(e);
}

function listen() {

  if (globalListening) {
    return;
  }

  container.bus.emit('thn:listen#start'); // #start of function execution hook

  const debugPrefix = 'listen()';
  globalListening = true;

  container.bus.emit('thn:listen'); // #default function execution hook

  // Create a place to register actions to do on unlisten
  unlistenCallbacks = generateCallbackQueue();
  const onpopstateValue = cancellable(function onpopstate(e) {
    container.onStateChange({ detail: e });
  });
  const onpushStateValue = cancellable(function pushState(state, title, url) {
    container.onStateChange({
      detail: {
        state: state,
        title: title,
        url: url,
      },
    });
  });
  const onreplaceStateValue = cancellable(function replaceState(state, title, url) {
    container.onStateChange({
      detail: {
        state: state,
        title: title,
        url: url,
      },
    });
  });
  unlistenCallbacks(() => {
    onpopstateValue.cancel();
    onpushStateValue.cancel();
    onreplaceStateValue.cancel();
  });

  // Detect Hash Changes
  container.globalThis.addEventListener('hashchange', observeHashChangesProxy, false);
  container.logger.trace(debugPrefix, 'Listening to Window\'s "hashchange" event');
  // Detect History Changes
  // Note the hijacker function will be cancelled once unlisten is called
  // That is important because after our "hijack" operation, a 3rth party
  // may hijack us. If that happens, the restoration operation done at
  // unlisten time will be useless. Thus we make sure the function will not work
  // anymore after unlisten() by using the cancellable.
  restoreOnpopstate = hijack(container.globalThis, 'onpopstate', onpopstateValue);
  restorePushState = hijack(container.globalThis.history, 'pushState', onpushStateValue);
  restoreReplaceState = hijack(container.globalThis.history, 'replaceState', onreplaceStateValue);
  container.logger.trace(debugPrefix, 'Listening to Window\'s "popstate" event');

  onWindowMessage = function () {
    container.bus.emit('window:message', null, ...arguments);
  };
  container.globalThis.addEventListener('message', onWindowMessage, false);
  container.logger.trace(debugPrefix, 'Listening to Window\'s "message" event');

  // function to be called on visibilitychange
  onDocumentVisibilityChange = function (evt) {
    container.bus.emit('document:visibilitychange', null, ...arguments);
    if (evt.target.visibilityState === 'hidden' && isIframed$1()) {
      container.globalThis.parent.postMessage({ action: 'thn_page_unload_tentative' }, '*');
    }
  };
  // listen to visibilitychange events from the document
  container.globalThis.document.addEventListener('visibilitychange', onDocumentVisibilityChange, false);
  container.logger.trace(debugPrefix, 'Listening to Document\'s "visibilitychange" event');

  // "window:resize" event: debounced to 400ms called in the leading edge
  onWindowResize = debounce(function () {

    container.bus.emit('window:resize', null, ...arguments);

  }, 400, true);
  // "window:resize.end" event: debounced to 250ms in of the trailing edge
  onWindowResizeEnd = debounce(function () {

    container.bus.emit('window:resize.end', null, ...arguments);

  }, 250);
  container.globalThis.addEventListener('resize', onWindowResize, false);
  container.globalThis.addEventListener('resize', onWindowResizeEnd, false);
  container.logger.trace(debugPrefix, 'Listening to Window\'s "resize" event');

  // "window:orientationchange" event: debounced to 400ms called in the leading edge
  onWindowOrientationchange = debounce(function () {

    container.bus.emit('window:orientationchange', null, ...arguments);

  }, 400, true);
  // "window:orientationchange.end" event: debounced to 250ms called in the trailing edge
  onWindowOrientationchangeEnd = debounce(function () {

    container.bus.emit('window:orientationchange.end', null, ...arguments);

  }, 250);
  container.globalThis.addEventListener('orientationchange', onWindowOrientationchange, false);
  container.globalThis.addEventListener('orientationchange', onWindowOrientationchangeEnd, false);
  container.logger.trace(debugPrefix, 'Listening to Window\'s "orientationchange" event');

  // Listen to THN events

  // Propagations of window messages
  container.bus.on('window:message', handleThnPing);
  container.bus.on('window:message', handleThnPong);
  container.bus.on('window:message', handleThnAwake);
  container.bus.on('window:message', handleThnExec);
  container.bus.on('window:message', handleThnInfo);
  container.bus.on('window:message', handleThnPageUnload);
  container.bus.on('window:message', handleThnPageUnloadTentative);
  container.bus.on('window:message', handleThnShutdown);

  // window resize
  container.bus.on('window:resize.end', handleWindowResizeEnd);

  // Changes in the THN state
  container.bus.on('thn:language.set', handleEffectLanguageSet);
  container.bus.on('thn:page.set', handleEffectPageSet);
  container.bus.on('thn:page.unload', handleEffectPageUnload);
  container.bus.on('thn:visitor-visit-data.set', handleEffectVisitorVisitDataSet);

  // Instantiate dataLayer for datalayer Mode. We instantiate the datalayer after setting event handlers
  // so that we can handle existing datalayer events when instantiating.
  container.logger.trace(debugPrefix, 'Forced instantiation of "dataLayerHelper"', container.dataLayerHelper?.get?.('@'));

  // datalayer mode events, note we use the "process history" flag for the bus
  container.logger.trace(debugPrefix, 'Listening to dataLayer events: "thnSearchQuery", "thnSearchResults", "thnBookingConfirmation"');
  container.bus.on('dataLayer:event.thnSearchQuery', handleDatalayerSearch, true);
  container.bus.on('dataLayer:event.thnSearchResults', handleDatalayerSearch, true);
  container.bus.on('dataLayer:event.thnBookingConfirmation', handleDatalayerBookingConfirmation, true);

  container.bus.emit('thn:listen#end'); // #end of function execution hook
}

function unlisten() {

  if (!globalListening) {
    return;
  }

  container.bus.emit('thn:unlisten#start'); // #start of function execution hook
  container.bus.emit('thn:unlisten'); // #default function execution hook

  const debugPrefix = 'unlisten()';

  // Trigger things that has been registered to be called on unlisten time
  if (unlistenCallbacks) {
    unlistenCallbacks();
  }

  // Detect Hash Changes
  container.globalThis.removeEventListener('hashchange', observeHashChangesProxy, false);
  container.logger.trace(debugPrefix, 'No longer listening to Window\'s "hashchange" event');
  [restoreOnpopstate, restorePushState, restoreReplaceState]
    .filter((fn) => fn)
    .forEach((fn) => fn());
  container.logger.trace(debugPrefix, 'No longer listening to Window\'s "popstate" event');

  container.globalThis.document.removeEventListener('visibilitychange', onDocumentVisibilityChange, false);
  onDocumentVisibilityChange = undefined;
  container.logger.trace(debugPrefix, 'No longer listening to Document\'s "visibilitychange" event');

  container.globalThis.removeEventListener('resize', onWindowResize, false);
  container.globalThis.removeEventListener('resize', onWindowResizeEnd, false);
  onWindowResize = undefined;
  onWindowResizeEnd = undefined;
  container.logger.trace(debugPrefix, 'No longer listening to Window\'s "resize" event');

  container.globalThis.removeEventListener('orientationchange', onWindowOrientationchange, false);
  container.globalThis.removeEventListener('orientationchange', onWindowOrientationchangeEnd, false);
  onWindowOrientationchange = undefined;
  onWindowOrientationchangeEnd = undefined;
  container.logger.trace(debugPrefix, 'No longer listening to Window\'s "orientationchange" event');

  container.globalThis.removeEventListener('message', onWindowMessage, false);
  onWindowMessage = undefined;
  container.logger.trace(debugPrefix, 'No longer listening to Window\'s "message" event');

  // Unlisten to THN events

  // Propagations of window messages
  container.bus.detach('window:message', handleThnPing);
  container.bus.detach('window:message', handleThnPong);
  container.bus.detach('window:message', handleThnAwake);
  container.bus.detach('window:message', handleThnExec);
  container.bus.detach('window:message', handleThnInfo);
  container.bus.detach('window:message', handleThnPageUnload);
  container.bus.detach('window:message', handleThnPageUnloadTentative);
  container.bus.detach('window:message', handleThnShutdown);

  // window resize
  container.bus.detach('window:resize.end', handleWindowResizeEnd);

  // Changes in the THN state
  container.bus.detach('thn:language.set', handleEffectLanguageSet);
  container.bus.detach('thn:page.set', handleEffectPageSet);
  container.bus.detach('thn:page.unload', handleEffectPageUnload);
  container.bus.detach('thn:visitor-visit-data.set', handleEffectVisitorVisitDataSet);

  // datalayer mode events
  container.bus.detach('dataLayer:event.thnSearchQuery', handleDatalayerSearch, true);
  container.bus.detach('dataLayer:event.thnSearchResults', handleDatalayerSearch, true);
  container.bus.detach('dataLayer:event.thnBookingConfirmation', handleDatalayerBookingConfirmation, true);

  globalListening = false;

  container.bus.emit('thn:unlisten#end'); // #end of function execution hook
}

// Trigger the initial side-effect
thn$1.setup();

const infoSwaps = () => container.swaps?.info();

/**
 * Add messages to the `thn.data.log` array.
 * Not for public usage.
 */
function addLog(log, maxMessages = Number.MAX_SAFE_INTEGER, ...messages) {
    log.push(messages.map((m) => {
        try {
            if (m && typeof m === 'object') {
                if (isError(m)) {
                    return m.toString();
                }
                return stringify(m);
            }
            return m;
        }
        catch {
            return m;
        }
    }).join(' '));
    // Eviction
    if (log.length > maxMessages) {
        log.shift();
    }
}
const name$1K = 'addLog';
function run$1K(bottle) {
    const deps = [
        'globalState',
        'logMaxMessages',
    ];
    bottle.serviceFactory(name$1K, (globalState, logMaxMessages) => addLog.bind(null, globalState.log, logMaxMessages), ...deps);
    return bottle;
}

var addLog$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    addLog: addLog,
    name: name$1K,
    run: run$1K
});

const name$1J = 'allowedLocation';
function run$1J(bottle) {
    const deps = [
        'callEngine',
        'globalThis',
        'logger',
    ];
    bottle.serviceFactory(name$1J, createAllowedLocation, ...deps);
    return bottle;
}

var allowedLocation = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1J,
    run: run$1J
});

const name$1I = 'awakeChildScript';
function run$1I(bottle) {
    const deps = [
        'globalState',
        'globalThis',
        'logger',
        'stopAwakeChildScript',
    ];
    bottle.serviceFactory(name$1I, createAwakeChildScript, ...deps);
    return bottle;
}

var awakeChildScript = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1I,
    run: run$1I
});

const name$1H = 'booking';
function run$1H(bottle) {
    const deps = [
        'constructors.Booking',
    ];
    bottle.serviceFactory(name$1H, (Booking) => new Booking(bottle), ...deps);
    return bottle;
}

var booking = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1H,
    run: run$1H
});

const name$1G = 'bookingDraft';
function run$1G(bottle) {
    const deps = [
        'constructors.BookingDraft',
    ];
    bottle.serviceFactory(name$1G, (BookingDraft) => new BookingDraft(bottle), ...deps);
    return bottle;
}

var bookingDraft = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1G,
    run: run$1G
});

const name$1F = 'bootstrap';
function run$1F(bottle) {
    const deps = [
        'allowedLocation',
        'bottle',
        'bus',
        'callEngine',
        'async',
        'domReady',
        'environment',
        'errorMonitor',
        'getSetting',
        'globalState',
        'globalThis',
        'languageCheck',
        'logger',
        'Logger',
        'networkIdleCallback',
        'parseUserAgent',
        'shutdown',
        'start',
        'scheduler',
    ];
    bottle.serviceFactory(name$1F, createBootstrap, ...deps);
    return bottle;
}

var bootstrap = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1F,
    run: run$1F
});

/**
 * @see {@link https://github.com/bcerati/js-event-bus}
 */
class EventBus {
    maxMessages;
    _listeners = {};
    _delayedTimers = {};
    _history = {};
    constructor(maxMessages = Number.MAX_SAFE_INTEGER) {
        this.maxMessages = maxMessages;
    }
    _registerListener(eventNames, callback, triggerLimit, processHistory = false) {
        const eventNamesArray = typeof eventNames === 'string' ? eventNames.split(/\s*,\s*/) : eventNames;
        eventNamesArray.filter(Boolean).forEach((eventName) => {
            if (typeof eventName !== 'string') {
                throw new Error('Only `String` and array of `String` are accepted for the event names!');
            }
            const info = {
                callback,
                triggerLimit,
            };
            this._listeners[eventName] = this._listeners[eventName] || [];
            const index = this._listeners[eventName].push(info) - 1;
            // process the past emitted events
            if (processHistory && this._history[eventName] && this._history[eventName].length) {
                this._history[eventName].some((pastEvent) => {
                    const boundCallback = callback.bind(pastEvent.context);
                    try {
                        boundCallback(...pastEvent.args);
                    }
                    catch (reason) {
                        // TODO: inject logger to log this failed listener execution
                    }
                    // if this event cannot be fired again, remove from the stack
                    info.triggerLimit -= 1;
                    if (this._toBeRemoved(info)) {
                        this._listeners[eventName].splice(index, 1);
                        return true;
                    }
                    return false;
                });
            }
        });
    }
    // eslint-disable-next-line class-methods-use-this
    _toBeRemoved(eventInfo) {
        const { triggerLimit } = eventInfo;
        if (triggerLimit !== Infinity) {
            return triggerLimit <= 0;
        }
        return false;
    }
    on(eventNames, callback, processHistory = false) {
        this._registerListener(eventNames, callback, Infinity, processHistory);
    }
    once(eventNames, callback, processHistory = false) {
        this._registerListener(eventNames, callback, 1, processHistory);
    }
    exactly(triggerLimit, eventNames, callback, processHistory = false) {
        this._registerListener(eventNames, callback, triggerLimit, processHistory);
    }
    die(eventName) {
        const eventNameAsArray = Array.isArray(eventName) ? eventName : [eventName];
        for (const name of eventNameAsArray) {
            delete this._listeners[name];
        }
    }
    off(eventName) {
        this.die(eventName);
    }
    detach(eventName, callback) {
        const eventNameAsArray = Array.isArray(eventName) ? eventName : [eventName];
        for (const name of eventNameAsArray) {
            const listeners = this._listeners[name];
            if (listeners) {
                const indexToRemove = listeners.findIndex(listener => listener.callback === callback);
                if (indexToRemove !== -1) {
                    listeners.splice(indexToRemove, 1);
                }
            }
        }
    }
    emit(eventName, context, ...args) {
        return this._emit(false, false, eventName, context, ...args);
    }
    emitDelayed(eventName, context, ...args) {
        return this._emit(true, false, eventName, context, ...args);
    }
    emitDelayedReplace(eventName, context, ...args) {
        return this._emit(true, true, eventName, context, ...args);
    }
    _emit(delayed, replace, eventName, context, ...args) {
        const actualContext = context || null;
        const listeners = this._listeners[eventName] || [];
        if (!this._history[eventName]) {
            this._history[eventName] = [];
        }
        if (delayed && replace) {
            const pendingEmits = this._delayedTimers[eventName];
            if (pendingEmits?.length) {
                const toRemoveFromHistory = Math.ceil(pendingEmits.length / listeners.length);
                // Cancel the pending emit operations
                for (const timer of pendingEmits) {
                    clearTimeout(timer);
                }
                delete this._delayedTimers[eventName];
                // Remove from history too, since this events never got emitted
                this._history[eventName].splice(this._history[eventName].length - toRemoveFromHistory, toRemoveFromHistory);
            }
        }
        this._history[eventName].push({ context: actualContext, args });
        if (this._history[eventName].length > this.maxMessages) {
            this._history[eventName].shift();
        }
        for (const info of Array.from(listeners)) {
            const { callback } = info;
            const boundCallback = callback.bind(actualContext);
            // eslint-disable-next-line no-param-reassign
            info.triggerLimit -= 1;
            // if this event cannot be fired again, remove from the stack
            if (this._toBeRemoved(info)) {
                const indexToRemove = listeners.findIndex(listener => listener.callback === callback);
                if (indexToRemove !== -1) {
                    listeners.splice(indexToRemove, 1);
                }
            }
            const execute = () => {
                try {
                    boundCallback(...args);
                }
                catch (_reason) {
                    // TODO: inject logger to log this failed listener execution
                }
            };
            if (delayed) {
                if (!this._delayedTimers[eventName]) {
                    this._delayedTimers[eventName] = [];
                }
                const timer = setTimeout(() => {
                    this._delayedTimers[eventName] = this._delayedTimers[eventName]?.filter((t) => t !== timer);
                    if (!this._delayedTimers[eventName]?.length) {
                        delete this._delayedTimers[eventName];
                    }
                    execute();
                }, 0);
                this._delayedTimers[eventName].push(timer);
            }
            else {
                execute();
            }
        }
    }
}

const name$1E = 'bus';
function run$1E(bottle) {
    const deps = [
        'busMaxMessages',
        'exec',
    ];
    bottle.serviceFactory(name$1E, (busMaxMessages, exec) => {
        const busInstance = new EventBus(busMaxMessages);
        busInstance.on('thn:exec', exec);
        return busInstance;
    }, ...deps);
    return bottle;
}

var bus = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1E,
    run: run$1E
});

function callEngineFactory(errorMonitor, logger, bottle) {
    /**
     * Calls an engine's function.
     * Invoke the given method from the engine either bound to this (widget) or just the engine (default)
     */
    return function callEngine(method, ...args) {
        const hasWidgetContext = !(isUndefined(this) || isGlobalThis(this) || isContainer(this));
        const localLogger = hasWidgetContext ? this.logger : logger;
        const debugMsg = `Call "engine.${method}". `;
        const { engine } = bottle.container;
        // Although "engine" is not a direct dependency of "callEngine",
        // the function should explode if the "engine" service is not defined on call time
        if (!engine) {
            const error = new Error('No instance of Engine found');
            errorMonitor.addError(error);
            localLogger?.error(error);
            return undefined;
        }
        try {
            localLogger?.trace(`${debugMsg}Args: `, ...args);
            const result = invokeFrom(engine, hasWidgetContext ? this : engine, method, ...args);
            localLogger?.trace(`${debugMsg}Result: `, result);
            // @ts-ignore impossible to satisfy declared return type here
            // eslint-disable-next-line  @typescript-eslint/no-unsafe-return
            return result;
        }
        catch (error) {
            if (error instanceof Error) {
                errorMonitor.addError(error);
            }
            localLogger?.trace(`${debugMsg}Exception: `, error);
        }
        // @ts-ignore impossible to satisfy declared return type here
        return undefined;
    };
}

function createBuildDefaultSearch(getSetting, addDays$1 = addDays, dateToString$1 = dateToString) {
    const defaultOptions = {
        leadDays: searchDefaultLeadDays,
        nights: 1,
        currency: CurrencyCode.Usd,
        roomsDispo: [{ adults: 2, children: 0, childrenAges: [] }],
    };
    return function buildDefaultSearch(options = {}) {
        const effectiveOptions = {
            ...defaultOptions,
            ...getSetting('search_default'),
            ...options,
        };
        // build the "default search" based on the effective Options
        const startDate = new Date(); // new Date() without is always local, NOT interpreted as UTC
        const checkIn = dateToString$1(addDays$1(startDate, effectiveOptions.leadDays));
        const checkOut = dateToString$1(addDays$1(startDate, effectiveOptions.leadDays + effectiveOptions.nights));
        if (!checkIn || !checkOut) {
            throw new RangeError('invalid date');
        }
        // calculate the effective number of rooms, adults and children
        const rooms = effectiveOptions.roomsDispo.length;
        let children = 0;
        let adults = 0;
        for (const room of effectiveOptions.roomsDispo) {
            adults = (room.adults ?? 0) + adults;
            children = (room.children ?? 0) + children;
        }
        return {
            dateBegin: checkIn,
            dateEnd: checkOut,
            adults,
            children,
            rooms,
            currency: effectiveOptions.currency,
            roomsDispo: effectiveOptions.roomsDispo,
        };
    };
}

const createGetPropertyPerks = (globalState, logger, fetch) => memoize(({ propertyId = globalState.propertyId, language = globalState.language, country = globalState.country, logged = false, } = {}) => {
    const debugPrefix = 'getPropertyPerks()';
    const payload = {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        property_id: propertyId,
        language,
        country,
        logged: logged ? 1 : 0,
    };
    logger.debug(debugPrefix, 'Call', payload);
    return fetch('/get_property_perks', { body: payload })
        .then((res) => res.ok && res.json())
        .then((response) => {
        if (response.result === 1) {
            logger.debug(debugPrefix, 'Response', response);
            return response.data;
        }
        logger.warn(debugPrefix, 'Response', response);
        return [];
    }).catch((e) => {
        logger.warn(debugPrefix, 'Failure', e);
        return [];
    });
});

const debugPrefix$4 = 'createSearchReplay()';

function filterUrlParams(url, paramsToExclude = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', '_ga', '_gl']) {
    try {
        const urlObject = new URL(url);
        for (const paramName of paramsToExclude) {
            urlObject.searchParams.delete(paramName);
        }
        return urlObject.toString();
    }
    catch (_) {
        return url;
    }
}

/**
 * Validate params not starting with a dot, hash or open bracket (CSS selectors)
 * and not ending with a parentheses (function)
 */
const isValidQueryStringParam = (value) => !(/^[.#[]/).test(value) && !value.endsWith('()');

/**
 * Replace all the `__self__` values in the extra params with the discount value.
 */
function replaceSelfValue(params, discountValue = '') {
    return params.map(([key, value]) => [key, value === '__self__' ? discountValue : value]);
}
/**
 * Gathers together all needed context for `createSearchReplayPure`.
 *
 * Note this is a highly impure and coupled function intentionally.
 *
 * @param data - Do not pass an argument to have it filled with a best guess.
 * @param baseUrl - The URL to be used as a base for the replay. Completely
 *  optional. Will take precedence over automatic URL selection, but it is
 *  not guaranteed to be the final base URL. Usually should not be passed
 *  explicitly.
 * @return Will be null when replay is not possible by any method
 * or the data argument is invalid.
 */
function createSearchReplayContext(services, data, options = {}) {
    const { buildDefaultSearch, bus, callEngine, getSetting, getVisitorLastComparison, globalThis, globalState, logger, package: pack, price, } = services;
    let search;
    let discount = null;
    if (data?.search) {
        search = data.search;
    }
    else {
        // Guess "search" data
        const searchEntry = getVisitorLastComparison({ acceptWithoutAvailability: false });
        if (searchEntry) {
            search = searchEntry.data.actual.search;
        }
        else {
            search = buildDefaultSearch();
        }
    }
    if (!search) {
        return null;
    }
    const searchEnriched = {
        ...search,
        // Enrich with "nights"
        // TODO: remove inlined declaration of daysBetween
        nights: daysBetween(search.dateBegin, search.dateEnd),
        // Enrich with language, prioritizing arguments
        // @ts-ignore
        language: data?.search?.language || globalState.language,
    };
    if (data?.discount) {
        // Soft validate "discount" data passed by argument
        if (!isPlainObject(data.discount)) {
            throw new TypeError('Expected `discount` to be an object');
        }
        discount = data.discount;
        // Make sure the discount has a kind
        discount.kind = discount.kind ?? DiscountCodeKind.Promocode;
    }
    // Resolve / map all the relevant settings
    const discountVariables = globalState.promocodeVars[discount?.kind]
        || globalState.promocodeVars[DiscountCodeKind.Promocode];
    const getSettingQualified = (key) => (discount ? getSetting(`${key}#${discount.kind}`) : getSetting(key));
    const settingInputFireEvent = getSettingQualified(DiscountSetting.DomDiscountInputDispatchEvents);
    const settingSelectFireEvent = getSettingQualified(DiscountSetting.DomDiscountSelectDispatchEvents);
    const domElementsRequireVisibility = getSettingQualified(DiscountSetting.DomElementsRequireVisibility);
    const domDiscountInputDispatchEvents = isString(settingInputFireEvent)
        ? settingInputFireEvent.split(',') : [];
    const domDiscountSelectDispatchEvents = isString(settingSelectFireEvent)
        ? settingSelectFireEvent.split(',') : [];
    const domDiscountSelectSelector = getSettingQualified(DiscountSetting.DomDiscountSelectSelector);
    const domDiscountSelectValue = getSettingQualified(DiscountSetting.DomDiscountSelectValue);
    const domSubmitDelay = getSettingQualified(DiscountSetting.DomSubmitDelay);
    const domSubmitMethod = getSettingQualified(DiscountSetting.DomSubmitSkip) ? 'click' : 'submit';
    const domSubmitSelector = getSettingQualified(DiscountSetting.DomSubmitSelector);
    const urlDiscountExtraParams = replaceSelfValue(getSettingQualified(DiscountSetting.UrlDiscountExtraParams), discount?.value);
    const urlTarget = isIframed$1() ? getSettingQualified(DiscountSetting.UrlTarget) : 'self';
    // In order to trust the "generateSearchUrl" engine implementation always, we need two guarantees:
    // 1 - setting "search_url" has been manually activated by the developers (human certification)
    // 2 - the "generateSearchUrl" method must exist in the engine
    let generateSearchUrlIsImplemented = false;
    try {
        generateSearchUrlIsImplemented = callEngine('generateSearchUrl', collectionClone({ data: searchEnriched, baseUrl: globalThis.location.href, newData: searchEnriched })) !== undefined;
    }
    catch { /* empty */ }
    const shouldTrustEngineAlways = generateSearchUrlIsImplemented && getSetting('search_url');
    const isRnrPage = price.isTargetPage(globalState.pageName)
        || pack.isTargetPage(globalState.pageName);
    const urlEngineTrust = isRnrPage || shouldTrustEngineAlways;
    logger.trace(debugPrefix$4, urlEngineTrust ? 'Can trust engine' : 'Can not trust engine, generateSearchUrl function and search_url setting needed');
    const excludeUrlMethod = getSettingQualified(DiscountSetting.UrlSkip);
    const excludeDomMethod = getSettingQualified(DiscountSetting.DomSkip);
    const replayMethods = [];
    if (!excludeUrlMethod) {
        replayMethods.push(ReplayMethod.Url);
    }
    if (!excludeDomMethod) {
        if (isRnrPage) {
            replayMethods.unshift(ReplayMethod.Dom);
        }
        else {
            replayMethods.push(ReplayMethod.Dom);
        }
    }
    replayMethods.unshift(ReplayMethod.Eval);
    // Make a list of candidate URLs to be used for the replay
    let customUrl;
    switch (price.data?.ssUrlOption) {
        case 2:
            // SS Option 2: Custom URL
            // "ssCustomUrl" will contain literally the URL to be used
            customUrl = price.data.ssCustomUrl;
            break;
        case 3: {
            // SS Option 3: JavaScript variable
            // "ssJsUrl" will contain the name of the variable to
            // be evaluated in order to obtain the final URL to be used
            const unkownToken = get$1(globalThis, price.data.ssJsUrl);
            if (isFunction(unkownToken)) {
                customUrl = unkownToken();
            }
            else if (unkownToken) {
                customUrl = String(unkownToken);
            }
            break;
        }
    }
    let siteLastComparisonUrl = globalState.site?.lastComparisonUrl;
    let siteLastComparisonIframeUrl = globalState.site?.lastComparisonIframeUrl;
    if (!discount) {
        // Query parameters to exclude from last comparisons URLs.
        // If no discount code applies, remove any discountVars to avoid carrying over old discounts.
        // Otherwise, discountVars will be updated later by createReplayUrl accordingly.
        const paramsToExclude = Object.values(globalState.promocodeVars).flat().filter(isValidQueryStringParam);
        siteLastComparisonUrl = siteLastComparisonUrl && filterUrlParams(siteLastComparisonUrl, paramsToExclude);
        siteLastComparisonIframeUrl = siteLastComparisonIframeUrl && filterUrlParams(siteLastComparisonIframeUrl, paramsToExclude);
    }
    // by order of precedence:
    const candidateUrls = [
        // 1 - explicitly passed by argument
        options.baseUrl,
        // 2 - custom URL
        customUrl,
        // 3 - The URL on which the previous Comparison was made (shortcircuited on RnR to depriorize)
        !isRnrPage && globalState.visitor?.lastComparison?.url,
        // 4 - The current URL (expecting to be on Rooms and Rates)
        globalThis.location.href,
        // 5 - The URL on which the previous Comparison was made
        globalState.visitor?.lastComparison?.url,
        // 6 - The URL on which the previous Comparison was made (for *any* visitor of this site)
        siteLastComparisonUrl,
        // 7 - The URL of the top window on which the previous Comparison was made (for *any* visitor of this site)
        siteLastComparisonIframeUrl,
        // 8 - Is there something configured in  SS Custom URL?
        // Then, even if ssUrlOption has not been configured, let's try with that.
        // Obi-wan, you're my only hope...
        price.data?.ssCustomUrl,
    ].filter((url) => isString(url) && !!url).map((url) => filterUrlParams(url));
    const replayContext = {
        data: {
            search: searchEnriched,
            candidateUrls: uniq(candidateUrls),
        },
        options: {
            discountVariables,
            domDiscountInputDispatchEvents,
            domDiscountSelectDispatchEvents,
            domDiscountSelectSelector,
            domDiscountSelectValue,
            domElementsRequireVisibility,
            domSubmitDelay,
            domSubmitMethod,
            domSubmitSelector,
            urlExtraParams: options.extraParams,
            replayMethods,
            urlDiscountExtraParams,
            urlEngineTrust,
            urlTarget,
        },
        services: {
            bus,
            callEngine,
            getVisitorLastComparison,
            globalThis,
            logger,
        },
    };
    if (discount !== null) {
        replayContext.data.discount = discount;
    }
    return replayContext;
}

function isValidDiscountVarFn(discountVar, services) {
    // expected input: "bookingEngine.applyPromcode()"
    const functionMatch = discountVar.split('()');
    // expected match: ["bookingEngine.applyPromcode", ""]
    if (functionMatch.length === 2 && functionMatch[1] === '') {
        try {
            const functionValue = services.globalThis.eval(functionMatch[0]);
            return typeof functionValue === 'function';
            // eslint-disable-next-line no-empty
        }
        catch (e) { }
    }
    return false;
}
function createReplayFnByEval(data, options, services) {
    // Check for functions
    const discountVarFunction = options.discountVariables.find((discountVar) => isValidDiscountVarFn(discountVar, services));
    if (!discountVarFunction) {
        return null;
    }
    const params = {};
    if (data.discount) {
        params.code = data.discount.value;
        params.type = data.discount.kind;
    }
    const result = async () => {
        const reload = () => {
            services.bus.emit('thn:exec', null, { func: 'reload' });
        };
        const functionMatch = discountVarFunction.split('()');
        const jsCode = `${functionMatch[0]}(${JSON.stringify(params)});`;
        services.globalThis.eval(jsCode);
        // Once the promocode is applied, most of the websites will reload.
        // However some may not (specially SPA), for that reason we will
        // force the reload in 5s (if the page reloads naturally, the
        // "forced" process is cancelled)
        reload();
    };
    return result;
}

/**
 * Parse a given selector
 *
 * @param {string} thn_selector
 * @return {object}
 */
function parseThnSelector(thnSelector) {
    const result = {};
    // if thn_selector is a "function" exclude it
    if (thnSelector.endsWith('()')) {
        return null;
    }
    result.tag = 'input';
    // special cases: css class, id, attributes
    if (thnSelector.substring(0, 1) === '.') {
        result.classes = [thnSelector.substring(1)];
        return result;
    }
    if (thnSelector.substring(0, 1) === '#') {
        result.ids = [thnSelector.substring(1)];
        return result;
    }
    if (thnSelector.substring(0, 1) === '[') {
        result.attrs = [thnSelector.substring(1, thnSelector.length - 1)];
        return result;
    }
    // default case
    result.attrs = [
        `name="${thnSelector}"`,
        `id="${thnSelector}"`,
    ];
    return result;
}

const buildElementsSelector = (htmlElements, elementSign, { tag, attributes }) => {
    const results = [];
    const selectorSchema = (htmlElement = '', attr = '') => [`${tag}${attr}${elementSign}${htmlElement}`, `${tag ? `${elementSign}${htmlElement} ${tag}${attr}` : ''}`];
    htmlElements.forEach((htmlElement) => {
        if (attributes.length) {
            attributes.forEach((attr) => {
                results.push(...selectorSchema(htmlElement, attr));
            });
            return;
        }
        results.push(...selectorSchema(htmlElement));
    });
    return results.filter(Boolean).join(',');
};
const buildAttributesSelector = ({ tag, attributes }) => attributes.map((attr) => `${tag}${attr}`).join(',');
function generateSelector({ tag = '', classes = [], attrs = [], ids = [], }) {
    const attributes = attrs.map((attr) => `[${attr}]`);
    if (classes.length) {
        return buildElementsSelector(classes, '.', { tag, attributes });
    }
    if (ids.length) {
        return buildElementsSelector(ids, '#', { tag, attributes });
    }
    if (attrs.length) {
        return buildAttributesSelector({ tag, attributes });
    }
    return tag;
}

function buildSelector(discountVars, withTextType = false) {
    const addTextTypeAttr = withTextType ? (selector) => selector.replace(/(^|\s|,)input\b/g, '$1input[type=text]') : (element) => element;
    return discountVars
        .map(parseThnSelector)
        .filter((selector) => selector !== null)
        .map(generateSelector)
        .map(addTextTypeAttr)
        .join(',');
}
function findInput(options, document, isVisible) {
    const selectorStandard = buildSelector(options.discountVariables);
    const selectorWithTextType = buildSelector(options.discountVariables, true);
    if (!(selectorWithTextType && selectorStandard)) {
        return null;
    }
    // First try to find input with [type=text], if cannot find input, try without
    const input = document.querySelectorAll(`${selectorWithTextType},${selectorStandard}`);
    // Some inputs are duplicated and not always the first one
    // found is the one who has the correct value.
    // Get the first with a valid value if possible.
    const visibilityPredicate = (options.domElementsRequireVisibility ? isVisible : (element) => !!element);
    const validInput = Array.from(input).filter(visibilityPredicate);
    const inputWithValue = Array.from(validInput).find((node) => !!node.value);
    return inputWithValue || validInput[0];
}
function findFormButton(validInput, form, options, isVisible) {
    const customSelector = options.domSubmitSelector || '';
    const primarySelector = 'input[type=submit], input[type=button], button:not(.warning)';
    const secondarySelector = 'a, .button';
    const requireVisibilityCheck = (options.domElementsRequireVisibility ? isVisible : (element) => !!element);
    const findNearestBtn = (selector) => (selector ? nearest(validInput, selector, requireVisibilityCheck) : null);
    const findFormBtn = (selector) => (selector && form ? Array.from(form.querySelectorAll(selector)).filter(requireVisibilityCheck)[0] : null);
    const findersWithSelectorArray = [[findNearestBtn, customSelector], [findNearestBtn, primarySelector], [findFormBtn, secondarySelector], [findNearestBtn, secondarySelector]];
    for (const [findFn, selector] of findersWithSelectorArray) {
        const result = findFn(selector);
        if (result)
            return result;
    }
    return null;
}
function createSendFormFn(validInput, form, options, isVisible) {
    // prepare the via POST
    if (form && options.domSubmitMethod === 'submit') {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        const formSubmit = form.submit;
        if (typeof formSubmit === 'function') {
            // Use the standard form submit function
            return formSubmit.bind(form);
        }
        if (isElement(formSubmit) && typeof formSubmit.click === 'function') {
            return formSubmit.click.bind(formSubmit);
        }
    }
    // Or workaround the form submission with a click if possible
    const formButton = findFormButton(validInput, form, options, isVisible);
    if (formButton && typeof formButton?.click === 'function') {
        return formButton.click.bind(formButton);
    }
    return null;
}
function createReplayFnByDom(data, options, services) {
    const { bus, callEngine, logger, globalThis, } = services;
    const { document, Event, setTimeout } = globalThis;
    const isVisible$1 = (element) => isVisible(element, globalThis);
    const validInput = findInput(options, document, isVisible$1);
    if (!validInput)
        return null;
    const form = validInput.closest('form');
    const recreateSendFormFn = () => createSendFormFn(validInput, form, options, isVisible$1);
    const sendFormFn = recreateSendFormFn();
    if (!sendFormFn)
        return null;
    // We may have a select form element to handle before sending the form
    const select = options.domDiscountSelectSelector && form ? form.querySelector(options.domDiscountSelectSelector) : null;
    function triggerEvent(fireEventsSetting, target, targetLastValue) {
        fireEventsSetting.forEach((eventName) => {
            if (!Event)
                return;
            const event = new Event(eventName, { bubbles: true });
            // hack: https://github.com/facebook/react/issues/11488#issuecomment-347775628
            event.simulated = true; // React15
            // @ts-ignore
            // eslint-disable-next-line no-underscore-dangle
            if (target._valueTracker) { // React16
                // @ts-ignore
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call, no-underscore-dangle
                target._valueTracker.setValue(targetLastValue);
            }
            target.dispatchEvent(event);
        });
    }
    const result = async () => {
        // Try to call the engine onBefore hook
        if (data.discount) {
            await Promise$1.resolve(callEngine('onBeforeApplyDiscount', data))
                .catch((reason) => { logger.error(reason); });
        }
        const inputLastValue = validInput.value;
        const selectLastValue = select?.value || '';
        if (data.discount) {
            validInput.value = data.discount?.value || '';
        }
        if (select && options.domDiscountSelectValue) {
            select.value = options.domDiscountSelectValue;
        }
        // trigger events if configured
        if (options.domDiscountInputDispatchEvents) {
            triggerEvent(options.domDiscountInputDispatchEvents, validInput, inputLastValue);
        }
        if (select && options.domDiscountSelectDispatchEvents) {
            triggerEvent(options.domDiscountSelectDispatchEvents, select, selectLastValue);
        }
        function executeSendForm() {
            const reload = () => {
                bus.emit('thn:exec', null, { func: 'reload' });
            };
            // Try to recreate the sendFormFn with the current DOM (most up-to-date)
            const effectiveSendFormFn = recreateSendFormFn() || sendFormFn;
            effectiveSendFormFn?.();
            // Once the promocode is applied, most of the websites will reload.
            // However some may not (specially SPA), for that reason we will
            // force the reload in 5s (if the page reloads naturally, the
            // "forced" process is cancelled)
            reload();
        }
        if (isNumeric(options.domSubmitDelay)) {
            setTimeout(executeSendForm, options.domSubmitDelay);
        }
        else {
            executeSendForm();
        }
    };
    return result;
}

function shouldForceReload(currentLocation, targetLocation) {
    // If some url is falsy: nothing to be done
    if (!currentLocation || !targetLocation) {
        return false;
    }
    // If both urls are completely equal: nothing to be done
    if (currentLocation === targetLocation) {
        return false;
    }
    const current = new URL(currentLocation);
    const target = new URL(targetLocation);
    const currentWithoutHash = new URL(currentLocation.replace(current.hash, ''));
    const targetWithoutHash = new URL(targetLocation.replace(target.hash, ''));
    const urlChanged = String(currentWithoutHash) !== String(targetWithoutHash);
    // Either there are changes in non-hash parts of the urls,
    // or hash is being swept: no forced reload is needed
    if (urlChanged || !target.hash) {
        return false;
    }
    // There is a hash change: forced reload is needed
    return true;
}
function createReplayFnByUrl(data, options, services) {
    const { callEngine, logger, globalThis } = services;
    const result = async () => {
        // Try to call the engine onBefore hook
        if (data.discount) {
            await Promise$1.resolve(callEngine('onBeforeApplyDiscount', data))
                .catch((reason) => { logger.error(reason); });
        }
        if (options.urlTarget === 'parent') {
            services.globalThis.parent.postMessage({ action: 'thn_exec', payload: { func: 'openLink', args: [data.replayUrl] } }, '*');
            return;
        }
        const { location } = globalThis;
        const doReload = shouldForceReload(String(location.href), data.replayUrl);
        location.href = data.replayUrl;
        if (doReload) {
            location.reload();
        }
    };
    return result;
}

function createSearchParamsFromHash(url) {
    const hashString = url.hash.substring(1);
    return new URLSearchParams(hashString.includes('?') ? hashString.split('?')[1] : hashString);
}
function buildUrl(url, paramPairs, applyOn) {
    const applyParamPairs = (mutableUrl) => {
        paramPairs.forEach(([key, value]) => {
            if (value === '') {
                mutableUrl.searchParams.delete(key);
                return;
            }
            mutableUrl.searchParams.set(key, value);
        });
        return mutableUrl;
    };
    const modifiedUrl = new URL(url);
    if (applyOn === 'queryString') {
        applyParamPairs(modifiedUrl);
        return modifiedUrl.toString();
    }
    const fakeBase = 'https://fake.app';
    const hashString = url.hash.replace(/^[#!]*/, '');
    const hasBang = url.hash.startsWith('#!');
    const hasSlash = hashString.startsWith('/');
    const hasQueryString = url.hash.includes('?');
    const isBareParams = !(hasSlash || hasQueryString);
    const subUrlFromHash = new URL(isBareParams ? `?${hashString}` : hashString, fakeBase);
    applyParamPairs(subUrlFromHash);
    const rebuildedHash = isBareParams
        ? subUrlFromHash.searchParams.toString()
        : subUrlFromHash.toString().replace(fakeBase, '');
    const keepSlash = isBareParams || hasSlash;
    modifiedUrl.hash = `${hasBang ? '!' : ''}${keepSlash ? rebuildedHash : rebuildedHash.substring(1)}`;
    return modifiedUrl.toString();
}
function processSearchUrlResult(ctx) {
    const TAG_OPEN = '(?:%5B|\\[)';
    const TAG_CLOSE = '(?:%5D|\\])';
    const camelData = toCamelCase$1(ctx.newData);
    const snakeData = toSnakeCase(ctx.newData);
    Object.assign(ctx.newData, flattenObject({
        ...snakeData,
        ...camelData,
    }));
    for (const [rawKey, rawValue] of Object.entries(ctx.newData)) {
        // replace undefined/nulls with empty string
        const value = rawValue ?? '';
        const key = rawKey
            .replace(/\[/g, '\\[')
            .replace(/]/g, '\\]')
            .replace(/\./g, '\\.');
        // Note we replace our THN params (example: "[date_begin]", "[adults]")
        // only when they are on a valid position, that is NOT preceding a
        // equal sign NOR a left bracket. The reason is to avoid substitution of
        // querystring keys instead of values. For instance, "[adults]" "[children]"
        // should NOT be replaced on the following example URL:
        // https://services.comwell.com/da/booking/fill/?arrival_date=2019-08-01&departure_date=2019-08-02&hotel_code=caa&rooms[0][adults]=2&rooms[0][children]=0
        ctx.newUrl = ctx.newUrl.replace(new RegExp(`(${TAG_OPEN}${key}${TAG_CLOSE})([^[=]|$)`, 'g'), `${value}$2`);
    }
    // Consider a param found *before* an equal sign to be valid
    // because it can be part of a legit URL (example:
    // https://services.comwell.com/da/booking/fill/?arrival_date=2019-08-01&departure_date=2019-08-02&hotel_code=caa&rooms[0][adults]=2&rooms[0][children]=0 )
    // If the param is in any other position, consider that is
    // a failed parameter value substitution (example: https://services.comwell.com/da/booking/fill/?arrival_date=[date_begin] )
    if (ctx.newUrl.match(new RegExp(`${TAG_OPEN}(date_begin|date_end|nights|language|adults|children|currency)${TAG_CLOSE}([^=]|$)`))) {
        // If params substitution has failed: this is an invalid URL
        ctx.newUrl = '';
    }
    return ctx.newUrl;
}
function dummyGenerateSearchUrl(ctx) {
    const result = {
        newData: collectionClone(ctx.data),
        newUrl: ctx.baseUrl,
    };
    return result;
}
function createReplayUrl(data, options, services) {
    const { callEngine } = services;
    let resultUrl = null;
    // Execute engine.generateSearchUrl foreach candidate URL until one is valid
    for (const candidateUrl of data.candidateUrls) {
        const context = collectionClone({
            baseUrl: candidateUrl,
            data: data.search,
            newUrl: '',
            newData: data.search,
        });
        const result = callEngine('generateSearchUrl', context)
            || dummyGenerateSearchUrl(context);
        const processedResult = result.newUrl && processSearchUrlResult(result);
        if (processedResult) {
            resultUrl = processedResult;
            break;
        }
    }
    if (!resultUrl) {
        return null;
    }
    if (options.urlExtraParams?.length) {
        const url = new URL(resultUrl);
        options.urlExtraParams.forEach(([key, value]) => {
            if (value !== undefined) {
                url.searchParams.set(key, value);
            }
        });
        resultUrl = url.toString();
    }
    if (!data.discount) {
        return resultUrl;
    }
    const { discount } = data;
    // Filter discountVars:
    // - not starting with a dot, hash or open bracket (CSS selectors)
    // - not ending with a parentesis (function)
    const discountVariables = options.discountVariables.filter(isValidQueryStringParam);
    if (!discountVariables.length) {
        if (discount.value === '') { // In case of empty discount code, we want to return the url
            return resultUrl;
        }
        services.logger.debug('Unable to apply discount code', discount);
        return null;
    }
    const url = new URL(resultUrl);
    // Find discount codes that exists in queryString
    const discountVarsPresent = discountVariables.filter((discountVar) => url.searchParams.get(discountVar) !== null);
    // If they exist, let's just replace the value on them
    if (discountVarsPresent.length) {
        const paramPairs = [
            ...discountVarsPresent.map((paramName) => [paramName, discount.value]),
            ...options.urlDiscountExtraParams,
        ];
        return buildUrl(url, paramPairs, 'queryString');
    }
    // Find discount codes that exists in hash
    const urlFromHash = createSearchParamsFromHash(url);
    const discountVarsPresentInHash = discountVariables.filter((discountVar) => urlFromHash.get(discountVar) !== null);
    // If they exist, let's just replace the value on them
    if (discountVarsPresentInHash.length) {
        const paramPairs = [
            ...discountVarsPresentInHash.map((paramName) => [paramName, discount.value]),
            ...options.urlDiscountExtraParams,
        ];
        return buildUrl(url, paramPairs, 'hash');
    }
    // If they dont't exist, let's pick the first discount code param
    const paramPairs = [
        [discountVariables[0], discount.value],
        ...options.urlDiscountExtraParams,
    ];
    // Apply discount on the hash if no regular queryString is present
    if (urlFromHash.toString() && !url.search) {
        return buildUrl(url, paramPairs, 'hash');
    }
    // Apply discount on the regular queryString
    return buildUrl(url, paramPairs, 'queryString');
}

function createSearchReplayPure(data, options, services) {
    // in any case should try to produce an URL
    const replayUrl = options.urlEngineTrust
        ? createReplayUrl(data, options, services)
        : null;
    // order of replayMethods matter, and should be carefully prepared by createReplayContext
    for (let index = 0; index < options.replayMethods.length; index += 1) {
        const replayMethod = options.replayMethods[index];
        switch (replayMethod) {
            case ReplayMethod.Eval: {
                const replayFn = createReplayFnByEval(data, options, services);
                if (replayFn) {
                    return {
                        replayFn,
                        replayMethod,
                        replayUrl,
                    };
                }
                break;
            }
            case ReplayMethod.Dom: {
                const replayFn = createReplayFnByDom(data, options, services);
                if (replayFn) {
                    return {
                        replayFn,
                        replayMethod,
                        replayUrl,
                    };
                }
                break;
            }
            case ReplayMethod.Url: {
                if (replayUrl) {
                    const replayFn = createReplayFnByUrl({ ...data, replayUrl }, options, services);
                    return {
                        replayFn,
                        replayMethod,
                        replayUrl,
                    };
                }
                break;
            }
        }
    }
    if (!replayUrl) {
        return null;
    }
    return {
        replayUrl,
        replayFn: null,
        replayMethod: null,
    };
}

function createSearchReplayFactory(searchReplayServices) {
    /**
     * Generates a URL and a function to replay a given search.
     *
     * Note this function is impure and coupled for convenience of usage.
     * It does exist a pure version which will rarely be directly used.
     *
     * @param data - Do not pass an argument to have it filled with a best guess.
     * @param baseUrl - The URL to be used as a base for the replay. Completely
     *  optional. Will take precedence over automatic URL selection, but it is
     *  not guaranteed to be the final base URL. Usually should not be passed
     *  explicitly.
     * @return Will be null when replay is not possible by any method
     * or the data argument is invalid.
     */
    return function createSearchReplay(data, options = {}) {
        const context = createSearchReplayContext(searchReplayServices, data, options);
        context?.services.logger?.trace(debugPrefix$4, 'Call with: (data)', data, '(options)', options);
        context?.services.logger?.trace(debugPrefix$4, 'Context', { ...context, services: '---replaced---' });
        if (!context) {
            return null;
        }
        const replayResult = createSearchReplayPure(context.data, context.options, context.services);
        context?.services.logger?.trace(debugPrefix$4, 'Result:', replayResult);
        if (!replayResult) {
            return null;
        }
        // Include de effective used context in the result (without services)
        return Object.assign(replayResult, {
            replayContext: {
                data: context.data,
                options: context.options,
            },
        });
    };
}

const SETTING_MOBILE_PREFIX = 'mobile_';
const SETTING_ENGINE_PREFIX = 'engine_';

const DEFAULT_VALUE$1 = 10000;
const FACTOR = 2.5;
function agentFetchTimeout(value) {
    // TODO
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    const effectiveValue = isNumericGtZero(value) ? value : DEFAULT_VALUE$1;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    const factor = environment$1() === 'production' ? 1 : FACTOR;
    return effectiveValue * factor;
}

const baseDecodeJson = (isValidValue, createDefaultValue) => ((value) => {
    let decodedValue;
    if (isString(value)) {
        try {
            decodedValue = JSON.parse(value);
        }
        catch { /* empty */ }
    }
    if (!isValidValue(decodedValue)) {
        return createDefaultValue();
    }
    return decodedValue;
});

const decodeJsonArray = /* #__PURE__ */ baseDecodeJson(isArray, () => []);

function handleNonEmptyString(value, defaultReturn) {
    return !empty(value) ? String(value) : defaultReturn;
}

function datalayerName(value) {
    return handleNonEmptyString(value, 'dataLayer');
}

const decodeJsonObject = /* #__PURE__ */ baseDecodeJson(isPlainObject, () => ({}));

function defaultHandler(value) {
    return !empty(value);
}

/**
 * If the raw setting value is an string (thus something was set on DB)
 * then the handler resolves the final value based on that raw value.
 * Otherwise defaults to true (inverse behaviour of the default handler).
 */
function defaultHandlerInverse(value) {
    if (isString(value)) {
        return !empty(value);
    }
    return true;
}

function isNumericHandler(value) {
    return isNumeric(value) ? Number(value) : undefined;
}

function formButtonSelector(value) {
    return handleNonEmptyString(value, '');
}

function fireEventHandler(value) {
    if (empty(value)) {
        return false;
    }
    if (isNumeric(value)) {
        return 'input';
    }
    return value;
}

function instantBookingHandler(value) {
    return handleNonEmptyString(value, undefined);
}

const DEFAULT_POSITION = 'after';
function instantBookingPosition(value) {
    const rawValue = String(value);
    return rawValue === 'before' ? rawValue : DEFAULT_POSITION;
}

// consider 0.5 as default (0.5 === 0.005)
const DEFAULT_VALUE = '0.5';
function sendTintoAssessment$1(value) {
    const effectiveValue = isUndefined(value) ? DEFAULT_VALUE : value;
    if (empty(effectiveValue)) {
        return false;
    }
    const parsedValue = Number(effectiveValue);
    if (!parsedValue) {
        return false;
    }
    return Math.random() <= (parsedValue * 0.01);
}

const adapters = ['pcomponents', 'dummy'];
function viewAdapterHandler(value) {
    const rawValue = String(value);
    return adapters.includes(rawValue) ? rawValue : adapters[0];
}

function partnershipId(value) {
    if (typeof value === 'string') {
        return value.split(/\s*,\s*/g).filter((id) => id);
    }
    return undefined;
}

function promocodeExtraParams(value) {
    const rawValue = handleNonEmptyString(value, undefined);
    const discountExtraParams = rawValue?.split(',') || [];
    if (discountExtraParams.length) {
        return discountExtraParams.map((extraParam) => (extraParam).split('='));
    }
    return [];
}

function promocodeSelectHandler(value) {
    return handleNonEmptyString(value, '');
}

const DEFAULT_TARGET = 'self';
function replayUrlTarget(value) {
    const rawValue = String(value);
    return rawValue === 'parent' ? rawValue : DEFAULT_TARGET;
}

function sendFormDelay(value) {
    return isNumericHandler(value) || 0;
}

function percentage(value) {
    const number = isNumeric(value) ? Number(value) : 0;
    if (number < 0) {
        return 0;
    }
    if (number > 100) {
        return 100;
    }
    return number;
}

var settingHandlers = /*#__PURE__*/Object.freeze({
  __proto__: null,
  agentFetchTimeout: agentFetchTimeout,
  customLanguageMap: decodeJsonObject,
  datalayerName: datalayerName,
  defaultHandler: defaultHandler,
  enginePromocodeParameterName: handleNonEmptyString,
  engineRatesBlacklistPattern: handleNonEmptyString,
  formButtonSelector: formButtonSelector,
  inputFireEvent: fireEventHandler,
  instantBookingButtonText: decodeJsonObject,
  instantBookingCssText: instantBookingHandler,
  instantBookingIcon: instantBookingHandler,
  instantBookingPosition: instantBookingPosition,
  partnershipId: partnershipId,
  promocodeExtraParams: promocodeExtraParams,
  promocodeSelectSelector: promocodeSelectHandler,
  promocodeSelectValue: promocodeSelectHandler,
  replayUrlTarget: replayUrlTarget,
  searchDefault: decodeJsonObject,
  selectFireEvent: fireEventHandler,
  sendFormDelay: sendFormDelay,
  sendTintoAssessment: sendTintoAssessment$1,
  targetPages: decodeJsonArray,
  tracingPercentage: percentage,
  viewAdapter: viewAdapterHandler,
  visitorIdentityTinto: defaultHandlerInverse,
  zIndex: isNumericHandler
});

const findDataSourceValue = (dataSources, candidateKeys) => {
    for (const candidateKey of candidateKeys) {
        const dataSource = dataSources.find((data) => candidateKey in data);
        if (dataSource) {
            return dataSource[candidateKey];
        }
    }
    return undefined;
};
const simpleCapitalize = (value) => `${value.slice(0, 1).toUpperCase()}${value.slice(1)}`;
const findHandler = memoize((handlerKey, handlers) => {
    if (handlerKey in handlers) {
        return handlers[handlerKey];
    }
    const closestHandlerKey = Object.keys(handlers).find((k) => handlerKey.endsWith(k) || handlerKey.endsWith(simpleCapitalize(k)));
    if (closestHandlerKey) {
        return handlers[closestHandlerKey];
    }
    if (handlers.defaultHandler) {
        return handlers.defaultHandler;
    }
    return (v) => v;
}, (handlerKey, handlers) => `${handlerKey},${Object.keys(handlers).join(',')}`);
/**
 * Removes the "mobile_" prefix and camelCases the key.
 */
const formatHandlerKey = (key) => camelCase(key.replace('mobile_', ''));
const buildCandidateKeys = (key, isMobile = () => false) => {
    const candidateKeys = [key];
    // Find out if the setting has a qualifier ("foo_bar#qualifier")
    const [bareKey, qualifier] = key.split('#');
    // When we have a qualifier, we fallback to the unqualified value
    if (qualifier) {
        candidateKeys.push(bareKey);
    }
    if (!isMobile()) {
        return [formatHandlerKey(bareKey), candidateKeys];
    }
    // On mobile, the mobile version of the setting has precedence
    candidateKeys.unshift(`${SETTING_MOBILE_PREFIX}${String(bareKey)}`);
    // And the fully qualified setting has the biggest precedence of all
    if (qualifier) {
        candidateKeys.unshift(`${SETTING_MOBILE_PREFIX}${String(key)}`);
    }
    return [formatHandlerKey(bareKey), candidateKeys];
};
function createGetSetting(dataSources, isMobile = () => false, handlers = settingHandlers) {
    return function getSetting(key) {
        const [handlerKey, candidateKeys] = buildCandidateKeys(key, isMobile);
        const rawValue = findDataSourceValue(dataSources, candidateKeys);
        if (key.startsWith(SETTING_ENGINE_PREFIX)) {
            return rawValue;
        }
        return findHandler(handlerKey, handlers)(rawValue);
    };
}

const name$1D = 'buildDefaultSearch';
function run$1D(bottle) {
    const deps = [
        'getSetting',
    ];
    bottle.serviceFactory(name$1D, createBuildDefaultSearch, ...deps);
    return bottle;
}

var buildDefaultSearch = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1D,
    run: run$1D
});

const MAX_BUS_MESSAGES = 10000;
const name$1C = 'busMaxMessages';
function run$1C(bottle) {
    bottle.factory(name$1C, () => MAX_BUS_MESSAGES);
    return bottle;
}

var busMaxMessages = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1C,
    run: run$1C
});

const name$1B = 'callEngine';
function run$1B(bottle) {
    const deps = [
        'errorMonitor',
        'logger',
        'bottle',
    ];
    bottle.serviceFactory(name$1B, callEngineFactory, ...deps);
    return bottle;
}

var callEngine = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1B,
    run: run$1B
});

const name$1A = 'chat';
function run$1A(bottle) {
    const deps = [
        'constructors.Chat',
    ];
    bottle.serviceFactory(name$1A, (Chat) => new Chat(bottle), ...deps);
    return bottle;
}

var chat = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1A,
    run: run$1A
});

const name$1z = 'convertCurrency';
const defaultPivotCurrencyCode = 'USD';
const createError = (currencyCode) => new Error(`Unknown rate for "${currencyCode}"`);
/**
 * Convert an amount of money between currencies.
 */
function convertCurrency(exchangeRates, amount, fromCurrencyCode, toCurrencyCode) {
    const pivotCurrencyCode = has$1(exchangeRates, defaultPivotCurrencyCode)
        ? defaultPivotCurrencyCode
        : Object.keys(exchangeRates)[0];
    const toPivotRate = pivotCurrencyCode === fromCurrencyCode
        ? 1
        : parseFloat(`${exchangeRates[pivotCurrencyCode]?.[fromCurrencyCode]}`);
    const inverseToPivotRate = parseFloat(`${exchangeRates[fromCurrencyCode]?.[pivotCurrencyCode]}`);
    const toTargetRate = pivotCurrencyCode === toCurrencyCode
        ? 1
        : parseFloat(`${exchangeRates[pivotCurrencyCode]?.[toCurrencyCode]}`);
    const inverseToTargetRate = parseFloat(`${exchangeRates[toCurrencyCode]?.[pivotCurrencyCode]}`);
    if (!toPivotRate && !inverseToPivotRate) {
        throw createError(fromCurrencyCode);
    }
    if (!toTargetRate && !inverseToTargetRate) {
        throw createError(toCurrencyCode);
    }
    const amountAsPivot = toPivotRate
        ? (amount * toPivotRate)
        : (amount / inverseToPivotRate);
    return toTargetRate
        ? (amountAsPivot / toTargetRate)
        : (amountAsPivot * inverseToTargetRate);
}
function run$1z(bottle) {
    bottle.serviceFactory(name$1z, () => convertCurrency);
    return bottle;
}

var convertCurrency$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    convertCurrency: convertCurrency,
    name: name$1z,
    run: run$1z
});

const name$1y = 'createSearchReplay';
function run$1y(bottle) {
    const deps = [
        'buildDefaultSearch',
        'bus',
        'callEngine',
        'getSetting',
        'getVisitorLastComparison',
        'globalState',
        'globalThis',
        'logger',
        'price',
        'package',
    ];
    bottle.serviceFactory(name$1y, (buildDefaultSearch, bus, callEngine, getSetting, getVisitorLastComparison, globalState, globalThis, logger, price, pack) => createSearchReplayFactory({
        buildDefaultSearch, bus, callEngine, getSetting, getVisitorLastComparison, globalState, globalThis, logger, price, package: pack,
    }), ...deps);
    return bottle;
}

var createSearchReplay = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1y,
    run: run$1y
});

const name$1x = 'dataLayer';
function run$1x(bottle) {
    const deps = [
        'dataLayerStub',
        'globalThis',
        'getSetting',
    ];
    bottle.serviceFactory(name$1x, (dataLayerStub, globalThis, getSetting) => {
        const datalayerName = getSetting('datalayer_name');
        const dataLayerCandidate = globalThis[datalayerName];
        const dataLayer = isArray(dataLayerCandidate) ? dataLayerCandidate : dataLayerStub;
        return dataLayer;
    }, ...deps);
    return bottle;
}

var dataLayer = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1x,
    run: run$1x
});

const name$1w = 'dataLayerHelper';
function run$1w(bottle) {
    const deps = [
        'dataLayer',
        'dataLayerStub',
        'constructors.DataLayerHelper',
        'bus',
        'getSetting',
    ];
    bottle.serviceFactory(name$1w, (dataLayer, dataLayerStub, DataLayerHelper, bus, getSetting) => {
        // If the dataLayer service has been executed before it exists on the website, we enter this condition.
        // As a workaround, we provide an implementation with a get method. Upon instantiation, it resets the dataLayer services if it is already present
        if (dataLayer === dataLayerStub) {
            return {
                get(key) {
                    bottle.resetProviders(['dataLayer']);
                    // Once the provided "dataLayer" is NOT the stub anymore
                    if (bottle.container.dataLayer !== dataLayerStub) {
                        // Reset "dataLayerHelper" and all the provisioners that depends on it
                        bottle.resetProviders(['dataLayerHelper', 'isUserLogged']);
                        return bottle.container.dataLayerHelper.get(key);
                    }
                    return undefined;
                },
                cancel() { },
            };
        }
        const isOwnThnPush = (value) => {
            const valueUnknownObject = isPlainObject(value) ? value : undefined;
            if (valueUnknownObject && isString(valueUnknownObject.event) && valueUnknownObject.event.startsWith('THN')) {
                return true;
            }
            if (isArguments(value) && isString(value[1]) && value[1].startsWith('THN')) {
                return true;
            }
            return false;
        };
        const isTransformableArguments = (value) => (
        // Arguments { "0": "set", "1": "user_properties", "2": { "gnahs_user_type": "", "gnahs_user_id": "", "gnahs_user_level": "" } }
        isArguments(value) && value.length === 3 && isString(value[0]) && isString(value[1]) && isPlainObject(value[2]));
        function datalayerListener(model, msg) {
            if (isOwnThnPush(msg)) {
                Object.defineProperty(msg, '_isThn', { value: true });
            }
            bus.emitDelayed('dataLayer:push', null, {
                model,
                message: msg,
            });
            if (isPlainObject(msg)) {
                const message = msg;
                const { event } = message;
                if (event) {
                    bus.emitDelayed(`dataLayer:event.${event}`, null, {
                        model,
                        message,
                    });
                }
            }
            // If transformations should happen
            if (getSetting('datalayer_transform')) {
                // Case 1: when the pushed message has this kind of shape
                // Arguments { "0": "set", "1": "user_properties", "2": { "gnahs_user_type": "", "gnahs_user_id": "", "gnahs_user_level": "" } }
                if (isTransformableArguments(msg)) {
                    // Then repush it as an object so that it becomes available as a dataLayer variable
                    // { "set": { "user_properties": { "gnahs_user_type": "", "gnahs_user_id": "", "gnahs_user_level": "" } } }
                    queueMicrotask(() => {
                        dataLayer.push({ [msg[0]]: { [msg[1]]: msg[2] } });
                    });
                }
            }
        }
        const dataLayerHelperInstance = new DataLayerHelper(dataLayer, datalayerListener, true);
        return dataLayerHelperInstance;
    }, ...deps);
    return bottle;
}

var dataLayerHelper$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1w,
    run: run$1w
});

const name$1v = 'dataLayerStub';
function run$1v(bottle) {
    bottle.serviceFactory(name$1v, () => ([]));
    return bottle;
}

var dataLayerStub = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1v,
    run: run$1v
});

class DemandManager {
    bus;
    logger;
    demands = [];
    static demandLevelMap = { normal: 'mid' };
    constructor(bus, logger) {
        this.bus = bus;
        this.logger = logger;
        this.bus.on('thn:server-event', (event) => {
            this.handleEvent(event);
        });
        this.bus.on(['thn:page.unload', 'thn:price.set', 'thn:package.set'], () => {
            this.reset();
        });
    }
    handleEvent(event) {
        if (DemandManager.isDemandEvent(event)) {
            this.logger.debug('handleEvent()', 'Setting demand event', event);
            this.demands.push(event);
            this.bus.emit('thn:demand', null, DemandManager.simplify(event));
        }
    }
    reset() {
        this.demands = [];
    }
    get() {
        return this.demands.length
            ? DemandManager.simplify(this.demands[this.demands.length - 1]).data.demandLevel
            : null;
    }
    static simplify(event) {
        const { demandLevel } = event.data;
        return {
            data: {
                demandLevel: DemandManager.demandLevelMap[demandLevel] ?? demandLevel,
            },
        };
    }
    static isDemandEvent(data) {
        return data.event.name === SseEventName.Demand;
    }
}

class DisparitiesManager {
    bus;
    logger;
    disparities = [];
    constructor(bus, logger) {
        this.bus = bus;
        this.logger = logger;
        this.bus.on('thn:server-event', (event) => {
            this.handleEvent(event);
        });
        this.bus.on(['thn:page.unload', 'thn:price.set', 'thn:package.set'], () => {
            this.reset();
        });
    }
    handleEvent(event) {
        if (DisparitiesManager.isDisparityEvent(event)) {
            this.logger.debug('handleEvent()', 'Setting disparity event', event);
            this.bus.emit('thn:disparity', null, DisparitiesManager.simplify(event));
            this.disparities.push(event);
        }
    }
    reset() {
        this.disparities = [];
    }
    get() {
        return this.disparities.map((item) => DisparitiesManager.simplify(item));
    }
    static simplify({ data }) {
        const { disparityRatio, sourceId } = data;
        return {
            data: {
                disparityRatio,
                sourceId,
            },
        };
    }
    static isDisparityEvent(data) {
        return data.event.name === SseEventName.Disparity;
    }
}

class DuettoManager {
    bus;
    logger;
    duettoScore;
    constructor(bus, logger) {
        this.bus = bus;
        this.logger = logger;
        this.bus.on('thn:server-event', (event) => {
            this.handleEvent(event);
        });
        this.bus.on(['thn:page.unload', 'thn:price.set', 'thn:package.set'], () => {
            this.reset();
        });
    }
    handleEvent(event) {
        if (DuettoManager.isDuettoEvent(event)) {
            this.set(event.data.occupancyForecastAdjusted);
        }
    }
    reset() {
        this.duettoScore = undefined;
    }
    get() {
        return this.duettoScore ?? null;
    }
    set(duettoScore) {
        if (typeof duettoScore !== 'number') {
            this.logger.debug('set()', 'Unable to set duettoScore', duettoScore);
            return;
        }
        this.logger.debug('set()', 'Setting duettoScore', duettoScore);
        this.bus.emit('thn:duetto', null, { occupancyForecastAdjusted: duettoScore });
        this.duettoScore = Math.round(duettoScore * 100);
    }
    static isDuettoEvent(data) {
        return data.event.name === SseEventName.Duetto;
    }
}

const defaultConfig$1 = {
    exitEndDelay: 1000,
    exitStartDelay: 750,
};
class ExitManager {
    exitIntentTimeout = null;
    lastMouseoutEl = null;
    exitedRecently = false;
    exitEndTimeout = null;
    outsideDocument = false;
    config;
    services;
    constructor(config, services) {
        this.config = { ...defaultConfig$1, ...config };
        this.services = {
            ...services,
            empty: services.empty ?? empty,
            isIe: services.isIe ?? isIe,
        };
        this.listen();
        this.services.bus.on('thn:page.unload', this.onPageUnload);
    }
    /**
     * Handle page unload event to reset state
     */
    onPageUnload = () => {
        this.reset();
    };
    /**
     * Public checker for recent exit action within the `exitEndDelay` buffer
     */
    isExiting() {
        return this.exitedRecently;
    }
    /**
     * Start listening to Document's mouseout/mouseenter events
     */
    listen() {
        const { globalThis } = this.services;
        // Listen to "mouseout" in capture phase. Otherwise, we may not fire the event
        globalThis.document.addEventListener('mouseout', this.onDocumentMouseout, true);
        globalThis.document.documentElement.addEventListener('mouseenter', this.onDocumentMouseenter, false);
    }
    /**
     * Document mouseout handler to detect exit intent and emit thn:exit
     */
    onDocumentMouseout = (event) => {
        const { bus, globalThis, empty, isIe, } = this.services;
        const effectiveEvent = event || globalThis.event;
        const to = effectiveEvent.relatedTarget || effectiveEvent.toElement;
        const isDoc = to && (to.nodeName === '#document' || to.nodeName === 'HTML');
        const comingFromSelect = this.lastMouseoutEl && this.lastMouseoutEl.tagName === 'SELECT';
        if (empty(to) || isDoc) {
            const { clientY } = effectiveEvent;
            if ((clientY < 0 && !comingFromSelect) || (isIe() && clientY < 100)) {
                if (this.exitIntentTimeout !== null) {
                    globalThis.clearTimeout(this.exitIntentTimeout);
                }
                this.exitIntentTimeout = globalThis.setTimeout(() => {
                    this.setExitedRecently(true);
                    this.outsideDocument = true;
                    bus.emit('thn:exit', null);
                }, this.config.exitStartDelay);
            }
            else if (this.exitIntentTimeout !== null) {
                globalThis.clearTimeout(this.exitIntentTimeout);
                this.exitIntentTimeout = null;
            }
        }
        this.lastMouseoutEl = to || null;
    };
    /**
     * Document mouseenter handler to cancel pending exit
     */
    onDocumentMouseenter = (event) => {
        const { empty, globalThis } = this.services;
        const effectiveEvent = event || globalThis.event;
        const to = effectiveEvent.relatedTarget || effectiveEvent.toElement;
        const isDoc = to && (to.nodeName === '#document' || to.nodeName === 'HTML');
        if (!(empty(to) || isDoc)) {
            return;
        }
        // If there is a pending intent timeout (user re-entered before delay), cancel it
        if (this.exitIntentTimeout !== null) {
            globalThis.clearTimeout(this.exitIntentTimeout);
            this.exitIntentTimeout = null;
        }
        // If the user was outside (exit already active), start the end buffer countdown now
        if (this.outsideDocument) {
            this.outsideDocument = false;
            this.startExitEndDelay();
        }
    };
    /**
     * Set recent exit state with a buffered window
     */
    setExitedRecently(exitedRecently) {
        const { globalThis } = this.services;
        this.exitedRecently = exitedRecently;
        if (this.exitEndTimeout !== null) {
            globalThis.clearTimeout(this.exitEndTimeout);
            this.exitEndTimeout = null;
        }
    }
    startExitEndDelay() {
        const { globalThis } = this.services;
        if (this.exitEndTimeout !== null) {
            globalThis.clearTimeout(this.exitEndTimeout);
            this.exitEndTimeout = null;
        }
        // maintain isExiting=true during the buffer, then reset to false
        this.exitEndTimeout = globalThis.setTimeout(() => {
            this.setExitedRecently(false);
        }, this.config.exitEndDelay);
    }
    /**
     * Reset state and cancel timers
     */
    reset() {
        const { globalThis, logger } = this.services;
        if (this.exitIntentTimeout !== null) {
            globalThis.clearTimeout(this.exitIntentTimeout);
            this.exitIntentTimeout = null;
        }
        this.setExitedRecently(false);
        this.lastMouseoutEl = null;
        this.outsideDocument = false;
        logger.trace('Reset exit manager state');
    }
}

const defaultServices$1 = {
    DateCtor: Date,
};
class IdleManager {
    idleGranularity = 1000;
    idleSeconds = 0;
    lastActivity = null;
    idleInterval = null;
    services;
    constructor(services) {
        this.services = { ...defaultServices$1, ...services };
        this.listen();
        this.services.bus.on('thn:page.unload', this.onPageUnload);
    }
    /**
     * Handle page unload event to reset state
     */
    onPageUnload = () => {
        this.reset();
    };
    /**
     * Handle idle timer tick
     */
    onWindowIdle = () => {
        const { bus, logger, DateCtor } = this.services;
        if (this.lastActivity === null) { // At this point, lastActivity should always be defined
            logger.warn('lastActivity should be defined');
            return;
        }
        const nowTime = DateCtor.now();
        this.idleSeconds = Math.floor((nowTime - this.lastActivity) / 1000);
        bus.emit('thn:idle', null, this.idleSeconds);
    };
    /**
     * Handle user activity events and start/restart the idle timer
     */
    onWindowActivity = debounce(() => {
        const { globalThis, DateCtor } = this.services;
        // reset lastActivity record
        this.lastActivity = DateCtor.now();
        // remove the current timer
        if (this.idleInterval !== null) {
            globalThis.clearInterval(this.idleInterval);
        }
        // start a new one
        this.idleInterval = globalThis.setInterval(this.onWindowIdle, this.idleGranularity);
    }, 400, { leading: true, trailing: false });
    /**
     * Start listening to user activity events
     */
    listen() {
        const { globalThis, logger, DateCtor } = this.services;
        if (this.lastActivity !== null) {
            logger.debug('Already listening to user activity');
            return;
        }
        logger.debug('Start listening to user activity');
        this.lastActivity = DateCtor.now();
        this.idleSeconds = 0;
        globalThis.addEventListener('mousemove', this.onWindowActivity, false);
        globalThis.addEventListener('click', this.onWindowActivity, false);
        globalThis.document.addEventListener('click', this.onWindowActivity, false);
        globalThis.addEventListener('scroll', this.onWindowActivity, false);
        globalThis.addEventListener('keypress', this.onWindowActivity, false);
        // start the idle countdown interval
        this.idleInterval = globalThis.setInterval(this.onWindowIdle, this.idleGranularity);
    }
    /**
     * Reset internal state and timers
     */
    reset() {
        const { globalThis, logger, DateCtor } = this.services;
        // Reset last activity timestamp and idle seconds
        this.lastActivity = DateCtor.now();
        this.idleSeconds = 0;
        // Restart the countdown interval
        if (this.idleInterval !== null) {
            globalThis.clearInterval(this.idleInterval);
        }
        this.idleInterval = globalThis.setInterval(this.onWindowIdle, this.idleGranularity);
        logger.debug('Reset idle manager state');
    }
}

const defaultServices = {
    DateCtor: Date,
};
class LoadManager {
    loadGranularity = 1000;
    toolsLoadedStartTime = null;
    toolsLoadedInterval = null;
    services;
    constructor(services) {
        this.services = { ...defaultServices, ...services };
        this.listen();
        this.services.bus.on('thn:page.unload', this.onPageUnload);
    }
    get elapsedSeconds() {
        return this.toolsLoadedStartTime ? Math.floor((this.services.DateCtor.now() - this.toolsLoadedStartTime) / 1000) : 0;
    }
    /**
     * Handle page unload event to reset state
     */
    onPageUnload = () => {
        this.reset();
    };
    /**
     * Handle tools loaded timer tick
     */
    onToolsLoaded = () => {
        this.services.bus.emit('thn:visitor-tools.loaded', null, this.elapsedSeconds);
    };
    /**
     * Handle "thn:visitor-tools.set" event to start emitting "thn:visitor-tools.loaded" every second
     */
    handleVisitorToolsSet = () => {
        const { clearInterval, setInterval } = this.services.globalThis;
        if (this.toolsLoadedInterval !== null) {
            clearInterval(this.toolsLoadedInterval);
        }
        this.toolsLoadedStartTime = this.services.DateCtor.now();
        this.onToolsLoaded();
        this.toolsLoadedInterval = setInterval(this.onToolsLoaded, this.loadGranularity);
        this.services.logger.trace('Started emitting "thn:visitor-tools.loaded" every second');
    };
    /**
     * Start listening to "thn:visitor-tools.set" event
     */
    listen() {
        this.services.bus.on('thn:visitor-tools.set', this.handleVisitorToolsSet, true);
    }
    /**
     * Reset internal state and timers
     */
    reset() {
        const { globalThis, logger } = this.services;
        if (this.toolsLoadedInterval !== null) {
            globalThis.clearInterval(this.toolsLoadedInterval);
            this.toolsLoadedInterval = null;
        }
        this.toolsLoadedStartTime = null;
        logger.trace('Reset load manager state');
    }
}

class OraculoManager {
    bus;
    logger;
    oraculoResults = {};
    constructor(bus, logger) {
        this.bus = bus;
        this.logger = logger;
        this.bus.on('thn:server-event', (event) => {
            this.handleEvent(event);
        });
        this.bus.on(['thn:page.unload'], () => {
            this.reset();
        });
    }
    /**
     * Temporal method to transform oraculo data to the new format
     */
    static transformOraculoData(data) {
        if (!Array.isArray(data)) {
            return data;
        }
        const transformedOraculoResult = {};
        data.forEach((item) => {
            // discard invalid items due to wrong status
            if (!item.status || item.status < 200 || item.status >= 300) {
                return;
            }
            // discard invalid items due to wrong accumulatedProbability
            if (globalThis.isNaN(item.accumulatedProbability) || item.accumulatedProbability < 0) {
                return;
            }
            transformedOraculoResult[camelCase(item.semanticLayer)] = item.accumulatedProbability;
        });
        return transformedOraculoResult;
    }
    handleEvent(event) {
        if (OraculoManager.isOraculoEvent(event)) {
            this.set(event.data);
        }
    }
    reset() {
        this.oraculoResults = {};
    }
    get() {
        return Object.keys(this.oraculoResults).length ? this.oraculoResults : null;
    }
    getSemanticLayer(semanticLayer) {
        return this.oraculoResults[semanticLayer] ?? null;
    }
    static normalizeOraculoProbability(data) {
        const normalizedOraculoResults = {};
        Object.entries(data).forEach(([key, value]) => {
            normalizedOraculoResults[key] = Math.round(value * 100);
        });
        return normalizedOraculoResults;
    }
    set(oraculoResults) {
        this.logger.debug('set()', 'Setting oraculoResults', oraculoResults);
        const transformedOraculoResults = OraculoManager.transformOraculoData(oraculoResults);
        if (!Object.keys(transformedOraculoResults).length) {
            this.logger.debug('set()', 'Unable to set oraculoResults');
            return;
        }
        const normalizedOraculoResults = OraculoManager.normalizeOraculoProbability(transformedOraculoResults);
        this.logger.debug('set()', 'Storing data', normalizedOraculoResults);
        this.oraculoResults = {
            ...this.oraculoResults,
            ...normalizedOraculoResults,
        };
        this.bus.emit('thn:visitor-oraculo.set', null, this.oraculoResults);
        this.logger.debug('set()', 'Stored oraculoResults', this.oraculoResults);
    }
    static isOraculoEvent(data) {
        return data.event.name === SseEventName.Oraculo;
    }
}

const defaultConfig = {
    scrollEndDelay: 1000,
};
class ScrollManager {
    config;
    services;
    scrolling = false;
    scrollEndTimeout = null;
    constructor(config, services) {
        this.config = config;
        this.services = services;
        this.config = { ...defaultConfig, ...config };
        this.listen();
        this.services.bus.on('thn:page.unload', this.onPageUnload);
    }
    /**
     * Handle page unload event to reset state
     */
    onPageUnload = () => {
        this.reset();
    };
    /**
     * Debounced emitter for the leading scroll event
     */
    emitScrollStart = debounce((...args) => {
        const { bus } = this.services;
        bus.emit('window:scroll', null, ...args);
    }, 400, { leading: true, trailing: false });
    /**
     * Raw scroll handler that updates the internal scrolling state and delegates to debounced emitters
     */
    onScroll = (...args) => {
        this.setScrolling(true);
        this.emitScrollStart(...args);
    };
    /**
     * Start listening to Window's "scroll" events
     */
    listen() {
        const { globalThis, logger } = this.services;
        // Note: forced to useCapture=true because of some hotels (propertyId 1011095)
        globalThis.addEventListener('scroll', this.onScroll, true);
        logger.trace('Listening to Window\'s "scroll" event');
    }
    /**
     * Throw away any pending debounced calls to reset state
     */
    reset() {
        this.setScrolling(false);
        this.emitScrollStart.cancel?.();
        this.services.logger.trace('Reset scroll manager state');
    }
    /**
     * Returns whether we are scrolling now or within the recent buffer window
     */
    isScrolling() {
        return this.scrolling;
    }
    /**
     * Set the internal scrolling state and manage the buffer timer
     */
    setScrolling(isScrolling) {
        const { globalThis } = this.services;
        this.scrolling = isScrolling;
        if (this.scrollEndTimeout) {
            globalThis.clearTimeout(this.scrollEndTimeout);
            this.scrollEndTimeout = null;
        }
        if (isScrolling) {
            // keep the scrolling state true for a small buffer after the last event
            this.scrollEndTimeout = globalThis.setTimeout(() => {
                this.scrolling = false;
                this.scrollEndTimeout = null;
            }, this.config.scrollEndDelay);
        }
    }
}

const name$1u = 'demandManager';
function run$1u(bottle) {
    const deps = [
        'bus',
        'Logger',
    ];
    bottle.serviceFactory(name$1u, (bus, Logger) => new DemandManager(bus, Logger.get('demand-manager')), ...deps);
    return bottle;
}

var demandManager = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1u,
    run: run$1u
});

const name$1t = 'disparitiesManager';
function run$1t(bottle) {
    const deps = [
        'bus',
        'Logger',
    ];
    bottle.serviceFactory(name$1t, (bus, Logger) => new DisparitiesManager(bus, Logger.get('disparities-manager')), ...deps);
    return bottle;
}

var disparitiesManager = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1t,
    run: run$1t
});

const name$1s = 'duettoManager';
function run$1s(bottle) {
    const deps = [
        'bus',
        'Logger',
    ];
    bottle.serviceFactory(name$1s, (bus, Logger) => new DuettoManager(bus, Logger.get('duetto-manager')), ...deps);
    return bottle;
}

var duettoManager = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1s,
    run: run$1s
});

const name$1r = 'domInteractive';
function run$1r(bottle) {
    const deps = [
        'globalThis',
    ];
    bottle.serviceFactory(name$1r, ({ document }) => {
        const domInteractive = () => (new Promise$1((resolve) => {
            if (document.readyState !== 'loading') {
                resolve();
            }
            else {
                // Only when readyState is "loading" we need to wait.
                // The first "readystatechange" event will make the DOM state "interactive"
                document.addEventListener('readystatechange', function onChange() {
                    document.removeEventListener('readystatechange', onChange);
                    resolve();
                });
            }
        }));
        return domInteractive;
    }, ...deps);
    return bottle;
}

var domInterative = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1r,
    run: run$1r
});

/* eslint no-void: "off" */

// Loaded ready states
var loadedStates = ['interactive', 'complete'];

// Return Promise
var whenDomReady = function whenDomReady(cb, doc) {
	return new Promise$1(function (resolve) {
		// Allow doc to be passed in as the lone first param
		if (cb && typeof cb !== 'function') {
			doc = cb;
			cb = null;
		}

		// Use global document if we don't have one
		doc = doc || window.document;

		// Handle DOM load
		var done = function done() {
			return resolve(void (cb && setTimeout(cb)));
		};

		// Resolve now if DOM has already loaded
		// Otherwise wait for DOMContentLoaded
		if (loadedStates.indexOf(doc.readyState) !== -1) {
			done();
		} else {
			doc.addEventListener('DOMContentLoaded', done);
		}
	});
};

// Promise chain helper
whenDomReady.resume = function (doc) {
	return function (val) {
		return whenDomReady(doc).then(function () {
			return val;
		});
	};
};

const name$1q = 'domReady';
function run$1q(bottle) {
    bottle.factory(name$1q, () => whenDomReady);
    return bottle;
}

var domReady = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1q,
    run: run$1q
});

const name$1p = 'engine';
function run$1p(bottle) {
    const deps = [
        'logger',
    ];
    bottle.serviceFactory(name$1p, (logger) => {
        const engineInstance = {
            boot() {
                logger.warn(new Error('Unexpected call to a dummy Engine instance'));
            },
        };
        return engineInstance;
    }, ...deps);
    return bottle;
}

var engine$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1p,
    run: run$1p
});

// @ts-ignore
const name$1o = 'env';
function run$1o(bottle) {
    bottle.factory(name$1o, () => env$1);
    return bottle;
}

var env = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1o,
    run: run$1o
});

// @ts-ignore
const name$1n = 'environment';
function run$1n(bottle) {
    bottle.factory(name$1n, () => environment$1);
    return bottle;
}

var environment = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1n,
    run: run$1n
});

const ERROR_EVENT_TYPE = 'error';
const ERROR_EVENT_HANDLER = `on${ERROR_EVENT_TYPE}`;
const ERROR_EVENT_METHOD = 'onError';
const UNHANDLED_REJECTION_EVENT_TYPE = 'unhandledrejection';
const UNHANDLED_REJECTION_EVENT_HANDLER = `on${UNHANDLED_REJECTION_EVENT_TYPE}`;
const UNHANDLED_REJECTION_EVENT_METHOD = 'onUnhandledRejection';
const SET_CONFIG_METHOD = 'setConfig';
const INIT_METHOD = 'init';
const ADD_ERROR_METHOD = 'addError';
const SENTRY_INSTRUMENTED_TOKEN = '__SENTRY_INSTRUMENTED__';

class ErrorMonitor {
    _queue = [];
    _adapter;
    _loadAndSetAdapter;
    _logger;
    _setAdapter(adapter) {
        this._adapter = adapter;
        // Process the queue of buffered calls
        while (this._queue.length) {
            const nextItem = this._queue.shift();
            if (nextItem) {
                if (this._adapter[nextItem[0]]) {
                    // @ts-ignore
                    this._adapter[nextItem[0]]?.(...nextItem[1]);
                }
                else {
                    this._logDrop(nextItem[0], nextItem[1]);
                }
            }
        }
        return this;
    }
    _logDrop(method, args) {
        this._logger.debug(`Drop call to "${method}". Args:`, args);
    }
    constructor({ globalThis, loadAdapter, logger }) {
        this._logger = logger;
        const onerror = (...args) => {
            if (!this._adapter) {
                this._queue.push([ERROR_EVENT_METHOD, args]);
                this._loadAndSetAdapter?.().catch(() => { });
                return;
            }
            if (!this._adapter[ERROR_EVENT_METHOD]) {
                this._logDrop(ERROR_EVENT_METHOD, args);
                return;
            }
            this._adapter[ERROR_EVENT_METHOD](...args);
        };
        const onunhandledrejection = (ev) => {
            if (!this._adapter) {
                this._queue.push([UNHANDLED_REJECTION_EVENT_METHOD, [ev]]);
                this._loadAndSetAdapter?.().catch(() => { });
                return;
            }
            if (!this._adapter[UNHANDLED_REJECTION_EVENT_METHOD]) {
                this._logDrop(UNHANDLED_REJECTION_EVENT_METHOD, [ev]);
                return;
            }
            this._adapter[UNHANDLED_REJECTION_EVENT_METHOD](ev);
        };
        this._loadAndSetAdapter = () => {
            const loadAdapterPromise = loadAdapter();
            this._loadAndSetAdapter = undefined;
            return loadAdapterPromise
                .then((adapter) => {
                globalThis.removeEventListener(ERROR_EVENT_TYPE, onerror);
                globalThis.removeEventListener(UNHANDLED_REJECTION_EVENT_TYPE, onunhandledrejection);
                this._setAdapter(adapter);
            })
                .catch((reason) => {
                this._logger.warn('Unable to load the adapter');
                this._logger.error(reason);
            });
        };
        globalThis.addEventListener(ERROR_EVENT_TYPE, onerror);
        globalThis.addEventListener(UNHANDLED_REJECTION_EVENT_TYPE, onunhandledrejection);
    }
    [INIT_METHOD](options) {
        if (!this._adapter) {
            this._queue.push([INIT_METHOD, [options]]);
            return;
        }
        if (!this._adapter[INIT_METHOD]) {
            this._logDrop(INIT_METHOD, [options]);
            return;
        }
        this._adapter[INIT_METHOD](options);
    }
    [ADD_ERROR_METHOD](error, data) {
        if (!this._adapter) {
            this._queue.push([ADD_ERROR_METHOD, [error, data]]);
            this._loadAndSetAdapter?.().catch(() => { });
            return;
        }
        if (!this._adapter[ADD_ERROR_METHOD]) {
            this._logDrop(ADD_ERROR_METHOD, [error, data]);
            return;
        }
        this._adapter[ADD_ERROR_METHOD](error, data);
    }
    [SET_CONFIG_METHOD](data) {
        if (!this._adapter) {
            this._queue.push([SET_CONFIG_METHOD, [data]]);
            return;
        }
        if (!this._adapter[SET_CONFIG_METHOD]) {
            this._logDrop(SET_CONFIG_METHOD, [data]);
            return;
        }
        this._adapter[SET_CONFIG_METHOD](data);
    }
}

const MSG_INIT = 'Adapter initialization';
const MSG_NO_INIT = `${MSG_INIT} missing`;
const MSG_IS_INIT = `${MSG_INIT} already done`;
const MSG_NO_INSTRUMENTED = 'Unexpected missing Sentry instrumentation on global';
const MSG_NO_INSTRUMENTED_ERROR_EVENT_HANDLER = `${MSG_NO_INSTRUMENTED} "${ERROR_EVENT_HANDLER}"`;
const MSG_NO_INSTRUMENTED_UNHANDLED_REJECTION_EVENT_HANDLER = `${MSG_NO_INSTRUMENTED} "${UNHANDLED_REJECTION_EVENT_HANDLER}"`;
class SentryAdapter {
    _globalThis;
    _logger;
    _scope;
    _sentryModule;
    constructor({ globalThis, logger, sentryModule }) {
        this._globalThis = globalThis;
        this._logger = logger;
        this._sentryModule = sentryModule;
    }
    [INIT_METHOD](options) {
        if (this._scope) {
            throw new Error(MSG_IS_INIT);
        }
        const { BrowserClient, Scope, defaultStackParser, getDefaultIntegrations, makeFetchTransport, } = this._sentryModule;
        const client = new BrowserClient({
            transport: makeFetchTransport,
            stackParser: defaultStackParser,
            integrations: getDefaultIntegrations({}),
            tracesSampleRate: 1.0,
            ...options,
        });
        this._scope = new Scope();
        this._scope.setClient(client);
        client.init();
        if (!this._globalThis[ERROR_EVENT_HANDLER]?.[SENTRY_INSTRUMENTED_TOKEN]) {
            this._logger.warn(MSG_NO_INSTRUMENTED_ERROR_EVENT_HANDLER);
        }
        if (!this._globalThis[UNHANDLED_REJECTION_EVENT_HANDLER]?.[SENTRY_INSTRUMENTED_TOKEN]) {
            this._logger.warn(MSG_NO_INSTRUMENTED_UNHANDLED_REJECTION_EVENT_HANDLER);
        }
    }
    [SET_CONFIG_METHOD](data) {
        if (!this._scope) {
            throw new Error(MSG_NO_INIT);
        }
        Object.keys(data).forEach((key) => {
            // Tag keys have a maximum length of 32 characters and can contain only letters (a-zA-Z), numbers (0-9), underscores (_), periods (.), colons (:), and dashes (-).
            const sanitizedKey = key.replace(/[^a-zA-Z0-9_.:-]/g, '_').slice(-32);
            this._scope.setTag(sanitizedKey, data[key]);
        });
    }
    [ADD_ERROR_METHOD](error, data) {
        if (!this._scope) {
            throw new Error(MSG_NO_INIT);
        }
        // assume a plain object contains Sentry "tags"
        this._scope.captureException(error, isPlainObject(data) ? { captureContext: { tags: data } } : undefined);
    }
    [ERROR_EVENT_METHOD](...args) {
        if (!this._scope) {
            throw new Error(MSG_NO_INIT);
        }
        if (!this._globalThis[ERROR_EVENT_HANDLER]) {
            this._logger.warn(MSG_NO_INSTRUMENTED_ERROR_EVENT_HANDLER);
            return;
        }
        this._globalThis[ERROR_EVENT_HANDLER](...args);
    }
    [UNHANDLED_REJECTION_EVENT_METHOD](ev) {
        if (!this._scope) {
            throw new Error(MSG_NO_INIT);
        }
        if (!this._globalThis[UNHANDLED_REJECTION_EVENT_HANDLER]) {
            this._logger.warn(MSG_NO_INSTRUMENTED_UNHANDLED_REJECTION_EVENT_HANDLER);
            return;
        }
        this._globalThis[UNHANDLED_REJECTION_EVENT_HANDLER]?.(ev);
    }
}

async function loadSentryAdapter(services) {
    // If `Sentry` exists we must wait for it to load before doing any import.
    // Eventhough THN instantiation is isolated, the import will define `globalThis.__SENTRY__`.
    // That pollution would prevent the automatic `Sentry.init()` call that happens by default,
    // seriously impacting the existing page's Sentry installation. See:
    // https://github.com/getsentry/sentry-javascript/blob/a524022a87b3260bf1b4181d505c41d1d999f824/packages/browser/test/loader.js#L103
    // https://github.com/getsentry/sentry-javascript/blob/a524022a87b3260bf1b4181d505c41d1d999f824/dev-packages/browser-integration-tests/loader-suites/loader/onLoad/customInit/init.js#L19
    if (services.globalThis.Sentry?.forceLoad) {
        services.logger.debug('Adapter load delayed until existing Sentry loads');
        const sentryShim = services.globalThis.Sentry;
        await new Promise$1((resolve) => {
            sentryShim.forceLoad();
            sentryShim.onLoad(resolve);
        });
    }
    const sentryModule = await import('@sentry/browser');
    return new SentryAdapter({ ...services, sentryModule });
}

const name$1m = 'errorMonitor';
function run$1m(bottle) {
    const deps = [
        'environment',
        'getSetting',
        'globalState',
        'globalThis',
        'Logger',
    ];
    bottle.serviceFactory(name$1m, (environment, getSetting, globalState, globalThis, Logger) => {
        const logger = Logger.get('error-monitor');
        const errorMonitor = new ErrorMonitor({
            globalThis,
            loadAdapter: async () => {
                if (getSetting('disable_monitoring')) {
                    logger.debug('Abort: disabled');
                    return {}; // NoopAdapter
                }
                logger.debug('Loading adapter');
                return loadSentryAdapter({ globalThis, logger });
            },
            logger,
        });
        errorMonitor.init({
            ignoreErrors: [
                // Unable to load module (Systemjs)
                /\(SystemJS https:\/\/github\.com\/systemjs\/systemjs\/blob\/main\/docs\/errors\.md#3\)/,
            ],
            sendClientReports: false,
            dsn: 'https://4e8a64c4227b0df43bc131a48d0cc685@o313875.ingest.sentry.io/1796084',
            get environment() { return environment(); },
            get release() { return globalState.semver; },
            beforeSend(event) {
                // Don't send errors from environments other than "production"
                if (!environment('production')) {
                    return null;
                }
                // Don't send errors when the page is not visible (most of the cases will be unloading)
                if (globalThis.document.visibilityState === 'hidden') {
                    return null;
                }
                // Discard non HTTP websites (local file system, etc)
                if (!['http:', 'https:'].includes(globalThis.location.protocol)) {
                    return null;
                }
                const pass = event.exception?.values?.some((ex) => {
                    if (!ex.stacktrace?.frames) {
                        return false;
                    }
                    const framesThn = ex.stacktrace.frames.map((frame) => typeof frame.filename === 'string' && frame.filename.includes(globalState.hostnameReal || globalState.hostname));
                    // Errors will be reported if:
                    // 1 - Exception is handled, and the first or the last file belong to THN.
                    // 2 - Exception is unhandled, and the the last file belongs to THN (it blew up in our code).
                    const isHandled = ex.mechanism?.handled;
                    const errorShouldBeReported = (isHandled && framesThn[framesThn.length - 1] && framesThn[0])
                        || (!isHandled && framesThn[framesThn.length - 1]);
                    return !!errorShouldBeReported;
                });
                return pass ? event : null;
            },
        });
        return errorMonitor;
    }, ...deps);
    bottle.factory('monitor', () => bottle.container.errorMonitor);
    return bottle;
}

var errorMonitor = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1m,
    run: run$1m
});

const ERROR_MSG = 'Exec service expects';
const name$1l = 'exec';
function run$1l(bottle) {
    const deps = [
        'globalThis',
    ];
    bottle.serviceFactory(name$1l, (globalThis) => {
        function exec({ func, args = [] }) {
            let fn = null;
            const { thn } = globalThis;
            if (!thn) {
                throw new TypeError(`${ERROR_MSG} to find a "thn" global`);
            }
            // Extract the function to be executed
            if (isString(func)) {
                const unknownValue = get$1(thn, func);
                if (isFunction(unknownValue)) {
                    fn = unknownValue;
                    const parts = func.split('.');
                    const context = parts
                        ? get$1(thn, parts.slice(0, -1).join('.'))
                        : globalThis.thn;
                    if (context) {
                        fn = fn.bind(context);
                    }
                }
            }
            if (!isFunction(fn)) {
                throw new TypeError(`${ERROR_MSG} options.func to resolve to a function`);
            }
            if (args && !Array.isArray(args)) {
                throw new TypeError(`${ERROR_MSG} options.args to be array`);
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            return fn(...args);
        }
        return exec;
    }, ...deps);
    return bottle;
}

var exec = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1l,
    run: run$1l
});

const name$1k = 'exit';
function run$1k(bottle) {
    const deps = [
        'constructors.Exit',
    ];
    bottle.serviceFactory(name$1k, (Exit) => new Exit(bottle), ...deps);
    return bottle;
}

var exit = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1k,
    run: run$1k
});

const name$1j = 'exitManager';
function run$1j(bottle) {
    const deps = [
        'bus',
        'globalThis',
        'Logger',
    ];
    bottle.serviceFactory(name$1j, (bus, globalThis, Logger) => new ExitManager({}, { bus, globalThis, logger: Logger.get('exit-manager') }), ...deps);
    return bottle;
}

var exitManager = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1j,
    run: run$1j
});

function createSendPageVisit(globalState, globalThis, sendBeacon, isUserLogged, logger, sendSiteAnalytics, widget) {
    const debugPrefix = 'sendPageVisit()';
    const endpoint = '/agent/ack-main';
    let hasBeenSent = false;
    const log = (...args) => logger.debug(debugPrefix, ...args);
    const sendPageVisit = () => {
        log('Call');
        if (!globalState.contextToken) {
            log('Aborted: unable to send without contextToken');
            return false;
        }
        if (hasBeenSent) {
            log('Aborted: already sent');
            return false;
        }
        // Along with the page visit beacon, there is an analytics event "THN VisitorStatus"
        // that informs about the group where this visitor would fall into if the regular "A/B test" feature were active.
        //
        // As usual "abTest: true" means the visitor would fall in "control", thus having no visual THN feedback,
        // and "abTest: false" means the vistitor would fall in "test" (or variant), thus having visual THN feedback.
        //
        // Note this is abTest value is prospective, the real "abTest" value depends on each widget execution.
        sendSiteAnalytics(AnalyticsEventName.VisitorStatus, {
            abTest: widget.isControlUser({ abTestActive: true }),
        });
        const payload = {
            url: globalThis?.location?.href?.toString?.(),
            visitorLoggedIn: !!isUserLogged(),
        };
        log('Payload', payload);
        hasBeenSent = true;
        return sendBeacon(endpoint, payload);
    };
    sendPageVisit.reset = () => {
        hasBeenSent = false;
    };
    return sendPageVisit;
}

function createUploadReport(fetch, globalThis, globalState, logger) {
    /**
     * Store the Agent execution log.
     */
    return function uploadReport() {
        const body = {
            page: globalState.pageName,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            property_id: globalState.propertyId,
            fingerprint: globalState.fingerprint,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            visit_date: globalState.pageLoadTime,
            url: globalThis.location.href,
            log: stringify(globalState.log),
        };
        return fetch('/add_widget_log', { body })
            .then((res) => res.ok && res.json())
            .then((data) => {
            if (data?.result === 1) {
                logger.debug('Report sent!');
                return true;
            }
            return Promise$1.reject(new Error('Failed to upload'));
        })
            .catch((reason) => {
            logger.warn(reason);
            return false;
        });
    };
}

function isNologFactory(globalState, callEngine) {
    /**
     * Denotes if the current user should be considered "nolog".
     *
     * A "nolog" user is special because their visit records are
     * handled as "office", that is they do not show/count in visit stats.
     *
     * If the user *is* "office", then the result of the function
     * will be `true`. It is not possible to deactivate "nolog" in
     * that case.
     *
     * If the user *is not* "office", then the result of the function
     * depends on the engine implementation (which should return
     * truthy or falsy values).
     *
     * Please note that the "nolog" feature is a combination of
     * frontend and backend data. Even if this function returns
     * `false`, the user could be visiting from a "nolog" ip.
     * In that case the user will still be considered "nolog" by
     * the backend. In other words, this function can **enable**
     * "nolog" for the current user (overruling the backend `false`),
     * but **can't** disabe it (can't override the backend `true`).
     */
    return function isNolog() {
        return !!(globalState?.office || !empty(callEngine('isNolog')));
    };
}

function createUploadPageHtml(fetch, globalState, globalThis, logger) {
    /**
     * Store a page's HTML in the server.
     */
    return function uploadPageHtml(page) {
        const debugPrefix = 'uploadPageHtml()';
        logger.trace(debugPrefix, 'Call');
        const body = {
            code: globalThis.document.documentElement.innerHTML,
            fingerprint: globalState.fingerprint,
            // warning: page name can be forced by param (needed on GuestCentric)
            page: (page && page === 'booking-confirmed') ? PageName.BookingConfirmed : globalState.pageName,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            property_id: globalState.propertyId,
            url: globalThis.location.href,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            visit_date: globalState.pageLoadTime,
        };
        const endpoint = '/add_widget_hotel_page_code';
        logger.trace(debugPrefix, endpoint, body);
        fetch('/add_widget_hotel_page_code', { body })
            .then((res) => res.ok && res.json())
            .then((data) => {
            logger.trace(debugPrefix, 'response:', data);
        })
            .catch(() => {
            logger.warn(new Error('Unable to upload HTML'));
        });
    };
}

function addHost(resource) {
    let isValid;
    try {
        isValid = !!(new URL(resource));
    }
    catch (e) {
        // eslint-ignore-next-line no-empty
    }
    if (isValid) {
        return resource;
    }
    return `${data.host}/${trim(String(resource), '/\\s\\uFEFF\\xA0')}`;
}

function encloseForSendBeacon(data) {
    return new URLSearchParams([['payload', bytesToBase64(stringify(data, (_k, v) => (v === STRINGIFY_REPLACEMENT ? undefined : v)))]]);
}

const contentTypesToStringify = [
    'text/plain',
    'application/json',
];
function shouldStringify(init) {
    return !!(contentTypesToStringify.includes(init.headers?.['content-type'])
        && init.body
        && !isString(init.body));
}
function shouldEncloseAsBeacon(init) {
    return !!(init.headers?.['content-type'] === 'application/x-www-form-urlencoded'
        && init.body
        && isPlainObject(init.body));
}
function fetchWrapper(fetch, defaults = {}) {
    if (!isFunction(fetch)) {
        throw new TypeError('fetch must be a function');
    }
    if (!isPlainObject(defaults)) {
        throw new TypeError('defaults must be an object');
    }
    return function fetchWrapped(resource, init = {}) {
        const timeout = init?.timeout || defaults?.timeout;
        return new AbortablePromise((resolve, reject, signal) => {
            const effectiveInit = { ...defaults, signal, ...init };
            if (shouldStringify(effectiveInit)) {
                effectiveInit.body = stringify(effectiveInit.body);
            }
            else if (shouldEncloseAsBeacon(effectiveInit)) {
                effectiveInit.body = encloseForSendBeacon(effectiveInit.body);
            }
            return fetch(addHost(resource), effectiveInit).then(resolve).catch(reject);
        }, { timeout });
    };
}

function sendBeaconWrapper(sendBeacon, defaultData = {}, requestDataFormatter = encloseForSendBeacon) {
    if (!isFunction(sendBeacon)) {
        throw new TypeError('sendBeacon must be a function');
    }
    if (!isPlainObject(defaultData)) {
        throw new TypeError('defaultData must be an object');
    }
    return memoize((url, data = null) => {
        const effectiveData = { ...defaultData, ...data };
        return sendBeacon(addHost(url), requestDataFormatter(effectiveData));
    });
}

const sendUniversalAnalyticsHit = (widgetName, ga, globalState, logger, customParams = {}) => {
    // https://developers.google.com/analytics/devguides/collection/analyticsjs/ga-object-methods-reference
    ga(() => {
        // register on each tracker
        ga.getAll().forEach((tracker) => {
            // Avoid registration of the client events into our
            // internal THN tracker
            if (tracker.get('trackingId') === globalState.GA_TRACKING_ID) {
                return;
            }
            ga(`${tracker.get('name')}.send`, {
                hitType: 'event',
                eventCategory: 'THN',
                eventAction: `THN ${widgetName}`,
                eventLabel: '',
                nonInteraction: true,
                ...customParams,
            });
        });
    });
    // log
    logger.debug('sendSiteAnalytics() used "ga" method');
};
const sendGoogleAnalytics4Event = (widgetName, gtag, logger, customParams = {}) => {
    gtag('event', `THN ${widgetName}`, {
        eventCategory: 'THN',
        nonInteraction: true,
        ...customParams,
    });
    // log
    logger.debug('sendSiteAnalytics() used "gtag" method');
};
/**
 * @returns `true` if no Google Tag Manager (GTM) tags were executed in response to the event,
 * `false` if at least one GTM tag was executed.
 */
const pushEventToDataLayer = (widgetName, globalThis, customParams = {}) => {
    if (!Array.isArray(globalThis.dataLayer)) {
        return true;
    }
    return globalThis.dataLayer.push({
        event: `THN ${widgetName}`,
        eventCategory: 'THN',
        nonInteraction: true,
        ...customParams,
    });
};
function createSendSiteAnalytics(globalThis, globalState, logger) {
    return function sendSiteAnalytics(widgetName, customParams = {}, shouldSend = globalState.widgetAnalytics) {
        if (!shouldSend) {
            return;
        }
        // log
        logger.debug(`sendSiteAnalytics() Call - ${widgetName}`, customParams);
        // TO DO: add deprecation message whenever a tool legacy event (THN Note, THN Layer, etc) is sent.
        // Indicate that the generic THN MessageStatus event should be used instead,
        // and attach an updated documentation to set the event in Google Analytics.
        /* const legacyEvents = ['note', 'layer', 'inliner', 'exit'];
        if (legacyEvents.includes(widgetName)) {
          logger.warn(`[Deprecation] - ${widgetName} is a legacy event, consider using a generic THN MessageStatus event instead. See https://...'`);
        } */
        const hasTriggeredAnEvent = !pushEventToDataLayer(widgetName, globalThis, customParams);
        // If a GTM tag has been fired when the event is pushed, we do not call any GA api to avoid repeated events.
        if (hasTriggeredAnEvent) {
            logger.debug(`sendSiteAnalytics() - ${widgetName} event pushed to the dataLayer has triggered a GTM tag`);
            return;
        }
        if (globalThis.gtag && isFunction(globalThis.gtag)) {
            sendGoogleAnalytics4Event(widgetName, globalThis.gtag, logger, customParams);
            return;
        }
        if (globalThis.ga && isFunction(globalThis.ga)) {
            sendUniversalAnalyticsHit(widgetName, globalThis.ga, globalState, logger, customParams);
        }
    };
}

// @ts-ignore
const name$1i = 'fetch';
function run$1i(bottle) {
    const deps = [
        'globalThis',
        'getSetting',
    ];
    bottle.serviceFactory(name$1i, (globalThis, getSetting) => {
        // Note the Agent fetch has a set of defaults tailored for POST/json
        // which is the most usual use case. It is the consumer responsability
        // to pass a "body" attribute in the options. In order to make requests with
        // other HTTP methods, It is required to overwritte this set of defaults ad-hoc.
        const defaultInit = {
            credentials: 'include',
            headers: {
                // Very important: use "text/plain" instead of "application/json"
                // to avoid the OPTIONS request (aka preflight).
                // Both classic and ABS backends will understand that they must
                // attempt to handle the request as if it where "application/json"
                'content-type': 'text/plain',
            },
            method: 'POST',
            timeout: {
                get milliseconds() {
                    return getSetting('agent_fetch_timeout');
                },
            },
        };
        const fetchInstance = fetchWrapper(globalThis.fetch, defaultInit);
        return fetchInstance;
    }, ...deps);
    return bottle;
}

var fetch = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1i,
    run: run$1i
});

class Logger {
    // Level definitions
    static TRACE = { value: 1, name: 'TRACE' };
    static DEBUG = { value: 2, name: 'DEBUG' };
    static INFO = { value: 3, name: 'INFO' };
    static TIME = { value: 4, name: 'TIME' };
    static WARN = { value: 5, name: 'WARN' };
    static ERROR = { value: 8, name: 'ERROR' };
    static OFF = { value: 99, name: 'OFF' };
    static logHandler;
    static level = this.INFO;
    static loggers = new Map();
    static names = new Map();
    static isNative = () => true;
    trace(...x) {
        this.console(Logger.TRACE, x);
    }
    debug(...x) {
        this.console(Logger.DEBUG, x);
    }
    info(...x) {
        this.console(Logger.INFO, x);
    }
    log(...x) {
        this.console(Logger.INFO, x);
    }
    warn(...x) {
        this.console(Logger.WARN, x);
    }
    error(...x) {
        this.console(Logger.ERROR, x);
    }
    static time(label) {
        if (!this.enabledFor(this.TIME) || !Logger.isNative(console.time))
            return;
        console.time?.(label);
    }
    static timeEnd(label) {
        if (!this.enabledFor(this.TIME) || !Logger.isNative(console.timeEnd))
            return;
        console.timeEnd?.(label);
    }
    static setLevel(level) {
        this.level = level;
    }
    static getLevel() {
        return this.level;
    }
    // eslint-disable-next-line class-methods-use-this
    openDebugGroup(titleText) {
        if (Logger.getLevel().value <= Logger.DEBUG.value
            && Logger.isNative(console.debug)
            && Logger.isNative(console.groupCollapsed)) {
            console.groupCollapsed?.(titleText);
        }
    }
    // eslint-disable-next-line class-methods-use-this
    closeDebugGroup() {
        if (Logger.getLevel().value <= Logger.DEBUG.value
            && Logger.isNative(console.debug)
            && Logger.isNative(console.groupEnd)) {
            console.groupEnd?.();
        }
    }
    static enabledFor(level) {
        return level.value >= this.level.value;
    }
    static setHandler(handler) {
        this.logHandler = handler;
    }
    static setNativeGuard(value) {
        this.isNative = value;
    }
    static get(name) {
        const logger = Logger.loggers.get(name) || new Logger();
        if (!Logger.loggers.has(name)) {
            Logger.loggers.set(name, logger);
            Logger.names.set(logger, name);
        }
        return logger;
    }
    getName() {
        return Logger.names.get(this);
    }
    console(level, message) {
        if (!Logger.logHandler)
            return;
        Logger.logHandler(message, { level, name: this.getName() });
    }
}

const isNotNullOrUndefined = (v) => typeof v !== 'undefined' && v !== null;
const filterNullUndefined = (array) => array.filter((item) => isNotNullOrUndefined(item));
const attrValueToAnyValue = (value) => {
    let values = [];
    switch (typeof value) {
        case 'string':
            return { stringValue: value };
        case 'boolean':
            return { boolValue: value };
        case 'number':
            return Number.isInteger(value) ? { intValue: value } : { doubleValue: value };
        default:
            try {
                values = filterNullUndefined(value).map(item => attrValueToAnyValue(item));
            }
            catch (error) {
                console.warn('attrValueToAnyValue error:', error);
            }
            return {
                arrayValue: {
                    values,
                },
            };
    }
};
// Note: It is impossible to convert IAnyValue to otel.AttributeValue.
// IAnyValue can contain nested IAnyValue, but otel.AttributeValue can't.
// It doesn't matter because all attributes are created from otel.AttributeValue.
const anyValueToAttrValue = (value) => {
    if (isNotNullOrUndefined(value.stringValue)) {
        return value.stringValue;
    }
    if (isNotNullOrUndefined(value.boolValue)) {
        return value.boolValue;
    }
    if (isNotNullOrUndefined(value.intValue)) {
        return value.intValue;
    }
    if (isNotNullOrUndefined(value.doubleValue)) {
        return value.doubleValue;
    }
    if (value.arrayValue) {
        const transformedArray = value.arrayValue.values.map(v => anyValueToAttrValue(v));
        if (transformedArray.every(v => typeof v === 'string' || v === null || v === undefined)) {
            return transformedArray;
        }
        if (transformedArray.every(v => typeof v === 'number' || v === null || v === undefined)) {
            return transformedArray;
        }
        if (transformedArray.every(v => typeof v === 'boolean' || v === null || v === undefined)) {
            return transformedArray;
        }
        return undefined;
    }
    if (value.kvlistValue) {
        return undefined;
    }
    if (value.bytesValue) {
        return undefined;
    }
    return undefined;
};
const keyValuesToAttributes = (keyValues) => keyValues.reduce((acc, keyValue) => {
    const value = anyValueToAttrValue(keyValue.value);
    if (value !== undefined) {
        acc[keyValue.key] = value;
    }
    return acc;
}, {});
const attributesToKeyValues = (attributes) => Object.entries(attributes).reduce((keyValues, [key, value]) => {
    if (typeof value !== 'undefined') {
        keyValues.push({ key, value: attrValueToAnyValue(value) });
    }
    else {
        keyValues.push({ key, value: { stringValue: 'undefined' } });
    }
    return keyValues;
}, []);
const iLinksToLinks = (links) => links.map(link => {
    const context = {
        traceId: link.traceId.toString(),
        spanId: link.spanId.toString(),
        traceFlags: 0,
    };
    return {
        context,
        attributes: keyValuesToAttributes(link.attributes),
        droppedAttributesCount: link.droppedAttributesCount,
    };
});
const linksToiLinks = (links) => links.map(link => ({
    traceId: link.context.traceId,
    spanId: link.context.spanId,
    traceState: undefined,
    droppedAttributesCount: link.droppedAttributesCount || 0,
    attributes: link.attributes ? attributesToKeyValues(link.attributes) : [],
}));
const hrTimeToMicro = (hrTime) => Math.floor((hrTime[0] * 1e12 + hrTime[1]) / 1000);
const microToNanoString = (micro) => `${micro}00000000`;
const timeStampToHrTime = (timeUnixMicro) => {
    const strHrTime = [
        parseInt(timeUnixMicro.slice(0, 10), 10),
        parseInt(timeUnixMicro.slice(10), 10),
    ];
    return strHrTime;
};
const iEventsToTimedEvents = (events) => events.map(event => ({
    time: timeStampToHrTime(event.timeUnixNano.toString()),
    name: event.name,
    attributes: keyValuesToAttributes(event.attributes),
    droppedAttributesCount: event.droppedAttributesCount,
}));
const timedEventsToiEvents = (events) => events.map(event => ({
    timeUnixNano: hrTimeToMicro(event.time),
    name: event.name,
    attributes: event.attributes ? attributesToKeyValues(event.attributes) : [],
    droppedAttributesCount: event.droppedAttributesCount || 0,
}));

const warnings = false;
class Span {
    _spanContext;
    name;
    onEnd;
    traceId = '';
    spanId = '';
    traceState;
    timeOriginMicro;
    startTime;
    endTime = [0, 0];
    startTimeUnixMicro;
    endTimeUnixMicro = 0;
    startTimeUnixNano = '';
    endTimeUnixNano = '';
    kind = 0;
    parentSpanId;
    status = { code: 0 };
    attributes = [];
    links = [];
    events = [];
    duration = [0, 0];
    ended = false;
    resource = {
        attributes: {},
        merge: () => this.resource,
    };
    instrumentationLibrary = {
        name: 'thn',
    };
    droppedAttributesCount = 0;
    droppedEventsCount = 0;
    droppedLinksCount = 0;
    constructor(_spanContext, name, onEnd) {
        this._spanContext = _spanContext;
        this.name = name;
        this.onEnd = onEnd;
        this.spanId = _spanContext.spanId;
        this.traceId = _spanContext.traceId;
        this.traceState = _spanContext.traceState?.toString();
        this.timeOriginMicro = Math.floor(performance.timeOrigin * 1000);
        this.startTimeUnixMicro = this.now();
        this.startTimeUnixNano = microToNanoString(this.startTimeUnixMicro);
        this.startTime = timeStampToHrTime(this.startTimeUnixNano);
    }
    spanContext() {
        // eslint-disable-next-line no-underscore-dangle
        return this._spanContext;
    }
    setAttribute(key, anyValue) {
        if (this.ended && warnings) {
            console.warn('Span Ended: Can not setAttribute');
        }
        const value = attrValueToAnyValue(anyValue);
        this.attributes.push({ key, value });
        return this;
    }
    setAttributes(attributes) {
        if (this.ended && warnings) {
            console.warn('Span Ended: Can not setAttributes');
        }
        Object.entries(attributes).forEach(([key, anyValue]) => {
            if (anyValue !== undefined && Object.prototype.hasOwnProperty.call(attributes, key)) {
                this.setAttribute(key, anyValue);
            }
        });
        return this;
    }
    addEvent(name, eventAattributes, startTime) {
        if (this.ended && warnings) {
            console.warn('Span Ended: Can not addEvent');
        }
        const timeUnixNano = microToNanoString(hrTimeToMicro(startTime || timeStampToHrTime(microToNanoString(this.now()))));
        const attributes = eventAattributes ? attributesToKeyValues(eventAattributes) : [];
        const event = {
            name,
            timeUnixNano,
            attributes,
            droppedAttributesCount: 0,
        };
        this.events.push(event);
        return this;
    }
    addLink(otelLink) {
        if (this.ended && warnings) {
            console.warn('Span Ended: Can not addLink');
        }
        const attributes = otelLink.attributes ? attributesToKeyValues(otelLink.attributes) : [];
        const link = {
            traceId: this.traceId,
            spanId: this.spanId,
            traceState: this.traceState || undefined,
            droppedAttributesCount: otelLink.droppedAttributesCount || 0,
            attributes,
        };
        this.links.push(link);
        return this;
    }
    addLinks(links) {
        if (this.ended && warnings) {
            console.warn('Span Ended: Can not addLinks');
        }
        links.forEach(link => this.addLink(link));
        return this;
    }
    setStatus(spanStatus) {
        this.status = {
            code: spanStatus.code,
            message: spanStatus.message,
        };
        return this;
    }
    updateName(name) {
        this.name = name;
        return this;
    }
    end(endTime) {
        this.endTimeUnixMicro = endTime ? hrTimeToMicro(endTime) : this.now();
        if (this.endTimeUnixMicro - this.startTimeUnixMicro === 0) {
            this.endTimeUnixMicro += 1;
        }
        this.endTimeUnixNano = microToNanoString(this.endTimeUnixMicro);
        this.endTime = timeStampToHrTime(this.endTimeUnixNano);
        this.ended = true;
        this.duration = [this.endTime[0] - this.startTime[0], this.endTime[1] - this.startTime[1]];
        this.onEnd(this.toReadableSpan());
    }
    toReadableSpan() {
        const status = {
            message: this.status.message,
            code: this.status.code,
        };
        const attributes = keyValuesToAttributes(this.attributes);
        const links = iLinksToLinks(this.links);
        const events = iEventsToTimedEvents(this.events);
        const readableSpan = {
            name: this.name,
            kind: this.kind,
            spanContext: () => this.spanContext(),
            parentSpanId: this.parentSpanId,
            startTime: this.startTime,
            endTime: this.endTime,
            status,
            attributes,
            links,
            events,
            duration: this.duration,
            ended: this.ended,
            resource: this.resource,
            instrumentationLibrary: this.instrumentationLibrary,
            droppedAttributesCount: this.droppedAttributesCount,
            droppedEventsCount: this.droppedEventsCount,
            droppedLinksCount: this.droppedLinksCount,
        };
        return readableSpan;
    }
    // eslint-disable-next-line class-methods-use-this
    isRecording() {
        // TODO: Change this to actual logic if required
        return true;
    }
    recordException(exception, time) {
        const exceptionName = typeof exception === 'string' ? exception : exception.name || 'unknown exception';
        const exceptionAsAttribute = typeof exception === 'string' ? { message: exception } : { ...exception };
        this.addEvent(exceptionName, exceptionAsAttribute, time);
    }
    // eslint-disable-next-line class-methods-use-this
    now() {
        return Date.now() * 1000;
    }
}

class BatchSpanProcessor {
    exporter;
    maxBatchSize;
    maxTimeMs;
    spans = [];
    timer = null;
    stopped = false;
    constructor(exporter, maxBatchSize = 100, maxTimeMs = 5000) {
        this.exporter = exporter;
        this.maxBatchSize = maxBatchSize;
        this.maxTimeMs = maxTimeMs;
    }
    onEnd(span) {
        if (this.stopped) {
            return;
        }
        this.spans.push(span);
        if (this.spans.length >= this.maxBatchSize) {
            this.flush();
        }
        if (!this.timer) {
            this.startTimer();
        }
    }
    // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-unused-vars
    onStart(span, parentContext) {
        throw new Error('Method not implemented.');
    }
    // Flushes the spans and sends them to the exporter.
    flush() {
        this.exporter.export(this.spans, (result) => {
            if (result.code !== 0) {
                console.error('Failed to export spans:', result.error);
            }
        });
        this.spans = [];
        this.clearTimer();
    }
    startTimer() {
        this.timer = setTimeout(() => {
            this.flush();
        }, this.maxTimeMs);
    }
    clearTimer() {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    }
    // eslint-disable-next-line class-methods-use-this
    async forceFlush() {
        throw new Error('Method not implemented.');
    }
    async shutdown() {
        await this.forceFlush();
        await this.exporter.shutdown();
        this.stopped = true;
    }
}

var SpanStatusCode = /*@__PURE__*/(function (SpanStatusCode = {}) {
    /**
     * The default status.
     */
    // eslint-disable-next-line @shopify/typescript/prefer-pascal-case-enums
    SpanStatusCode[SpanStatusCode["UNSET"] = 0] = "UNSET";
    /**
     * The operation has been validated by an Application developer or
     * Operator to have completed successfully.
     */
    // eslint-disable-next-line @shopify/typescript/prefer-pascal-case-enums
    SpanStatusCode[SpanStatusCode["OK"] = 1] = "OK";
    /**
     * The operation contains an error.
     */
    // eslint-disable-next-line @shopify/typescript/prefer-pascal-case-enums
    SpanStatusCode[SpanStatusCode["ERROR"] = 2] = "ERROR";
    return SpanStatusCode;
})(SpanStatusCode);
var TraceFlag = /*@__PURE__*/(function (TraceFlag = {}) {
    /** Represents no flag set. */
    TraceFlag[TraceFlag["None"] = 0] = "None";
    /** Bit to represent whether trace is sampled in trace flags. */
    TraceFlag[TraceFlag["Sampled"] = 1] = "Sampled";
    return TraceFlag;
})(TraceFlag);

class SpanExporter {
    url;
    sendBeacon;
    serviceName = 'agent-tracer-test';
    version = '1.0.0';
    env = 'dev';
    constructor(url, sendBeacon) {
        this.url = url;
        this.sendBeacon = sendBeacon;
    }
    export(spans, resultCallback) {
        const spanData = spans.map(s => this.convertSpanToPayload(s));
        const data = this.transformOpenTracingToOtlp(spanData);
        const success = this.sendBeacon(this.url, {
            content: data,
        });
        resultCallback({ code: success ? 0 : 1 });
    }
    // eslint-disable-next-line class-methods-use-this
    convertSpanToPayload(span) {
        const { traceId, spanId } = span.spanContext();
        const { parentSpanId, name, droppedAttributesCount, droppedEventsCount, droppedLinksCount, } = span;
        const traceState = undefined;
        const kind = 1;
        const startTimeUnixNano = hrTimeToMicro(span.startTime);
        const endTimeUnixNano = hrTimeToMicro(span.endTime);
        const attributes = attributesToKeyValues(span.attributes);
        const events = timedEventsToiEvents(span.events);
        const links = linksToiLinks(span.links);
        const status = {
            message: span.status.message,
            code: span.status.code.valueOf(),
        };
        return {
            traceId,
            spanId,
            traceState,
            parentSpanId,
            name,
            kind,
            startTimeUnixNano,
            endTimeUnixNano,
            attributes,
            droppedAttributesCount,
            events,
            droppedEventsCount,
            links,
            droppedLinksCount,
            status,
        };
    }
    transformOpenTracingToOtlp(spans) {
        const resourceSpan = {
            resource: {
                attributes: [
                    {
                        key: 'service.name',
                        value: {
                            stringValue: this.serviceName,
                        },
                    }, {
                        key: 'telemetry.sdk.language',
                        value: {
                            stringValue: 'javascript',
                        },
                    }, {
                        key: 'telemetry.sdk.name',
                        value: {
                            stringValue: 'opentelemetry',
                        },
                    }, {
                        key: 'telemetry.sdk.version',
                        value: {
                            stringValue: '1.24.0',
                        },
                    }, {
                        key: 'deployment.environment',
                        value: {
                            stringValue: this.env,
                        },
                    }, {
                        key: 'service.version',
                        value: {
                            stringValue: this.version,
                        },
                    },
                ],
                droppedAttributesCount: 0,
            },
            scopeSpans: [
                {
                    scope: {
                        name: 'agent',
                    },
                    spans,
                },
            ],
        };
        return { resourceSpans: [resourceSpan] };
    }
    // Method to handle cleanup of any resources or ongoing exports.
    // eslint-disable-next-line class-methods-use-this
    shutdown() {
        return new Promise$1((resolve) => {
            console.log('HttpSpanExporter shutting down');
            resolve();
        });
    }
}

function generateTraceId() {
    const buffer = new Uint8Array(16);
    crypto.getRandomValues(buffer);
    return Array.from(buffer).map(b => b.toString(16).padStart(2, '0')).join('');
}
function generateSpanId() {
    const buffer = new Uint8Array(8);
    crypto.getRandomValues(buffer);
    return Array.from(buffer).map(b => b.toString(16).padStart(2, '0')).join('');
}
const active = Symbol('active');
class Tracer {
    id;
    serverUrl;
    spans = [];
    spanProcessor;
    constructor(options, sendBeacon) {
        this.id = generateTraceId();
        this.serverUrl = options.serverUrl;
        this.spanProcessor = new BatchSpanProcessor(new SpanExporter(this.serverUrl, sendBeacon));
    }
    // eslint-disable-next-line class-methods-use-this
    startSpan(name, options, context) {
        let spanId;
        if (options?.attributes?.spanId && typeof options.attributes.spanId === 'string') {
            spanId = options.attributes.spanId;
        }
        else {
            spanId = generateSpanId();
        }
        const spanContext = {
            traceId: this.id,
            spanId,
            traceFlags: TraceFlag.Sampled,
        };
        const span = new Span(spanContext, name, (readableSpan) => this.spanProcessor.onEnd(readableSpan));
        context?.setValue(active, span);
        const parentSpanId = context?.getValue(Symbol.for('parentSpanId'));
        if (typeof parentSpanId === 'string') {
            span.parentSpanId = parentSpanId;
        }
        this.spans.push(span);
        return span;
    }
    startActiveSpan(name, optionsOrFn, contextOrFn, maybeFn) {
        let options;
        let context;
        let fn;
        let returnValue;
        if (typeof optionsOrFn === 'function') {
            fn = optionsOrFn;
        }
        else if (typeof contextOrFn === 'function') {
            options = optionsOrFn;
            fn = contextOrFn;
        }
        else {
            options = optionsOrFn;
            context = contextOrFn;
            fn = maybeFn;
        }
        const span = this.startSpan(name, options, context);
        if (fn) {
            try {
                returnValue = fn(span);
            }
            catch (error) {
                let message = 'Unknown Error in active span';
                if (error instanceof Error) {
                    message = error.message;
                }
                else if (typeof error === 'string') {
                    message = error;
                }
                else if (error != null) {
                    message = JSON.stringify(error);
                }
                span.setStatus({ code: SpanStatusCode.ERROR, message });
                throw error;
            }
        }
        return returnValue;
    }
}

class TracerProvider {
    sendBeacon;
    tracers = new Map();
    version = '1.25.1';
    env = 'stg';
    serverUrl = '/agent/traces';
    constructor(sendBeacon) {
        this.sendBeacon = sendBeacon;
    }
    getTracer(name, version, options) {
        const existingTracer = this.tracers.get(name);
        if (existingTracer) {
            return existingTracer;
        }
        const tracer = new Tracer({
            name,
            version: version || this.version,
            env: this.env,
            serverUrl: this.serverUrl,
            ...options,
        }, this.sendBeacon);
        this.tracers.set(name, tracer);
        return tracer;
    }
}

class Context {
    values;
    constructor() {
        this.values = new Map();
    }
    getValue(key) {
        return this.values.get(key);
    }
    setValue(key, value) {
        this.values.set(key, value);
        return this;
    }
    deleteValue(key) {
        this.values.delete(key);
        return this;
    }
}

const name$1h = 'context';
function run$1h(bottle) {
    bottle.serviceFactory(name$1h, () => ({
        active: () => new Context(),
    }));
    return bottle;
}

var context = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1h,
    run: run$1h
});

const name$1g = 'getPropertyPerks';
function run$1g(bottle) {
    const deps = [
        'globalState',
        'logger',
        'fetch',
    ];
    bottle.serviceFactory(name$1g, createGetPropertyPerks, ...deps);
    return bottle;
}

var getPropertyPerks = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1g,
    run: run$1g
});

const name$1f = 'getSetting';
function run$1f(bottle) {
    const deps = [
        'globalState',
    ];
    bottle.serviceFactory(name$1f, (globalState) => {
        const isMobile = () => globalState?.media?.name === 'mobile';
        const proxify = (obj, prop) => new Proxy(obj, {
            has(target, subprop) {
                return Reflect.has(target[prop], subprop);
            },
            get(target, subprop, receiver) {
                return Reflect.get(target[prop], subprop, receiver);
            },
        });
        return createGetSetting([
            proxify(globalState, 'injectedSettings'),
            proxify(globalState, 'propertySettings'),
            proxify(globalState, 'corporateSettings'),
            proxify(globalState, 'bookingSystemSettings'),
            proxify(globalState, 'globalSettings'),
        ], isMobile);
    }, ...deps);
    return bottle;
}

var getSetting = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1f,
    run: run$1f
});

// Note the "key" used to store the state in the combinedStorage
// is changed from a more appropiated name like "visitor", to the
// name "thn_id" just to avoid creating a new cookie on the thn domain.
const MSG_BAD_RESPONSE = 'Bad Response:';
const MSG_FREEMIUM = 'This Site has no paid products';
const MSG_NO_PAGE = 'No page detected';
const VISITOR_PERSISTENT_STATE_KEY = 'thn_id';

/**
 * If we care about past search dates, checks if the entry data contains dates before today. If not, false is returned.
 */
const isAllowedStayDates = (lastComparisonStayDates, acceptStayDatesBeforeToday) => {
    if (acceptStayDatesBeforeToday) {
        return true;
    }
    try {
        return daysBetween(new Date(), lastComparisonStayDates.dateBegin) >= 0;
    }
    catch (error) {
        return false;
    }
};
/**
 * If we care about old lastComparisons, checks if the entry data contains a `visitDate` parameter with a date before the last 24 hours. If not, false is returned.
 */
const isAllowedVisitDate = (lastComparisonVisitDate, acceptVisitDatesBeforeLast24Hours) => {
    if (acceptVisitDatesBeforeLast24Hours) {
        return true;
    }
    try {
        const visitDate = new Date(1000 * Number(lastComparisonVisitDate)).getTime();
        const isWithinLast24Hours = daysBetween(visitDate, Date.now()) < 1;
        return isWithinLast24Hours;
    }
    catch (error) {
        return false;
    }
};
/**
 * Checks if the lastComparison data contains a price and availability.
 */
const isAllowedAvailability = (search, acceptWithoutAvailability) => {
    if (acceptWithoutAvailability) {
        return true;
    }
    const hasPrice = 'price' in search && !empty(search.price);
    const hasAvailability = search.noRooms !== true;
    return hasPrice && hasAvailability;
};
/**
 * Build a filter for the search entry.
 */
const buildEntryFilter = (options, currentPid) => (entry) => {
    if (empty(entry?.data?.actual?.search)) {
        return false;
    }
    const isEntryFromCurrentProperty = entry.data.actual.context?.propertyId === currentPid;
    // Any search entry that belongs to other sites is unacceptable
    if (!isEntryFromCurrentProperty) {
        return false;
    }
    const isPages = entry.data.actual.metadata
        && 'custom' in entry.data.actual.metadata;
    // Any search entry originated by a PW pages config is unacceptable
    if (isPages) {
        return false;
    }
    // Avoid returning a lastComparison if visitDate is before last 24 hours.
    // If we care about avialablity, make sure the entry has "price" and is not a NO_ROOMS.
    // And if we care about stay dates, make sure the entry has stay dates in the future.
    return isAllowedAvailability(entry.data.actual.search, options.acceptWithoutAvailability)
        && isAllowedVisitDate(entry.data.actual.context.visitDate, options.acceptVisitDatesBeforeLast24Hours)
        && isAllowedStayDates(entry.data.actual.search, options.acceptStayDatesBeforeToday);
};
/**
 * Helper in charge of converting a SearchEntry into a plain comparison search data object
 */
const fromEntry = (entry) => {
    if (!entry) {
        return undefined;
    }
    const status = entry.state.status || '';
    const { visitDate, widgetName } = entry.data.actual.context;
    return {
        ...entry?.data.actual.search,
        status,
        visitDate,
        widgetName,
    };
};
/**
 * Helper in charge of converting all the entries of a LastComparisonContext into plain comparison search data objects
 */
const convertContextEntries = (comparisonContext) => Object.fromEntries(Object.entries(comparisonContext).map(([key, value]) => {
    const transformedValue = fromEntry(value);
    return [key, transformedValue];
}));
/**
 * Helper in charge of converting a plain comparison search data object into a SearchEntry
 */
const toEntry = (comparisonPlainData, services, filter) => {
    if (!comparisonPlainData) {
        return undefined;
    }
    try {
        // Note we always create an entry to validate "lastComparison" data
        // (even when that data is going to be returned as a plain object)
        const lastComparisonAsEntry = services[comparisonPlainData.widgetName || 'price'].assertValid(comparisonPlainData);
        // Even if the lastComparisonAsEntry produced is valid, we still need
        // to make sure it passes the initial filter builded for the given options
        if (!filter(lastComparisonAsEntry)) {
            return undefined;
        }
        return lastComparisonAsEntry;
    }
    catch (e) {
        return undefined;
    }
};
function createGetVisitorLastComparison(globalState, searches, price, pack) {
    return function getVisitorLastComparison({ acceptWithoutAvailability = true, acceptStayDatesBeforeToday = true, acceptVisitDatesBeforeLast24Hours = true, asAll = false, } = {}) {
        const options = { acceptWithoutAvailability, acceptVisitDatesBeforeLast24Hours, acceptStayDatesBeforeToday };
        const isTargetPage = price?.isTargetPage?.(globalState.pageName) || pack?.isTargetPage?.(globalState.pageName);
        // The client searches registry has priority over any other source
        const filter = buildEntryFilter(options, globalState.propertyId);
        let clientComparison;
        {
            // On the searches registry, the current search entry
            // always has priority over any other search entry
            const currentComparison = searches.getCurrentEntry();
            if (currentComparison && filter(currentComparison)) {
                // If there is a current entry & it passes the filters, that's it
                clientComparison = currentComparison;
            }
            else if (!isTargetPage) {
                // Otherwise it is acceptable to use other search entries (not current)
                // only when we are NOT in a Target page (probably we have moved forward
                // or backwards in the funnel, thus the "current" state is not relevant).
                clientComparison = searches.getLatestEntry(filter);
            }
        }
        if (asAll) {
            const services = { globalState, price, package: pack };
            const lastComparisonServer = toEntry(globalState.visitor?.lastComparison, services, filter);
            // If we have clientComparison we will return its value as the default context.
            // If we don't have it, but we are in a target page, we don't want to use visitor.lastComparison
            const lastComparisonContext = {
                client: clientComparison,
                server: lastComparisonServer,
                default: (clientComparison || isTargetPage) ? clientComparison : lastComparisonServer,
            };
            return convertContextEntries(lastComparisonContext);
        }
        // First option is always to return the latest search we know of from the registry
        if (clientComparison) {
            return clientComparison;
        }
        // If we are on RnR, we don't use the visitor.lastComparison never
        if (isTargetPage) {
            return undefined;
        }
        // Otherwise, our only hope is the visitor.lastComparison (given by the backend).
        return toEntry(globalState.visitor?.lastComparison, { globalState, price, package: pack }, filter);
    };
}

function createGetVisitorPersistentState(asyncCombinedStorage, logger) {
    async function getVisitorPersistentState(prop) {
        let persistentState = {};
        try {
            const combinedStorage = await asyncCombinedStorage;
            persistentState = (await combinedStorage.get(VISITOR_PERSISTENT_STATE_KEY)) ?? {};
        }
        catch (error) {
            logger.warn(error);
        }
        return prop ? persistentState[prop] : persistentState;
    }
    return getVisitorPersistentState;
}

function createGetVisitorTokens(asyncContainer, fetch, getVisitorPersistentState, globalState, logger, tintoModelId) {
    const debugPrefix = 'getVisitorTokens()';
    const FINGERPRINT_EXPIRE = 1 /* days */
        * 24 /* hours */
        * 60 /* minutes */
        * 60 /* seconds */
        * 1000; /* milliseconds */
    function analyzeState(state) {
        const { fingerprint, mtime, source, token, } = state;
        const sourceIsTinto = !!(source?.startsWith('TINTO'));
        const isNewVisitor = !(fingerprint || token);
        const isReturningVisitorOld = !isNewVisitor && !sourceIsTinto;
        const hasToken = !!token;
        const fingerprintHasExpired = !mtime
            || (Date.now() - Number(mtime) >= FINGERPRINT_EXPIRE);
        const sourceHasChanged = source !== tintoModelId;
        const shouldMakeRenewal = sourceIsTinto && (sourceHasChanged || fingerprintHasExpired);
        const shouldIncludeTintoData = isNewVisitor
            || isReturningVisitorOld
            || !hasToken
            || shouldMakeRenewal;
        return {
            sourceIsTinto,
            isNewVisitor,
            isReturningVisitorOld,
            hasToken,
            fingerprintHasExpired,
            sourceHasChanged,
            shouldMakeRenewal,
            shouldIncludeTintoData,
        };
    }
    function buildBody(state) {
        const { fingerprint, token, source, } = state;
        const { sourceIsTinto, shouldMakeRenewal, shouldIncludeTintoData, } = analyzeState(state);
        const currentFingerprint = sourceIsTinto && fingerprint;
        const currentFingerprintSource = sourceIsTinto && currentFingerprint && source;
        // Note: ideally we would not want to attach site data to the visitor
        // identification process. However we are forced to add the site
        // data to use the Tinto remote service. That is why, in case of not needing
        // to ask for a fresh tinto fingerprint, we are not adding site data.
        // We hope for a day when the Tinto remote service does not require
        // site data. Then the process for visitor init might be done much earlier.
        const commonBody = {
            renew: shouldMakeRenewal || undefined,
            tintoId: currentFingerprint || undefined,
            tintoModelId: currentFingerprintSource || undefined,
            visitorToken: token || undefined,
        };
        const body = shouldIncludeTintoData
            ? {
                ...commonBody,
                accountKey: globalState.accountKey,
                propertyId: globalState.propertyId || undefined,
                siteMode: globalState.mode,
                userId: globalState.accountUserId,
            }
            : commonBody;
        if (shouldIncludeTintoData) {
            return asyncContainer.tinto
                .then((tinto) => tinto.getReducedFeatures({ ...body, fingerprint: (!sourceIsTinto && fingerprint) || undefined }))
                .then((tintoReducedFeatures) => ({
                ...tintoReducedFeatures,
                dsHashFeatures: undefined,
            }));
        }
        return Promise$1.resolve(body);
    }
    const getVisitorTokens = memoize(() => (new AbortablePromise((resolve, reject, abortSignal) => {
        const prefetchPromise = new AbortablePromise();
        let fetchPromise;
        // eslint-disable-next-line no-param-reassign
        abortSignal.onabort = () => {
            // Abort the request
            (fetchPromise || prefetchPromise).abort();
            // Clear the memoized result
            getVisitorTokens.cache.clear();
        };
        const persistentStatePromise = getVisitorPersistentState();
        let lastBody;
        Promise$1.race([prefetchPromise, persistentStatePromise])
            .then(buildBody)
            .then(function fetchData(body) {
            lastBody = body;
            logger.debug(debugPrefix, 'sent:', body);
            fetchPromise = fetch('/agent/init-visitor', {
                body,
                headers: {
                    'content-type': 'application/x-www-form-urlencoded',
                },
            });
            return fetchPromise.then((res) => {
                if (res.ok) {
                    // We are done, data comes next
                    return res.json();
                }
                if (body.features) {
                    // If the request already included the Tinto reduced features
                    // nothing else can be done :(
                    throw new Error(`${MSG_BAD_RESPONSE} not OK status`);
                }
                // Otherwise, let's make a last retry attaching Tinto reduced features
                return persistentStatePromise.then((state) => (buildBody({ ...state, token: undefined }))).then(fetchData);
            });
        })
            .then((res) => {
            const { assessment, success, tintoId: fingerprint, visitorToken: token, } = res;
            if (!token || !fingerprint) {
                throw new Error(`${MSG_BAD_RESPONSE} missing visitorToken or tintoId`);
            }
            const shouldUpdateMetadata = !!(lastBody?.features && has$1(res, 'success'));
            return {
                assessment,
                fingerprint,
                ...(shouldUpdateMetadata
                    ? { mtime: success ? String(Date.now()) : '0' }
                    : null),
                source: tintoModelId,
                token,
            };
        })
            .then(resolve)
            .catch(reject);
    })));
    return getVisitorTokens;
}

const debugPrefix$3 = 'getVisitorVisitData()';
const getVisitorVisitDataEndpoint = '/agent/init-visit';
function createGetVisitorVisitData(fetch, getDomain, globalState, globalThis, isNolog, isUserLogged, logger, parseUserAgent, ulid, visitorVisitDataAbsNormalizerModel) {
    return function getVisitorVisitData() {
        const referrerDomain = getDomain(globalThis.document.referrer);
        const pageDomain = getDomain(globalThis.location.href);
        const body = {
            accountKey: globalState.accountKey,
            agent: {
                buildCommit: globalState.buildCommit,
                republishDate: globalState.republishDate,
                version: globalState.resolvedVersions?.['@thehotelsnetwork/agent-main'],
            },
            contextId: ulid(),
            device: globalState.media?.id,
            ignoreStats: isNolog(),
            media: globalState.media?.name,
            originSource: referrerDomain === pageDomain ? '' : referrerDomain,
            pageId: globalState.pageId,
            pageName: globalState.pageName,
            propertyId: globalState.propertyId || undefined,
            referrer: globalThis.document.referrer,
            siteMode: globalState.mode,
            thnRef: globalState.thnRef,
            url: globalThis?.location?.href?.replace(/localhost|127\.0\.0\.1/, '****'),
            userId: globalState.accountUserId,
            visitorLoggedIn: isUserLogged(),
            visitorToken: globalState.visitorToken,
            ...pick(globalState, [
                'language',
            ]),
            ...pick(parseUserAgent?.(), [
                'browser',
                'browserVersion',
                'os',
                'osVersion',
            ]),
        };
        if (!body.visitorToken) {
            return AbortablePromise.reject(new Error('Missing visitorToken'));
        }
        logger.info(`Visit debug: https://visitor-debug.thn.app/${body.contextId}`);
        logger.debug(`Visit debug data: ${globalState.host}/agent/_debug/visit/${body.contextId}`);
        logger.debug(debugPrefix$3, `URL: ${getVisitorVisitDataEndpoint}`, body);
        return new AbortablePromise((resolve, reject, abortSignal) => {
            const abortSignalInstance = abortSignal;
            const fetchPromise = fetch(getVisitorVisitDataEndpoint, { body });
            abortSignalInstance.onabort = () => { fetchPromise.abort(); };
            fetchPromise
                .then((res) => {
                if (!res.ok) {
                    throw new Error(`${MSG_BAD_RESPONSE} not OK status`);
                }
                return res.json();
            })
                .then((data) => visitorVisitDataAbsNormalizerModel.transform(data))
                .then((data) => {
                const result = { ...data, contextId: body.contextId };
                resolve(result);
            })
                .catch(reject);
        });
    };
}

const debugPrefix$2 = 'getVisitorTools()';
const getVisitorToolsEndpoint = '/agent/get-visitor-tools';
function createGetVisitorTools(fetch, globalState, logger, visitorToolsAbsNormalizerModel) {
    return function getVisitorTools(alternativeData) {
        if (!globalState.office
            && globalState.site?.isFreemium) {
            return AbortablePromise.reject(new Error(MSG_FREEMIUM));
        }
        if (!globalState.pageName) {
            return AbortablePromise.reject(new Error(MSG_NO_PAGE));
        }
        const body = {
            contextToken: alternativeData?.contextToken || globalState.contextToken,
        };
        logger.debug(debugPrefix$2, `URL: ${getVisitorToolsEndpoint}`, body);
        return new AbortablePromise((resolve, reject, abortSignal) => {
            const fetchPromise = fetch(getVisitorToolsEndpoint, { body });
            // eslint-disable-next-line no-param-reassign
            abortSignal.onabort = () => { fetchPromise.abort(); };
            fetchPromise
                .then((res) => res.ok && res.json())
                .then(visitorToolsAbsNormalizerModel.transform)
                .then(resolve)
                .catch(reject);
        });
    };
}

function isUserLoggedFactory(dataLayerHelper, logger, callEngine) {
    /**
     * Denotes if the current Visitor is considered a logged in user in the context of the Site.
     * Note this function has no relation with THN users.
    */
    return function isUserLogged() {
        const debugPrefix = 'isUserLogged()';
        logger?.trace(debugPrefix, 'Call');
        const isDatalayerLogged = dataLayerHelper?.get('thn.user.loggedIn');
        if (isBoolean(isDatalayerLogged)) {
            logger?.debug(debugPrefix, 'DataLayer handled');
            return isDatalayerLogged;
        }
        return !!callEngine('isUserLogged');
    };
}

const eventPrefix$2 = 'thn:visitor-token';
const startMark = `${eventPrefix$2}#start`;
const endMark = `${eventPrefix$2}#end`;
const measure = `thn:(${startMark}->${endMark})`;
function createPrepareVisitorTokens(getVisitorTokens, globalState, globalThis, logger, setVisitorTokens) {
    return function prepareVisitorTokens() {
        // Avoid execution when no site has been detected
        if (!['hotel', 'corporate'].includes(globalState.mode)) {
            return AbortablePromise.reject(new Error('No site'));
        }
        const { performance } = globalThis;
        performance?.clearMarks(startMark);
        performance?.mark(startMark);
        return new AbortablePromise((resolve, reject, abortSignal) => {
            const getVisitorTokensPromise = getVisitorTokens();
            // eslint-disable-next-line no-param-reassign
            abortSignal.onabort = () => {
                getVisitorTokensPromise.abort();
            };
            getVisitorTokensPromise.then((tokens) => setVisitorTokens(tokens), (error) => { reject(error); })
                .then((data) => {
                resolve(data);
                try {
                    performance.clearMarks(endMark);
                    performance.mark(endMark);
                    performance.clearMeasures(measure);
                    const duration = performance.measure(measure, startMark, endMark)?.duration;
                    logger.debug(`(timing) from ${startMark} to ${endMark}:`, duration);
                }
                catch { /* empty */ }
            }).catch((error) => {
                reject(error);
            });
        });
    };
}

function createPrepareVisitorTools(logger, getVisitorTools, setVisitorTools, unsetVisitorTools) {
    return function prepareVisitorTools() {
        return new AbortablePromise((resolve, reject, abortSignal) => {
            const getVisitorToolsPromise = getVisitorTools();
            // eslint-disable-next-line no-param-reassign
            abortSignal.onabort = () => { getVisitorToolsPromise.abort(); };
            getVisitorToolsPromise
                .then(setVisitorTools)
                .then((data) => {
                logger.info('Successfully prepared tools');
                resolve(data);
            })
                .catch((error) => {
                unsetVisitorTools();
                if (error instanceof AbortError) {
                    // Continue propagation of an explicit abortion
                    reject(error);
                    return;
                }
                // Log any other error and try to continue execution
                logger.warn('Error preparing tools:', error?.message || error);
                resolve({});
            });
        });
    };
}

function createPrepareVisitorVisitData(getVisitorVisitData, logger, setVisitorVisitData) {
    return function prepareVisitorVisitData() {
        return new AbortablePromise((resolve, reject, abortSignal) => {
            const getVisitorVisitDataPromise = getVisitorVisitData();
            // eslint-disable-next-line no-param-reassign
            abortSignal.onabort = () => { getVisitorVisitDataPromise.abort(); };
            getVisitorVisitDataPromise
                .then(setVisitorVisitData)
                .then((data) => {
                logger.info('Successfully prepared visit data');
                resolve(data);
            })
                .catch((error) => {
                if (!(error instanceof AbortError)) {
                    logger.warn('Error preparing visit data:', error?.message || error);
                }
                reject(error);
            });
        });
    };
}

function dropBallast(state) {
    const entries = Object.entries(state)
        .sort((a, b) => {
        if (isUndefined(a[1]))
            return 1;
        if (isUndefined(b[1]))
            return -1;
        return String(b[1]).length - String(a[1]).length;
    });
    if (entries[0][1]) {
        entries[0][1] = undefined;
    }
    return Object.fromEntries(entries);
}
const isValidFingerprint = (value) => !!(value?.match(/^[0-9a-f]{32}$/));
function createSetVisitorPersistentState(asyncCombinedStorage, getVisitorPersistentState, logger) {
    return async function setVisitorPersistentState(state) {
        const [combinedStorage, persistentState] = await Promise$1.all([
            asyncCombinedStorage,
            getVisitorPersistentState(),
        ]);
        const updatedState = { ...persistentState, ...state };
        const fingerprintHasChanged = !!(state.fingerprint && persistentState.fingerprint !== state.fingerprint);
        if (fingerprintHasChanged && !has$1(updatedState, 'mtime')) {
            throw new Error('Illegal invocation: refused to change fingerprint without "mtime"');
        }
        if (state.fingerprint && !isValidFingerprint(state.fingerprint)) {
            throw new Error('Illegal invocation: refused to persist non-compliant fingerprint');
        }
        try {
            await combinedStorage.set(VISITOR_PERSISTENT_STATE_KEY, updatedState);
        }
        catch (error) {
            if (error instanceof Error && error.name === 'ImmortalStoresPartialError' && error.message.match(/integrity/i)) {
                const dropped = dropBallast(state);
                return setVisitorPersistentState(dropped);
            }
            logger.warn(error);
            return persistentState;
        }
        return updatedState;
    };
}

function createSetVisitorTokens(errorMonitor, getSetting, globalState, logger, setVisitorPersistentState) {
    return function setVisitorTokens(data) {
        const { assessment, ...persistableData } = data;
        const { fingerprint, mtime, source, token, } = persistableData;
        if (!token || !fingerprint || !source) {
            throw new TypeError('Illegal invocation');
        }
        const shouldPersist = !getSetting('disable_persistence');
        const visitorStatePersistedPromise = shouldPersist
            ? setVisitorPersistentState(persistableData)
                .then(() => data, (reason) => { logger.warn(reason); return data; })
            : Promise$1.resolve(data);
        if (isBoolean(assessment)) {
            // Synthetically set the possibility of assessment to 100% or 0%
            const forcedSendTintoAssessmentValue = assessment ? '100' : '0';
            const previousSendTintoAssessmentValue = globalState.injectedSettings.send_tinto_assessment;
            globalState.injectedSettings.send_tinto_assessment = forcedSendTintoAssessmentValue;
            logger.debug(`overwritten setting send_tinto_assessment: "${previousSendTintoAssessmentValue ?? ''}" -> "${forcedSendTintoAssessmentValue}"`);
        }
        globalState.fingerprint = fingerprint;
        globalState.fingerprintSource = source;
        globalState.visitorToken = token;
        logger.info('Fingerprint:', globalState.fingerprint);
        logger.info('Fingerprint source:', globalState.fingerprintSource);
        if (mtime && shouldPersist) {
            logger.debug('Fingerprint mtime:', mtime);
        }
        if (!getSetting('disable_monitoring')) {
            errorMonitor.setConfig({
                fingerprint,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                fingerprint_source: source,
            });
        }
        return visitorStatePersistedPromise;
    };
}

const debugPrefix$1 = 'setVisitorVisitData()';
const eventPrefix$1 = 'thn:visitor-visit-data';
function createSetVisitorVisitData(bus, globalState, globalThis, logger) {
    return function setVisitorVisitData(data) {
        if (!(data && data.contextToken)) {
            throw new TypeError('Illegal invocation');
        }
        globalState.contextToken = data.contextToken;
        globalState.contextId = data.contextId;
        globalState.outputTime = Date.now();
        /** the server time of the current visit, also known as `visit_date` in DB */
        globalState.pageLoadTime = data.pageLoadTime;
        globalState.visitor = { ...globalState.visitor, ...data.visitor };
        globalState.site = data.site || {};
        if (!isCountryCode(globalState.visitor?.geolocation?.country?.code)) {
            set$1(globalState.visitor, 'geolocation.country.code', 'es');
        }
        globalState.country = globalState.visitor.geolocation.country.code;
        logger.debug(debugPrefix$1, 'Response:', data);
        globalState.output = data;
        // Hopefully this days and hours since last visit calc + origin will be done on ABS in a near future
        let daysSincePreviousVisitDate = null;
        let hoursSincePreviousVisitDate = null;
        if (!empty(globalState.visitor?.tracker?.previousVisitDate) && !empty(globalState.pageLoadTime)) {
            daysSincePreviousVisitDate = daysBetween(globalState.visitor.tracker.previousVisitDate, globalState.pageLoadTime);
            hoursSincePreviousVisitDate = Math.floor((globalState.pageLoadTime - globalState.visitor.tracker.previousVisitDate) / 3600);
        }
        logger.info(`Days since last visit: ${daysSincePreviousVisitDate !== null ? daysSincePreviousVisitDate : 'N/A'}`);
        logger.info(`Hours since last visit: ${hoursSincePreviousVisitDate !== null ? hoursSincePreviousVisitDate : 'N/A'}`);
        // once a visitor visit data is set, we can consider the app initialized
        globalState.initialized = true;
        if (globalState.visitor?.tracker) {
            globalState.visitor.tracker.daysSincePreviousVisitDate = daysSincePreviousVisitDate ?? undefined;
            globalState.visitor.tracker.hoursSincePreviousVisitDate = hoursSincePreviousVisitDate ?? undefined;
        }
        // once a visitor visit data is set, we can consider the app initialized
        globalState.initialized = true;
        // Broadcast
        bus.emitDelayed(`${eventPrefix$1}.set`, null, data);
        try {
            const currentMark = `${eventPrefix$1}#end`;
            globalThis.performance.clearMarks(currentMark);
            globalThis.performance.mark(currentMark);
            const startMark = 'thn:loader#start';
            const endMark = currentMark;
            const duration = globalThis.performance.measure(`thn:(${startMark}->${endMark})`, startMark, endMark)?.duration;
            logger.debug(`(timing) from ${startMark} to ${endMark}:`, duration);
        }
        catch { /* empty */ }
        return data;
    };
}

const debugPrefix = 'setVisitorTools()';
const eventPrefix = 'thn:visitor-tools';
function createSetVisitorTools(bus, globalState, globalThis, logger, snippet, widgets) {
    return async function setVisitorTools(data) {
        logger.debug(debugPrefix, 'Response:', data);
        // eslint-disable-next-line no-param-reassign
        globalState.outputTools = data;
        await Promise$1.all([
            ...widgets.map(widget => widget.setTools((data.tools ?? []).filter(toolPayload => toolPayload?.toolType === widget.data.name))),
            snippet.setTools(data.snippets || []),
        ]);
        // Broadcast
        bus.emitDelayed(`${eventPrefix}.set`, null, data);
        try {
            const currentMark = `${eventPrefix}#end`;
            globalThis.performance.clearMarks(currentMark);
            globalThis.performance.mark(currentMark);
            const startMark = 'thn:loader#start';
            const endMark = currentMark;
            const duration = globalThis.performance.measure(`thn:(${startMark}->${endMark}))`, startMark, endMark)?.duration;
            logger.debug(`(timing) from ${startMark} to ${endMark}:`, duration);
        }
        catch { /* empty */ }
        return data;
    };
}

function createUnsetVisitorTools(globalState, widgets) {
    return function unsetVisitorTools() {
        // eslint-disable-next-line no-param-reassign
        globalState.outputTools = {};
        widgets.forEach((widget) => {
            widget.unsetTools();
        });
    };
}

const name$1e = 'getVisitorTools';
function run$1e(bottle) {
    const deps = [
        'fetch',
        'globalState',
        'logger',
    ];
    bottle.serviceFactory(name$1e, (fetch, globalState, logger) => createGetVisitorTools(fetch, globalState, logger, visitorToolsAbsNormalizerModel), ...deps);
    return bottle;
}

var getVisitorTools = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1e,
    run: run$1e
});

const name$1d = 'getVisitorLastComparison';
function run$1d(bottle) {
    const deps = [
        'globalState',
        'searches',
        'price',
        'package',
    ];
    bottle.serviceFactory(name$1d, createGetVisitorLastComparison, ...deps);
    return bottle;
}

var getVisitorLastComparison = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1d,
    run: run$1d
});

const name$1c = 'getVisitorVisitData';
function run$1c(bottle) {
    const deps = [
        'fetch',
        'globalState',
        'globalThis',
        'isNolog',
        'isUserLogged',
        'logger',
        'parseUserAgent',
        'ulid',
    ];
    bottle.serviceFactory(name$1c, (fetch, globalState, globalThis, isNolog, isUserLogged, logger, parseUserAgent, ulid) => createGetVisitorVisitData(fetch, getDomain, globalState, globalThis, isNolog, isUserLogged, logger, parseUserAgent, ulid, visitorVisitDataAbsNormalizerModel), ...deps);
    return bottle;
}

var getVisitorVisitData = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1c,
    run: run$1c
});

const name$1b = 'getVisitorTokens';
function run$1b(bottle) {
    const deps = [
        'async',
        'fetch',
        'getVisitorPersistentState',
        'globalState',
        'logger',
        'tintoModelId',
    ];
    bottle.serviceFactory(name$1b, createGetVisitorTokens, ...deps);
    return bottle;
}

var getVisitorTokens = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1b,
    run: run$1b
});

// Google analytics
const name$1a = 'ga';
function run$1a(bottle) {
    bottle.factory('ga', () => {
        /* eslint-disable */
        (function (i, s, o, g, r, a, m) {
            i['GoogleAnalyticsObject'] = r;
            i[r] = i[r] || function () {
                (i[r].q = i[r].q || []).push(arguments);
            }, i[r].l = 1 * new Date();
            a = s.createElement(o),
                m = s.getElementsByTagName(o)[0];
            a.async = 1;
            a.src = g;
            m.parentNode.insertBefore(a, m);
        })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');
        return window['ga'];
        /* eslint-enable */
    });
    return bottle;
}

var ga = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1a,
    run: run$1a
});

const name$19 = 'getVisitorPersistentState';
function run$19(bottle) {
    const deps = [
        'async.combinedStorage',
        'logger',
    ];
    bottle.serviceFactory(name$19, createGetVisitorPersistentState, ...deps);
    return bottle;
}

var getVisitorPersistentState = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$19,
    run: run$19
});

const name$18 = 'globalState';
function run$18(bottle) {
    bottle.factory(name$18, () => data);
    return bottle;
}

var globalState = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$18,
    run: run$18
});

const name$17 = 'globalThis';
function run$17(bottle) {
    bottle.factory(name$17, () => {
        /** Detect free variable `global` from Node.js. */
        const freeGlobal = typeof global === 'object' && global !== null && global.Object === Object && global;
        /** Detect free variable `globalThis` */
        // eslint-disable-next-line eqeqeq
        const freeGlobalThis = typeof globalThis === 'object' && globalThis !== null && globalThis.Object == Object && globalThis;
        /** Detect free variable `self`. */
        const freeSelf = typeof self === 'object' && self !== null && self.Object === Object && self;
        // Used as a reference to the global object.
        // eslint-disable-next-line @typescript-eslint/no-implied-eval
        const globalObject = (freeGlobalThis || freeGlobal || freeSelf || Function('return this')());
        return globalObject;
    });
    return bottle;
}

var globalThis$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$17,
    run: run$17
});

const name$16 = 'idleManager';
function run$16(bottle) {
    const deps = [
        'bus',
        'globalThis',
        'Logger',
    ];
    bottle.serviceFactory(name$16, (bus, globalThis, Logger) => new IdleManager({ bus, globalThis, logger: Logger.get('idle-manager') }), ...deps);
    return bottle;
}

var idleManager = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$16,
    run: run$16
});

const name$15 = 'isUserLogged';
function run$15(bottle) {
    const deps = [
        'dataLayerHelper',
        'logger',
        'callEngine',
    ];
    bottle.serviceFactory(name$15, (dataLayerHelper, logger, callEngine) => isUserLoggedFactory(dataLayerHelper, logger, callEngine), ...deps);
    return bottle;
}

var isUserLogged = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$15,
    run: run$15
});

const name$14 = 'inliner';
function run$14(bottle) {
    const deps = [
        'constructors.Inliner',
    ];
    bottle.serviceFactory(name$14, (Inliner) => new Inliner(bottle), ...deps);
    return bottle;
}

var inliner = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$14,
    run: run$14
});

// @ts-ignore
const name$13 = 'isIframed';
function run$13(bottle) {
    bottle.factory(name$13, () => isIframed$1);
    return bottle;
}

var isIframed = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$13,
    run: run$13
});

const name$12 = 'isNolog';
function run$12(bottle) {
    const deps = [
        'globalState',
        'callEngine',
    ];
    bottle.serviceFactory(name$12, (globalState, callEngine) => isNologFactory(globalState, callEngine), ...deps);
    return bottle;
}

var isNoLog = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$12,
    run: run$12
});

const name$11 = 'kitt';
function run$11(bottle) {
    const deps = [
        'constructors.Kitt',
    ];
    bottle.serviceFactory(name$11, (Kitt) => new Kitt(bottle), ...deps);
    return bottle;
}

var kitt = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$11,
    run: run$11
});

const name$10 = 'languageCheck';
function run$10(bottle) {
    const deps = [
        'domReady',
        'callEngine',
        'globalThis',
        'logger',
        'setLanguage',
    ];
    bottle.serviceFactory(name$10, createLanguageCheck, ...deps);
    return bottle;
}

var languageCheck = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$10,
    run: run$10
});

const name$$ = 'loadManager';
function run$$(bottle) {
    const deps = [
        'bus',
        'globalThis',
        'Logger',
    ];
    bottle.serviceFactory(name$$, (bus, globalThis, Logger) => new LoadManager({ bus, globalThis, logger: Logger.get('load-manager') }), ...deps);
    return bottle;
}

var loadManager = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$$,
    run: run$$
});

const name$_ = 'loadScript';
function run$_(bottle) {
    bottle.factory(name$_, () => loadScript$1);
    return bottle;
}

var loadScript = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$_,
    run: run$_
});

const name$Z = 'logger';
const moduleName = 'Logger';
const colors = {
    violet: {
        light: '#833471',
        dark: '#ff82e3',
    },
    green: {
        light: '#7c992b',
        dark: '#7c992b',
    },
    grey: {
        light: '#3d3d3d',
        dark: '#b1b1b1',
    },
};
function run$Z(bottle) {
    const deps = [
        'globalThis',
        'isIframed',
        'addLog',
    ];
    bottle.factory(name$Z, (container) => container.Logger.get('thn'));
    bottle.serviceFactory(moduleName, (globalThis, isIframed, addLog) => {
        let loggerPrefix = isIframed() ? '%c[thn][iframe]' : '%c[thn]';
        const isFirefox = /firefox/i.test(globalThis.navigator.userAgent);
        // @ts-ignore
        const consoleStyles = !!globalThis.chrome || !!isFirefox;
        if (!consoleStyles) {
            loggerPrefix = isIframed() ? '[thn][iframe]' : '[thn]';
        }
        const colorSchema = window.matchMedia?.('(prefers-color-scheme: dark)')?.matches ? 'dark' : 'light';
        Logger.setNativeGuard(memoize(isNative));
        Logger.setHandler((messages, context) => {
            // avoid Array.from because of mootools (propertyId 1014418)
            messages = Array.prototype.slice.call(messages);
            // For loggers other than the main one, prepend their name
            if (context.name && context.name.substring(0, 3) !== 'thn') {
                messages.unshift(`[${context.name}]`);
            }
            // add messages to the log array as always
            addLog(...[(new Date()).toISOString(), context.level.name].concat(messages));
            if (Logger.enabledFor(context.level)) {
                // pipe to the console handler
                let count = 1;
                let merged = '';
                const styles = [`color: ${colors.violet[colorSchema]}`];
                let hasFunctionName = false;
                if (messages.length && typeof messages[0] === 'string' && messages[0].substring(0, 1) === '[') {
                    messages[0] = loggerPrefix + messages[0];
                }
                else {
                    messages.unshift(loggerPrefix);
                }
                if (messages.length > 1 && typeof messages[1] === 'string') {
                    if (messages[1].match(/^(\w|\.)+\(\)$/)) {
                        hasFunctionName = true;
                        styles.push(`color: ${colors.green[colorSchema]}`);
                    }
                    else {
                        styles.push(`color: ${colors.grey[colorSchema]}`);
                    }
                    messages[1] = (consoleStyles ? '%c' : '') + messages[1];
                    count += 1;
                }
                if (hasFunctionName && messages.length > 2 && typeof messages[2] === 'string') {
                    messages[2] = (consoleStyles ? '%c' : '') + messages[2];
                    count += 1;
                    styles.push(`color: ${colors.grey[colorSchema]}`);
                }
                do {
                    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                    merged += ` ${messages.shift()}`;
                    count -= 1;
                } while (count);
                if (consoleStyles) {
                    // add all to styles array
                    styles.unshift(merged);
                    Array.prototype.unshift.apply(messages, styles);
                }
                else {
                    // just add the merged message
                    messages.unshift(merged);
                }
                // Log the messages based on the context.level
                if (context.level === Logger.WARN && Logger.isNative(console.warn))
                    console.warn(...messages);
                else if (context.level === Logger.ERROR && Logger.isNative(console.error))
                    console.error(...messages);
                else if (context.level === Logger.INFO && Logger.isNative(console.info))
                    console.info(...messages);
                else if (context.level === Logger.DEBUG && Logger.isNative(console.debug))
                    console.debug(...messages);
                else if (context.level === Logger.TRACE && Logger.isNative(console.debug))
                    console.debug(...messages);
                else if (Logger.isNative(console.log))
                    console.log(...messages);
            }
        });
        // eslint-disable-next-line @typescript-eslint/unbound-method
        if (Logger.getLevel().value !== Logger.OFF.value && !Logger.isNative(globalThis.console?.log)) {
            try {
                globalThis.console?.warn?.('[thn] 🚨 CONSOLE output is limited and unsafe on this website. Use `thn.report()`');
                // eslint-disable-next-line no-empty
            }
            catch (_) { }
            Logger.get('thn').debug('console: not native');
        }
        return Logger;
    }, ...deps);
    return bottle;
}

var logger = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$Z,
    run: run$Z
});

const MAX_LOG_MESSAGES = 10000;
const name$Y = 'logMaxMessages';
function run$Y(bottle) {
    bottle.factory(name$Y, () => MAX_LOG_MESSAGES);
    return bottle;
}

var logMaxMessages = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$Y,
    run: run$Y
});

function createNetworkIdleCallback(globalThis) {
    return function networkIdleCallback(callback, options) {
        const cancellableCallback = cancellable(callback);
        // if the performance API is not available, <callback> will be executed immediately.
        if (!globalThis.PerformanceObserver || !globalThis.performance) {
            cancellableCallback({ didTimeout: false });
            return () => {
                cancellableCallback.cancel();
            };
        }
        const idleTime = options?.idleTime || 3000;
        const timeout = options?.timeout || 10000;
        let observer;
        let lastResourceTimestamp;
        let checkIdleNetworkTimeoutId;
        let timeoutId;
        // The <callback> is called when no resources have loaded for <idleTime> ms or the page has fully loaded, serving as an approximate measure of network idleness.
        const checkIdleNetwork = () => {
            const timeSinceLastResourceLoaded = globalThis.performance.now() - lastResourceTimestamp;
            const isPageLoaded = globalThis.document.readyState === 'complete';
            if (timeSinceLastResourceLoaded >= idleTime && isPageLoaded) {
                observer.disconnect();
                clearTimeout(timeoutId);
                cancellableCallback({ didTimeout: false });
            }
            else {
                checkIdleNetworkTimeoutId = setTimeout(checkIdleNetwork, idleTime);
            }
        };
        observer = new globalThis.PerformanceObserver((list) => {
            const entries = list.getEntries();
            if (entries.length > 0) {
                lastResourceTimestamp = entries[entries.length - 1].responseEnd;
            }
            clearTimeout(checkIdleNetworkTimeoutId);
            checkIdleNetwork();
        });
        observer.observe({ type: 'resource', buffered: true });
        // the <callback> is called when the <timeout> is reached and the previous condition has not yet been met.
        timeoutId = setTimeout(() => {
            observer.disconnect();
            clearTimeout(checkIdleNetworkTimeoutId);
            cancellableCallback({ didTimeout: true });
        }, timeout);
        // invokation of the returned CancelNetworkIdleCallback function will prevent the execution of the <callback>
        return () => {
            observer.disconnect();
            clearTimeout(timeoutId);
            clearTimeout(checkIdleNetworkTimeoutId);
            cancellableCallback.cancel();
        };
    };
}

const name$X = 'networkIdleCallback';
function run$X(bottle) {
    const deps = [
        'globalThis',
    ];
    bottle.serviceFactory(name$X, createNetworkIdleCallback, ...deps);
    return bottle;
}

var networkIdleCallback = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$X,
    run: run$X
});

const name$W = 'note';
function run$W(bottle) {
    const deps = [
        'constructors.Note',
    ];
    bottle.serviceFactory(name$W, (Note) => new Note(bottle), ...deps);
    return bottle;
}

var note = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$W,
    run: run$W
});

const name$V = 'onStateChange';
function run$V(bottle) {
    const deps = [
        'bus',
        'callEngine',
        'globalThis',
        'logger',
    ];
    bottle.serviceFactory(name$V, createOnStateChange, ...deps);
    return bottle;
}

var onStateChange = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$V,
    run: run$V
});

const name$U = 'onHashChange';
function run$U(bottle) {
    const deps = [
        'bus',
        'callEngine',
        'globalThis',
        'logger',
    ];
    bottle.serviceFactory(name$U, createOnHashChange, ...deps);
    return bottle;
}

var onHashChange = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$U,
    run: run$U
});

const name$T = 'oraculoManager';
function run$T(bottle) {
    const deps = [
        'bus',
        'Logger',
    ];
    bottle.serviceFactory(name$T, (bus, Logger) => new OraculoManager(bus, Logger.get('oraculo-manager')), ...deps);
    return bottle;
}

var oraculoManager = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$T,
    run: run$T
});

const name$S = 'package';
function run$S(bottle) {
    const deps = [
        'constructors.Package',
    ];
    bottle.serviceFactory(name$S, (Package) => new Package(bottle), ...deps);
    return bottle;
}

var _package = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$S,
    run: run$S
});

const name$R = 'pageCheck';
function run$R(bottle) {
    const deps = [
        'bus',
        'globalThis',
        'globalState',
        'logger',
    ];
    bottle.serviceFactory(name$R, createPageCheck, ...deps);
    return bottle;
}

var pageCheck = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$R,
    run: run$R
});

const name$Q = 'pageUnload';
function run$Q(bottle) {
    const deps = [
        'bus',
        'logger',
    ];
    bottle.serviceFactory(name$Q, createPageUnload, ...deps);
    return bottle;
}

var pageUnload = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$Q,
    run: run$Q
});

function parseUserAgentDevice$1(win = globalThis) {
    if (NATIVE_NAME_VAR in win) {
        return {
            mobile: false,
            native: true,
            tablet: false,
        };
    }
    const nAgt = win.navigator.userAgent;
    const native = false;
    const mobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(nAgt);
    const tablet = !mobile && /android|ipad|playbook|silk/i.test(nAgt);
    return { mobile, native, tablet };
}

function parseUserAgent$1(win = globalThis) {
    const unrecognized = '-';
    // browser
    const nVer = win.navigator.appVersion;
    const uAgt = win.navigator.userAgent;
    const nAgt = uAgt.charAt(uAgt.length - 1) === ']'
        ? uAgt.substring(0, uAgt.lastIndexOf('[')).trim()
        : uAgt;
    let browser = win.navigator.appName ?? 'Other';
    let version = parseFloat(win.navigator.appVersion)?.toString();
    let majorVersion = parseInt(win.navigator.appVersion, 10);
    let nameOffset;
    let verOffset;
    let ix;
    if (nAgt.indexOf('Opera') !== -1) {
        // Opera
        browser = 'Opera';
        verOffset = nAgt.indexOf('Opera');
        version = nAgt.substring(verOffset + 6);
        if (nAgt.indexOf('Version') !== -1) {
            verOffset = nAgt.indexOf('Version');
            version = nAgt.substring(verOffset + 8);
        }
    }
    else if (nAgt.indexOf('OPR') !== -1) {
        // Opera Next
        browser = 'Opera';
        verOffset = nAgt.indexOf('OPR');
        version = nAgt.substring(verOffset + 4);
    }
    else if (nAgt.indexOf('Edg') !== -1) {
        // Edge (Chromium-based) - check before Chrome since it contains Chrome
        browser = 'Microsoft Edge';
        verOffset = nAgt.indexOf('Edg');
        // Find the '/' after Edg/EdgA/EdgiOS
        const slashPos = nAgt.indexOf('/', verOffset);
        version = nAgt.substring(slashPos + 1);
    }
    else if (nAgt.indexOf('MSIE') !== -1) {
        // MSIE
        browser = 'Microsoft Internet Explorer';
        verOffset = nAgt.indexOf('MSIE');
        version = nAgt.substring(verOffset + 5);
    }
    else if (nAgt.indexOf('UCBrowser') !== -1) {
        // UCBrowser
        browser = 'UCBrowser';
        verOffset = nAgt.indexOf('UCBrowser');
        version = nAgt.substring(verOffset + 10);
    }
    else if (nAgt.indexOf('Chrome') !== -1) {
        // Chrome
        browser = 'Chrome';
        verOffset = nAgt.indexOf('Chrome');
        version = nAgt.substring(verOffset + 7);
    }
    else if (nAgt.indexOf('FxiOS') !== -1) {
        // Firefox
        browser = 'Firefox';
        verOffset = nAgt.indexOf('FxiOS');
        version = nAgt.substring(verOffset + 6);
    }
    else if (nAgt.indexOf('Safari') !== -1) {
        // Safari
        browser = 'Safari';
        verOffset = nAgt.indexOf('Safari');
        version = nAgt.substring(verOffset + 7);
        if (nAgt.indexOf('Version') !== -1) {
            verOffset = nAgt.indexOf('Version');
            version = nAgt.substring(verOffset + 8);
        }
    }
    else if (nAgt.indexOf('Firefox') !== -1) {
        // Firefox
        browser = 'Firefox';
        verOffset = nAgt.indexOf('Firefox');
        version = nAgt.substring(verOffset + 8);
    }
    else if (nAgt.indexOf('Trident/') !== -1) {
        // MSIE 11+
        browser = 'Microsoft Internet Explorer';
        version = nAgt.substring(nAgt.indexOf('rv:') + 3);
    }
    else if ((nAgt.lastIndexOf(' ') + 1) < nAgt.lastIndexOf('/')) {
        // Other browsers
        nameOffset = nAgt.lastIndexOf(' ') + 1;
        verOffset = nAgt.lastIndexOf('/');
        const parsedBrowser = nAgt.substring(nameOffset, verOffset);
        const parsedVersion = nAgt.substring(verOffset + 1);
        if (parsedVersion.match(/^[0-9._]*$/)) {
            version = parsedVersion;
            if (parsedBrowser.toLowerCase() !== parsedBrowser.toUpperCase()) {
                browser = parsedBrowser;
            }
        }
    }
    // trim the version string
    ix = version.indexOf(';');
    if (ix !== -1) {
        version = version.substring(0, ix);
    }
    ix = version.indexOf(' ');
    if (ix !== -1) {
        version = version.substring(0, ix);
    }
    ix = version.indexOf(')');
    if (ix !== -1) {
        version = version.substring(0, ix);
    }
    // Update "major" based on the updated "version"
    {
        const updatedMajorVersion = parseInt(`${version}`, 10);
        if (!Number.isNaN(updatedMajorVersion)) {
            majorVersion = updatedMajorVersion;
        }
        if (Number.isNaN(majorVersion)) {
            majorVersion = 0;
            version = unrecognized;
        }
    }
    // mobile version
    const { mobile, native, tablet } = parseUserAgentDevice$1(win);
    // system
    let os = unrecognized;
    const clientStrings = [
        { name: 'Windows 10', regex: /(Windows NT 10.0)/ }, // Windows 10 or 11 (11 also uses NT 10.0)
        { name: 'Windows 8.1', regex: /(Windows 8.1|Windows NT 6.3)/ },
        { name: 'Windows 8', regex: /(Windows 8|Windows NT 6.2)/ },
        { name: 'Windows 7', regex: /(Windows 7|Windows NT 6.1)/ },
        { name: 'Windows [deprecated]', regex: /(Windows NT 6.0|Windows NT 5\.[0-2]|Windows NT 4\.0|Windows CE|Win16|Windows 98|Win98|Windows 95|Win95|Windows_95|Win 9x 4\.90|Windows ME|Windows 2000|WinNT4\.0|WinNT|Windows NT(?! 10\.0| 6\.[1-3]))/ },
        { name: 'Android', regex: /Android/ },
        { name: 'Open BSD', regex: /OpenBSD/ },
        { name: 'Sun OS', regex: /SunOS/ },
        { name: 'Linux', regex: /(Linux|X11)/ },
        { name: 'iOS', regex: /(iPhone|iPad|iPod)/ },
        { name: 'Mac OS X', regex: /Mac OS X/ },
        { name: 'Mac OS', regex: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
        { name: 'QNX', regex: /QNX/ },
        { name: 'UNIX', regex: /UNIX/ },
        { name: 'BeOS', regex: /BeOS/ },
        { name: 'OS/2', regex: /OS\/2/ },
        { name: 'Search Bot', regex: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|bingbot|Ask Jeeves\/Teoma|ia_archiver)/ },
    ];
    clientStrings.some(clientString => {
        if (clientString.regex.test(nAgt)) {
            os = clientString.name;
            return true;
        }
        return false;
    });
    let osVersion = unrecognized;
    if (/Windows/.test(os)) {
        const windowsVersion = /Windows (.*)/.exec(os);
        osVersion = windowsVersion ? windowsVersion[1] : unrecognized;
        os = 'Windows';
    }
    switch (os) {
        case 'Mac OS X': {
            const macOsVersion = /Mac OS X (1[01][._\d]+)/.exec(nAgt);
            osVersion = macOsVersion ? macOsVersion[1] : unrecognized;
            break;
        }
        case 'Android': {
            const androidVersion = /Android ([._\d]+)/.exec(nAgt);
            osVersion = androidVersion ? androidVersion[1] : unrecognized;
            break;
        }
        case 'iOS': {
            const iosVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
            if (iosVersion) {
                osVersion = `${iosVersion[1]}.${iosVersion[2]}.${iosVersion[3] ? iosVersion[3] : 0}`;
            }
            else {
                osVersion = unrecognized;
            }
            break;
        }
        // no default
    }
    return {
        browser,
        browserVersion: version.replace(/_/g, '.'),
        browserMajorVersion: majorVersion,
        mobile,
        native,
        tablet,
        os,
        osVersion: osVersion.replace(/_/g, '.'),
    };
}

const name$P = 'parseUserAgentDevice';
function run$P(bottle) {
    bottle.factory(name$P, () => parseUserAgentDevice$1);
    return bottle;
}

var parseUserAgentDevice = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$P,
    run: run$P
});

const name$O = 'parseUserAgent';
function run$O(bottle) {
    bottle.factory(name$O, () => memoize(parseUserAgent$1));
    return bottle;
}

var parseUserAgent = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$O,
    run: run$O
});

const name$N = 'partnershipCheck';
function run$N(bottle) {
    const deps = [
        'partnershipManager',
    ];
    bottle.serviceFactory(name$N, (partnershipManager) => partnershipManager.check.bind(partnershipManager), ...deps);
    return bottle;
}

var partnershipCheck = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$N,
    run: run$N
});

const name$M = 'partnershipManager';
function run$M(bottle) {
    const deps = [
        'globalThis',
        'Logger',
        'siteCheck',
    ];
    bottle.serviceFactory(name$M, (globalThis, Logger, siteCheck) => new PartnershipManager(globalThis, Logger.get('partnership'), siteCheck), ...deps);
    return bottle;
}

var partnershipManager = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$M,
    run: run$M
});

const name$L = 'prepareVisitorTools';
function run$L(bottle) {
    const deps = [
        'logger',
        'getVisitorTools',
        'setVisitorTools',
        'unsetVisitorTools',
    ];
    bottle.serviceFactory(name$L, createPrepareVisitorTools, ...deps);
    return bottle;
}

var prepareVisitorTools = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$L,
    run: run$L
});

const name$K = 'prepareVisitorVisitData';
function run$K(bottle) {
    const deps = [
        'getVisitorVisitData',
        'logger',
        'setVisitorVisitData',
    ];
    bottle.serviceFactory(name$K, createPrepareVisitorVisitData, ...deps);
    return bottle;
}

var prepareVisitorVisitData = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$K,
    run: run$K
});

const name$J = 'prepareVisitorTokens';
function run$J(bottle) {
    const deps = [
        'getVisitorTokens',
        'globalState',
        'globalThis',
        'logger',
        'setVisitorTokens',
    ];
    bottle.serviceFactory(name$J, createPrepareVisitorTokens, ...deps);
    return bottle;
}

var prepareVisitorTokens = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$J,
    run: run$J
});

const name$I = 'price';
function run$I(bottle) {
    const deps = [
        'constructors.Price',
    ];
    bottle.serviceFactory(name$I, (Price) => new Price(bottle), ...deps);
    return bottle;
}

var price = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$I,
    run: run$I
});

const name$H = 'pricematch';
function run$H(bottle) {
    const deps = [
        'constructors.Pricematch',
    ];
    bottle.serviceFactory(name$H, (Pricematch) => new Pricematch(bottle), ...deps);
    return bottle;
}

var pricematch = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$H,
    run: run$H
});

const name$G = 'registerModuleConstructors';
function registerModuleConstructors(bottle, mod) {
    for (const [key, value] of Object.entries(mod)) {
        const head = key.slice(0, 1);
        const tail = key.slice(1);
        const isConstructor = typeof value === 'function'
            && head.toUpperCase() === head
            && tail.toUpperCase() !== tail;
        if (isConstructor) {
            bottle.factory(`constructors.${key}`, () => value);
        }
    }
    return bottle;
}
function run$G(bottle) {
    bottle.factory(name$G, () => registerModuleConstructors);
    return bottle;
}

var registerModuleConstructors$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$G,
    registerModuleConstructors: registerModuleConstructors,
    run: run$G
});

const name$F = 'reload';
function run$F(bottle) {
    const deps = [
        'logger',
        'pageCheck',
        'pageUnload',
    ];
    bottle.serviceFactory(name$F, createReload, ...deps);
    return bottle;
}

var reload = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$F,
    run: run$F
});

const name$E = 'report';
function run$E(bottle) {
    const deps = [
        'errorMonitor',
        'globalThis',
        'globalState',
        'logger',
        'swaps',
    ];
    bottle.serviceFactory(name$E, 
    /**
     * Opens a download dialog to save the full content
     * of THN's console messages.
     */
    (errorMonitor, globalThis, globalState, logger, swaps) => function report(companionLog = []) {
        const reportDate = (new Date()).toISOString();
        const isIframe = isIframed$1();
        const hasEmptyCompaniongLogs = empty(companionLog);
        const swapsInfo = swaps?.getInfo() || [];
        const reqInfo = globalThis.performance?.getEntriesByType('resource')
            .filter((entry) => entry.name.startsWith(globalState.host)) || [];
        let log = Array.prototype.slice.call(globalState.log);
        if (reqInfo.length) {
            log.push(`${reportDate} DEBUG Performance resources: ${stringify(reqInfo)}`);
        }
        log.push(...swapsInfo);
        if (isIframe) {
            log = log.map((l) => `${l.substring(0, 24)} (iframe) ${l.substring(25)}`);
        }
        const companion = isIframe
            ? globalThis.parent : globalState.childFrame;
        if (companion && hasEmptyCompaniongLogs) {
            if (!isIframe) {
                // We want to start the report process always from the child
                companion.postMessage({ action: 'thn_exec', payload: { func: 'report' } }, { targetOrigin: '*' });
                return;
            }
            // If a child script is registered, OR
            // we are a child script AND the companion log is not provided,
            // pass the current log and delegate the task to the companion script
            companion.postMessage({
                action: 'thn_exec',
                // Note: forcing recreation of the Array with a clean prototype
                // "log" might have been instantiated using literal notation "[]"
                // thus might be using the global Array.prototype from the website
                payload: {
                    func: 'report',
                    args: [Array.from(log)],
                },
            }, { targetOrigin: '*' });
            return;
        }
        try {
            const parsedLogs = hasEmptyCompaniongLogs
                ? log
                : log.concat(companionLog).sort((line1, line2) => {
                    const time1 = line1.substring(0, 24);
                    const time2 = line2.substring(0, 24);
                    if (time1 < time2) {
                        return -1;
                    }
                    if (time1 > time2) {
                        return 1;
                    }
                    return 0;
                });
            const filename = `thn-report${globalState.propertyId ? `--property_id-${globalState.propertyId}` : ''}--site_id-${globalState.siteId}--${reportDate}.txt`;
            const link = globalThis.document.createElement('a');
            const blob = new globalThis.Blob(parsedLogs.map((l) => `${l}\n`));
            const url = globalThis.URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', filename);
            const event = new globalThis.MouseEvent('click', {
                view: globalThis,
                bubbles: true,
                cancelable: true,
            });
            link.dispatchEvent(event);
        }
        catch (error) {
            logger.warn('Unable to download console, browser might not support it');
            errorMonitor.addError(error);
        }
    }, ...deps);
    return bottle;
}

var report = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$E,
    run: run$E
});

const name$D = 'requestIdleCallback';
function run$D(bottle) {
    const deps = [
        'globalThis',
    ];
    bottle.serviceFactory(name$D, (globalThis) => globalThis.requestIdleCallback.bind(globalThis), ...deps);
    return bottle;
}

var requestIdleCallback = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$D,
    run: run$D
});

const name$C = 'review';
function run$C(bottle) {
    const deps = [
        'constructors.Review',
    ];
    bottle.serviceFactory(name$C, (Review) => new Review(bottle), ...deps);
    return bottle;
}

var review = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$C,
    run: run$C
});

const name$B = 'uploadPageHtml';
function run$B(bottle) {
    const deps = [
        'fetch',
        'globalState',
        'globalThis',
        'logger',
    ];
    bottle.serviceFactory(name$B, createUploadPageHtml, ...deps);
    return bottle;
}

var uploadPageHtml = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$B,
    run: run$B
});

const name$A = 'scheduler';
function run$A(bottle) {
    const deps = [
        'globalThis',
    ];
    bottle.serviceFactory(name$A, (globalThis) => {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        if (isFunction(globalThis.scheduler?.yield)) {
            return globalThis.scheduler;
        }
        const schedulerPonyfill = {
            yield(options = {}) {
                // If the signal is already aborted, immediately throw in order to reject the promise.
                if (options.signal?.aborted) {
                    return Promise$1.reject(options.signal.reason);
                }
                let timer;
                return new Promise$1((resolve, reject) => {
                    timer = setTimeout(() => {
                        timer = undefined;
                        resolve();
                    }, 0);
                    // Watch for 'abort' signals
                    if (options.signal) {
                        options.signal.addEventListener('abort', () => {
                            // Stop the main operation
                            if (timer) {
                                clearTimeout(timer);
                                timer = undefined;
                            }
                            // Reject the promise with the abort reason.
                            reject(options.signal?.reason);
                        });
                    }
                });
            },
        };
        return schedulerPonyfill;
    }, ...deps);
    return bottle;
}

var scheduler = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$A,
    run: run$A
});

const name$z = 'scrollManager';
function run$z(bottle) {
    const deps = [
        'bus',
        'globalThis',
        'Logger',
    ];
    bottle.serviceFactory(name$z, (bus, globalThis, Logger) => new ScrollManager({}, { bus, globalThis, logger: Logger.get('scroll-manager') }), ...deps);
    return bottle;
}

var scrollManager = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$z,
    run: run$z
});

const name$y = 'searches';
function run$y(bottle) {
    const deps = [
        'constructors.Searches',
        'searchesAdapter',
        'scheduler',
    ];
    bottle.serviceFactory(name$y, (Searches, searchesAdapter, scheduler) => {
        const searchesInstance = new Searches({
            adapter: searchesAdapter,
            scheduler,
        });
        return searchesInstance;
    }, ...deps);
    return bottle;
}

var searches = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$y,
    run: run$y
});

const name$x = 'searchesAdapter';
function run$x(bottle) {
    const deps = [
        'globalState',
        'getSetting',
        'constructors.SearchesSseAdapter',
    ];
    bottle.serviceFactory(name$x, (globalState, getSetting, SearchesSseAdapter) => {
        const searchesAdapterInstance = new SearchesSseAdapter({
            container: bottle.container,
            debug: !!getSetting('comparison_logs_enabled'),
            host: globalState.host,
            normalize: comparisonSseNormalizerModel.transform,
            routePrefix: '/agent',
        });
        return searchesAdapterInstance;
    }, ...deps);
    return bottle;
}

var searchesAdapter = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$x,
    run: run$x
});

const name$w = 'sendBeacon';
function run$w(bottle) {
    const deps = [
        'globalState',
        'logger',
    ];
    bottle.serviceFactory(name$w, (globalState, logger) => {
        const defaultData = {
            get contextToken() {
                return globalState.contextToken;
            },
        };
        try {
            const sendBeaconInstance = sendBeaconWrapper(sendBeacon$2, defaultData);
            // Test sendBeacon implementation
            // Note: using "module" instead of "import" given that they are the same for system output
            // @ts-ignore to avoid warning about 'import.meta' meta-property
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-argument
            const result = sendBeaconInstance(new URL('/agent/probe', module.meta.url));
            if (typeof result !== 'boolean') {
                throw new TypeError('Unexpected sendBeacon return type');
            }
            // Good to go
            logger.debug(`${name$w}: native`, sendBeacon$2.toString());
            return sendBeaconInstance;
        }
        catch {
            const sendBeaconInstance = sendBeaconWrapper(sendBeacon$1, defaultData);
            // No test on the pony, good to go
            logger.debug(`${name$w}: ponyfill`);
            return sendBeaconInstance;
        }
    }, ...deps);
    return bottle;
}

var sendBeacon = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$w,
    run: run$w
});

const name$v = 'sendPageVisit';
function run$v(bottle) {
    const deps = [
        'globalState',
        'globalThis',
        'sendBeacon',
        'isUserLogged',
        'logger',
        'sendSiteAnalytics',
        'price',
    ];
    bottle.serviceFactory(name$v, createSendPageVisit, ...deps);
    return bottle;
}

var sendPageVisit = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$v,
    run: run$v
});

const name$u = 'sendSiteAnalytics';
function run$u(bottle) {
    const deps = [
        'globalThis',
        'globalState',
        'logger',
    ];
    bottle.serviceFactory(name$u, createSendSiteAnalytics, ...deps);
    return bottle;
}

var sendSiteAnalytics = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$u,
    run: run$u
});

const name$t = 'sendTintoAssessment';
function run$t(bottle) {
    const deps = [
        'async',
        'fetch',
        'getSetting',
        'globalState',
        'logger',
        'errorMonitor',
    ];
    const debugPrefix = `${name$t}()`;
    const chosenMsg = 'chosen for assessment';
    const endpoint = '/agent/visitor-assessment';
    bottle.serviceFactory(name$t, (containerAsync, fetch, getSetting, globalState, logger, errorMonitor) => {
        // Only when selected for assessment
        if (getSetting('send_tinto_assessment') === false) {
            return async () => {
                logger.debug(debugPrefix, `abort: inactive or not ${chosenMsg}`);
            };
        }
        return memoize(async () => {
            try {
                logger.debug(debugPrefix, chosenMsg);
                const extraParams = {
                    accountKey: globalState.accountKey,
                    contextToken: globalState.contextToken,
                    pageId: globalState.pageId || undefined,
                    propertyId: globalState.propertyId || undefined,
                    siteMode: globalState.mode,
                    userId: globalState.accountUserId,
                };
                const tintoInstance = await containerAsync.tinto;
                const body = await tintoInstance.getReducedFeatures(extraParams);
                logger.debug(debugPrefix, 'sent:', body);
                const res = await fetch(endpoint, {
                    body,
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded',
                    },
                });
                logger.debug(debugPrefix, 'status:', res.status);
                if (!res.ok) {
                    throw new Error(`HttpError: ${endpoint}`);
                }
                return true;
            }
            catch (reason) {
                errorMonitor.addError(reason, { endpoint });
                logger.warn(debugPrefix, 'error:', reason);
                return false;
            }
        });
    }, ...deps);
    return bottle;
}

var sendTintoAssessment = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$t,
    run: run$t
});

const name$s = 'setLanguage';
function run$s(bottle) {
    const deps = [
        'bus',
        'getSetting',
        'globalState',
        'logger',
    ];
    bottle.serviceFactory(name$s, createSetLanguage, ...deps);
    return bottle;
}

var setLanguage = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$s,
    run: run$s
});

const name$r = 'setVisitorTools';
function run$r(bottle) {
    const deps = [
        'bus',
        'globalState',
        'globalThis',
        'logger',
        'snippet',
        'note',
        'exit',
        'layer',
        'inliner',
    ];
    bottle.serviceFactory(name$r, (bus, globalState, globalThis, logger, snippet, note, exit, layer, inliner) => {
        const widgetsWithTools = [note, exit, layer, inliner];
        return createSetVisitorTools(bus, globalState, globalThis, logger, snippet, widgetsWithTools);
    }, ...deps);
    return bottle;
}

var setVisitorTools = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$r,
    run: run$r
});

const name$q = 'setVisitorVisitData';
function run$q(bottle) {
    const deps = [
        'bus',
        'globalState',
        'globalThis',
        'logger',
    ];
    bottle.serviceFactory(name$q, createSetVisitorVisitData, ...deps);
    return bottle;
}

var setVisitorVisitData = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$q,
    run: run$q
});

const name$p = 'setVisitorPersistentState';
function run$p(bottle) {
    const deps = [
        'async.combinedStorage',
        'getVisitorPersistentState',
        'logger',
    ];
    bottle.serviceFactory(name$p, createSetVisitorPersistentState, ...deps);
    return bottle;
}

var setVisitorPersistentState = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$p,
    run: run$p
});

const name$o = 'setVisitorTokens';
function run$o(bottle) {
    const deps = [
        'errorMonitor',
        'getSetting',
        'globalState',
        'logger',
        'setVisitorPersistentState',
    ];
    bottle.serviceFactory(name$o, createSetVisitorTokens, ...deps);
    return bottle;
}

var setVisitorTokens = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$o,
    run: run$o
});

const name$n = 'shutdown';
function run$n(bottle) {
    const deps = [
        'bus',
        'callEngine',
        'logger',
        'pageUnload',
    ];
    bottle.serviceFactory(name$n, createShutdown, ...deps);
    return bottle;
}

var shutdown = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$n,
    run: run$n
});

const name$m = 'siteChange';
function run$m(bottle) {
    const deps = [
        'bootstrap',
        'errorMonitor',
        'globalState',
        'globalThis',
        'logger',
        'scheduler',
        'shutdown',
    ];
    bottle.serviceFactory(name$m, createSiteChange, ...deps);
    return bottle;
}

var siteChange = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$m,
    run: run$m
});

const name$l = 'siteCheck';
function run$l(bottle) {
    const deps = [
        'bottle',
        'errorMonitor',
        'globalState',
        'globalThis',
        'logger',
        'siteChange',
    ];
    bottle.serviceFactory(name$l, createSiteCheck, ...deps);
    return bottle;
}

var siteCheck = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$l,
    run: run$l
});

const name$k = 'snippet';
function run$k(bottle) {
    const deps = [
        'constructors.Snippet',
    ];
    bottle.serviceFactory(name$k, (Snippet) => new Snippet(bottle), ...deps);
    return bottle;
}

var snippet = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$k,
    run: run$k
});

const name$j = 'start';
function run$j(bottle) {
    const deps = [
        'bus',
        'errorMonitor',
        'getSetting',
        'globalState',
        'globalThis',
        'logger',
        'pageCheck',
    ];
    bottle.serviceFactory(name$j, createStart, ...deps);
    return bottle;
}

var start = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$j,
    run: run$j
});

const name$i = 'stopAwakeChildScript';
function run$i(bottle) {
    const deps = [
        'globalState',
        'logger',
    ];
    bottle.serviceFactory(name$i, createStopAwakeChildScript, ...deps);
    return bottle;
}

var stopAwakeChildScript = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$i,
    run: run$i
});

const name$h = 'swaps';
function run$h(bottle) {
    const deps = [
        'globalThis',
    ];
    bottle.serviceFactory(name$h, (globalThis) => {
        const x = globalThis[SWAPS_VAR];
        return x;
    }, ...deps);
    return bottle;
}

var swaps = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$h,
    run: run$h
});

const tintoModelId$1 = 'TINTO_THN_20230713_01_RELEVANCE_THR_099_T20230420_20230503';

// @ts-ignore
// eslint-disable-next-line import/extensions
const name$g = 'tintoModelId';
function run$g(bottle) {
    bottle.factory(name$g, () => tintoModelId$1);
    return bottle;
}

var tintoModelId = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$g,
    run: run$g
});

const name$f = 'trace';
/**
 * Copy from /packages/widgets/src/helpers/is-fingerprint-percent.ts
 */
const magicNumber = 0.390625;
function isFingerprintPercent(fingerprint, percent = 0) {
    if (!percent || !fingerprint) {
        return false;
    }
    return parseInt(`0X${fingerprint.slice(-2)}`, 16) * magicNumber < percent;
}
function run$f(bottle) {
    const deps = [
        'sendBeacon',
        'getSetting',
        'globalState',
    ];
    bottle.serviceFactory(name$f, (sendBeacon, getSetting, globalState) => {
        let tracerProvider;
        const tracingPercentage = getSetting('tracing_percentage');
        const finalSendBeacon = (url, data) => {
            const shouldTrace = isFingerprintPercent(globalState.fingerprint, tracingPercentage);
            return (shouldTrace ? sendBeacon(url, data) : true);
        };
        finalSendBeacon.cache = sendBeacon.cache;
        return {
            getTracer: (tracerName) => {
                if (!tracerProvider) {
                    tracerProvider = new TracerProvider(finalSendBeacon);
                }
                return tracerProvider.getTracer(tracerName);
            },
            getTracerProvider: () => {
                if (!tracerProvider) {
                    tracerProvider = new TracerProvider(finalSendBeacon);
                }
                return tracerProvider;
            },
        };
    }, ...deps);
    return bottle;
}

var trace = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$f,
    run: run$f
});

const name$e = 'ulid';
function run$e(bottle) {
    bottle.factory(name$e, () => ulid$1);
    return bottle;
}

var ulid = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$e,
    run: run$e
});

const name$d = 'unsetVisitorTools';
function run$d(bottle) {
    const deps = [
        'globalState',
        'note',
        'exit',
        'layer',
        'inliner',
        'snippet',
    ];
    bottle.serviceFactory(name$d, (globalState, note, exit, layer, inliner, snippet) => {
        const widgetsWithTools = [note, exit, layer, inliner, snippet];
        return createUnsetVisitorTools(globalState, widgetsWithTools);
    }, ...deps);
    return bottle;
}

var unsetVisitorTools = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$d,
    run: run$d
});

const name$c = 'uploadReport';
function run$c(bottle) {
    const deps = [
        'fetch',
        'globalThis',
        'globalState',
        'logger',
    ];
    bottle.serviceFactory(name$c, createUploadReport, ...deps);
    return bottle;
}

var uploadReport = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$c,
    run: run$c
});

const name$b = 'layer';
function run$b(bottle) {
    const deps = [
        'constructors.Layer',
    ];
    bottle.serviceFactory(name$b, (Layer) => new Layer(bottle), ...deps);
    return bottle;
}

var layer = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$b,
    run: run$b
});

function prefix$1(value) {
    return `async.${value}`;
}

const name$a = 'combinedStorage';
function run$a(bottle) {
    const deps = [
        'errorMonitor',
    ];
    const qualifiedName = prefix$1(name$a);
    bottle.serviceFactory(qualifiedName, async (errorMonitor) => {
        const combinedStorageModule = await Promise.resolve().then(function () { return index; });
        const { factory, rotDecoder: decoder, rotEncoder: encoder, } = combinedStorageModule;
        const combinedStorageInstance = factory({
            // Note we are **forced** to avoid the prefix usage
            // in order to be able to use the legacy cookie name "thn_id"
            keyPrefix: '',
            encoder,
            decoder,
            indexedDbDatabaseName: 'thn',
            indexedDbTableName: 'agent',
        });
        try {
            await combinedStorageInstance.onReady;
        }
        catch (reason) {
            if (reason instanceof Error && reason.message !== 'Unable to construct any store') {
                errorMonitor.addError(reason);
            }
        }
        return combinedStorageInstance;
    }, ...deps);
    return bottle;
}

var combinedStorage = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$a,
    run: run$a
});

const name$9 = 'engine';
function run$9(bottle) {
    const deps = [
        'globalState',
        'globalThis',
        'logger',
    ];
    const qualifiedName = prefix$1(name$9);
    bottle.serviceFactory(qualifiedName, async (globalState, globalThis, logger) => {
        let engineInstance = {};
        if (!globalThis.thn) {
            throw new Error('Missing "thn" global instance');
        }
        try {
            const { engineId } = globalState;
            const engineModule = (await import(`@thehotelsnetwork/agent-engines/${engineId}`));
            engineInstance = engineModule.factory({
                document: globalThis.document,
                thn: globalThis.thn,
                window: globalThis,
            });
        }
        catch (error) {
            let log = logger.warn.bind(logger);
            if (isError(error) && error.message.match(/SystemJS/)) {
                // If the error is something like:
                // "Error: https://www.thehotelsnetwork.com/sjs/@thehotelsnetwork/agent-engines@latest&bundle/1032625 (SystemJS https://github.com/systemjs/systemjs/blob/main/docs/errors.md#2)"
                // that means the engine module does not exist (404). Usually that is expected,
                // so we switch to "trace" level rather than "warn" to avoid confusions.
                log = logger.trace.bind(logger);
            }
            log('Loading of the engine has failed', error);
        }
        bottle.resetProviders([name$9]);
        bottle.factory(name$9, () => engineInstance);
        return engineInstance;
    }, ...deps);
    return bottle;
}

var engine = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$9,
    run: run$9
});

const name$8 = 'fontsLoader';
function run$8(bottle) {
    const deps = [
        'logger',
        'trace',
        'context',
    ];
    const qualifiedName = prefix$1(name$8);
    bottle.serviceFactory(qualifiedName, async (logger, trace, context) => {
        const { FontsLoaderService } = await import('./chunk-index.js');
        return new FontsLoaderService({ logger, trace, context });
    }, ...deps);
    return bottle;
}

var fontsLoader = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$8,
    run: run$8
});

const name$7 = 'instantBooking';
function run$7(bottle) {
    const deps = [
        'callEngine',
        'bus',
        'fetch',
        'getSetting',
        'globalThis',
        'globalState',
        'Logger',
        'price',
        'sendSiteAnalytics',
    ];
    const qualifiedName = prefix$1(name$7);
    bottle.serviceFactory(qualifiedName, async (callEngine, bus, fetch, getSetting, globalThis, globalState, Logger, price, sendSiteAnalytics) => {
        const { InstantBooking, loadView } = await import('./chunk-index2.js');
        const logger = Logger.get('instant-booking');
        const instantConfig = {
            buttonText: getSetting('instant_booking_button_text'),
            cssText: getSetting('instant_booking_css_text'),
            iconName: getSetting('instant_booking_icon'),
            position: getSetting('instant_booking_position'),
        };
        const loadViewWrapper = () => loadView(Logger.get('instant-booking-view'));
        const dataLayer = [];
        // get the original push method when the service calls dataLayer.push
        Object.defineProperty(dataLayer, 'push', {
            get() {
                return bottle.container.dataLayer.push.bind(bottle.container.dataLayer);
            },
        });
        const instantbookingInstance = new InstantBooking(instantConfig, callEngine, bus, globalThis, globalState, logger, price, sendSiteAnalytics, dataLayer, fetch, getSetting, loadViewWrapper);
        await instantbookingInstance.onReady();
        return instantbookingInstance;
    }, ...deps);
    return bottle;
}

var instantBooking = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$7,
    run: run$7
});

const name$6 = 'moment';
function run$6(bottle) {
    const qualifiedName = prefix$1(name$6);
    bottle.serviceFactory(qualifiedName, async () => {
        // @ts-ignore
        const { default: momentModule } = await import('moment-timezone/builds/moment-timezone-with-data-10-year-range');
        bottle.resetProviders([name$6]);
        bottle.factory(name$6, () => momentModule);
        return momentModule;
    });
    return bottle;
}

var moment = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$6,
    run: run$6
});

const name$5 = 'serverEventsListener';
function run$5(bottle) {
    const deps = [
        'globalState',
        'globalThis',
        'bus',
        'Logger',
        'errorMonitor',
        'sendBeacon',
    ];
    const qualifiedName = prefix$1(name$5);
    bottle.serviceFactory(qualifiedName, async (globalState, globalThis, bus, Logger, errorMonitor, sendBeacon) => {
        const [ServerEventsListenerModule] = await Promise$1.all([
            import('./chunk-index3.js'),
        ]);
        const { ServerEventsListener } = ServerEventsListenerModule;
        const logger = Logger.get('server-events-listener');
        const serverEventsListenerInstance = new ServerEventsListener(globalState, globalThis, bus, logger, errorMonitor, sendBeacon);
        return serverEventsListenerInstance;
    }, ...deps);
    return bottle;
}

var serverEventsListener = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$5,
    run: run$5
});

const name$4 = 'tinto';
function run$4(bottle) {
    const deps = [
        'parseUserAgent',
        'scheduler',
    ];
    const qualifiedName = prefix$1(name$4);
    bottle.serviceFactory(qualifiedName, async (parseUserAgent, scheduler) => {
        const { FingerprintDs, FingerprintJsLite, Tinto } = await import('@thehotelsnetwork/agent-fingerprint');
        const userAgentDetails = parseUserAgent();
        const fingerprintDsInstance = new FingerprintDs(scheduler);
        const fingerprintJsInstance = await (new FingerprintJsLite(scheduler)).load();
        const tintoInstance = new Tinto(fingerprintDsInstance, fingerprintJsInstance, userAgentDetails, scheduler);
        return tintoInstance;
    }, ...deps);
    return bottle;
}

var tinto = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$4,
    run: run$4
});

const name$3 = 'swapsBridge';
function run$3(bottle) {
    const deps = [
        'bus',
        'async.widgets',
        'Logger',
        'sendBeacon',
    ];
    const qualifiedName = prefix$1(name$3);
    bottle.serviceFactory(qualifiedName, async (bus, widgetsPromise, Logger, sendBeacon) => {
        const logger = Logger.get('swaps');
        const { RuleChecker } = await widgetsPromise;
        const ruleChecker = new RuleChecker(bottle.container, logger);
        logger.info('Connecting to swaps script...');
        globalThis.dispatchEvent(new CustomEvent('thn:swaps', {
            detail: {
                ruleChecker,
                bus,
                logger,
                sendBeacon,
            },
        }));
    }, ...deps);
    return bottle;
}

var swapsBridge = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$3,
    run: run$3
});

const name$2 = 'widgets';
function run$2(bottle) {
    const deps = [
        'registerModuleConstructors',
    ];
    const qualifiedName = prefix$1(name$2);
    bottle.serviceFactory(qualifiedName, async (registerModuleConstructors) => {
        // @ts-ignore
        const widgetsModule = await import('./chunk-widgets.js');
        registerModuleConstructors(bottle, widgetsModule);
        return widgetsModule;
    }, ...deps);
    return bottle;
}

var widgets = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$2,
    run: run$2
});

function prefix(value) {
    return `constructors.${value}`;
}

const name$1 = 'Recorder';
function run$1(bottle) {
    bottle.factory(prefix(name$1), () => Recorder);
    return bottle;
}

var recorder = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name$1,
    run: run$1
});

var dataLayerHelper$1 = {};

var hasRequiredDataLayerHelper;

function requireDataLayerHelper () {
	if (hasRequiredDataLayerHelper) return dataLayerHelper$1;
	hasRequiredDataLayerHelper = 1;
	(function(){/*

	 Copyright The Closure Library Authors.
	 SPDX-License-Identifier: Apache-2.0
	*/
	var f=/\[object (Boolean|Number|String|Function|Array|Date|RegExp|Arguments)\]/;function g(a){return null==a?String(a):(a=f.exec(Object.prototype.toString.call(Object(a))))?a[1].toLowerCase():"object"}function m(a,b){return Object.prototype.hasOwnProperty.call(Object(a),b)}function n(a){if(!a||"object"!=g(a)||a.nodeType||a==a.window)return !1;try{if(a.constructor&&!m(a,"constructor")&&!m(a.constructor.prototype,"isPrototypeOf"))return !1}catch(c){return !1}for(var b in a);return void 0===b||m(a,b)}function p(a,b){var c={},d=c;a=a.split(".");for(var e=0;e<a.length-1;e++)d=d[a[e]]={};d[a[a.length-1]]=b;return c}function q(a,b){var c=!a._clear,d;for(d in a)if(m(a,d)){var e=a[d];"array"===g(e)&&c?("array"===g(b[d])||(b[d]=[]),q(e,b[d])):n(e)&&c?(n(b[d])||(b[d]={}),q(e,b[d])):b[d]=e;}delete b._clear;}	function r(a,b,c){b=void 0===b?{}:b;"function"===typeof b?b={listener:b,listenToPast:void 0===c?!1:c,processNow:!0,commandProcessors:{}}:b={listener:b.listener||function(){},listenToPast:b.listenToPast||!1,processNow:void 0===b.processNow?!0:b.processNow,commandProcessors:b.commandProcessors||{}};this.a=a;this.l=b.listener;this.j=b.listenToPast;this.g=this.i=!1;this.c={};this.f=[];this.b=b.commandProcessors;this.h=u(this);var d=this.a.push,e=this;this.a.push=function(){var k=[].slice.call(arguments,
	0),l=d.apply(e.a,k);v(e,k);return l};b.processNow&&this.process();}r.prototype.process=function(){this.registerProcessor("set",function(){var c={};1===arguments.length&&"object"===g(arguments[0])?c=arguments[0]:2===arguments.length&&"string"===g(arguments[0])&&(c=p(arguments[0],arguments[1]));return c});this.i=!0;for(var a=this.a.length,b=0;b<a;b++)v(this,[this.a[b]],!this.j);};r.prototype.get=function(a){var b=this.c;a=a.split(".");for(var c=0;c<a.length;c++){if(void 0===b[a[c]]||null===b[a[c]])return;b=b[a[c]];}return b};
	r.prototype.flatten=function(){this.a.splice(0,this.a.length);this.a[0]={};q(this.c,this.a[0]);};r.prototype.registerProcessor=function(a,b){a in this.b||(this.b[a]=[]);this.b[a].push(b);};
	function v(a,b,c){c=void 0===c?!1:c;if(a.i&&(a.f.push.apply(a.f,b),!a.g))for(;0<a.f.length;){b=a.f.shift();if("array"===g(b))a:{var d=a.c;if(g(b[0])!=="string"){return;}for(var e=b[0].split("."),k=e.pop(),l=b.slice(1),h=0;h<e.length;h++){if(void 0===d[e[h]])break a;d=d[e[h]];}try{d[k].apply(d,l);}catch(w){}}else if("arguments"===g(b)){e=a;k=[];l=b[0];if(e.b[l])for(d=e.b[l].length,h=0;h<d;h++)k.push(e.b[l][h].apply(e.h,[].slice.call(b,1)));a.f.push.apply(a.f,k);}else if("function"==typeof b)try{b.call(a.h);}catch(w){}else if(n(b))for(var t in b)q(p(t,
	b[t]),a.c);else continue;c||(a.g=!0,a.l(a.c,b),a.g=!1);}}r.prototype.registerProcessor=r.prototype.registerProcessor;r.prototype.flatten=r.prototype.flatten;r.prototype.get=r.prototype.get;r.prototype.process=r.prototype.process;window.DataLayerHelper=r;function u(a){return {set:function(b,c){q(p(b,c),a.c);},get:function(b){return a.get(b)}}}})();
	return dataLayerHelper$1;
}

// eslint-disable-next-line import/no-mutable-exports
let DataLayerHelper$1;
if (typeof window !== 'undefined') {
    // Keep track of the original situation
    const originalDataLayerHelper = window.DataLayerHelper;
    // Perform side-effects
    // eslint-disable-next-line global-require
    requireDataLayerHelper();
    // Capture the side-effects
    DataLayerHelper$1 = window.DataLayerHelper;
    // Restore the original situation
    if (originalDataLayerHelper) {
        window.DataLayerHelper = originalDataLayerHelper;
    }
    else {
        delete window.DataLayerHelper;
    }
}

class DataLayerHelper extends DataLayerHelper$1 {
    listener;
    constructor(dataLayer, listenerParam, listenToPast) {
        if (typeof listenerParam === 'function') {
            const cancellableListener = cancellable(listenerParam);
            super(dataLayer, cancellableListener, listenToPast);
            this.listener = cancellableListener;
            return;
        }
        const cancellableListener = listenerParam?.listener ? cancellable(listenerParam.listener) : undefined;
        const options = {
            ...listenerParam,
            listener: cancellableListener,
        };
        super(dataLayer, options);
        this.listener = cancellableListener;
    }
    cancel() {
        if (this.listener) {
            this.listener.cancel();
        }
    }
}

const name = 'DataLayerHelper';
function run(bottle) {
    const qualifiedName = prefix(name);
    bottle.factory(qualifiedName, () => DataLayerHelper);
    return bottle;
}

var dataLayerHelper = /*#__PURE__*/Object.freeze({
    __proto__: null,
    name: name,
    run: run
});

var allProvisioners = /*#__PURE__*/Object.freeze({
    __proto__: null,
    addLog: addLog$1,
    allowedLocation: allowedLocation,
    awakeChildScript: awakeChildScript,
    booking: booking,
    bookingDraft: bookingDraft,
    bootstrap: bootstrap,
    bus: bus,
    busMaxMessages: busMaxMessages,
    callEngine: callEngine,
    chat: chat,
    combinedStorage: combinedStorage,
    context: context,
    convertCurrency: convertCurrency$1,
    createBuildDefaultSearch: buildDefaultSearch,
    createSearchReplay: createSearchReplay,
    dataLayer: dataLayer,
    dataLayerHelper: dataLayerHelper$2,
    dataLayerHelperConstructor: dataLayerHelper,
    dataLayerStub: dataLayerStub,
    demandManager: demandManager,
    disparitiesManager: disparitiesManager,
    domInteractive: domInterative,
    domReady: domReady,
    duettoManager: duettoManager,
    engine: engine,
    engineDummy: engine$1,
    env: env,
    environment: environment,
    errorMonitor: errorMonitor,
    exec: exec,
    exit: exit,
    exitManager: exitManager,
    fetch: fetch,
    fontsLoader: fontsLoader,
    ga: ga,
    getPropertyPerks: getPropertyPerks,
    getSetting: getSetting,
    getVisitorLastComparison: getVisitorLastComparison,
    getVisitorPersistentState: getVisitorPersistentState,
    getVisitorTokens: getVisitorTokens,
    getVisitorTools: getVisitorTools,
    getVisitorVisitData: getVisitorVisitData,
    globalState: globalState,
    globalThis: globalThis$1,
    idleManager: idleManager,
    inliner: inliner,
    instantBooking: instantBooking,
    isIframed: isIframed,
    isNoLog: isNoLog,
    isUserLogged: isUserLogged,
    kitt: kitt,
    languageCheck: languageCheck,
    layer: layer,
    loadManager: loadManager,
    loadScript: loadScript,
    logMaxMessages: logMaxMessages,
    logger: logger,
    moment: moment,
    networkIdleCallback: networkIdleCallback,
    note: note,
    onHashChange: onHashChange,
    onStateChange: onStateChange,
    oraculoManager: oraculoManager,
    pack: _package,
    pageCheck: pageCheck,
    pageUnload: pageUnload,
    parseUserAgent: parseUserAgent,
    parseUserAgentDevice: parseUserAgentDevice,
    partnershipCheck: partnershipCheck,
    partnershipManager: partnershipManager,
    prepareVisitorTokens: prepareVisitorTokens,
    prepareVisitorTools: prepareVisitorTools,
    prepareVisitorVisitData: prepareVisitorVisitData,
    price: price,
    pricematch: pricematch,
    recorderConstructor: recorder,
    registerModuleConstructors: registerModuleConstructors$1,
    reload: reload,
    report: report,
    requestIdleCallback: requestIdleCallback,
    review: review,
    scheduler: scheduler,
    scrollManager: scrollManager,
    searches: searches,
    searchesAdapter: searchesAdapter,
    sendBeacon: sendBeacon,
    sendPageVisit: sendPageVisit,
    sendSiteAnalytics: sendSiteAnalytics,
    sendTintoAssessment: sendTintoAssessment,
    serverEventsListener: serverEventsListener,
    setLanguage: setLanguage,
    setVisitorPersistentState: setVisitorPersistentState,
    setVisitorTokens: setVisitorTokens,
    setVisitorTools: setVisitorTools,
    setVisitorVisitData: setVisitorVisitData,
    shutdown: shutdown,
    siteChange: siteChange,
    siteCheck: siteCheck,
    snippet: snippet,
    start: start,
    stopAwakeChildScript: stopAwakeChildScript,
    swaps: swaps,
    swapsBridge: swapsBridge,
    tinto: tinto,
    tintoModelId: tintoModelId,
    trace: trace,
    ulid: ulid,
    unsetVisitorTools: unsetVisitorTools,
    uploadPageHtml: uploadPageHtml,
    uploadReport: uploadReport,
    widgets: widgets
});

function runProvisioners(bottle, provisioners) {
    provisioners.forEach((provisioner) => {
        provisioner.run(bottle);
    });
    return bottle;
}

function configureInjector(bottle) {
    return runProvisioners(bottle, Object.values(allProvisioners));
}

// @ts-nocheck
/* eslint-disable */
const { bottle } = thn$1;
const deprecationNotice = () => {
    bottle.container.logger.warn('This function has been deprecated in favor of the Agent devtools extension. Find more info at: https://bit.ly/agent-devtools');
};
// Configure all the DI
configureInjector(bottle);
// Utils
for (const key in utils) {
    thn$1[key] = utils[key];
}
Object.assign(thn$1, {
    fetchLoaderData,
    info,
    infoSwaps,
    infoDebug: deprecationNotice,
    infoReset: deprecationNotice,
    listen,
    pageCheckConditions,
    unlisten,
});
// Shortcuts to the Bottle services
[
    'awakeChildScript',
    'bootstrap',
    'bus',
    'createSearchReplay',
    'pageCheck',
    'dataLayer',
    'dataLayerHelper',
    'domReady',
    'engine',
    'getSetting',
    'isUserLogged',
    'isNolog',
    'languageCheck',
    'logger',
    'report',
    'trace',
    'context',
    'Logger',
    'getPropertyPerks',
    'onStateChange',
    'onHashChange',
    'pageUnload',
    'partnershipManager',
    'partnershipCheck',
    'reload',
    'start',
    'siteChange',
    'siteCheck',
    'uploadPageHtml',
    'sendPageVisit',
    'shutdown',
    'stopAwakeChildScript',
    'uploadReport',
].forEach((prop) => {
    Object.defineProperty(thn$1, prop, {
        get() {
            return bottle.container[prop];
        },
        set(value) {
            bottle.resetProviders([prop]);
            bottle.factory(prop, () => value);
        },
    });
});
// Shortcuts to the Bottle constructors
[
    'DataLayerHelper',
    'Searches',
    'SearchesSseAdapter',
].forEach((prop) => {
    Object.defineProperty(thn$1, prop, {
        get() {
            return bottle.container.constructors[prop];
        },
    });
});
thn$1.widgets = {};
// Shortcuts for the widgets
Object.values(WidgetsList).forEach((name) => {
    const camelName = camelCase(name);
    Object.defineProperty(thn$1.widgets, camelName, {
        get() {
            return bottle.container[camelName];
        },
    });
});

export { AbortError, AbortablePromise, ActivityKind, AgentActionKind, AnalyticsEventName, Array, CountdownKind, CredentialsRealm, CurrencyCode, DEFAULT_PROPERTY_DESCRIPTOR, Date, Day, DayName, Device, DiscountCodeKind, EvaluationFrequency, FontType, Map, NostromoAvailabilityType, NostromoPage, OraculoSemanticLayer, PageName, PriceNightConfig, PriceStatus, Promise$1, Recorder, ReferenceTimezone, RetargetingPage, RightToLeftLanguageCode, RuleConfigAbstractVariableRelationalOperation, RuleConfigCondition, RuleConfigRelationalOperation, RuleKind, RulesConfigProp, SHADOW_RESET_CSS, Scope, SocialDomain, TriggerKind, URL, UriSchema, WidgetMode, WidgetTypeId, WidgetsList, appendUrlParams, ary, bookingDatalayerModel, bookingDetailsItemModel, bookingDetailsModel, bytesToBase64, camelCase, cancellable, collectionClone, comparisonPagesModel, comparisonSseModel, comparisonStandardModel, createElement, datalayerEventBookingModel, datalayerEventSearchModel, daysBetween, debounce, thn$1 as default, delegate, empty, emptyRecursive, eq, findMountElement, flattenObject, generateCallbackQueue, get$1 as get, gt, gte, has$1 as has, identity$1 as identity, invoke, isArray, isBoolean, isEmail, isFunction, isIframed$1 as isIframed, isNumeric, isNumericGtZero, isPlainObject, isString, isThnDate, isUndefined, isUrl, isVisible, lt, memoize, merge, notEmpty, omit, openLink, parseUrlParameter, pick, reset, set$1 as set, setup, stringCapitalize, stringSnakeCase, stringify, toCamelCase$1, trigger, trim, ulid$1 as ulid, uniq };
